/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Geometry: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: string; output: string; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ActivateUserInput = {
  id: Scalars['ID']['input'];
};

/**
 * AffectedByNotificationWhereInput is used for filtering AffectedByNotificationView objects.
 * Input was generated by ent.
 */
export type AffectedByNotificationWhereInput = {
  /** affected_assets_count field predicates */
  affectedAssetsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedAssetsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** affected_components_count field predicates */
  affectedComponentsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedComponentsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<AffectedByNotificationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AffectedByNotificationWhereInput>;
  /** notification_id field predicates */
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<AffectedByNotificationWhereInput>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Are = {
  __typename?: 'Are';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AreConnection = {
  __typename?: 'AreConnection';
  edges: Array<AreEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AreEdge = {
  __typename?: 'AreEdge';
  cursor: Scalars['Cursor']['output'];
  node: Are;
};

export type AreOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AreOrderField>;
};

export enum AreOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * AreWhereInput is used for filtering Are objects.
 * Input was generated by ent.
 */
export type AreWhereInput = {
  and?: InputMaybe<Array<AreWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AreWhereInput>;
  or?: InputMaybe<Array<AreWhereInput>>;
};

export type Asset = {
  __typename?: 'Asset';
  alias?: Maybe<Scalars['String']['output']>;
  assetAttributes?: Maybe<Array<AssetAttribute>>;
  assetItems?: Maybe<Array<Maybe<AssetItem>>>;
  assetType: AssetType;
  createTime?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectZone: ProjectZone;
  status: AssetStatus;
  systemRating: AssetSystemRating;
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type AssetAttribute = {
  __typename?: 'AssetAttribute';
  asset: Asset;
  assetAttributeDefinition: AssetAttributeDefinition;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updateTime?: Maybe<Scalars['Time']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AssetAttributeDefinition = {
  __typename?: 'AssetAttributeDefinition';
  assetAttributes?: Maybe<Array<AssetAttribute>>;
  assetType: AssetType;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isMandatory: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  project: Project;
  sequence: Scalars['Int']['output'];
  type: AssetAttributeDefinitionType;
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type AssetAttributeDefinitionConnection = {
  __typename?: 'AssetAttributeDefinitionConnection';
  edges: Array<AssetAttributeDefinitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetAttributeDefinitionEdge = {
  __typename?: 'AssetAttributeDefinitionEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetAttributeDefinition;
};

export type AssetAttributeDefinitionOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetAttributeDefinitionOrderField>;
};

export enum AssetAttributeDefinitionOrderField {
  Assettypeid = 'ASSETTYPEID',
  Id = 'ID',
  Label = 'LABEL',
  Sequence = 'SEQUENCE',
  Type = 'TYPE'
}

export enum AssetAttributeDefinitionTemplateType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * AssetAttributeDefinitionTemplateWhereInput is used for filtering AssetAttributeDefinitionTemplate objects.
 * Input was generated by ent.
 */
export type AssetAttributeDefinitionTemplateWhereInput = {
  and?: InputMaybe<Array<AssetAttributeDefinitionTemplateWhereInput>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_type edge predicates */
  hasAssetType?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetTypeWith?: InputMaybe<Array<AssetTypeWhereInput>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetAttributeDefinitionTemplateWhereInput>;
  or?: InputMaybe<Array<AssetAttributeDefinitionTemplateWhereInput>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetAttributeDefinitionTemplateType>;
  typeIn?: InputMaybe<Array<AssetAttributeDefinitionTemplateType>>;
  typeNEQ?: InputMaybe<AssetAttributeDefinitionTemplateType>;
  typeNotIn?: InputMaybe<Array<AssetAttributeDefinitionTemplateType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum AssetAttributeDefinitionType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * AssetAttributeDefinitionWhereInput is used for filtering AssetAttributeDefinition objects.
 * Input was generated by ent.
 */
export type AssetAttributeDefinitionWhereInput = {
  and?: InputMaybe<Array<AssetAttributeDefinitionWhereInput>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_attributes edge predicates */
  hasAssetAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetAttributesWith?: InputMaybe<Array<AssetAttributeWhereInput>>;
  /** asset_type edge predicates */
  hasAssetType?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetTypeWith?: InputMaybe<Array<AssetTypeWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetAttributeDefinitionWhereInput>;
  or?: InputMaybe<Array<AssetAttributeDefinitionWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetAttributeDefinitionType>;
  typeIn?: InputMaybe<Array<AssetAttributeDefinitionType>>;
  typeNEQ?: InputMaybe<AssetAttributeDefinitionType>;
  typeNotIn?: InputMaybe<Array<AssetAttributeDefinitionType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * AssetAttributeWhereInput is used for filtering AssetAttribute objects.
 * Input was generated by ent.
 */
export type AssetAttributeWhereInput = {
  and?: InputMaybe<Array<AssetAttributeWhereInput>>;
  /** asset_attribute_definition_id field predicates */
  assetAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetAttributeDefinitionIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetAttributeDefinitionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset edge predicates */
  hasAsset?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_attribute_definition edge predicates */
  hasAssetAttributeDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetAttributeDefinitionWith?: InputMaybe<Array<AssetAttributeDefinitionWhereInput>>;
  hasAssetWith?: InputMaybe<Array<AssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AssetAttributeWhereInput>;
  or?: InputMaybe<Array<AssetAttributeWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  edges: Array<AssetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetEdge = {
  __typename?: 'AssetEdge';
  cursor: Scalars['Cursor']['output'];
  node: Asset;
};

export type AssetItem = {
  __typename?: 'AssetItem';
  asset: Asset;
  assetItemAttributes?: Maybe<Array<AssetItemAttribute>>;
  component?: Maybe<Component>;
  createTime?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: AssetItemType;
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type AssetItemAttribute = {
  __typename?: 'AssetItemAttribute';
  assetItem: AssetItem;
  assetItemAttributeDefinition: AssetItemAttributeDefinition;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updateTime?: Maybe<Scalars['Time']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AssetItemAttributeDefinition = {
  __typename?: 'AssetItemAttributeDefinition';
  assetItemAttributes?: Maybe<Array<AssetItemAttribute>>;
  assetItemType: AssetItemAttributeDefinitionAssetItemType;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isMandatory: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  project: Project;
  sequence: Scalars['Int']['output'];
  type: AssetItemAttributeDefinitionType;
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export enum AssetItemAttributeDefinitionAssetItemType {
  Hardware = 'HARDWARE',
  Info = 'INFO',
  Software = 'SOFTWARE'
}

export type AssetItemAttributeDefinitionConnection = {
  __typename?: 'AssetItemAttributeDefinitionConnection';
  edges: Array<AssetItemAttributeDefinitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetItemAttributeDefinitionEdge = {
  __typename?: 'AssetItemAttributeDefinitionEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetItemAttributeDefinition;
};

export type AssetItemAttributeDefinitionOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetItemAttributeDefinitionOrderField>;
};

export enum AssetItemAttributeDefinitionOrderField {
  Assetitemtype = 'ASSETITEMTYPE',
  Id = 'ID',
  Label = 'LABEL',
  Sequence = 'SEQUENCE',
  Type = 'TYPE'
}

export enum AssetItemAttributeDefinitionTemplateAssetItemType {
  Hardware = 'HARDWARE',
  Info = 'INFO',
  Software = 'SOFTWARE'
}

export enum AssetItemAttributeDefinitionTemplateType {
  String = 'STRING'
}

/**
 * AssetItemAttributeDefinitionTemplateWhereInput is used for filtering AssetItemAttributeDefinitionTemplate objects.
 * Input was generated by ent.
 */
export type AssetItemAttributeDefinitionTemplateWhereInput = {
  and?: InputMaybe<Array<AssetItemAttributeDefinitionTemplateWhereInput>>;
  /** asset_item_type field predicates */
  assetItemType?: InputMaybe<AssetItemAttributeDefinitionTemplateAssetItemType>;
  assetItemTypeIn?: InputMaybe<Array<AssetItemAttributeDefinitionTemplateAssetItemType>>;
  assetItemTypeNEQ?: InputMaybe<AssetItemAttributeDefinitionTemplateAssetItemType>;
  assetItemTypeNotIn?: InputMaybe<Array<AssetItemAttributeDefinitionTemplateAssetItemType>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetItemAttributeDefinitionTemplateWhereInput>;
  or?: InputMaybe<Array<AssetItemAttributeDefinitionTemplateWhereInput>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetItemAttributeDefinitionTemplateType>;
  typeIn?: InputMaybe<Array<AssetItemAttributeDefinitionTemplateType>>;
  typeNEQ?: InputMaybe<AssetItemAttributeDefinitionTemplateType>;
  typeNotIn?: InputMaybe<Array<AssetItemAttributeDefinitionTemplateType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum AssetItemAttributeDefinitionType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * AssetItemAttributeDefinitionWhereInput is used for filtering AssetItemAttributeDefinition objects.
 * Input was generated by ent.
 */
export type AssetItemAttributeDefinitionWhereInput = {
  and?: InputMaybe<Array<AssetItemAttributeDefinitionWhereInput>>;
  /** asset_item_type field predicates */
  assetItemType?: InputMaybe<AssetItemAttributeDefinitionAssetItemType>;
  assetItemTypeIn?: InputMaybe<Array<AssetItemAttributeDefinitionAssetItemType>>;
  assetItemTypeNEQ?: InputMaybe<AssetItemAttributeDefinitionAssetItemType>;
  assetItemTypeNotIn?: InputMaybe<Array<AssetItemAttributeDefinitionAssetItemType>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_item_attributes edge predicates */
  hasAssetItemAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemAttributesWith?: InputMaybe<Array<AssetItemAttributeWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetItemAttributeDefinitionWhereInput>;
  or?: InputMaybe<Array<AssetItemAttributeDefinitionWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetItemAttributeDefinitionType>;
  typeIn?: InputMaybe<Array<AssetItemAttributeDefinitionType>>;
  typeNEQ?: InputMaybe<AssetItemAttributeDefinitionType>;
  typeNotIn?: InputMaybe<Array<AssetItemAttributeDefinitionType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * AssetItemAttributeWhereInput is used for filtering AssetItemAttribute objects.
 * Input was generated by ent.
 */
export type AssetItemAttributeWhereInput = {
  and?: InputMaybe<Array<AssetItemAttributeWhereInput>>;
  /** asset_item_attribute_definition_id field predicates */
  assetItemAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetItemAttributeDefinitionIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetItemAttributeDefinitionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_item_id field predicates */
  assetItemID?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetItemIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_item edge predicates */
  hasAssetItem?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_item_attribute_definition edge predicates */
  hasAssetItemAttributeDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemAttributeDefinitionWith?: InputMaybe<Array<AssetItemAttributeDefinitionWhereInput>>;
  hasAssetItemWith?: InputMaybe<Array<AssetItemWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AssetItemAttributeWhereInput>;
  or?: InputMaybe<Array<AssetItemAttributeWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetItemConnection = {
  __typename?: 'AssetItemConnection';
  edges: Array<AssetItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetItemEdge = {
  __typename?: 'AssetItemEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetItem;
};

export type AssetItemOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetItemOrderField>;
};

export enum AssetItemOrderField {
  Assetitemtype = 'ASSETITEMTYPE',
  Createtime = 'CREATETIME',
  Description = 'DESCRIPTION',
  Externalidentifier = 'EXTERNALIDENTIFIER',
  Id = 'ID',
  Isvalid = 'ISVALID',
  Name = 'NAME',
  Updatetime = 'UPDATETIME'
}

export enum AssetItemType {
  Hardware = 'HARDWARE',
  Info = 'INFO',
  Software = 'SOFTWARE'
}

/**
 * AssetItemWhereInput is used for filtering AssetItem objects.
 * Input was generated by ent.
 */
export type AssetItemWhereInput = {
  and?: InputMaybe<Array<AssetItemWhereInput>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_identifier field predicates */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIdentifierIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIdentifierNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset edge predicates */
  hasAsset?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_item_attributes edge predicates */
  hasAssetItemAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemAttributesWith?: InputMaybe<Array<AssetItemAttributeWhereInput>>;
  hasAssetWith?: InputMaybe<Array<AssetWhereInput>>;
  /** component edge predicates */
  hasComponent?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** mitigations edge predicates */
  hasMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationsWith?: InputMaybe<Array<MitigationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_valid field predicates */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetItemWhereInput>;
  or?: InputMaybe<Array<AssetItemWhereInput>>;
  /** type field predicates */
  type?: InputMaybe<AssetItemType>;
  typeIn?: InputMaybe<Array<AssetItemType>>;
  typeNEQ?: InputMaybe<AssetItemType>;
  typeNotIn?: InputMaybe<Array<AssetItemType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type AssetItemsProjectNotificationCount = {
  __typename?: 'AssetItemsProjectNotificationCount';
  assetID: Scalars['ID']['output'];
  componentID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  notificationCount: Scalars['Int']['output'];
  notificationIsResolved: Scalars['Boolean']['output'];
  notificationPriority: AssetItemsProjectNotificationCountNotificationPriority;
  projectID: Scalars['ID']['output'];
  projectZoneID: Scalars['ID']['output'];
};

export type AssetItemsProjectNotificationCountConnection = {
  __typename?: 'AssetItemsProjectNotificationCountConnection';
  edges: Array<AssetItemsProjectNotificationCountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetItemsProjectNotificationCountEdge = {
  __typename?: 'AssetItemsProjectNotificationCountEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetItemsProjectNotificationCount;
};

/** The set of notification priorities - exactly the same values as in NotificationPriority enum list */
export enum AssetItemsProjectNotificationCountNotificationPriority {
  /**
   * Critical - Typically used for remote attacks with critical impact which cause
   * full compromise of the system. Investigate immediately and follow recommended
   * action as soon as possible with urgency.
   */
  P01Critical = 'P01CRITICAL',
  /**
   * Major - Typically used for remote or local attacks with significant impact but
   * no full compromise of system. Investigate as soon as possible and follow
   * recommended action.
   */
  P02Major = 'P02MAJOR',
  /**
   * Minor - Typically used for local attacks with minor impact to system. Follow
   * the recommended action in a reasonable amount of time.
   */
  P03Minor = 'P03MINOR',
  /**
   * Information - Typically used for notifications that are not directly related
   * to vulnerabilities but could have a security impact nonetheless, e.g. updates
   * of trusted root CAs or time zone information.
   */
  P04Information = 'P04INFORMATION',
  /**
   * Withdrawn - The vulnerability has been withdrawn either by the vendor or
   * Siemens ProductCERT. It is no longer valid and can be disregarded.
   */
  P05Withdrawn = 'P05WITHDRAWN'
}

export type AssetItemsProjectNotificationCountOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetItemsProjectNotificationCountOrderField>;
};

export enum AssetItemsProjectNotificationCountOrderField {
  Notificationcount = 'NOTIFICATIONCOUNT',
  Notificationisresolved = 'NOTIFICATIONISRESOLVED',
  Notificationpriority = 'NOTIFICATIONPRIORITY'
}

/**
 * AssetItemsProjectNotificationCountWhereInput is used for filtering AssetItemsProjectNotificationCountView objects.
 * Input was generated by ent.
 */
export type AssetItemsProjectNotificationCountWhereInput = {
  and?: InputMaybe<Array<AssetItemsProjectNotificationCountWhereInput>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AssetItemsProjectNotificationCountWhereInput>;
  /** notification_count field predicates */
  notificationCount?: InputMaybe<Scalars['Int']['input']>;
  notificationCountGT?: InputMaybe<Scalars['Int']['input']>;
  notificationCountGTE?: InputMaybe<Scalars['Int']['input']>;
  notificationCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  notificationCountLT?: InputMaybe<Scalars['Int']['input']>;
  notificationCountLTE?: InputMaybe<Scalars['Int']['input']>;
  notificationCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  notificationCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** notification_is_resolved field predicates */
  notificationIsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  notificationIsResolvedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** notification_priority field predicates */
  notificationPriority?: InputMaybe<AssetItemsProjectNotificationCountNotificationPriority>;
  notificationPriorityIn?: InputMaybe<Array<AssetItemsProjectNotificationCountNotificationPriority>>;
  notificationPriorityNEQ?: InputMaybe<AssetItemsProjectNotificationCountNotificationPriority>;
  notificationPriorityNotIn?: InputMaybe<Array<AssetItemsProjectNotificationCountNotificationPriority>>;
  or?: InputMaybe<Array<AssetItemsProjectNotificationCountWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssetOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetOrderField>;
};

export enum AssetOrderField {
  Alias = 'ALIAS',
  Createtime = 'CREATETIME',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Status = 'STATUS',
  Systemrating = 'SYSTEMRATING',
  Typeid = 'TYPEID',
  Updatetime = 'UPDATETIME'
}

export type AssetRelation = {
  __typename?: 'AssetRelation';
  assetRelationAttributes?: Maybe<Array<Maybe<AssetRelationAttribute>>>;
  createTime: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  sourceAsset: Asset;
  targetAsset: Asset;
  type: AssetRelationType;
  updateTime: Scalars['Time']['output'];
};

export type AssetRelationAttribute = {
  __typename?: 'AssetRelationAttribute';
  assetID?: Maybe<Scalars['ID']['output']>;
  assetRelation: AssetRelation;
  assetRelationAttributeDefinition: AssetRelationAttributeDefinition;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AssetRelationAttributeDefinition = {
  __typename?: 'AssetRelationAttributeDefinition';
  assetRelationAttributes?: Maybe<Array<Maybe<AssetRelationAttribute>>>;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  objectType: AssetRelationAttributeDefinitionObjectType;
  project: Project;
  relationType: AssetRelationAttributeDefinitionRelationType;
  sequence: Scalars['Int']['output'];
  type: AssetRelationAttributeDefinitionType;
  updateTime: Scalars['Time']['output'];
};

export type AssetRelationAttributeDefinitionConnection = {
  __typename?: 'AssetRelationAttributeDefinitionConnection';
  edges: Array<AssetRelationAttributeDefinitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetRelationAttributeDefinitionEdge = {
  __typename?: 'AssetRelationAttributeDefinitionEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetRelationAttributeDefinition;
};

export enum AssetRelationAttributeDefinitionObjectType {
  Assets = 'ASSETS',
  Relation = 'RELATION'
}

export type AssetRelationAttributeDefinitionOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetRelationAttributeDefinitionOrderField>;
};

export enum AssetRelationAttributeDefinitionOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Label = 'LABEL',
  Objecttype = 'OBJECTTYPE',
  Relationtype = 'RELATIONTYPE',
  Sequence = 'SEQUENCE',
  Type = 'TYPE',
  Updatetime = 'UPDATETIME'
}

export enum AssetRelationAttributeDefinitionRelationType {
  Electrical = 'ELECTRICAL',
  Logical = 'LOGICAL',
  Network = 'NETWORK'
}

export enum AssetRelationAttributeDefinitionTemplateObjectType {
  Assets = 'ASSETS',
  Relation = 'RELATION'
}

export enum AssetRelationAttributeDefinitionTemplateRelationType {
  Electrical = 'ELECTRICAL',
  Logical = 'LOGICAL',
  Network = 'NETWORK'
}

export enum AssetRelationAttributeDefinitionTemplateType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * AssetRelationAttributeDefinitionTemplateWhereInput is used for filtering AssetRelationAttributeDefinitionTemplate objects.
 * Input was generated by ent.
 */
export type AssetRelationAttributeDefinitionTemplateWhereInput = {
  and?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetRelationAttributeDefinitionTemplateWhereInput>;
  /** object_type field predicates */
  objectType?: InputMaybe<AssetRelationAttributeDefinitionTemplateObjectType>;
  objectTypeIn?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateObjectType>>;
  objectTypeNEQ?: InputMaybe<AssetRelationAttributeDefinitionTemplateObjectType>;
  objectTypeNotIn?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateObjectType>>;
  or?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateWhereInput>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** relation_type field predicates */
  relationType?: InputMaybe<AssetRelationAttributeDefinitionTemplateRelationType>;
  relationTypeIn?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateRelationType>>;
  relationTypeNEQ?: InputMaybe<AssetRelationAttributeDefinitionTemplateRelationType>;
  relationTypeNotIn?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateRelationType>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetRelationAttributeDefinitionTemplateType>;
  typeIn?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateType>>;
  typeNEQ?: InputMaybe<AssetRelationAttributeDefinitionTemplateType>;
  typeNotIn?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum AssetRelationAttributeDefinitionType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * AssetRelationAttributeDefinitionWhereInput is used for filtering AssetRelationAttributeDefinition objects.
 * Input was generated by ent.
 */
export type AssetRelationAttributeDefinitionWhereInput = {
  and?: InputMaybe<Array<AssetRelationAttributeDefinitionWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_relation_attributes edge predicates */
  hasAssetRelationAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributesWith?: InputMaybe<Array<AssetRelationAttributeWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetRelationAttributeDefinitionWhereInput>;
  /** object_type field predicates */
  objectType?: InputMaybe<AssetRelationAttributeDefinitionObjectType>;
  objectTypeIn?: InputMaybe<Array<AssetRelationAttributeDefinitionObjectType>>;
  objectTypeNEQ?: InputMaybe<AssetRelationAttributeDefinitionObjectType>;
  objectTypeNotIn?: InputMaybe<Array<AssetRelationAttributeDefinitionObjectType>>;
  or?: InputMaybe<Array<AssetRelationAttributeDefinitionWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** relation_type field predicates */
  relationType?: InputMaybe<AssetRelationAttributeDefinitionRelationType>;
  relationTypeIn?: InputMaybe<Array<AssetRelationAttributeDefinitionRelationType>>;
  relationTypeNEQ?: InputMaybe<AssetRelationAttributeDefinitionRelationType>;
  relationTypeNotIn?: InputMaybe<Array<AssetRelationAttributeDefinitionRelationType>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetRelationAttributeDefinitionType>;
  typeIn?: InputMaybe<Array<AssetRelationAttributeDefinitionType>>;
  typeNEQ?: InputMaybe<AssetRelationAttributeDefinitionType>;
  typeNotIn?: InputMaybe<Array<AssetRelationAttributeDefinitionType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * AssetRelationAttributeWhereInput is used for filtering AssetRelationAttribute objects.
 * Input was generated by ent.
 */
export type AssetRelationAttributeWhereInput = {
  and?: InputMaybe<Array<AssetRelationAttributeWhereInput>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_relation_attribute_definition_id field predicates */
  assetRelationAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetRelationAttributeDefinitionIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_relation_id field predicates */
  assetRelationID?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetRelationIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetRelationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset edge predicates */
  hasAsset?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_relation edge predicates */
  hasAssetRelation?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_relation_attribute_definition edge predicates */
  hasAssetRelationAttributeDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributeDefinitionWith?: InputMaybe<Array<AssetRelationAttributeDefinitionWhereInput>>;
  hasAssetRelationWith?: InputMaybe<Array<AssetRelationWhereInput>>;
  hasAssetWith?: InputMaybe<Array<AssetWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AssetRelationAttributeWhereInput>;
  or?: InputMaybe<Array<AssetRelationAttributeWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AssetRelationConnection = {
  __typename?: 'AssetRelationConnection';
  edges: Array<AssetRelationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetRelationEdge = {
  __typename?: 'AssetRelationEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetRelation;
};

export type AssetRelationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetRelationOrderField>;
};

export enum AssetRelationOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Name = 'NAME',
  Type = 'TYPE',
  Updatetime = 'UPDATETIME'
}

export enum AssetRelationType {
  Electrical = 'ELECTRICAL',
  Logical = 'LOGICAL',
  Network = 'NETWORK'
}

/**
 * AssetRelationWhereInput is used for filtering AssetRelation objects.
 * Input was generated by ent.
 */
export type AssetRelationWhereInput = {
  and?: InputMaybe<Array<AssetRelationWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_relation_attributes edge predicates */
  hasAssetRelationAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributesWith?: InputMaybe<Array<AssetRelationAttributeWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** source_asset edge predicates */
  hasSourceAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceAssetWith?: InputMaybe<Array<AssetWhereInput>>;
  /** target_asset edge predicates */
  hasTargetAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasTargetAssetWith?: InputMaybe<Array<AssetWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetRelationWhereInput>;
  or?: InputMaybe<Array<AssetRelationWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** source_asset_id field predicates */
  sourceAssetID?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** target_asset_id field predicates */
  targetAssetID?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  targetAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<AssetRelationType>;
  typeIn?: InputMaybe<Array<AssetRelationType>>;
  typeNEQ?: InputMaybe<AssetRelationType>;
  typeNotIn?: InputMaybe<Array<AssetRelationType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AssetStatus {
  Invalid = 'INVALID',
  Valid = 'VALID',
  Zoneassignmenterror = 'ZONEASSIGNMENTERROR'
}

export enum AssetSystemRating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type AssetType = {
  __typename?: 'AssetType';
  createTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type AssetTypeConnection = {
  __typename?: 'AssetTypeConnection';
  edges: Array<AssetTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetTypeEdge = {
  __typename?: 'AssetTypeEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetType;
};

export type AssetTypeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetTypeOrderField>;
};

export enum AssetTypeOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Name = 'NAME',
  Updatetime = 'UPDATETIME'
}

/**
 * AssetTypeWhereInput is used for filtering AssetType objects.
 * Input was generated by ent.
 */
export type AssetTypeWhereInput = {
  and?: InputMaybe<Array<AssetTypeWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_attribute_definitions edge predicates */
  hasAssetAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetAttributeDefinitionsWith?: InputMaybe<Array<AssetAttributeDefinitionWhereInput>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<AssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetTypeWhereInput>;
  or?: InputMaybe<Array<AssetTypeWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type AssetView = {
  __typename?: 'AssetView';
  alias?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectZoneExposureRating?: Maybe<Scalars['String']['output']>;
  projectZoneName: Scalars['String']['output'];
  status: AssetViewStatus;
  systemRating: AssetViewSystemRating;
  typeName: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type AssetViewConnection = {
  __typename?: 'AssetViewConnection';
  edges: Array<AssetViewEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetViewEdge = {
  __typename?: 'AssetViewEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssetView;
};

export type AssetViewOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AssetViewOrderField>;
};

export enum AssetViewOrderField {
  Alias = 'ALIAS',
  Createtime = 'CREATETIME',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Projectid = 'PROJECTID',
  Projectzoneexposurerating = 'PROJECTZONEEXPOSURERATING',
  Projectzoneid = 'PROJECTZONEID',
  Projectzonename = 'PROJECTZONENAME',
  Status = 'STATUS',
  Systemrating = 'SYSTEMRATING',
  Typeid = 'TYPEID',
  Typename = 'TYPENAME',
  Updatetime = 'UPDATETIME'
}

export enum AssetViewStatus {
  Invalid = 'INVALID',
  Valid = 'VALID',
  Zoneassignmenterror = 'ZONEASSIGNMENTERROR'
}

export enum AssetViewSystemRating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * AssetViewWhereInput is used for filtering AssetView objects.
 * Input was generated by ent.
 */
export type AssetViewWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AssetViewWhereInput>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetViewWhereInput>;
  or?: InputMaybe<Array<AssetViewWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_zone_exposure_rating field predicates */
  projectZoneExposureRating?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingContains?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingContainsFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingEqualFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingGT?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingGTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingHasPrefix?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingHasSuffix?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectZoneExposureRatingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectZoneExposureRatingLT?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingLTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingNEQ?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectZoneExposureRatingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_zone_name field predicates */
  projectZoneName?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameContains?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameGT?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameGTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectZoneNameLT?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameLTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameNEQ?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<AssetViewStatus>;
  statusIn?: InputMaybe<Array<AssetViewStatus>>;
  statusNEQ?: InputMaybe<AssetViewStatus>;
  statusNotIn?: InputMaybe<Array<AssetViewStatus>>;
  /** system_rating field predicates */
  systemRating?: InputMaybe<AssetViewSystemRating>;
  systemRatingIn?: InputMaybe<Array<AssetViewSystemRating>>;
  systemRatingNEQ?: InputMaybe<AssetViewSystemRating>;
  systemRatingNotIn?: InputMaybe<Array<AssetViewSystemRating>>;
  /** type_name field predicates */
  typeName?: InputMaybe<Scalars['String']['input']>;
  typeNameContains?: InputMaybe<Scalars['String']['input']>;
  typeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  typeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeNameGT?: InputMaybe<Scalars['String']['input']>;
  typeNameGTE?: InputMaybe<Scalars['String']['input']>;
  typeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeNameLT?: InputMaybe<Scalars['String']['input']>;
  typeNameLTE?: InputMaybe<Scalars['String']['input']>;
  typeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  typeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * AssetWhereInput is used for filtering Asset objects.
 * Input was generated by ent.
 */
export type AssetWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AssetWhereInput>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_attributes edge predicates */
  hasAssetAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetAttributesWith?: InputMaybe<Array<AssetAttributeWhereInput>>;
  /** asset_items edge predicates */
  hasAssetItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemsWith?: InputMaybe<Array<AssetItemWhereInput>>;
  /** asset_relation_attributes edge predicates */
  hasAssetRelationAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributesWith?: InputMaybe<Array<AssetRelationAttributeWhereInput>>;
  /** asset_type edge predicates */
  hasAssetType?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetTypeWith?: InputMaybe<Array<AssetTypeWhereInput>>;
  /** project_hierarchy_assets edge predicates */
  hasProjectHierarchyAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAssetsWith?: InputMaybe<Array<ProjectHierarchyAssetWhereInput>>;
  /** project_zone edge predicates */
  hasProjectZone?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneWith?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** source_asset_relations edge predicates */
  hasSourceAssetRelations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceAssetRelationsWith?: InputMaybe<Array<AssetRelationWhereInput>>;
  /** target_asset_relations edge predicates */
  hasTargetAssetRelations?: InputMaybe<Scalars['Boolean']['input']>;
  hasTargetAssetRelationsWith?: InputMaybe<Array<AssetRelationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AssetWhereInput>;
  or?: InputMaybe<Array<AssetWhereInput>>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<AssetStatus>;
  statusIn?: InputMaybe<Array<AssetStatus>>;
  statusNEQ?: InputMaybe<AssetStatus>;
  statusNotIn?: InputMaybe<Array<AssetStatus>>;
  /** system_rating field predicates */
  systemRating?: InputMaybe<AssetSystemRating>;
  systemRatingIn?: InputMaybe<Array<AssetSystemRating>>;
  systemRatingNEQ?: InputMaybe<AssetSystemRating>;
  systemRatingNotIn?: InputMaybe<Array<AssetSystemRating>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Attck = {
  __typename?: 'Attck';
  assets: Array<AttckAsset>;
  createTime: Scalars['Time']['output'];
  domain: AttckDomain;
  id: Scalars['ID']['output'];
  tactics: Array<AttckTactic>;
  techniques: Array<AttckTechnique>;
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AttckAsset = {
  __typename?: 'AttckAsset';
  attck: Attck;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  srcId: Scalars['String']['output'];
  techniqueAssets: Array<AttckTechniqueAsset>;
  url: Scalars['String']['output'];
};

/**
 * AttckAssetWhereInput is used for filtering AttckAsset objects.
 * Input was generated by ent.
 */
export type AttckAssetWhereInput = {
  and?: InputMaybe<Array<AttckAssetWhereInput>>;
  /** attck_id field predicates */
  attckID?: InputMaybe<Scalars['ID']['input']>;
  attckIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** attck edge predicates */
  hasAttck?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttckWith?: InputMaybe<Array<AttckWhereInput>>;
  /** technique_assets edge predicates */
  hasTechniqueAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniqueAssetsWith?: InputMaybe<Array<AttckTechniqueAssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AttckAssetWhereInput>;
  or?: InputMaybe<Array<AttckAssetWhereInput>>;
  /** src_id field predicates */
  srcID?: InputMaybe<Scalars['String']['input']>;
  srcIDContains?: InputMaybe<Scalars['String']['input']>;
  srcIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  srcIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  srcIDGT?: InputMaybe<Scalars['String']['input']>;
  srcIDGTE?: InputMaybe<Scalars['String']['input']>;
  srcIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  srcIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  srcIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  srcIDLT?: InputMaybe<Scalars['String']['input']>;
  srcIDLTE?: InputMaybe<Scalars['String']['input']>;
  srcIDNEQ?: InputMaybe<Scalars['String']['input']>;
  srcIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttckConnection = {
  __typename?: 'AttckConnection';
  edges: Array<AttckEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AttckDomain {
  Enterprise = 'ENTERPRISE',
  Ics = 'ICS'
}

export type AttckEdge = {
  __typename?: 'AttckEdge';
  cursor: Scalars['Cursor']['output'];
  node: Attck;
};

export type AttckMitigation = {
  __typename?: 'AttckMitigation';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  srcId: Scalars['String']['output'];
  techniqueMitigations: Array<AttckTechniqueMitigation>;
  url: Scalars['String']['output'];
};

/**
 * AttckMitigationWhereInput is used for filtering AttckMitigation objects.
 * Input was generated by ent.
 */
export type AttckMitigationWhereInput = {
  and?: InputMaybe<Array<AttckMitigationWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** technique_mitigations edge predicates */
  hasTechniqueMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniqueMitigationsWith?: InputMaybe<Array<AttckTechniqueMitigationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AttckMitigationWhereInput>;
  or?: InputMaybe<Array<AttckMitigationWhereInput>>;
  /** src_id field predicates */
  srcID?: InputMaybe<Scalars['String']['input']>;
  srcIDContains?: InputMaybe<Scalars['String']['input']>;
  srcIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  srcIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  srcIDGT?: InputMaybe<Scalars['String']['input']>;
  srcIDGTE?: InputMaybe<Scalars['String']['input']>;
  srcIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  srcIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  srcIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  srcIDLT?: InputMaybe<Scalars['String']['input']>;
  srcIDLTE?: InputMaybe<Scalars['String']['input']>;
  srcIDNEQ?: InputMaybe<Scalars['String']['input']>;
  srcIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttckOrder = {
  direction: OrderDirection;
  field?: InputMaybe<AttckOrderField>;
};

export enum AttckOrderField {
  Createtime = 'CREATETIME',
  Domain = 'DOMAIN',
  Version = 'VERSION'
}

export type AttckTactic = {
  __typename?: 'AttckTactic';
  attck: Attck;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  srcId: Scalars['String']['output'];
  techniques: Array<AttckTechnique>;
  url: Scalars['String']['output'];
};

/**
 * AttckTacticWhereInput is used for filtering AttckTactic objects.
 * Input was generated by ent.
 */
export type AttckTacticWhereInput = {
  and?: InputMaybe<Array<AttckTacticWhereInput>>;
  /** attck_id field predicates */
  attckID?: InputMaybe<Scalars['ID']['input']>;
  attckIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** attck edge predicates */
  hasAttck?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttckWith?: InputMaybe<Array<AttckWhereInput>>;
  /** techniques edge predicates */
  hasTechniques?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniquesWith?: InputMaybe<Array<AttckTechniqueWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AttckTacticWhereInput>;
  or?: InputMaybe<Array<AttckTacticWhereInput>>;
  /** src_id field predicates */
  srcID?: InputMaybe<Scalars['String']['input']>;
  srcIDContains?: InputMaybe<Scalars['String']['input']>;
  srcIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  srcIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  srcIDGT?: InputMaybe<Scalars['String']['input']>;
  srcIDGTE?: InputMaybe<Scalars['String']['input']>;
  srcIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  srcIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  srcIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  srcIDLT?: InputMaybe<Scalars['String']['input']>;
  srcIDLTE?: InputMaybe<Scalars['String']['input']>;
  srcIDNEQ?: InputMaybe<Scalars['String']['input']>;
  srcIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttckTechnique = {
  __typename?: 'AttckTechnique';
  attck: Attck;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  srcId: Scalars['String']['output'];
  tactics: Array<AttckTactic>;
  techniqueAssets: Array<AttckTechniqueAsset>;
  techniqueMitigations: Array<AttckTechniqueMitigation>;
  url: Scalars['String']['output'];
};

export type AttckTechniqueAsset = {
  __typename?: 'AttckTechniqueAsset';
  asset: AttckAsset;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  srcId: Scalars['String']['output'];
  technique: AttckTechnique;
};

/**
 * AttckTechniqueAssetWhereInput is used for filtering AttckTechniqueAsset objects.
 * Input was generated by ent.
 */
export type AttckTechniqueAssetWhereInput = {
  and?: InputMaybe<Array<AttckTechniqueAssetWhereInput>>;
  /** attck_asset_id field predicates */
  attckAssetID?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** attck_technique_id field predicates */
  attckTechniqueID?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckTechniqueIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset edge predicates */
  hasAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetWith?: InputMaybe<Array<AttckAssetWhereInput>>;
  /** technique edge predicates */
  hasTechnique?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniqueWith?: InputMaybe<Array<AttckTechniqueWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AttckTechniqueAssetWhereInput>;
  or?: InputMaybe<Array<AttckTechniqueAssetWhereInput>>;
  /** src_id field predicates */
  srcID?: InputMaybe<Scalars['String']['input']>;
  srcIDContains?: InputMaybe<Scalars['String']['input']>;
  srcIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  srcIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  srcIDGT?: InputMaybe<Scalars['String']['input']>;
  srcIDGTE?: InputMaybe<Scalars['String']['input']>;
  srcIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  srcIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  srcIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  srcIDLT?: InputMaybe<Scalars['String']['input']>;
  srcIDLTE?: InputMaybe<Scalars['String']['input']>;
  srcIDNEQ?: InputMaybe<Scalars['String']['input']>;
  srcIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttckTechniqueMitigation = {
  __typename?: 'AttckTechniqueMitigation';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mitigation: AttckMitigation;
  srcId: Scalars['String']['output'];
  technique: AttckTechnique;
};

/**
 * AttckTechniqueMitigationWhereInput is used for filtering AttckTechniqueMitigation objects.
 * Input was generated by ent.
 */
export type AttckTechniqueMitigationWhereInput = {
  and?: InputMaybe<Array<AttckTechniqueMitigationWhereInput>>;
  /** attck_mitigation_id field predicates */
  attckMitigationID?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckMitigationIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckMitigationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** attck_technique_id field predicates */
  attckTechniqueID?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckTechniqueIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckTechniqueIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** mitigation edge predicates */
  hasMitigation?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationWith?: InputMaybe<Array<AttckMitigationWhereInput>>;
  /** technique edge predicates */
  hasTechnique?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniqueWith?: InputMaybe<Array<AttckTechniqueWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AttckTechniqueMitigationWhereInput>;
  or?: InputMaybe<Array<AttckTechniqueMitigationWhereInput>>;
  /** src_id field predicates */
  srcID?: InputMaybe<Scalars['String']['input']>;
  srcIDContains?: InputMaybe<Scalars['String']['input']>;
  srcIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  srcIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  srcIDGT?: InputMaybe<Scalars['String']['input']>;
  srcIDGTE?: InputMaybe<Scalars['String']['input']>;
  srcIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  srcIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  srcIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  srcIDLT?: InputMaybe<Scalars['String']['input']>;
  srcIDLTE?: InputMaybe<Scalars['String']['input']>;
  srcIDNEQ?: InputMaybe<Scalars['String']['input']>;
  srcIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * AttckTechniqueWhereInput is used for filtering AttckTechnique objects.
 * Input was generated by ent.
 */
export type AttckTechniqueWhereInput = {
  and?: InputMaybe<Array<AttckTechniqueWhereInput>>;
  /** attck_id field predicates */
  attckID?: InputMaybe<Scalars['ID']['input']>;
  attckIDContains?: InputMaybe<Scalars['ID']['input']>;
  attckIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  attckIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  attckIDGT?: InputMaybe<Scalars['ID']['input']>;
  attckIDGTE?: InputMaybe<Scalars['ID']['input']>;
  attckIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  attckIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  attckIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckIDLT?: InputMaybe<Scalars['ID']['input']>;
  attckIDLTE?: InputMaybe<Scalars['ID']['input']>;
  attckIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attckIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** attck edge predicates */
  hasAttck?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttckWith?: InputMaybe<Array<AttckWhereInput>>;
  /** tactics edge predicates */
  hasTactics?: InputMaybe<Scalars['Boolean']['input']>;
  hasTacticsWith?: InputMaybe<Array<AttckTacticWhereInput>>;
  /** technique_assets edge predicates */
  hasTechniqueAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniqueAssetsWith?: InputMaybe<Array<AttckTechniqueAssetWhereInput>>;
  /** technique_mitigations edge predicates */
  hasTechniqueMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniqueMitigationsWith?: InputMaybe<Array<AttckTechniqueMitigationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AttckTechniqueWhereInput>;
  or?: InputMaybe<Array<AttckTechniqueWhereInput>>;
  /** src_id field predicates */
  srcID?: InputMaybe<Scalars['String']['input']>;
  srcIDContains?: InputMaybe<Scalars['String']['input']>;
  srcIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  srcIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  srcIDGT?: InputMaybe<Scalars['String']['input']>;
  srcIDGTE?: InputMaybe<Scalars['String']['input']>;
  srcIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  srcIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  srcIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  srcIDLT?: InputMaybe<Scalars['String']['input']>;
  srcIDLTE?: InputMaybe<Scalars['String']['input']>;
  srcIDNEQ?: InputMaybe<Scalars['String']['input']>;
  srcIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  srcIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * AttckWhereInput is used for filtering Attck objects.
 * Input was generated by ent.
 */
export type AttckWhereInput = {
  and?: InputMaybe<Array<AttckWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** domain field predicates */
  domain?: InputMaybe<AttckDomain>;
  domainIn?: InputMaybe<Array<AttckDomain>>;
  domainNEQ?: InputMaybe<AttckDomain>;
  domainNotIn?: InputMaybe<Array<AttckDomain>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<AttckAssetWhereInput>>;
  /** tactics edge predicates */
  hasTactics?: InputMaybe<Scalars['Boolean']['input']>;
  hasTacticsWith?: InputMaybe<Array<AttckTacticWhereInput>>;
  /** techniques edge predicates */
  hasTechniques?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechniquesWith?: InputMaybe<Array<AttckTechniqueWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AttckWhereInput>;
  or?: InputMaybe<Array<AttckWhereInput>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  edges: Array<AuditLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditLogEdge = {
  __typename?: 'AuditLogEdge';
  cursor: Scalars['String']['output'];
  node: AuditLogEntry;
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  entityID: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  operation: Scalars['String']['output'];
  requestID?: Maybe<Scalars['String']['output']>;
  snapshot?: Maybe<Scalars['Map']['output']>;
  timestamp: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['String']['output'];
};

export type AuditLogEntryWithDiff = {
  __typename?: 'AuditLogEntryWithDiff';
  diff?: Maybe<Scalars['Map']['output']>;
  entityID: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  operation: Scalars['String']['output'];
  requestID?: Maybe<Scalars['String']['output']>;
  snapshot?: Maybe<Scalars['Map']['output']>;
  timestamp: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['String']['output'];
};

export type AuditLogHistoryConnection = {
  __typename?: 'AuditLogHistoryConnection';
  edges: Array<AuditLogHistoryEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AuditLogHistoryEdge = {
  __typename?: 'AuditLogHistoryEdge';
  node: AuditLogEntryWithDiff;
};

export type AuditLogOrder = {
  direction: AuditLogOrderDirection;
  field?: InputMaybe<AuditLogOrderField>;
};

export enum AuditLogOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AuditLogOrderField {
  EntityId = 'ENTITY_ID',
  EntityType = 'ENTITY_TYPE',
  Operation = 'OPERATION',
  Timestamp = 'TIMESTAMP',
  UserId = 'USER_ID'
}

export type AuditLogWhereInput = {
  entityID?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['Time']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthTokenPurpose {
  Excel = 'EXCEL',
  Serviceaccess = 'SERVICEACCESS'
}

/**
 * AuthTokenWhereInput is used for filtering AuthToken objects.
 * Input was generated by ent.
 */
export type AuthTokenWhereInput = {
  and?: InputMaybe<Array<AuthTokenWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_at_time field predicates */
  expiresAtTime?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTimeGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtTimeLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** issuedFor edge predicates */
  hasIssuedFor?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssuedForWith?: InputMaybe<Array<UserWhereInput>>;
  /** issuer edge predicates */
  hasIssuer?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssuerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_revoked field predicates */
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  isRevokedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_access_time field predicates */
  lastAccessTime?: InputMaybe<Scalars['Time']['input']>;
  lastAccessTimeGT?: InputMaybe<Scalars['Time']['input']>;
  lastAccessTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  lastAccessTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastAccessTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastAccessTimeLT?: InputMaybe<Scalars['Time']['input']>;
  lastAccessTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  lastAccessTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastAccessTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastAccessTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<AuthTokenWhereInput>;
  or?: InputMaybe<Array<AuthTokenWhereInput>>;
  /** purpose field predicates */
  purpose?: InputMaybe<AuthTokenPurpose>;
  purposeIn?: InputMaybe<Array<AuthTokenPurpose>>;
  purposeNEQ?: InputMaybe<AuthTokenPurpose>;
  purposeNotIn?: InputMaybe<Array<AuthTokenPurpose>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type AuthorizationError = ErrInvalidToken | ErrSubjectNotAuthorized | ErrUserNotActive | ErrUserNotFound;

export type BulkIdInput = {
  IDs: Array<Scalars['ID']['input']>;
};

/**
 * CPENVDWhereInput is used for filtering CPENVD objects.
 * Input was generated by ent.
 */
export type CpenvdWhereInput = {
  /** advisory_url field predicates */
  advisoryURL?: InputMaybe<Scalars['String']['input']>;
  advisoryURLContains?: InputMaybe<Scalars['String']['input']>;
  advisoryURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  advisoryURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  advisoryURLGT?: InputMaybe<Scalars['String']['input']>;
  advisoryURLGTE?: InputMaybe<Scalars['String']['input']>;
  advisoryURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  advisoryURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  advisoryURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  advisoryURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  advisoryURLLT?: InputMaybe<Scalars['String']['input']>;
  advisoryURLLTE?: InputMaybe<Scalars['String']['input']>;
  advisoryURLNEQ?: InputMaybe<Scalars['String']['input']>;
  advisoryURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  advisoryURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<CpenvdWhereInput>>;
  /** cpe field predicates */
  cpe?: InputMaybe<Scalars['String']['input']>;
  cpeContains?: InputMaybe<Scalars['String']['input']>;
  cpeContainsFold?: InputMaybe<Scalars['String']['input']>;
  cpeEqualFold?: InputMaybe<Scalars['String']['input']>;
  cpeGT?: InputMaybe<Scalars['String']['input']>;
  cpeGTE?: InputMaybe<Scalars['String']['input']>;
  cpeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cpeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cpeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpeLT?: InputMaybe<Scalars['String']['input']>;
  cpeLTE?: InputMaybe<Scalars['String']['input']>;
  cpeNEQ?: InputMaybe<Scalars['String']['input']>;
  cpeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deprecated_by field predicates */
  deprecatedBy?: InputMaybe<Scalars['String']['input']>;
  deprecatedByContains?: InputMaybe<Scalars['String']['input']>;
  deprecatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deprecatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deprecatedByGT?: InputMaybe<Scalars['String']['input']>;
  deprecatedByGTE?: InputMaybe<Scalars['String']['input']>;
  deprecatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deprecatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deprecatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deprecatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedByLT?: InputMaybe<Scalars['String']['input']>;
  deprecatedByLTE?: InputMaybe<Scalars['String']['input']>;
  deprecatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deprecatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deprecatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_deprecated field predicates */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecatedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_update_date field predicates */
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<CpenvdWhereInput>;
  or?: InputMaybe<Array<CpenvdWhereInput>>;
  /** publish_date field predicates */
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  publishDateGT?: InputMaybe<Scalars['Time']['input']>;
  publishDateGTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateLT?: InputMaybe<Scalars['Time']['input']>;
  publishDateLTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  publishDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vendor field predicates */
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendorContains?: InputMaybe<Scalars['String']['input']>;
  vendorContainsFold?: InputMaybe<Scalars['String']['input']>;
  vendorEqualFold?: InputMaybe<Scalars['String']['input']>;
  vendorGT?: InputMaybe<Scalars['String']['input']>;
  vendorGTE?: InputMaybe<Scalars['String']['input']>;
  vendorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vendorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vendorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorLT?: InputMaybe<Scalars['String']['input']>;
  vendorLTE?: InputMaybe<Scalars['String']['input']>;
  vendorNEQ?: InputMaybe<Scalars['String']['input']>;
  vendorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Cra = {
  __typename?: 'CRA';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isApplicable?: Maybe<Scalars['Boolean']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  justification?: Maybe<Scalars['String']['output']>;
  project: Project;
  type: CraType;
  updateTime: Scalars['Time']['output'];
  /**  so called: evidences  */
  uploads: Array<CraUpload>;
};

export type CraCybersecRiskAssessment = {
  __typename?: 'CRACybersecRiskAssessment';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  updateTime: Scalars['Time']['output'];
  uploads: Array<CraCybersecRiskAssessmentUpload>;
};

export type CraCybersecRiskAssessmentUpload = {
  __typename?: 'CRACybersecRiskAssessmentUpload';
  completeness: CraCybersecRiskAssessmentUploadCompleteness;
  craCybersecRiskAssessment: CraCybersecRiskAssessment;
  createTime: Scalars['Time']['output'];
  fileAsset: FileAsset;
  id: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
};

export enum CraCybersecRiskAssessmentUploadCompleteness {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

/**
 * CRACybersecRiskAssessmentUploadWhereInput is used for filtering CRACybersecRiskAssessmentUpload objects.
 * Input was generated by ent.
 */
export type CraCybersecRiskAssessmentUploadWhereInput = {
  and?: InputMaybe<Array<CraCybersecRiskAssessmentUploadWhereInput>>;
  /** completeness field predicates */
  completeness?: InputMaybe<CraCybersecRiskAssessmentUploadCompleteness>;
  completenessIn?: InputMaybe<Array<CraCybersecRiskAssessmentUploadCompleteness>>;
  completenessNEQ?: InputMaybe<CraCybersecRiskAssessmentUploadCompleteness>;
  completenessNotIn?: InputMaybe<Array<CraCybersecRiskAssessmentUploadCompleteness>>;
  /** cra_cybersec_risk_assessment_id field predicates */
  craCybersecRiskAssessmentID?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDContains?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDGT?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craCybersecRiskAssessmentIDLT?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craCybersecRiskAssessmentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** cra_cybersec_risk_assessment edge predicates */
  hasCraCybersecRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraCybersecRiskAssessmentWith?: InputMaybe<Array<CraCybersecRiskAssessmentWhereInput>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CraCybersecRiskAssessmentUploadWhereInput>;
  or?: InputMaybe<Array<CraCybersecRiskAssessmentUploadWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * CRACybersecRiskAssessmentWhereInput is used for filtering CRACybersecRiskAssessment objects.
 * Input was generated by ent.
 */
export type CraCybersecRiskAssessmentWhereInput = {
  and?: InputMaybe<Array<CraCybersecRiskAssessmentWhereInput>>;
  /** cra_id field predicates */
  craID?: InputMaybe<Scalars['ID']['input']>;
  craIDContains?: InputMaybe<Scalars['ID']['input']>;
  craIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craIDGT?: InputMaybe<Scalars['ID']['input']>;
  craIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craIDLT?: InputMaybe<Scalars['ID']['input']>;
  craIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cra edge predicates */
  hasCra?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraWith?: InputMaybe<Array<CraWhereInput>>;
  /** uploads edge predicates */
  hasUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasUploadsWith?: InputMaybe<Array<CraCybersecRiskAssessmentUploadWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_completed field predicates */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CraCybersecRiskAssessmentWhereInput>;
  or?: InputMaybe<Array<CraCybersecRiskAssessmentWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type CraDocumentation = {
  __typename?: 'CRADocumentation';
  cra: Cra;
  createTime: Scalars['Time']['output'];
  hasIntendedPurpose: Scalars['Boolean']['output'];
  hasProcessReference: Scalars['Boolean']['output'];
  hasProductVisual: Scalars['Boolean']['output'];
  hasRefDocuments: Scalars['Boolean']['output'];
  hasSecDesignArchitecture: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  updateTime: Scalars['Time']['output'];
  uploads: Array<CraDocumentationUpload>;
};

export type CraDocumentationUpload = {
  __typename?: 'CRADocumentationUpload';
  category: CraDocumentationUploadCategory;
  craDocumentation: CraDocumentation;
  createTime: Scalars['Time']['output'];
  createdBy: User;
  fileAsset?: Maybe<FileAsset>;
  id: Scalars['ID']['output'];
  kind: CraDocumentationUploadKind;
  link?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['Time']['output'];
};

export enum CraDocumentationUploadCategory {
  IntendedPurpose = 'INTENDED_PURPOSE',
  ProcessReference = 'PROCESS_REFERENCE',
  ProductVisual = 'PRODUCT_VISUAL',
  ReferenceDocuments = 'REFERENCE_DOCUMENTS',
  SecurityDesignArchitecture = 'SECURITY_DESIGN_ARCHITECTURE'
}

export enum CraDocumentationUploadKind {
  File = 'FILE',
  Link = 'LINK'
}

/**
 * CRADocumentationUploadWhereInput is used for filtering CRADocumentationUpload objects.
 * Input was generated by ent.
 */
export type CraDocumentationUploadWhereInput = {
  and?: InputMaybe<Array<CraDocumentationUploadWhereInput>>;
  /** category field predicates */
  category?: InputMaybe<CraDocumentationUploadCategory>;
  categoryIn?: InputMaybe<Array<CraDocumentationUploadCategory>>;
  categoryNEQ?: InputMaybe<CraDocumentationUploadCategory>;
  categoryNotIn?: InputMaybe<Array<CraDocumentationUploadCategory>>;
  /** cra_documentation_id field predicates */
  craDocumentationID?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDContains?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDGT?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craDocumentationIDLT?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craDocumentationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContains?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDLT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDLTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cra_documentation edge predicates */
  hasCraDocumentation?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraDocumentationWith?: InputMaybe<Array<CraDocumentationWhereInput>>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<CraDocumentationUploadKind>;
  kindIn?: InputMaybe<Array<CraDocumentationUploadKind>>;
  kindNEQ?: InputMaybe<CraDocumentationUploadKind>;
  kindNotIn?: InputMaybe<Array<CraDocumentationUploadKind>>;
  /** link field predicates */
  link?: InputMaybe<Scalars['String']['input']>;
  linkContains?: InputMaybe<Scalars['String']['input']>;
  linkContainsFold?: InputMaybe<Scalars['String']['input']>;
  linkEqualFold?: InputMaybe<Scalars['String']['input']>;
  linkGT?: InputMaybe<Scalars['String']['input']>;
  linkGTE?: InputMaybe<Scalars['String']['input']>;
  linkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  linkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  linkIn?: InputMaybe<Array<Scalars['String']['input']>>;
  linkIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  linkLT?: InputMaybe<Scalars['String']['input']>;
  linkLTE?: InputMaybe<Scalars['String']['input']>;
  linkNEQ?: InputMaybe<Scalars['String']['input']>;
  linkNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  linkNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CraDocumentationUploadWhereInput>;
  or?: InputMaybe<Array<CraDocumentationUploadWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * CRADocumentationWhereInput is used for filtering CRADocumentation objects.
 * Input was generated by ent.
 */
export type CraDocumentationWhereInput = {
  and?: InputMaybe<Array<CraDocumentationWhereInput>>;
  /** cra_id field predicates */
  craID?: InputMaybe<Scalars['ID']['input']>;
  craIDContains?: InputMaybe<Scalars['ID']['input']>;
  craIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craIDGT?: InputMaybe<Scalars['ID']['input']>;
  craIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craIDLT?: InputMaybe<Scalars['ID']['input']>;
  craIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cra edge predicates */
  hasCra?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraWith?: InputMaybe<Array<CraWhereInput>>;
  /** has_intended_purpose field predicates */
  hasIntendedPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntendedPurposeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_process_reference field predicates */
  hasProcessReference?: InputMaybe<Scalars['Boolean']['input']>;
  hasProcessReferenceNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_product_visual field predicates */
  hasProductVisual?: InputMaybe<Scalars['Boolean']['input']>;
  hasProductVisualNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_ref_documents field predicates */
  hasRefDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefDocumentsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_sec_design_architecture field predicates */
  hasSecDesignArchitecture?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecDesignArchitectureNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** uploads edge predicates */
  hasUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasUploadsWith?: InputMaybe<Array<CraDocumentationUploadWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_completed field predicates */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CraDocumentationWhereInput>;
  or?: InputMaybe<Array<CraDocumentationWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type CraGeneral = {
  __typename?: 'CRAGeneral';
  ProductCategory?: Maybe<CraGeneralProductCategory>;
  ProductVersion?: Maybe<Scalars['String']['output']>;
  cra: Cra;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  productLifetime?: Maybe<Scalars['Int']['output']>;
  productLifetimeEndDate?: Maybe<Scalars['Time']['output']>;
  productLifetimeStartDate?: Maybe<Scalars['Time']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectManager?: Maybe<User>;
  securityResponsible?: Maybe<User>;
  supportPeriod?: Maybe<Scalars['Int']['output']>;
  supportPeriodEndDate?: Maybe<Scalars['Time']['output']>;
  supportPeriodInformation?: Maybe<Scalars['String']['output']>;
  supportPeriodStartDate?: Maybe<Scalars['Time']['output']>;
  updateTime: Scalars['Time']['output'];
};

export enum CraGeneralProductCategory {
  CriticalProduct = 'CRITICAL_PRODUCT',
  DefaultProduct = 'DEFAULT_PRODUCT',
  ImportantProductClassI = 'IMPORTANT_PRODUCT_CLASS_I',
  ImportantProductClassIi = 'IMPORTANT_PRODUCT_CLASS_II'
}

/**
 * CRAGeneralWhereInput is used for filtering CRAGeneral objects.
 * Input was generated by ent.
 */
export type CraGeneralWhereInput = {
  and?: InputMaybe<Array<CraGeneralWhereInput>>;
  /** cra_id field predicates */
  craID?: InputMaybe<Scalars['ID']['input']>;
  craIDContains?: InputMaybe<Scalars['ID']['input']>;
  craIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craIDGT?: InputMaybe<Scalars['ID']['input']>;
  craIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craIDLT?: InputMaybe<Scalars['ID']['input']>;
  craIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cra edge predicates */
  hasCra?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraWith?: InputMaybe<Array<CraWhereInput>>;
  /** project_manager edge predicates */
  hasProjectManager?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectManagerWith?: InputMaybe<Array<UserWhereInput>>;
  /** security_responsible edge predicates */
  hasSecurityResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecurityResponsibleWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_completed field predicates */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CraGeneralWhereInput>;
  or?: InputMaybe<Array<CraGeneralWhereInput>>;
  /** product_category field predicates */
  productCategory?: InputMaybe<CraGeneralProductCategory>;
  productCategoryIn?: InputMaybe<Array<CraGeneralProductCategory>>;
  productCategoryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryNEQ?: InputMaybe<CraGeneralProductCategory>;
  productCategoryNotIn?: InputMaybe<Array<CraGeneralProductCategory>>;
  productCategoryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** product_lifetime field predicates */
  productLifetime?: InputMaybe<Scalars['Int']['input']>;
  /** product_lifetime_end_date field predicates */
  productLifetimeEndDate?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeEndDateGT?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeEndDateGTE?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeEndDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  productLifetimeEndDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productLifetimeEndDateLT?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeEndDateLTE?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeEndDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeEndDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  productLifetimeEndDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  productLifetimeGT?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeGTE?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  productLifetimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productLifetimeLT?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeLTE?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeNEQ?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  productLifetimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** product_lifetime_start_date field predicates */
  productLifetimeStartDate?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDateGT?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDateGTE?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  productLifetimeStartDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productLifetimeStartDateLT?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDateLTE?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  productLifetimeStartDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** product_name field predicates */
  productName?: InputMaybe<Scalars['String']['input']>;
  productNameContains?: InputMaybe<Scalars['String']['input']>;
  productNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  productNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  productNameGT?: InputMaybe<Scalars['String']['input']>;
  productNameGTE?: InputMaybe<Scalars['String']['input']>;
  productNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  productNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  productNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productNameLT?: InputMaybe<Scalars['String']['input']>;
  productNameLTE?: InputMaybe<Scalars['String']['input']>;
  productNameNEQ?: InputMaybe<Scalars['String']['input']>;
  productNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** product_version field predicates */
  productVersion?: InputMaybe<Scalars['String']['input']>;
  productVersionContains?: InputMaybe<Scalars['String']['input']>;
  productVersionContainsFold?: InputMaybe<Scalars['String']['input']>;
  productVersionEqualFold?: InputMaybe<Scalars['String']['input']>;
  productVersionGT?: InputMaybe<Scalars['String']['input']>;
  productVersionGTE?: InputMaybe<Scalars['String']['input']>;
  productVersionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  productVersionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  productVersionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productVersionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productVersionLT?: InputMaybe<Scalars['String']['input']>;
  productVersionLTE?: InputMaybe<Scalars['String']['input']>;
  productVersionNEQ?: InputMaybe<Scalars['String']['input']>;
  productVersionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productVersionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_manager_user_id field predicates */
  projectManagerUserID?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectManagerUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectManagerUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectManagerUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectManagerUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_responsible_user_id field predicates */
  securityResponsibleUserID?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDContains?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityResponsibleUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityResponsibleUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityResponsibleUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** support_period field predicates */
  supportPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** support_period_end_date field predicates */
  supportPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodEndDateGT?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodEndDateGTE?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodEndDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  supportPeriodEndDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supportPeriodEndDateLT?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodEndDateLTE?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodEndDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodEndDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  supportPeriodEndDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  supportPeriodGT?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodGTE?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** support_period_information field predicates */
  supportPeriodInformation?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationContains?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationContainsFold?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationEqualFold?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationGT?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationGTE?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supportPeriodInformationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supportPeriodInformationLT?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationLTE?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationNEQ?: InputMaybe<Scalars['String']['input']>;
  supportPeriodInformationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supportPeriodInformationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  supportPeriodIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supportPeriodLT?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodLTE?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodNEQ?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  supportPeriodNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** support_period_start_date field predicates */
  supportPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodStartDateGT?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodStartDateGTE?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodStartDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  supportPeriodStartDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supportPeriodStartDateLT?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodStartDateLTE?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodStartDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodStartDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  supportPeriodStartDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type CraModuleComment = {
  __typename?: 'CRAModuleComment';
  action: CraModuleCommentAction;
  content: Scalars['String']['output'];
  craRefID: Scalars['ID']['output'];
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
  user: User;
};

export enum CraModuleCommentAction {
  Complete = 'COMPLETE',
  Delete = 'DELETE',
  Incomplete = 'INCOMPLETE',
  Save = 'SAVE',
  Upload = 'UPLOAD'
}

/**
 * CRAModuleCommentWhereInput is used for filtering CRAModuleComment objects.
 * Input was generated by ent.
 */
export type CraModuleCommentWhereInput = {
  /** action field predicates */
  action?: InputMaybe<CraModuleCommentAction>;
  actionIn?: InputMaybe<Array<CraModuleCommentAction>>;
  actionNEQ?: InputMaybe<CraModuleCommentAction>;
  actionNotIn?: InputMaybe<Array<CraModuleCommentAction>>;
  and?: InputMaybe<Array<CraModuleCommentWhereInput>>;
  /** content field predicates */
  content?: InputMaybe<Scalars['String']['input']>;
  contentContains?: InputMaybe<Scalars['String']['input']>;
  contentContainsFold?: InputMaybe<Scalars['String']['input']>;
  contentEqualFold?: InputMaybe<Scalars['String']['input']>;
  contentGT?: InputMaybe<Scalars['String']['input']>;
  contentGTE?: InputMaybe<Scalars['String']['input']>;
  contentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentLT?: InputMaybe<Scalars['String']['input']>;
  contentLTE?: InputMaybe<Scalars['String']['input']>;
  contentNEQ?: InputMaybe<Scalars['String']['input']>;
  contentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** cra_ref_id field predicates */
  craRefID?: InputMaybe<Scalars['ID']['input']>;
  craRefIDContains?: InputMaybe<Scalars['ID']['input']>;
  craRefIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craRefIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craRefIDGT?: InputMaybe<Scalars['ID']['input']>;
  craRefIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craRefIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craRefIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craRefIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craRefIDLT?: InputMaybe<Scalars['ID']['input']>;
  craRefIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craRefIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craRefIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CraModuleCommentWhereInput>;
  or?: InputMaybe<Array<CraModuleCommentWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum CraType {
  CraEu = 'CRA_EU'
}

export type CraUpload = {
  __typename?: 'CRAUpload';
  cra: Cra;
  createTime: Scalars['Time']['output'];
  fileAsset: FileAsset;
  id: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
};

export type CraUploadDeleteResult = {
  __typename?: 'CRAUploadDeleteResult';
  cra: Cra;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
};

/**
 * CRAUploadWhereInput is used for filtering CRAUpload objects.
 * Input was generated by ent.
 */
export type CraUploadWhereInput = {
  and?: InputMaybe<Array<CraUploadWhereInput>>;
  /** cra_id field predicates */
  craID?: InputMaybe<Scalars['ID']['input']>;
  craIDContains?: InputMaybe<Scalars['ID']['input']>;
  craIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craIDGT?: InputMaybe<Scalars['ID']['input']>;
  craIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craIDLT?: InputMaybe<Scalars['ID']['input']>;
  craIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** cra edge predicates */
  hasCra?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraWith?: InputMaybe<Array<CraWhereInput>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CraUploadWhereInput>;
  or?: InputMaybe<Array<CraUploadWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type CraVulnerabilityHandling = {
  __typename?: 'CRAVulnerabilityHandling';
  IsCompleted: Scalars['Boolean']['output'];
  cra: Cra;
  createTime: Scalars['Time']['output'];
  customerContact?: Maybe<Scalars['String']['output']>;
  customerContactValidationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  seContact?: Maybe<Scalars['String']['output']>;
  seContactValidationDate?: Maybe<Scalars['Time']['output']>;
  updateTime: Scalars['Time']['output'];
  /**  so called: evidences  */
  uploads: Array<CraVulnerabilityHandlingUpload>;
};

export type CraVulnerabilityHandlingUpload = {
  __typename?: 'CRAVulnerabilityHandlingUpload';
  craVulnerabilityHandling: CraVulnerabilityHandling;
  createTime: Scalars['Time']['output'];
  fileAsset: FileAsset;
  id: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
};

/**
 * CRAVulnerabilityHandlingUploadWhereInput is used for filtering CRAVulnerabilityHandlingUpload objects.
 * Input was generated by ent.
 */
export type CraVulnerabilityHandlingUploadWhereInput = {
  and?: InputMaybe<Array<CraVulnerabilityHandlingUploadWhereInput>>;
  /** cra_vulnerability_handling_id field predicates */
  craVulnerabilityHandlingID?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDContains?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDGT?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craVulnerabilityHandlingIDLT?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craVulnerabilityHandlingIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** cra_vulnerability_handling edge predicates */
  hasCraVulnerabilityHandling?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraVulnerabilityHandlingWith?: InputMaybe<Array<CraVulnerabilityHandlingWhereInput>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CraVulnerabilityHandlingUploadWhereInput>;
  or?: InputMaybe<Array<CraVulnerabilityHandlingUploadWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * CRAVulnerabilityHandlingWhereInput is used for filtering CRAVulnerabilityHandling objects.
 * Input was generated by ent.
 */
export type CraVulnerabilityHandlingWhereInput = {
  and?: InputMaybe<Array<CraVulnerabilityHandlingWhereInput>>;
  /** cra_id field predicates */
  craID?: InputMaybe<Scalars['ID']['input']>;
  craIDContains?: InputMaybe<Scalars['ID']['input']>;
  craIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  craIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  craIDGT?: InputMaybe<Scalars['ID']['input']>;
  craIDGTE?: InputMaybe<Scalars['ID']['input']>;
  craIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  craIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  craIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  craIDLT?: InputMaybe<Scalars['ID']['input']>;
  craIDLTE?: InputMaybe<Scalars['ID']['input']>;
  craIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  craIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** customer_contact field predicates */
  customerContact?: InputMaybe<Scalars['String']['input']>;
  customerContactContains?: InputMaybe<Scalars['String']['input']>;
  customerContactContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerContactEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerContactGT?: InputMaybe<Scalars['String']['input']>;
  customerContactGTE?: InputMaybe<Scalars['String']['input']>;
  customerContactHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerContactHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerContactIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerContactIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerContactLT?: InputMaybe<Scalars['String']['input']>;
  customerContactLTE?: InputMaybe<Scalars['String']['input']>;
  customerContactNEQ?: InputMaybe<Scalars['String']['input']>;
  customerContactNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerContactNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_contact_validation_date field predicates */
  customerContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
  customerContactValidationDateGT?: InputMaybe<Scalars['Time']['input']>;
  customerContactValidationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  customerContactValidationDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  customerContactValidationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerContactValidationDateLT?: InputMaybe<Scalars['Time']['input']>;
  customerContactValidationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  customerContactValidationDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  customerContactValidationDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  customerContactValidationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cra edge predicates */
  hasCra?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraWith?: InputMaybe<Array<CraWhereInput>>;
  /** uploads edge predicates */
  hasUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasUploadsWith?: InputMaybe<Array<CraVulnerabilityHandlingUploadWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_completed field predicates */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CraVulnerabilityHandlingWhereInput>;
  or?: InputMaybe<Array<CraVulnerabilityHandlingWhereInput>>;
  /** se_contact field predicates */
  seContact?: InputMaybe<Scalars['String']['input']>;
  seContactContains?: InputMaybe<Scalars['String']['input']>;
  seContactContainsFold?: InputMaybe<Scalars['String']['input']>;
  seContactEqualFold?: InputMaybe<Scalars['String']['input']>;
  seContactGT?: InputMaybe<Scalars['String']['input']>;
  seContactGTE?: InputMaybe<Scalars['String']['input']>;
  seContactHasPrefix?: InputMaybe<Scalars['String']['input']>;
  seContactHasSuffix?: InputMaybe<Scalars['String']['input']>;
  seContactIn?: InputMaybe<Array<Scalars['String']['input']>>;
  seContactIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  seContactLT?: InputMaybe<Scalars['String']['input']>;
  seContactLTE?: InputMaybe<Scalars['String']['input']>;
  seContactNEQ?: InputMaybe<Scalars['String']['input']>;
  seContactNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  seContactNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** se_contact_validation_date field predicates */
  seContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
  seContactValidationDateGT?: InputMaybe<Scalars['Time']['input']>;
  seContactValidationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  seContactValidationDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  seContactValidationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  seContactValidationDateLT?: InputMaybe<Scalars['Time']['input']>;
  seContactValidationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  seContactValidationDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  seContactValidationDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  seContactValidationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * CRAWhereInput is used for filtering CRA objects.
 * Input was generated by ent.
 */
export type CraWhereInput = {
  and?: InputMaybe<Array<CraWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** uploads edge predicates */
  hasUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasUploadsWith?: InputMaybe<Array<CraUploadWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_applicable field predicates */
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicableIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicableNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicableNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_completed field predicates */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** justification field predicates */
  justification?: InputMaybe<Scalars['String']['input']>;
  justificationContains?: InputMaybe<Scalars['String']['input']>;
  justificationContainsFold?: InputMaybe<Scalars['String']['input']>;
  justificationEqualFold?: InputMaybe<Scalars['String']['input']>;
  justificationGT?: InputMaybe<Scalars['String']['input']>;
  justificationGTE?: InputMaybe<Scalars['String']['input']>;
  justificationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  justificationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  justificationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  justificationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  justificationLT?: InputMaybe<Scalars['String']['input']>;
  justificationLTE?: InputMaybe<Scalars['String']['input']>;
  justificationNEQ?: InputMaybe<Scalars['String']['input']>;
  justificationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  justificationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CraWhereInput>;
  or?: InputMaybe<Array<CraWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<CraType>;
  typeIn?: InputMaybe<Array<CraType>>;
  typeNEQ?: InputMaybe<CraType>;
  typeNotIn?: InputMaybe<Array<CraType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Cvss = {
  score: Scalars['Float']['output'];
  vector: Scalars['String']['output'];
};

export type Cvss20 = Cvss & {
  __typename?: 'CVSS20';
  baseScore: Scalars['Float']['output'];
  environmentalScore: Scalars['Float']['output'];
  exploitability: Scalars['Float']['output'];
  impact: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  temporalScore: Scalars['Float']['output'];
  vector: Scalars['String']['output'];
};

export type Cvss20Input = {
  a?: InputMaybe<Cvss20_A>;
  ac?: InputMaybe<Cvss20_Ac>;
  ar?: InputMaybe<Cvss20_Ar>;
  au?: InputMaybe<Cvss20_Au>;
  av?: InputMaybe<Cvss20_Av>;
  c?: InputMaybe<Cvss20_C>;
  cdp?: InputMaybe<Cvss20_Cdp>;
  cr?: InputMaybe<Cvss20_Cr>;
  e?: InputMaybe<Cvss20_E>;
  i?: InputMaybe<Cvss20_I>;
  ir?: InputMaybe<Cvss20_Ir>;
  rc?: InputMaybe<Cvss20_Rc>;
  rl?: InputMaybe<Cvss20_Rl>;
  td?: InputMaybe<Cvss20_Td>;
};

export enum Cvss20_A {
  C = 'C',
  N = 'N',
  P = 'P'
}

export enum Cvss20_Ac {
  H = 'H',
  L = 'L',
  M = 'M'
}

export enum Cvss20_Ar {
  H = 'H',
  L = 'L',
  M = 'M',
  Nd = 'ND'
}

export enum Cvss20_Au {
  M = 'M',
  N = 'N',
  S = 'S'
}

export enum Cvss20_Av {
  A = 'A',
  L = 'L',
  N = 'N'
}

export enum Cvss20_C {
  C = 'C',
  N = 'N',
  P = 'P'
}

export enum Cvss20_Cdp {
  H = 'H',
  L = 'L',
  Lm = 'LM',
  Mh = 'MH',
  N = 'N',
  Nd = 'ND'
}

export enum Cvss20_Cr {
  H = 'H',
  L = 'L',
  M = 'M',
  Nd = 'ND'
}

export enum Cvss20_E {
  F = 'F',
  H = 'H',
  Nd = 'ND',
  Poc = 'POC',
  U = 'U'
}

export enum Cvss20_I {
  C = 'C',
  N = 'N',
  P = 'P'
}

export enum Cvss20_Ir {
  H = 'H',
  L = 'L',
  M = 'M',
  Nd = 'ND'
}

export enum Cvss20_Rc {
  C = 'C',
  Nd = 'ND',
  Uc = 'UC',
  Ur = 'UR'
}

export enum Cvss20_Rl {
  Nd = 'ND',
  Of = 'OF',
  Tf = 'TF',
  U = 'U',
  W = 'W'
}

export enum Cvss20_Td {
  H = 'H',
  L = 'L',
  M = 'M',
  N = 'N',
  Nd = 'ND'
}

export type Cvss30 = Cvss & {
  __typename?: 'CVSS30';
  baseScore: Scalars['Float']['output'];
  environmentalScore: Scalars['Float']['output'];
  exploitability: Scalars['Float']['output'];
  impact: Scalars['Float']['output'];
  rating: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  temporalScore: Scalars['Float']['output'];
  vector: Scalars['String']['output'];
};

export type Cvss30Input = {
  a?: InputMaybe<Cvss30_A>;
  ac?: InputMaybe<Cvss30_Ac>;
  ar?: InputMaybe<Cvss30_Ar>;
  av?: InputMaybe<Cvss30_Av>;
  c?: InputMaybe<Cvss30_C>;
  cr?: InputMaybe<Cvss30_Cr>;
  e?: InputMaybe<Cvss30_E>;
  i?: InputMaybe<Cvss30_I>;
  ir?: InputMaybe<Cvss30_Ir>;
  ma?: InputMaybe<Cvss30_Ma>;
  mac?: InputMaybe<Cvss30_Mac>;
  mav?: InputMaybe<Cvss30_Mav>;
  mc?: InputMaybe<Cvss30_Mc>;
  mi?: InputMaybe<Cvss30_Mi>;
  mpr?: InputMaybe<Cvss30_Mpr>;
  ms?: InputMaybe<Cvss30_Ms>;
  mui?: InputMaybe<Cvss30_Mui>;
  pr?: InputMaybe<Cvss30_Pr>;
  rc?: InputMaybe<Cvss30_Rc>;
  rl?: InputMaybe<Cvss30_Rl>;
  s?: InputMaybe<Cvss30_S>;
  ui?: InputMaybe<Cvss30_Ui>;
};

export enum Cvss30_A {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum Cvss30_Ac {
  H = 'H',
  L = 'L'
}

export enum Cvss30_Ar {
  H = 'H',
  L = 'L',
  M = 'M',
  X = 'X'
}

export enum Cvss30_Av {
  A = 'A',
  L = 'L',
  N = 'N',
  P = 'P'
}

export enum Cvss30_C {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum Cvss30_Cr {
  H = 'H',
  L = 'L',
  M = 'M',
  X = 'X'
}

export enum Cvss30_E {
  F = 'F',
  H = 'H',
  P = 'P',
  U = 'U',
  X = 'X'
}

export enum Cvss30_I {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum Cvss30_Ir {
  H = 'H',
  L = 'L',
  M = 'M',
  X = 'X'
}

export enum Cvss30_Ma {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss30_Mac {
  H = 'H',
  L = 'L',
  X = 'X'
}

export enum Cvss30_Mav {
  A = 'A',
  L = 'L',
  N = 'N',
  P = 'P',
  X = 'X'
}

export enum Cvss30_Mc {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss30_Mi {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss30_Mpr {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss30_Ms {
  C = 'C',
  U = 'U',
  X = 'X'
}

export enum Cvss30_Mui {
  N = 'N',
  R = 'R',
  X = 'X'
}

export enum Cvss30_Pr {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum Cvss30_Rc {
  C = 'C',
  R = 'R',
  U = 'U',
  X = 'X'
}

export enum Cvss30_Rl {
  O = 'O',
  T = 'T',
  U = 'U',
  W = 'W',
  X = 'X'
}

export enum Cvss30_S {
  C = 'C',
  U = 'U'
}

export enum Cvss30_Ui {
  N = 'N',
  R = 'R'
}

export type Cvss40 = Cvss & {
  __typename?: 'CVSS40';
  nomenclature: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  vector: Scalars['String']['output'];
};

export type Cvss40Input = {
  ac?: InputMaybe<Cvss40_Ac>;
  ar?: InputMaybe<Cvss40_Cia_R>;
  at?: InputMaybe<Cvss40_At>;
  au?: InputMaybe<Cvss40_Au>;
  av?: InputMaybe<Cvss40_Av>;
  cr?: InputMaybe<Cvss40_Cia_R>;
  e?: InputMaybe<Cvss40_E>;
  ir?: InputMaybe<Cvss40_Cia_R>;
  mac?: InputMaybe<Cvss40_Mac>;
  mat?: InputMaybe<Cvss40_Mat>;
  mav?: InputMaybe<Cvss40_Mav>;
  mpr?: InputMaybe<Cvss40_Mpr>;
  msa?: InputMaybe<Cvss40_Mscia>;
  msc?: InputMaybe<Cvss40_Mscia>;
  msi?: InputMaybe<Cvss40_Mscia>;
  mui?: InputMaybe<Cvss40_Mui>;
  mva?: InputMaybe<Cvss40_Mvcia>;
  mvc?: InputMaybe<Cvss40_Mvcia>;
  mvi?: InputMaybe<Cvss40_Mvcia>;
  pr?: InputMaybe<Cvss40_Pr>;
  r?: InputMaybe<Cvss40_R>;
  re?: InputMaybe<Cvss40_Re>;
  s?: InputMaybe<Cvss40_S>;
  sa?: InputMaybe<Cvss40_Sc>;
  sc?: InputMaybe<Cvss40_Sc>;
  si?: InputMaybe<Cvss40_Sc>;
  u?: InputMaybe<Cvss40_U>;
  ui?: InputMaybe<Cvss40_Ui>;
  v?: InputMaybe<Cvss40_V>;
  va?: InputMaybe<Cvss40_Vcia>;
  vc?: InputMaybe<Cvss40_Vcia>;
  vi?: InputMaybe<Cvss40_Vcia>;
};

export enum Cvss40_Ac {
  H = 'H',
  L = 'L'
}

export enum Cvss40_At {
  N = 'N',
  P = 'P'
}

export enum Cvss40_Au {
  N = 'N',
  X = 'X',
  Y = 'Y'
}

export enum Cvss40_Av {
  A = 'A',
  L = 'L',
  N = 'N',
  P = 'P'
}

export enum Cvss40_Cia_R {
  H = 'H',
  L = 'L',
  M = 'M',
  X = 'X'
}

export enum Cvss40_E {
  A = 'A',
  P = 'P',
  U = 'U',
  X = 'X'
}

export enum Cvss40_Mac {
  H = 'H',
  L = 'L',
  X = 'X'
}

export enum Cvss40_Mat {
  N = 'N',
  P = 'P',
  X = 'X'
}

export enum Cvss40_Mav {
  A = 'A',
  L = 'L',
  N = 'N',
  P = 'P',
  X = 'X'
}

export enum Cvss40_Mpr {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss40_Mscia {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss40_Mui {
  A = 'A',
  N = 'N',
  P = 'P',
  X = 'X'
}

export enum Cvss40_Mvcia {
  H = 'H',
  L = 'L',
  N = 'N',
  X = 'X'
}

export enum Cvss40_Pr {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum Cvss40_R {
  A = 'A',
  I = 'I',
  U = 'U',
  X = 'X'
}

export enum Cvss40_Re {
  H = 'H',
  L = 'L',
  M = 'M',
  X = 'X'
}

export enum Cvss40_S {
  N = 'N',
  P = 'P',
  X = 'X'
}

export enum Cvss40_Sc {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum Cvss40_U {
  Amber = 'Amber',
  Clear = 'Clear',
  Green = 'Green',
  Red = 'Red',
  X = 'X'
}

export enum Cvss40_Ui {
  A = 'A',
  N = 'N',
  P = 'P'
}

export enum Cvss40_V {
  C = 'C',
  D = 'D',
  X = 'X'
}

export enum Cvss40_Vcia {
  H = 'H',
  L = 'L',
  N = 'N'
}

export enum CvssOverridesType {
  Global = 'GLOBAL',
  Local = 'LOCAL'
}

/**
 * CVSSOverridesWhereInput is used for filtering CVSSOverrides objects.
 * Input was generated by ent.
 */
export type CvssOverridesWhereInput = {
  and?: InputMaybe<Array<CvssOverridesWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cvss_id field predicates */
  cvssID?: InputMaybe<Scalars['ID']['input']>;
  cvssIDContains?: InputMaybe<Scalars['ID']['input']>;
  cvssIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  cvssIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  cvssIDGT?: InputMaybe<Scalars['ID']['input']>;
  cvssIDGTE?: InputMaybe<Scalars['ID']['input']>;
  cvssIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  cvssIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  cvssIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  cvssIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cvssIDLT?: InputMaybe<Scalars['ID']['input']>;
  cvssIDLTE?: InputMaybe<Scalars['ID']['input']>;
  cvssIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  cvssIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  cvssIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cvss_vector field predicates */
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cvssVectorContains?: InputMaybe<Scalars['String']['input']>;
  cvssVectorContainsFold?: InputMaybe<Scalars['String']['input']>;
  cvssVectorEqualFold?: InputMaybe<Scalars['String']['input']>;
  cvssVectorGT?: InputMaybe<Scalars['String']['input']>;
  cvssVectorGTE?: InputMaybe<Scalars['String']['input']>;
  cvssVectorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cvssVectorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cvssVectorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cvssVectorLT?: InputMaybe<Scalars['String']['input']>;
  cvssVectorLTE?: InputMaybe<Scalars['String']['input']>;
  cvssVectorNEQ?: InputMaybe<Scalars['String']['input']>;
  cvssVectorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** cvss edge predicates */
  hasCvss?: InputMaybe<Scalars['Boolean']['input']>;
  hasCvssWith?: InputMaybe<Array<CvssWhereInput>>;
  /** notification edge predicates */
  hasNotification?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationWith?: InputMaybe<Array<NotificationWhereInput>>;
  /** project_zone edge predicates */
  hasProjectZone?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneWith?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CvssOverridesWhereInput>;
  /** notification_id field predicates */
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<CvssOverridesWhereInput>>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  type?: InputMaybe<CvssOverridesType>;
  typeIn?: InputMaybe<Array<CvssOverridesType>>;
  typeNEQ?: InputMaybe<CvssOverridesType>;
  typeNotIn?: InputMaybe<Array<CvssOverridesType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * CVSSWhereInput is used for filtering CVSS objects.
 * Input was generated by ent.
 */
export type CvssWhereInput = {
  and?: InputMaybe<Array<CvssWhereInput>>;
  /** cvss_overrides edge predicates */
  hasCvssOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasCvssOverridesWith?: InputMaybe<Array<CvssOverridesWhereInput>>;
  /** notifications edge predicates */
  hasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationsWith?: InputMaybe<Array<NotificationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CvssWhereInput>;
  or?: InputMaybe<Array<CvssWhereInput>>;
  /** score field predicates */
  score?: InputMaybe<Scalars['Float']['input']>;
  scoreGT?: InputMaybe<Scalars['Float']['input']>;
  scoreGTE?: InputMaybe<Scalars['Float']['input']>;
  scoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  scoreLT?: InputMaybe<Scalars['Float']['input']>;
  scoreLTE?: InputMaybe<Scalars['Float']['input']>;
  scoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  scoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** vector field predicates */
  vector?: InputMaybe<Scalars['String']['input']>;
  vectorContains?: InputMaybe<Scalars['String']['input']>;
  vectorContainsFold?: InputMaybe<Scalars['String']['input']>;
  vectorEqualFold?: InputMaybe<Scalars['String']['input']>;
  vectorGT?: InputMaybe<Scalars['String']['input']>;
  vectorGTE?: InputMaybe<Scalars['String']['input']>;
  vectorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vectorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vectorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vectorLT?: InputMaybe<Scalars['String']['input']>;
  vectorLTE?: InputMaybe<Scalars['String']['input']>;
  vectorNEQ?: InputMaybe<Scalars['String']['input']>;
  vectorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['Float']['input']>;
  versionGT?: InputMaybe<Scalars['Float']['input']>;
  versionGTE?: InputMaybe<Scalars['Float']['input']>;
  versionIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  versionLT?: InputMaybe<Scalars['Float']['input']>;
  versionLTE?: InputMaybe<Scalars['Float']['input']>;
  versionNEQ?: InputMaybe<Scalars['Float']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Component = {
  __typename?: 'Component';
  assetItems?: Maybe<Array<Maybe<AssetItem>>>;
  assets?: Maybe<Array<Maybe<Asset>>>;
  componentExternalIdentifiers?: Maybe<Array<ComponentExternalIdentifier>>;
  componentVendor: ComponentVendor;
  cpeName?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['Time']['output']>;
  eolDate?: Maybe<Scalars['Time']['output']>;
  eolReached: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  monitoredSince?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectZone?: Maybe<ProjectZone>;
  securityUrl?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['Time']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type ComponentAffectedByNotification = {
  __typename?: 'ComponentAffectedByNotification';
  affectedAssetsCount: Scalars['Int']['output'];
  affectedProjectsCount: Scalars['Int']['output'];
  componentVendorID?: Maybe<Scalars['ID']['output']>;
  componentVendorName?: Maybe<Scalars['String']['output']>;
  cpeName?: Maybe<Scalars['String']['output']>;
  eolDate?: Maybe<Scalars['Time']['output']>;
  eolReached: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  monitoredSince?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  notificationID: Scalars['ID']['output'];
  securityURL?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userID: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type ComponentAffectedByNotificationConnection = {
  __typename?: 'ComponentAffectedByNotificationConnection';
  edges: Array<ComponentAffectedByNotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentAffectedByNotificationEdge = {
  __typename?: 'ComponentAffectedByNotificationEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentAffectedByNotification;
};

export type ComponentAffectedByNotificationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentAffectedByNotificationOrderField>;
};

export enum ComponentAffectedByNotificationOrderField {
  Affectedassetscount = 'AFFECTEDASSETSCOUNT',
  Affectedprojectscount = 'AFFECTEDPROJECTSCOUNT',
  Componentvendorid = 'COMPONENTVENDORID',
  Componentvendorname = 'COMPONENTVENDORNAME',
  Cpename = 'CPENAME',
  Createtime = 'CREATETIME',
  Eoldate = 'EOLDATE',
  Eolreached = 'EOLREACHED',
  Id = 'ID',
  Isvalid = 'ISVALID',
  Monitoredsince = 'MONITOREDSINCE',
  Name = 'NAME',
  Securityurl = 'SECURITYURL',
  Updatetime = 'UPDATETIME',
  Url = 'URL',
  Version = 'VERSION'
}

export type ComponentAffectedByNotificationProject = {
  __typename?: 'ComponentAffectedByNotificationProject';
  affectedAssetsCount: Scalars['Int']['output'];
  componentProjectID?: Maybe<Scalars['ID']['output']>;
  componentVendorID?: Maybe<Scalars['ID']['output']>;
  componentVendorName?: Maybe<Scalars['String']['output']>;
  cpeName?: Maybe<Scalars['String']['output']>;
  eolDate?: Maybe<Scalars['Time']['output']>;
  eolReached: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  monitoredSince?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  notificationID: Scalars['ID']['output'];
  projectID: Scalars['ID']['output'];
  securityURL?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userID: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type ComponentAffectedByNotificationProjectConnection = {
  __typename?: 'ComponentAffectedByNotificationProjectConnection';
  edges: Array<ComponentAffectedByNotificationProjectEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentAffectedByNotificationProjectEdge = {
  __typename?: 'ComponentAffectedByNotificationProjectEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentAffectedByNotificationProject;
};

export type ComponentAffectedByNotificationProjectOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentAffectedByNotificationProjectOrderField>;
};

export enum ComponentAffectedByNotificationProjectOrderField {
  Affectedassetscount = 'AFFECTEDASSETSCOUNT',
  Componentvendorid = 'COMPONENTVENDORID',
  Componentvendorname = 'COMPONENTVENDORNAME',
  Cpename = 'CPENAME',
  Createtime = 'CREATETIME',
  Eoldate = 'EOLDATE',
  Eolreached = 'EOLREACHED',
  Id = 'ID',
  Isvalid = 'ISVALID',
  Monitoredsince = 'MONITOREDSINCE',
  Name = 'NAME',
  Securityurl = 'SECURITYURL',
  Updatetime = 'UPDATETIME',
  Url = 'URL',
  Version = 'VERSION'
}

/**
 * ComponentAffectedByNotificationProjectWhereInput is used for filtering ComponentAffectedByNotificationProjectView objects.
 * Input was generated by ent.
 */
export type ComponentAffectedByNotificationProjectWhereInput = {
  /** affected_assets_count field predicates */
  affectedAssetsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedAssetsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<ComponentAffectedByNotificationProjectWhereInput>>;
  /** component_project_id field predicates */
  componentProjectID?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentProjectIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentProjectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_vendor_name field predicates */
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContains?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameLT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** cpe_name field predicates */
  cpeName?: InputMaybe<Scalars['String']['input']>;
  cpeNameContains?: InputMaybe<Scalars['String']['input']>;
  cpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameGT?: InputMaybe<Scalars['String']['input']>;
  cpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpeNameLT?: InputMaybe<Scalars['String']['input']>;
  cpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  cpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** eol_date field predicates */
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolDateGT?: InputMaybe<Scalars['Time']['input']>;
  eolDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateLT?: InputMaybe<Scalars['Time']['input']>;
  eolDateLTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  eolDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eol_reached field predicates */
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  eolReachedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_valid field predicates */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_sync field predicates */
  lastSync?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSyncLT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** monitored_since field predicates */
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNEQ?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentAffectedByNotificationProjectWhereInput>;
  /** notification_id field predicates */
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<ComponentAffectedByNotificationProjectWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** security_url field predicates */
  securityURL?: InputMaybe<Scalars['String']['input']>;
  securityURLContains?: InputMaybe<Scalars['String']['input']>;
  securityURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityURLGT?: InputMaybe<Scalars['String']['input']>;
  securityURLGTE?: InputMaybe<Scalars['String']['input']>;
  securityURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityURLLT?: InputMaybe<Scalars['String']['input']>;
  securityURLLTE?: InputMaybe<Scalars['String']['input']>;
  securityURLNEQ?: InputMaybe<Scalars['String']['input']>;
  securityURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ComponentAffectedByNotificationWhereInput is used for filtering ComponentAffectedByNotificationView objects.
 * Input was generated by ent.
 */
export type ComponentAffectedByNotificationWhereInput = {
  /** affected_assets_count field predicates */
  affectedAssetsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedAssetsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** affected_projects_count field predicates */
  affectedProjectsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedProjectsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedProjectsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedProjectsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedProjectsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedProjectsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedProjectsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedProjectsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<ComponentAffectedByNotificationWhereInput>>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_vendor_name field predicates */
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContains?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameLT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** cpe_name field predicates */
  cpeName?: InputMaybe<Scalars['String']['input']>;
  cpeNameContains?: InputMaybe<Scalars['String']['input']>;
  cpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameGT?: InputMaybe<Scalars['String']['input']>;
  cpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpeNameLT?: InputMaybe<Scalars['String']['input']>;
  cpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  cpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** eol_date field predicates */
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolDateGT?: InputMaybe<Scalars['Time']['input']>;
  eolDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateLT?: InputMaybe<Scalars['Time']['input']>;
  eolDateLTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  eolDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eol_reached field predicates */
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  eolReachedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_valid field predicates */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_sync field predicates */
  lastSync?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSyncLT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** monitored_since field predicates */
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNEQ?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentAffectedByNotificationWhereInput>;
  /** notification_id field predicates */
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<ComponentAffectedByNotificationWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** security_url field predicates */
  securityURL?: InputMaybe<Scalars['String']['input']>;
  securityURLContains?: InputMaybe<Scalars['String']['input']>;
  securityURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityURLGT?: InputMaybe<Scalars['String']['input']>;
  securityURLGTE?: InputMaybe<Scalars['String']['input']>;
  securityURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityURLLT?: InputMaybe<Scalars['String']['input']>;
  securityURLLTE?: InputMaybe<Scalars['String']['input']>;
  securityURLNEQ?: InputMaybe<Scalars['String']['input']>;
  securityURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ComponentConnection = {
  __typename?: 'ComponentConnection';
  edges: Array<ComponentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentCreateRequest = {
  __typename?: 'ComponentCreateRequest';
  Requester: User;
  User: User;
  componentID?: Maybe<Scalars['ID']['output']>;
  componentName?: Maybe<Scalars['String']['output']>;
  componentVendorID?: Maybe<Scalars['ID']['output']>;
  componentVendorName?: Maybe<Scalars['String']['output']>;
  componentVersion?: Maybe<Scalars['String']['output']>;
  externalComponentID?: Maybe<Scalars['String']['output']>;
  externalRequestRef?: Maybe<Scalars['String']['output']>;
  externalRequestStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  referenceSecurity?: Maybe<Scalars['String']['output']>;
  referenceWeb?: Maybe<Scalars['String']['output']>;
  requestPriority?: Maybe<ComponentCreateRequestRequestPriority>;
  /** who created the request */
  requesterID: Scalars['ID']['output'];
  sourceID: Scalars['ID']['output'];
  statusID: Scalars['ID']['output'];
  /** who did latest update/change on the request */
  userID: Scalars['ID']['output'];
};

/**
 * ComponentCreateRequestCommentWhereInput is used for filtering ComponentCreateRequestComment objects.
 * Input was generated by ent.
 */
export type ComponentCreateRequestCommentWhereInput = {
  and?: InputMaybe<Array<ComponentCreateRequestCommentWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_create_request_id field predicates */
  componentCreateRequestID?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentCreateRequestIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentCreateRequestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_create_requests edge predicates */
  hasComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentCreateRequestCommentWhereInput>;
  or?: InputMaybe<Array<ComponentCreateRequestCommentWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ComponentCreateRequestConnection = {
  __typename?: 'ComponentCreateRequestConnection';
  edges: Array<ComponentCreateRequestEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentCreateRequestEdge = {
  __typename?: 'ComponentCreateRequestEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentCreateRequest;
};

export type ComponentCreateRequestOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentCreateRequestOrderField>;
};

export enum ComponentCreateRequestOrderField {
  Comment = 'COMMENT',
  Componentid = 'COMPONENTID',
  Componentname = 'COMPONENTNAME',
  Componentvendorid = 'COMPONENTVENDORID',
  Componentvendorname = 'COMPONENTVENDORNAME',
  Componentversion = 'COMPONENTVERSION',
  Externalcomponentid = 'EXTERNALCOMPONENTID',
  Externalrequestref = 'EXTERNALREQUESTREF',
  Externalrequeststatus = 'EXTERNALREQUESTSTATUS',
  Referencesecurity = 'REFERENCESECURITY',
  Referenceweb = 'REFERENCEWEB',
  Requestpriority = 'REQUESTPRIORITY',
  Sourceid = 'SOURCEID',
  Statusid = 'STATUSID',
  Userid = 'USERID'
}

export enum ComponentCreateRequestRequestPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ComponentCreateRequestStatus = {
  __typename?: 'ComponentCreateRequestStatus';
  code: ComponentCreateRequestStatusCode;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
};

export enum ComponentCreateRequestStatusCode {
  ApprovalPending = 'APPROVAL_PENDING',
  Approved = 'APPROVED',
  Created = 'CREATED',
  Forwarded = 'FORWARDED',
  Removed = 'REMOVED',
  Replaced = 'REPLACED'
}

export type ComponentCreateRequestStatusConnection = {
  __typename?: 'ComponentCreateRequestStatusConnection';
  edges: Array<ComponentCreateRequestStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentCreateRequestStatusEdge = {
  __typename?: 'ComponentCreateRequestStatusEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentCreateRequestStatus;
};

export type ComponentCreateRequestStatusOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentCreateRequestStatusOrderField>;
};

export enum ComponentCreateRequestStatusOrderField {
  Code = 'CODE',
  Isactive = 'ISACTIVE',
  Name = 'NAME',
  Sequence = 'SEQUENCE'
}

export type ComponentCreateRequestStatusTransition = {
  __typename?: 'ComponentCreateRequestStatusTransition';
  fromID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  toID: Scalars['ID']['output'];
};

export type ComponentCreateRequestStatusTransitionConnection = {
  __typename?: 'ComponentCreateRequestStatusTransitionConnection';
  edges: Array<ComponentCreateRequestStatusTransitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentCreateRequestStatusTransitionEdge = {
  __typename?: 'ComponentCreateRequestStatusTransitionEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentCreateRequestStatusTransition;
};

export type ComponentCreateRequestStatusTransitionOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentCreateRequestStatusTransitionOrderField>;
};

export enum ComponentCreateRequestStatusTransitionOrderField {
  Fromid = 'FROMID',
  Isactive = 'ISACTIVE',
  Toid = 'TOID'
}

/**
 * ComponentCreateRequestStatusTransitionWhereInput is used for filtering ComponentCreateRequestStatusTransition objects.
 * Input was generated by ent.
 */
export type ComponentCreateRequestStatusTransitionWhereInput = {
  and?: InputMaybe<Array<ComponentCreateRequestStatusTransitionWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** from_id field predicates */
  fromID?: InputMaybe<Scalars['ID']['input']>;
  fromIDContains?: InputMaybe<Scalars['ID']['input']>;
  fromIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fromIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fromIDGT?: InputMaybe<Scalars['ID']['input']>;
  fromIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fromIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fromIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fromIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fromIDLT?: InputMaybe<Scalars['ID']['input']>;
  fromIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fromIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fromIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_create_request_status_from_id edge predicates */
  hasComponentCreateRequestStatusFromID?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestStatusFromIDWith?: InputMaybe<Array<ComponentCreateRequestStatusWhereInput>>;
  /** component_create_request_status_to_id edge predicates */
  hasComponentCreateRequestStatusToID?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestStatusToIDWith?: InputMaybe<Array<ComponentCreateRequestStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ComponentCreateRequestStatusTransitionWhereInput>;
  or?: InputMaybe<Array<ComponentCreateRequestStatusTransitionWhereInput>>;
  /** to_id field predicates */
  toID?: InputMaybe<Scalars['ID']['input']>;
  toIDContains?: InputMaybe<Scalars['ID']['input']>;
  toIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  toIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  toIDGT?: InputMaybe<Scalars['ID']['input']>;
  toIDGTE?: InputMaybe<Scalars['ID']['input']>;
  toIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  toIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  toIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  toIDLT?: InputMaybe<Scalars['ID']['input']>;
  toIDLTE?: InputMaybe<Scalars['ID']['input']>;
  toIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  toIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ComponentCreateRequestStatusWhereInput is used for filtering ComponentCreateRequestStatus objects.
 * Input was generated by ent.
 */
export type ComponentCreateRequestStatusWhereInput = {
  and?: InputMaybe<Array<ComponentCreateRequestStatusWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<ComponentCreateRequestStatusCode>;
  codeIn?: InputMaybe<Array<ComponentCreateRequestStatusCode>>;
  codeNEQ?: InputMaybe<ComponentCreateRequestStatusCode>;
  codeNotIn?: InputMaybe<Array<ComponentCreateRequestStatusCode>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_create_request_status_transitions_from_id edge predicates */
  hasComponentCreateRequestStatusTransitionsFromID?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestStatusTransitionsFromIDWith?: InputMaybe<Array<ComponentCreateRequestStatusTransitionWhereInput>>;
  /** component_create_request_status_transitions_to_id edge predicates */
  hasComponentCreateRequestStatusTransitionsToID?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestStatusTransitionsToIDWith?: InputMaybe<Array<ComponentCreateRequestStatusTransitionWhereInput>>;
  /** component_create_requests edge predicates */
  hasComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentCreateRequestStatusWhereInput>;
  or?: InputMaybe<Array<ComponentCreateRequestStatusWhereInput>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ComponentCreateRequestView = {
  __typename?: 'ComponentCreateRequestView';
  comments: Array<ComponentCreateRequestViewComment>;
  componentID?: Maybe<Scalars['ID']['output']>;
  componentName: Scalars['String']['output'];
  componentVendorID?: Maybe<Scalars['ID']['output']>;
  componentVendorName?: Maybe<Scalars['String']['output']>;
  componentVersion: Scalars['String']['output'];
  externalComponentID?: Maybe<Scalars['String']['output']>;
  externalRequestRef?: Maybe<Scalars['String']['output']>;
  externalRequestStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  referenceSecurity?: Maybe<Scalars['String']['output']>;
  referenceWeb?: Maybe<Scalars['String']['output']>;
  requestPriority?: Maybe<ComponentCreateRequestRequestPriority>;
  /** who created the request */
  requesterID: Scalars['ID']['output'];
  sourceID: Scalars['ID']['output'];
  statusCode: ComponentCreateRequestStatusCode;
  statusID: Scalars['ID']['output'];
  statusTransitions: Array<ComponentCreateRequestViewAllowedStatusTransition>;
  /** who did latest update/change on the request */
  userID: Scalars['ID']['output'];
};

export type ComponentCreateRequestViewAllowedStatusTransition = {
  __typename?: 'ComponentCreateRequestViewAllowedStatusTransition';
  blocked: Scalars['Boolean']['output'];
  code: ComponentCreateRequestStatusCode;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type ComponentCreateRequestViewComment = {
  __typename?: 'ComponentCreateRequestViewComment';
  comment: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  userID: Scalars['ID']['output'];
};

export type ComponentCreateRequestViewConnection = {
  __typename?: 'ComponentCreateRequestViewConnection';
  edges: Array<ComponentCreateRequestViewEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentCreateRequestViewEdge = {
  __typename?: 'ComponentCreateRequestViewEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentCreateRequestView;
};

/**
 * ComponentCreateRequestWhereInput is used for filtering ComponentCreateRequest objects.
 * Input was generated by ent.
 */
export type ComponentCreateRequestWhereInput = {
  and?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_name field predicates */
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentNameContains?: InputMaybe<Scalars['String']['input']>;
  componentNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentNameGT?: InputMaybe<Scalars['String']['input']>;
  componentNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentNameLT?: InputMaybe<Scalars['String']['input']>;
  componentNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_vendor_name field predicates */
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContains?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentVendorNameLT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_version field predicates */
  componentVersion?: InputMaybe<Scalars['String']['input']>;
  componentVersionContains?: InputMaybe<Scalars['String']['input']>;
  componentVersionContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVersionEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVersionGT?: InputMaybe<Scalars['String']['input']>;
  componentVersionGTE?: InputMaybe<Scalars['String']['input']>;
  componentVersionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVersionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVersionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVersionLT?: InputMaybe<Scalars['String']['input']>;
  componentVersionLTE?: InputMaybe<Scalars['String']['input']>;
  componentVersionNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVersionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** external_component_id field predicates */
  externalComponentID?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDContains?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDGT?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalComponentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalComponentIDLT?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalComponentIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalComponentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_request_ref field predicates */
  externalRequestRef?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefContains?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefGT?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefGTE?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalRequestRefIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalRequestRefLT?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefLTE?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefNEQ?: InputMaybe<Scalars['String']['input']>;
  externalRequestRefNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalRequestRefNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_request_status field predicates */
  externalRequestStatus?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusContains?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusGT?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusGTE?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalRequestStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalRequestStatusLT?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusLTE?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusNEQ?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalRequestStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component edge predicates */
  hasComponent?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_create_request_comments edge predicates */
  hasComponentCreateRequestComments?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestCommentsWith?: InputMaybe<Array<ComponentCreateRequestCommentWhereInput>>;
  /** component_create_request_status edge predicates */
  hasComponentCreateRequestStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestStatusWith?: InputMaybe<Array<ComponentCreateRequestStatusWhereInput>>;
  /** component_sources edge predicates */
  hasComponentSources?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSourcesWith?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** component_vendor edge predicates */
  hasComponentVendor?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentVendorWith?: InputMaybe<Array<ComponentVendorWhereInput>>;
  hasComponentWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** requester edge predicates */
  hasRequester?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequesterWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentCreateRequestWhereInput>;
  or?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** reference_security field predicates */
  referenceSecurity?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityContains?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityContainsFold?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityEqualFold?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityGT?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityGTE?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceSecurityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  referenceSecurityLT?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityLTE?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityNEQ?: InputMaybe<Scalars['String']['input']>;
  referenceSecurityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceSecurityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** reference_web field predicates */
  referenceWeb?: InputMaybe<Scalars['String']['input']>;
  referenceWebContains?: InputMaybe<Scalars['String']['input']>;
  referenceWebContainsFold?: InputMaybe<Scalars['String']['input']>;
  referenceWebEqualFold?: InputMaybe<Scalars['String']['input']>;
  referenceWebGT?: InputMaybe<Scalars['String']['input']>;
  referenceWebGTE?: InputMaybe<Scalars['String']['input']>;
  referenceWebHasPrefix?: InputMaybe<Scalars['String']['input']>;
  referenceWebHasSuffix?: InputMaybe<Scalars['String']['input']>;
  referenceWebIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceWebIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  referenceWebLT?: InputMaybe<Scalars['String']['input']>;
  referenceWebLTE?: InputMaybe<Scalars['String']['input']>;
  referenceWebNEQ?: InputMaybe<Scalars['String']['input']>;
  referenceWebNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceWebNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_priority field predicates */
  requestPriority?: InputMaybe<ComponentCreateRequestRequestPriority>;
  requestPriorityIn?: InputMaybe<Array<ComponentCreateRequestRequestPriority>>;
  requestPriorityNEQ?: InputMaybe<ComponentCreateRequestRequestPriority>;
  requestPriorityNotIn?: InputMaybe<Array<ComponentCreateRequestRequestPriority>>;
  /** requester_id field predicates */
  requesterID?: InputMaybe<Scalars['ID']['input']>;
  requesterIDContains?: InputMaybe<Scalars['ID']['input']>;
  requesterIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  requesterIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  requesterIDGT?: InputMaybe<Scalars['ID']['input']>;
  requesterIDGTE?: InputMaybe<Scalars['ID']['input']>;
  requesterIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  requesterIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  requesterIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requesterIDLT?: InputMaybe<Scalars['ID']['input']>;
  requesterIDLTE?: InputMaybe<Scalars['ID']['input']>;
  requesterIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requesterIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** source_id field predicates */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status_id field predicates */
  statusID?: InputMaybe<Scalars['ID']['input']>;
  statusIDContains?: InputMaybe<Scalars['ID']['input']>;
  statusIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  statusIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  statusIDGT?: InputMaybe<Scalars['ID']['input']>;
  statusIDGTE?: InputMaybe<Scalars['ID']['input']>;
  statusIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  statusIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  statusIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  statusIDLT?: InputMaybe<Scalars['ID']['input']>;
  statusIDLTE?: InputMaybe<Scalars['ID']['input']>;
  statusIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  statusIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ComponentEdge = {
  __typename?: 'ComponentEdge';
  cursor: Scalars['Cursor']['output'];
  node: Component;
};

export type ComponentExternalIdentifier = {
  __typename?: 'ComponentExternalIdentifier';
  externalIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeprecated: Scalars['Boolean']['output'];
  source: ComponentExternalIdentifierSource;
};

export enum ComponentExternalIdentifierSource {
  Svm = 'SVM'
}

/**
 * ComponentExternalIdentifierWhereInput is used for filtering ComponentExternalIdentifier objects.
 * Input was generated by ent.
 */
export type ComponentExternalIdentifierWhereInput = {
  and?: InputMaybe<Array<ComponentExternalIdentifierWhereInput>>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** external_identifier field predicates */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIdentifierNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component edge predicates */
  hasComponent?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_deprecated field predicates */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecatedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ComponentExternalIdentifierWhereInput>;
  or?: InputMaybe<Array<ComponentExternalIdentifierWhereInput>>;
  /** source field predicates */
  source?: InputMaybe<ComponentExternalIdentifierSource>;
  sourceIn?: InputMaybe<Array<ComponentExternalIdentifierSource>>;
  sourceNEQ?: InputMaybe<ComponentExternalIdentifierSource>;
  sourceNotIn?: InputMaybe<Array<ComponentExternalIdentifierSource>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ComponentInProject = {
  __typename?: 'ComponentInProject';
  componentVendorID?: Maybe<Scalars['ID']['output']>;
  componentVendorName?: Maybe<Scalars['String']['output']>;
  cpeName?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['Time']['output'];
  eolDate?: Maybe<Scalars['Time']['output']>;
  eolReached: Scalars['Boolean']['output'];
  hasAssessments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  lastSync: Scalars['Time']['output'];
  monitoredSince?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  projectID: Scalars['ID']['output'];
  securityURL?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['Time']['output'];
  url?: Maybe<Scalars['String']['output']>;
  usedInProjectCount: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type ComponentInProjectConnection = {
  __typename?: 'ComponentInProjectConnection';
  edges: Array<ComponentInProjectEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentInProjectEdge = {
  __typename?: 'ComponentInProjectEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentInProject;
};

export type ComponentInProjectOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentInProjectOrderField>;
};

export enum ComponentInProjectOrderField {
  Componentvendorid = 'COMPONENTVENDORID',
  Componentvendorname = 'COMPONENTVENDORNAME',
  Cpename = 'CPENAME',
  Createtime = 'CREATETIME',
  Eoldate = 'EOLDATE',
  Eolreached = 'EOLREACHED',
  Id = 'ID',
  Isvalid = 'ISVALID',
  Lastsync = 'LASTSYNC',
  Monitoredsince = 'MONITOREDSINCE',
  Name = 'NAME',
  Projectid = 'PROJECTID',
  Securityurl = 'SECURITYURL',
  Updatetime = 'UPDATETIME',
  Url = 'URL',
  Usedinprojectcount = 'USEDINPROJECTCOUNT',
  Version = 'VERSION'
}

/**
 * ComponentInProjectWhereInput is used for filtering ComponentInProjectView objects.
 * Input was generated by ent.
 */
export type ComponentInProjectWhereInput = {
  and?: InputMaybe<Array<ComponentInProjectWhereInput>>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_vendor_name field predicates */
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContains?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentVendorNameLT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cpe_name field predicates */
  cpeName?: InputMaybe<Scalars['String']['input']>;
  cpeNameContains?: InputMaybe<Scalars['String']['input']>;
  cpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameGT?: InputMaybe<Scalars['String']['input']>;
  cpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpeNameLT?: InputMaybe<Scalars['String']['input']>;
  cpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  cpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eol_date field predicates */
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolDateGT?: InputMaybe<Scalars['Time']['input']>;
  eolDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateLT?: InputMaybe<Scalars['Time']['input']>;
  eolDateLTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  eolDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eol_reached field predicates */
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  eolReachedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_assessments field predicates */
  hasAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssessmentsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_valid field predicates */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_sync field predicates */
  lastSync?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSyncLT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** monitored_since field predicates */
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNEQ?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentInProjectWhereInput>;
  or?: InputMaybe<Array<ComponentInProjectWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** security_url field predicates */
  securityURL?: InputMaybe<Scalars['String']['input']>;
  securityURLContains?: InputMaybe<Scalars['String']['input']>;
  securityURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityURLGT?: InputMaybe<Scalars['String']['input']>;
  securityURLGTE?: InputMaybe<Scalars['String']['input']>;
  securityURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityURLLT?: InputMaybe<Scalars['String']['input']>;
  securityURLLTE?: InputMaybe<Scalars['String']['input']>;
  securityURLNEQ?: InputMaybe<Scalars['String']['input']>;
  securityURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** used_in_project_count field predicates */
  usedInProjectCount?: InputMaybe<Scalars['Int']['input']>;
  usedInProjectCountGT?: InputMaybe<Scalars['Int']['input']>;
  usedInProjectCountGTE?: InputMaybe<Scalars['Int']['input']>;
  usedInProjectCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  usedInProjectCountLT?: InputMaybe<Scalars['Int']['input']>;
  usedInProjectCountLTE?: InputMaybe<Scalars['Int']['input']>;
  usedInProjectCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  usedInProjectCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ComponentMappingWhereInput is used for filtering ComponentMapping objects.
 * Input was generated by ent.
 */
export type ComponentMappingWhereInput = {
  and?: InputMaybe<Array<ComponentMappingWhereInput>>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_raw_id field predicates */
  componentRawID?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentRawIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentRawIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentRawIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentRawIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_raws edge predicates */
  hasComponentRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsWith?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** components edge predicates */
  hasComponents?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentsWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentMappingWhereInput>;
  or?: InputMaybe<Array<ComponentMappingWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ComponentNotification = {
  __typename?: 'ComponentNotification';
  component: Component;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notification: Notification;
  updateTime: Scalars['Time']['output'];
};

/**
 * ComponentNotificationWhereInput is used for filtering ComponentNotification objects.
 * Input was generated by ent.
 */
export type ComponentNotificationWhereInput = {
  and?: InputMaybe<Array<ComponentNotificationWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentNotificationWhereInput>;
  or?: InputMaybe<Array<ComponentNotificationWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ComponentOrError = Component | ErrInvalidInput;

export type ComponentOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentOrderField>;
};

export enum ComponentOrderField {
  Cpename = 'CPENAME',
  Createtime = 'CREATETIME',
  Eoldate = 'EOLDATE',
  Eolreached = 'EOLREACHED',
  Id = 'ID',
  Isvalid = 'ISVALID',
  Monitoredsince = 'MONITOREDSINCE',
  Name = 'NAME',
  Securityurl = 'SECURITYURL',
  Updatetime = 'UPDATETIME',
  Url = 'URL',
  Version = 'VERSION'
}

export enum ComponentRawCpeVersion {
  Cpe23 = 'CPE23'
}

/**
 * ComponentRawNotificationRawWhereInput is used for filtering ComponentRawNotificationRaw objects.
 * Input was generated by ent.
 */
export type ComponentRawNotificationRawWhereInput = {
  and?: InputMaybe<Array<ComponentRawNotificationRawWhereInput>>;
  /** component_raws_id field predicates */
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_raws edge predicates */
  hasComponentRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsWith?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** notification_raws edge predicates */
  hasNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsWith?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentRawNotificationRawWhereInput>;
  /** notification_raws_id field predicates */
  notificationRawsID?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<ComponentRawNotificationRawWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ComponentRawNotificationVilocifyRelationshipWhereInput is used for filtering
 * ComponentRawNotificationVilocifyRelationship objects.
 * Input was generated by ent.
 */
export type ComponentRawNotificationVilocifyRelationshipWhereInput = {
  and?: InputMaybe<Array<ComponentRawNotificationVilocifyRelationshipWhereInput>>;
  /** component_raws_id field predicates */
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_raws edge predicates */
  hasComponentRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsWith?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentRawNotificationVilocifyRelationshipWhereInput>;
  /** notification_vilocify_id field predicates */
  notificationVilocifyID?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDContains?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDGT?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDGTE?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationVilocifyIDLT?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDLTE?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationVilocifyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<ComponentRawNotificationVilocifyRelationshipWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ComponentRawVulnerabilityRawWhereInput is used for filtering ComponentRawVulnerabilityRaw objects.
 * Input was generated by ent.
 */
export type ComponentRawVulnerabilityRawWhereInput = {
  and?: InputMaybe<Array<ComponentRawVulnerabilityRawWhereInput>>;
  /** component_raws_id field predicates */
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_raws edge predicates */
  hasComponentRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsWith?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** vulnerability_raws edge predicates */
  hasVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawsWith?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentRawVulnerabilityRawWhereInput>;
  or?: InputMaybe<Array<ComponentRawVulnerabilityRawWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vulnerability_raws_id field predicates */
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vulnerabilityRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * ComponentRawWhereInput is used for filtering ComponentRaw objects.
 * Input was generated by ent.
 */
export type ComponentRawWhereInput = {
  and?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** cpe_2_3 field predicates */
  cpe23?: InputMaybe<Scalars['String']['input']>;
  cpe23Contains?: InputMaybe<Scalars['String']['input']>;
  cpe23ContainsFold?: InputMaybe<Scalars['String']['input']>;
  cpe23EqualFold?: InputMaybe<Scalars['String']['input']>;
  cpe23GT?: InputMaybe<Scalars['String']['input']>;
  cpe23GTE?: InputMaybe<Scalars['String']['input']>;
  cpe23HasPrefix?: InputMaybe<Scalars['String']['input']>;
  cpe23HasSuffix?: InputMaybe<Scalars['String']['input']>;
  cpe23In?: InputMaybe<Array<Scalars['String']['input']>>;
  cpe23IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cpe23LT?: InputMaybe<Scalars['String']['input']>;
  cpe23LTE?: InputMaybe<Scalars['String']['input']>;
  cpe23NEQ?: InputMaybe<Scalars['String']['input']>;
  cpe23NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpe23NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eol_date field predicates */
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolDateGT?: InputMaybe<Scalars['Time']['input']>;
  eolDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  eolDateLT?: InputMaybe<Scalars['Time']['input']>;
  eolDateLTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  eolDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** eol_reached field predicates */
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  eolReachedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_mappings edge predicates */
  hasComponentMappings?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentMappingsWith?: InputMaybe<Array<ComponentMappingWhereInput>>;
  /** component_raw_notification_vilocify_relationships edge predicates */
  hasComponentRawNotificationVilocifyRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawNotificationVilocifyRelationshipsWith?: InputMaybe<Array<ComponentRawNotificationVilocifyRelationshipWhereInput>>;
  /** component_raws_notification_raws edge predicates */
  hasComponentRawsNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsNotificationRawsWith?: InputMaybe<Array<ComponentRawNotificationRawWhereInput>>;
  /** component_raws_vulnerability_raws edge predicates */
  hasComponentRawsVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsVulnerabilityRawsWith?: InputMaybe<Array<ComponentRawVulnerabilityRawWhereInput>>;
  /** component_sources edge predicates */
  hasComponentSources?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSourcesWith?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** monitored_since field predicates */
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  monitoredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNEQ?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentRawWhereInput>;
  or?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** source_id field predicates */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vendor_name field predicates */
  vendorName?: InputMaybe<Scalars['String']['input']>;
  vendorNameContains?: InputMaybe<Scalars['String']['input']>;
  vendorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  vendorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  vendorNameGT?: InputMaybe<Scalars['String']['input']>;
  vendorNameGTE?: InputMaybe<Scalars['String']['input']>;
  vendorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vendorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vendorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorNameLT?: InputMaybe<Scalars['String']['input']>;
  vendorNameLTE?: InputMaybe<Scalars['String']['input']>;
  vendorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  vendorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ComponentSource = {
  __typename?: 'ComponentSource';
  code: ComponentSourceCode;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
};

export enum ComponentSourceCode {
  Ics = 'ICS',
  Nvd = 'NVD',
  Vilocify = 'VILOCIFY'
}

export type ComponentSourceConnection = {
  __typename?: 'ComponentSourceConnection';
  edges: Array<ComponentSourceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentSourceEdge = {
  __typename?: 'ComponentSourceEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentSource;
};

export type ComponentSourceOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentSourceOrderField>;
};

export enum ComponentSourceOrderField {
  Code = 'CODE',
  Isactive = 'ISACTIVE',
  Name = 'NAME',
  Sequence = 'SEQUENCE'
}

export type ComponentSourceRaw = {
  __typename?: 'ComponentSourceRaw';
  componentName: Scalars['String']['output'];
  cpe?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['Time']['output'];
  eolDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  sourceID: Scalars['ID']['output'];
  sourceName: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * ComponentSourceWhereInput is used for filtering ComponentSource objects.
 * Input was generated by ent.
 */
export type ComponentSourceWhereInput = {
  and?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<ComponentSourceCode>;
  codeIn?: InputMaybe<Array<ComponentSourceCode>>;
  codeNEQ?: InputMaybe<ComponentSourceCode>;
  codeNotIn?: InputMaybe<Array<ComponentSourceCode>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_create_requests edge predicates */
  hasComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** component_raws edge predicates */
  hasComponentRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsWith?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** notification_raws edge predicates */
  hasNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsWith?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** vulnerability_raws edge predicates */
  hasVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawsWith?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentSourceWhereInput>;
  or?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ComponentSuggestionWhereInput is used for filtering ComponentSuggestion objects.
 * Input was generated by ent.
 */
export type ComponentSuggestionWhereInput = {
  and?: InputMaybe<Array<ComponentSuggestionWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** for_name field predicates */
  forName?: InputMaybe<Scalars['String']['input']>;
  forNameContains?: InputMaybe<Scalars['String']['input']>;
  forNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  forNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  forNameGT?: InputMaybe<Scalars['String']['input']>;
  forNameGTE?: InputMaybe<Scalars['String']['input']>;
  forNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  forNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  forNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  forNameLT?: InputMaybe<Scalars['String']['input']>;
  forNameLTE?: InputMaybe<Scalars['String']['input']>;
  forNameNEQ?: InputMaybe<Scalars['String']['input']>;
  forNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** for_vendor field predicates */
  forVendor?: InputMaybe<Scalars['String']['input']>;
  forVendorContains?: InputMaybe<Scalars['String']['input']>;
  forVendorContainsFold?: InputMaybe<Scalars['String']['input']>;
  forVendorEqualFold?: InputMaybe<Scalars['String']['input']>;
  forVendorGT?: InputMaybe<Scalars['String']['input']>;
  forVendorGTE?: InputMaybe<Scalars['String']['input']>;
  forVendorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  forVendorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  forVendorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  forVendorLT?: InputMaybe<Scalars['String']['input']>;
  forVendorLTE?: InputMaybe<Scalars['String']['input']>;
  forVendorNEQ?: InputMaybe<Scalars['String']['input']>;
  forVendorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** for_version field predicates */
  forVersion?: InputMaybe<Scalars['String']['input']>;
  forVersionContains?: InputMaybe<Scalars['String']['input']>;
  forVersionContainsFold?: InputMaybe<Scalars['String']['input']>;
  forVersionEqualFold?: InputMaybe<Scalars['String']['input']>;
  forVersionGT?: InputMaybe<Scalars['String']['input']>;
  forVersionGTE?: InputMaybe<Scalars['String']['input']>;
  forVersionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  forVersionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  forVersionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  forVersionLT?: InputMaybe<Scalars['String']['input']>;
  forVersionLTE?: InputMaybe<Scalars['String']['input']>;
  forVersionNEQ?: InputMaybe<Scalars['String']['input']>;
  forVersionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** got_name field predicates */
  gotName?: InputMaybe<Scalars['String']['input']>;
  gotNameContains?: InputMaybe<Scalars['String']['input']>;
  gotNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  gotNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  gotNameGT?: InputMaybe<Scalars['String']['input']>;
  gotNameGTE?: InputMaybe<Scalars['String']['input']>;
  gotNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gotNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gotNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gotNameLT?: InputMaybe<Scalars['String']['input']>;
  gotNameLTE?: InputMaybe<Scalars['String']['input']>;
  gotNameNEQ?: InputMaybe<Scalars['String']['input']>;
  gotNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** got_vendor field predicates */
  gotVendor?: InputMaybe<Scalars['String']['input']>;
  gotVendorContains?: InputMaybe<Scalars['String']['input']>;
  gotVendorContainsFold?: InputMaybe<Scalars['String']['input']>;
  gotVendorEqualFold?: InputMaybe<Scalars['String']['input']>;
  gotVendorGT?: InputMaybe<Scalars['String']['input']>;
  gotVendorGTE?: InputMaybe<Scalars['String']['input']>;
  gotVendorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gotVendorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gotVendorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gotVendorLT?: InputMaybe<Scalars['String']['input']>;
  gotVendorLTE?: InputMaybe<Scalars['String']['input']>;
  gotVendorNEQ?: InputMaybe<Scalars['String']['input']>;
  gotVendorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** got_version field predicates */
  gotVersion?: InputMaybe<Scalars['String']['input']>;
  gotVersionContains?: InputMaybe<Scalars['String']['input']>;
  gotVersionContainsFold?: InputMaybe<Scalars['String']['input']>;
  gotVersionEqualFold?: InputMaybe<Scalars['String']['input']>;
  gotVersionGT?: InputMaybe<Scalars['String']['input']>;
  gotVersionGTE?: InputMaybe<Scalars['String']['input']>;
  gotVersionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gotVersionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gotVersionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gotVersionLT?: InputMaybe<Scalars['String']['input']>;
  gotVersionLTE?: InputMaybe<Scalars['String']['input']>;
  gotVersionNEQ?: InputMaybe<Scalars['String']['input']>;
  gotVersionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component edge predicates */
  hasComponent?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_match field predicates */
  isMatch?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ComponentSuggestionWhereInput>;
  or?: InputMaybe<Array<ComponentSuggestionWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentSyncLogStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS'
}

/**
 * ComponentSyncLogWhereInput is used for filtering ComponentSyncLog objects.
 * Input was generated by ent.
 */
export type ComponentSyncLogWhereInput = {
  and?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_create_requests edge predicates */
  hasComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** component_raw_notification_vilocify_relationships edge predicates */
  hasComponentRawNotificationVilocifyRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawNotificationVilocifyRelationshipsWith?: InputMaybe<Array<ComponentRawNotificationVilocifyRelationshipWhereInput>>;
  /** component_raws edge predicates */
  hasComponentRaws?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_raws_notification_raws edge predicates */
  hasComponentRawsNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsNotificationRawsWith?: InputMaybe<Array<ComponentRawNotificationRawWhereInput>>;
  /** component_raws_vulnerability_raws edge predicates */
  hasComponentRawsVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsVulnerabilityRawsWith?: InputMaybe<Array<ComponentRawVulnerabilityRawWhereInput>>;
  hasComponentRawsWith?: InputMaybe<Array<ComponentRawWhereInput>>;
  /** component_sources edge predicates */
  hasComponentSources?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSourcesWith?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** notification_raw_vulnerability_vilocify_relationships edge predicates */
  hasNotificationRawVulnerabilityVilocifyRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawVulnerabilityVilocifyRelationshipsWith?: InputMaybe<Array<NotificationRawVulnerabilityVilocifyRelationshipWhereInput>>;
  /** notification_raws edge predicates */
  hasNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  /** notification_raws_vulnerability_raws edge predicates */
  hasNotificationRawsVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsVulnerabilityRawsWith?: InputMaybe<Array<NotificationRawVulnerabilityRawWhereInput>>;
  hasNotificationRawsWith?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** nvd_match_criterias edge predicates */
  hasNvdMatchCriterias?: InputMaybe<Scalars['Boolean']['input']>;
  hasNvdMatchCriteriasWith?: InputMaybe<Array<NvdMatchCriteriaWhereInput>>;
  /** vulnerability_cvss_raws edge predicates */
  hasVulnerabilityCvssRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityCvssRawsWith?: InputMaybe<Array<VulnerabilityCvssRawWhereInput>>;
  /** vulnerability_raw_component_nvd_relationships edge predicates */
  hasVulnerabilityRawComponentNvdRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawComponentNvdRelationshipsWith?: InputMaybe<Array<VulnerabilityRawComponentNvdRelationshipWhereInput>>;
  /** vulnerability_raws edge predicates */
  hasVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawsWith?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentSyncLogWhereInput>;
  or?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** source_id field predicates */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<ComponentSyncLogStatus>;
  statusIn?: InputMaybe<Array<ComponentSyncLogStatus>>;
  statusNEQ?: InputMaybe<ComponentSyncLogStatus>;
  statusNotIn?: InputMaybe<Array<ComponentSyncLogStatus>>;
  /** sync_end_time field predicates */
  syncEndTime?: InputMaybe<Scalars['Time']['input']>;
  syncEndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  syncEndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  syncEndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  syncEndTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncEndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  syncEndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  syncEndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  syncEndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  syncEndTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sync_start_time field predicates */
  syncStartTime?: InputMaybe<Scalars['Time']['input']>;
  syncStartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  syncStartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  syncStartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  syncStartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  syncStartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  syncStartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  syncStartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ComponentVendor = {
  __typename?: 'ComponentVendor';
  assessments?: Maybe<Array<ComponentVendorAssessment>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ifa?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type ComponentVendorAssessment = {
  __typename?: 'ComponentVendorAssessment';
  completionTime?: Maybe<Scalars['Time']['output']>;
  componentVendor: ComponentVendor;
  createTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  result: ComponentVendorAssessmentResult;
  status: ComponentVendorAssessmentStatus;
  type: ComponentVendorAssessmentType;
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type ComponentVendorAssessmentImportSummary = {
  __typename?: 'ComponentVendorAssessmentImportSummary';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ComponentVendorAssessmentResult {
  None = 'NONE',
  Notrecommended = 'NOTRECOMMENDED',
  Ok = 'OK',
  Okwithopenissues = 'OKWITHOPENISSUES',
  Withdrawn = 'WITHDRAWN'
}

export enum ComponentVendorAssessmentStatus {
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Notassessed = 'NOTASSESSED'
}

export enum ComponentVendorAssessmentType {
  Cots = 'COTS',
  Individual = 'INDIVIDUAL',
  Oss = 'OSS',
  Service = 'SERVICE'
}

/**
 * ComponentVendorAssessmentWhereInput is used for filtering ComponentVendorAssessment objects.
 * Input was generated by ent.
 */
export type ComponentVendorAssessmentWhereInput = {
  and?: InputMaybe<Array<ComponentVendorAssessmentWhereInput>>;
  /** completion_time field predicates */
  completionTime?: InputMaybe<Scalars['Time']['input']>;
  completionTimeGT?: InputMaybe<Scalars['Time']['input']>;
  completionTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  completionTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completionTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completionTimeLT?: InputMaybe<Scalars['Time']['input']>;
  completionTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  completionTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  completionTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completionTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_vendor edge predicates */
  hasComponentVendor?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentVendorWith?: InputMaybe<Array<ComponentVendorWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComponentVendorAssessmentWhereInput>;
  or?: InputMaybe<Array<ComponentVendorAssessmentWhereInput>>;
  /** reference field predicates */
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceContains?: InputMaybe<Scalars['String']['input']>;
  referenceContainsFold?: InputMaybe<Scalars['String']['input']>;
  referenceEqualFold?: InputMaybe<Scalars['String']['input']>;
  referenceGT?: InputMaybe<Scalars['String']['input']>;
  referenceGTE?: InputMaybe<Scalars['String']['input']>;
  referenceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  referenceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  referenceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  referenceLT?: InputMaybe<Scalars['String']['input']>;
  referenceLTE?: InputMaybe<Scalars['String']['input']>;
  referenceNEQ?: InputMaybe<Scalars['String']['input']>;
  referenceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** result field predicates */
  result?: InputMaybe<ComponentVendorAssessmentResult>;
  resultIn?: InputMaybe<Array<ComponentVendorAssessmentResult>>;
  resultNEQ?: InputMaybe<ComponentVendorAssessmentResult>;
  resultNotIn?: InputMaybe<Array<ComponentVendorAssessmentResult>>;
  /** status field predicates */
  status?: InputMaybe<ComponentVendorAssessmentStatus>;
  statusIn?: InputMaybe<Array<ComponentVendorAssessmentStatus>>;
  statusNEQ?: InputMaybe<ComponentVendorAssessmentStatus>;
  statusNotIn?: InputMaybe<Array<ComponentVendorAssessmentStatus>>;
  /** type field predicates */
  type?: InputMaybe<ComponentVendorAssessmentType>;
  typeIn?: InputMaybe<Array<ComponentVendorAssessmentType>>;
  typeNEQ?: InputMaybe<ComponentVendorAssessmentType>;
  typeNotIn?: InputMaybe<Array<ComponentVendorAssessmentType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ComponentVendorConnection = {
  __typename?: 'ComponentVendorConnection';
  edges: Array<ComponentVendorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentVendorEdge = {
  __typename?: 'ComponentVendorEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentVendor;
};

export type ComponentVendorOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ComponentVendorOrderField>;
};

export enum ComponentVendorOrderField {
  Contactemail = 'CONTACTEMAIL',
  Contactname = 'CONTACTNAME',
  Contactphone = 'CONTACTPHONE',
  Createtime = 'CREATETIME',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Ifa = 'IFA',
  Name = 'NAME',
  Updatetime = 'UPDATETIME'
}

/**
 * ComponentVendorWhereInput is used for filtering ComponentVendor objects.
 * Input was generated by ent.
 */
export type ComponentVendorWhereInput = {
  and?: InputMaybe<Array<ComponentVendorWhereInput>>;
  /** contact_email field predicates */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactEmailContains?: InputMaybe<Scalars['String']['input']>;
  contactEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  contactEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  contactEmailGT?: InputMaybe<Scalars['String']['input']>;
  contactEmailGTE?: InputMaybe<Scalars['String']['input']>;
  contactEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contactEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contactEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmailLT?: InputMaybe<Scalars['String']['input']>;
  contactEmailLTE?: InputMaybe<Scalars['String']['input']>;
  contactEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  contactEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** contact_name field predicates */
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactNameContains?: InputMaybe<Scalars['String']['input']>;
  contactNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  contactNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  contactNameGT?: InputMaybe<Scalars['String']['input']>;
  contactNameGTE?: InputMaybe<Scalars['String']['input']>;
  contactNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contactNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contactNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  contactNameLT?: InputMaybe<Scalars['String']['input']>;
  contactNameLTE?: InputMaybe<Scalars['String']['input']>;
  contactNameNEQ?: InputMaybe<Scalars['String']['input']>;
  contactNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** contact_phone field predicates */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactPhoneContains?: InputMaybe<Scalars['String']['input']>;
  contactPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  contactPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  contactPhoneGT?: InputMaybe<Scalars['String']['input']>;
  contactPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  contactPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contactPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contactPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPhoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  contactPhoneLT?: InputMaybe<Scalars['String']['input']>;
  contactPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPhoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assessments edge predicates */
  hasAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssessmentsWith?: InputMaybe<Array<ComponentVendorAssessmentWhereInput>>;
  /** component_create_requests edge predicates */
  hasComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** components edge predicates */
  hasComponents?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentsWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ifa field predicates */
  ifa?: InputMaybe<Scalars['String']['input']>;
  ifaContains?: InputMaybe<Scalars['String']['input']>;
  ifaContainsFold?: InputMaybe<Scalars['String']['input']>;
  ifaEqualFold?: InputMaybe<Scalars['String']['input']>;
  ifaGT?: InputMaybe<Scalars['String']['input']>;
  ifaGTE?: InputMaybe<Scalars['String']['input']>;
  ifaHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ifaHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ifaIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ifaIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ifaLT?: InputMaybe<Scalars['String']['input']>;
  ifaLTE?: InputMaybe<Scalars['String']['input']>;
  ifaNEQ?: InputMaybe<Scalars['String']['input']>;
  ifaNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ifaNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ComponentVendorWhereInput>;
  or?: InputMaybe<Array<ComponentVendorWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ComponentWhereInput is used for filtering Component objects.
 * Input was generated by ent.
 */
export type ComponentWhereInput = {
  and?: InputMaybe<Array<ComponentWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  bodyContains?: InputMaybe<Scalars['String']['input']>;
  bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyGT?: InputMaybe<Scalars['String']['input']>;
  bodyGTE?: InputMaybe<Scalars['String']['input']>;
  bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bodyLT?: InputMaybe<Scalars['String']['input']>;
  bodyLTE?: InputMaybe<Scalars['String']['input']>;
  bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** cpe_name field predicates */
  cpeName?: InputMaybe<Scalars['String']['input']>;
  cpeNameContains?: InputMaybe<Scalars['String']['input']>;
  cpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  cpeNameGT?: InputMaybe<Scalars['String']['input']>;
  cpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpeNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cpeNameLT?: InputMaybe<Scalars['String']['input']>;
  cpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  cpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  cpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cpeNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eol_date field predicates */
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolDateGT?: InputMaybe<Scalars['Time']['input']>;
  eolDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  eolDateLT?: InputMaybe<Scalars['Time']['input']>;
  eolDateLTE?: InputMaybe<Scalars['Time']['input']>;
  eolDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  eolDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eolDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** eol_reached field predicates */
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  eolReachedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_items edge predicates */
  hasAssetItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemsWith?: InputMaybe<Array<AssetItemWhereInput>>;
  /** component_create_requests edge predicates */
  hasComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** component_external_identifiers edge predicates */
  hasComponentExternalIdentifiers?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentExternalIdentifiersWith?: InputMaybe<Array<ComponentExternalIdentifierWhereInput>>;
  /** component_mappings edge predicates */
  hasComponentMappings?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentMappingsWith?: InputMaybe<Array<ComponentMappingWhereInput>>;
  /** component_notifications edge predicates */
  hasComponentNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentNotificationsWith?: InputMaybe<Array<ComponentNotificationWhereInput>>;
  /** component_suggestion edge predicates */
  hasComponentSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSuggestionWith?: InputMaybe<Array<ComponentSuggestionWhereInput>>;
  /** component_vendor edge predicates */
  hasComponentVendor?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentVendorWith?: InputMaybe<Array<ComponentVendorWhereInput>>;
  /** measures edge predicates */
  hasMeasures?: InputMaybe<Scalars['Boolean']['input']>;
  hasMeasuresWith?: InputMaybe<Array<MeasureWhereInput>>;
  /** notifications edge predicates */
  hasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationsWith?: InputMaybe<Array<NotificationWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_valid field predicates */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_sync field predicates */
  lastSync?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSyncIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSyncLT?: InputMaybe<Scalars['Time']['input']>;
  lastSyncLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSyncNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSyncNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** monitored_since field predicates */
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  monitoredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNEQ?: InputMaybe<Scalars['Time']['input']>;
  monitoredSinceNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  monitoredSinceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** normalized_name field predicates */
  normalizedName?: InputMaybe<Scalars['String']['input']>;
  normalizedNameContains?: InputMaybe<Scalars['String']['input']>;
  normalizedNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  normalizedNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  normalizedNameGT?: InputMaybe<Scalars['String']['input']>;
  normalizedNameGTE?: InputMaybe<Scalars['String']['input']>;
  normalizedNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  normalizedNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  normalizedNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  normalizedNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  normalizedNameLT?: InputMaybe<Scalars['String']['input']>;
  normalizedNameLTE?: InputMaybe<Scalars['String']['input']>;
  normalizedNameNEQ?: InputMaybe<Scalars['String']['input']>;
  normalizedNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  normalizedNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** normalized_version field predicates */
  normalizedVersion?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionContains?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionContainsFold?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionEqualFold?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionGT?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionGTE?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  normalizedVersionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  normalizedVersionLT?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionLTE?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionNEQ?: InputMaybe<Scalars['String']['input']>;
  normalizedVersionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  normalizedVersionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ComponentWhereInput>;
  or?: InputMaybe<Array<ComponentWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_url field predicates */
  securityURL?: InputMaybe<Scalars['String']['input']>;
  securityURLContains?: InputMaybe<Scalars['String']['input']>;
  securityURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityURLGT?: InputMaybe<Scalars['String']['input']>;
  securityURLGTE?: InputMaybe<Scalars['String']['input']>;
  securityURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityURLLT?: InputMaybe<Scalars['String']['input']>;
  securityURLLTE?: InputMaybe<Scalars['String']['input']>;
  securityURLNEQ?: InputMaybe<Scalars['String']['input']>;
  securityURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ComponentWithSources = {
  __typename?: 'ComponentWithSources';
  componentVendor: ComponentVendor;
  cpeName?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['Time']['output']>;
  eolDate?: Maybe<Scalars['Time']['output']>;
  eolReached: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  monitoredSince?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  securityUrl?: Maybe<Scalars['String']['output']>;
  sourcesData: Array<ComponentSourceRaw>;
  updateTime?: Maybe<Scalars['Time']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type ComponentWithSourcesConnection = {
  __typename?: 'ComponentWithSourcesConnection';
  edges: Array<ComponentWithSourcesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComponentWithSourcesEdge = {
  __typename?: 'ComponentWithSourcesEdge';
  cursor: Scalars['Cursor']['output'];
  node: ComponentWithSources;
};

/**
 * ConfigurationWhereInput is used for filtering Configuration objects.
 * Input was generated by ent.
 */
export type ConfigurationWhereInput = {
  and?: InputMaybe<Array<ConfigurationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ConfigurationWhereInput>;
  or?: InputMaybe<Array<ConfigurationWhereInput>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CopyProjectInput = {
  copyAssetAttributes: Scalars['Boolean']['input'];
  copyAssetItems: Scalars['Boolean']['input'];
  copyAssetItemsAttributes: Scalars['Boolean']['input'];
  copyAssetRelations: Scalars['Boolean']['input'];
  copyAssetRelationsAttributes: Scalars['Boolean']['input'];
  copyAssets: Scalars['Boolean']['input'];
  copyCRAEU: Scalars['Boolean']['input'];
  copyCRAEULinkedFiles: Scalars['Boolean']['input'];
  copyCountries: Scalars['Boolean']['input'];
  copyCustomerAndLocation: Scalars['Boolean']['input'];
  copyMeasures: Scalars['Boolean']['input'];
  copyProjectAttributes: Scalars['Boolean']['input'];
  copyProjectHierarchies: Scalars['Boolean']['input'];
  copyProjectHierarchiesFiles: Scalars['Boolean']['input'];
  copyProjectHierarchiesTodos: Scalars['Boolean']['input'];
  copyProjectHierarchyAttributes: Scalars['Boolean']['input'];
  copyProjectUsers: Scalars['Boolean']['input'];
  copyProjectZoneStandardProfiles: Scalars['Boolean']['input'];
  copyProjectZones: Scalars['Boolean']['input'];
  copyPssClassification: Scalars['Boolean']['input'];
  copyStandardProfiles: Scalars['Boolean']['input'];
  copyTRA: Scalars['Boolean']['input'];
  copyTasks: Scalars['Boolean']['input'];
  copyTasksDeliverables: Scalars['Boolean']['input'];
  copyTasksEvidences: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  milestoneID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  statusID: Scalars['ID']['input'];
};

export type CopyProjectResult = {
  __typename?: 'CopyProjectResult';
  projectID: Scalars['ID']['output'];
};

export type Country = {
  __typename?: 'Country';
  children?: Maybe<Array<Country>>;
  code: Scalars['String']['output'];
  /**  Standards that are assinged to this country by country_standards  */
  countryStandards?: Maybe<Array<CountryStandard>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Country>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  edges: Array<CountryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryEdge = {
  __typename?: 'CountryEdge';
  cursor: Scalars['Cursor']['output'];
  node: Country;
};

export type CountryOrder = {
  direction: OrderDirection;
  field?: InputMaybe<CountryOrderField>;
};

export enum CountryOrderField {
  Id = 'ID',
  Name = 'NAME'
}

export type CountryStandard = {
  __typename?: 'CountryStandard';
  country: Country;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  standard: Standard;
};

export type CountryStandardConnection = {
  __typename?: 'CountryStandardConnection';
  edges: Array<CountryStandardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryStandardEdge = {
  __typename?: 'CountryStandardEdge';
  cursor: Scalars['Cursor']['output'];
  node: CountryStandard;
};

export type CountryStandardOrder = {
  direction: OrderDirection;
  field?: InputMaybe<CountryStandardOrderField>;
};

export enum CountryStandardOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Updatetime = 'UPDATETIME'
}

/**
 * CountryStandardWhereInput is used for filtering CountryStandard objects.
 * Input was generated by ent.
 */
export type CountryStandardWhereInput = {
  and?: InputMaybe<Array<CountryStandardWhereInput>>;
  /** country_id field predicates */
  countryID?: InputMaybe<Scalars['ID']['input']>;
  countryIDContains?: InputMaybe<Scalars['ID']['input']>;
  countryIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  countryIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  countryIDGT?: InputMaybe<Scalars['ID']['input']>;
  countryIDGTE?: InputMaybe<Scalars['ID']['input']>;
  countryIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  countryIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  countryIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDLT?: InputMaybe<Scalars['ID']['input']>;
  countryIDLTE?: InputMaybe<Scalars['ID']['input']>;
  countryIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  countryIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** country edge predicates */
  hasCountry?: InputMaybe<Scalars['Boolean']['input']>;
  hasCountryWith?: InputMaybe<Array<CountryWhereInput>>;
  /** standard edge predicates */
  hasStandard?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardWith?: InputMaybe<Array<StandardWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CountryStandardWhereInput>;
  or?: InputMaybe<Array<CountryStandardWhereInput>>;
  /** standard_id field predicates */
  standardID?: InputMaybe<Scalars['ID']['input']>;
  standardIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * CountryWhereInput is used for filtering Country objects.
 * Input was generated by ent.
 */
export type CountryWhereInput = {
  and?: InputMaybe<Array<CountryWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<CountryWhereInput>>;
  /** country_standards edge predicates */
  hasCountryStandards?: InputMaybe<Scalars['Boolean']['input']>;
  hasCountryStandardsWith?: InputMaybe<Array<CountryStandardWhereInput>>;
  /** parent edge predicates */
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentWith?: InputMaybe<Array<CountryWhereInput>>;
  /** project_countries edge predicates */
  hasProjectCountries?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectCountriesWith?: InputMaybe<Array<ProjectCountryWhereInput>>;
  /** standards edge predicates */
  hasStandards?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardsWith?: InputMaybe<Array<StandardWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<CountryWhereInput>;
  or?: InputMaybe<Array<CountryWhereInput>>;
  /** parent_id field predicates */
  parentID?: InputMaybe<Scalars['ID']['input']>;
  parentIDContains?: InputMaybe<Scalars['ID']['input']>;
  parentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  parentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  parentIDGT?: InputMaybe<Scalars['ID']['input']>;
  parentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  parentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  parentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  parentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentIDLT?: InputMaybe<Scalars['ID']['input']>;
  parentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  parentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateApiTokenInput = {
  /**
   *  How long the token should be valid, provide in days like '365' or '30'  max
   * value is 2 years wich is '730' DEFAULT: '365'
   */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /**  For who the token will be issued  */
  issueForID: Scalars['ID']['input'];
};

export type CreateApiTokenResponse = {
  __typename?: 'CreateAPITokenResponse';
  /**  When the token expires  */
  expiresAt: Scalars['Time']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  Who issued the token  */
  issuedByID: Scalars['ID']['output'];
  /**  For who the token was issued  */
  issuedForID?: Maybe<Scalars['ID']['output']>;
  /**  Token itself  */
  token: Scalars['String']['output'];
};

/**
 * CreateAreInput is used for create Are object.
 * Input was generated by ent.
 */
export type CreateAreInput = {
  name: Scalars['String']['input'];
};

/**
 * CreateAssetAttributeDefinitionInput is used for create AssetAttributeDefinition object.
 * Input was generated by ent.
 */
export type CreateAssetAttributeDefinitionInput = {
  assetTypeID: Scalars['ID']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AssetAttributeDefinitionType>;
};

export type CreateAssetAttributeDefinitionRawInput = {
  applyToAllTypes?: InputMaybe<Scalars['Boolean']['input']>;
  assetTypeID: Scalars['ID']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AssetAttributeDefinitionType>;
};

/**
 * CreateAssetAttributeInput is used for create AssetAttribute object.
 * Input was generated by ent.
 */
export type CreateAssetAttributeInput = {
  assetAttributeDefinitionID: Scalars['ID']['input'];
  assetID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetAttributeRawInput = {
  assetAttributeDefinitionID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAssetInput is used for create Asset object.
 * Input was generated by ent.
 */
export type CreateAssetInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  assetAttributeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetTypeID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectZoneID: Scalars['ID']['input'];
  status?: InputMaybe<AssetStatus>;
  systemRating?: InputMaybe<AssetSystemRating>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateAssetItemAttributeDefinitionInput is used for create AssetItemAttributeDefinition object.
 * Input was generated by ent.
 */
export type CreateAssetItemAttributeDefinitionInput = {
  assetItemType?: InputMaybe<AssetItemAttributeDefinitionAssetItemType>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AssetItemAttributeDefinitionType>;
};

export type CreateAssetItemAttributeDefinitionRawInput = {
  applyToAllTypes?: InputMaybe<Scalars['Boolean']['input']>;
  assetItemType: AssetItemAttributeDefinitionAssetItemType;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AssetItemAttributeDefinitionType>;
};

/**
 * CreateAssetItemAttributeInput is used for create AssetItemAttribute object.
 * Input was generated by ent.
 */
export type CreateAssetItemAttributeInput = {
  assetItemAttributeDefinitionID: Scalars['ID']['input'];
  assetItemID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetItemAttributeRawInput = {
  assetItemAttributeDefinitionID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAssetItemInput is used for create AssetItem object.
 * Input was generated by ent.
 */
export type CreateAssetItemInput = {
  assetID: Scalars['ID']['input'];
  componentID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<AssetItemType>;
};

export type CreateAssetItemRawInput = {
  assetID: Scalars['ID']['input'];
  attributes?: InputMaybe<Array<CreateAssetItemAttributeRawInput>>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<AssetItemType>;
};

export type CreateAssetRawInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['ID']['input'];
  attributes?: InputMaybe<Array<CreateAssetAttributeRawInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectZoneID: Scalars['ID']['input'];
  status?: InputMaybe<AssetStatus>;
  systemRating?: InputMaybe<AssetSystemRating>;
};

/**
 * CreateAssetRelationAttributeDefinitionInput is used for create AssetRelationAttributeDefinition object.
 * Input was generated by ent.
 */
export type CreateAssetRelationAttributeDefinitionInput = {
  label: Scalars['String']['input'];
  objectType: AssetRelationAttributeDefinitionObjectType;
  projectID: Scalars['ID']['input'];
  relationType: AssetRelationAttributeDefinitionRelationType;
  sequence: Scalars['Int']['input'];
  type: AssetRelationAttributeDefinitionType;
  userID: Scalars['ID']['input'];
};

export type CreateAssetRelationAttributeDefinitionRawInput = {
  label: Scalars['String']['input'];
  objectType: AssetRelationAttributeDefinitionObjectType;
  relationType: AssetRelationAttributeDefinitionRelationType;
  sequence: Scalars['Int']['input'];
  type: AssetRelationAttributeDefinitionType;
};

/**
 * CreateAssetRelationAttributeDefinitionTemplateInput is used for create AssetRelationAttributeDefinitionTemplate object.
 * Input was generated by ent.
 */
export type CreateAssetRelationAttributeDefinitionTemplateInput = {
  label: Scalars['String']['input'];
  objectType: AssetRelationAttributeDefinitionTemplateObjectType;
  projectTypeID: Scalars['ID']['input'];
  relationType: AssetRelationAttributeDefinitionTemplateRelationType;
  sequence: Scalars['Int']['input'];
  type: AssetRelationAttributeDefinitionTemplateType;
};

/**
 * CreateAssetRelationAttributeInput is used for create AssetRelationAttribute object.
 * Input was generated by ent.
 */
export type CreateAssetRelationAttributeInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionID: Scalars['ID']['input'];
  assetRelationID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/**
 * CreateAssetRelationInput is used for create AssetRelation object.
 * Input was generated by ent.
 */
export type CreateAssetRelationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sourceAssetID: Scalars['ID']['input'];
  targetAssetID: Scalars['ID']['input'];
  type: AssetRelationType;
  userID: Scalars['ID']['input'];
};

export type CreateAssetRelationRawAttributeInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreateAssetRelationRawInput = {
  assetRelationAttributes?: InputMaybe<Array<CreateAssetRelationRawAttributeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sourceAssetID: Scalars['ID']['input'];
  targetAssetID: Scalars['ID']['input'];
  type: AssetRelationType;
};

/**
 * CreateAssetTypeInput is used for create AssetType object.
 * Input was generated by ent.
 */
export type CreateAssetTypeInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
};

/**
 * CreateAttckAssetInput is used for create AttckAsset object.
 * Input was generated by ent.
 */
export type CreateAttckAssetInput = {
  attckID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAttckInput is used for create Attck object.
 * Input was generated by ent.
 */
export type CreateAttckInput = {
  assetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  domain?: InputMaybe<AttckDomain>;
  tacticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  techniqueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  url: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/**
 * CreateAttckMitigationInput is used for create AttckMitigation object.
 * Input was generated by ent.
 */
export type CreateAttckMitigationInput = {
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAttckTacticInput is used for create AttckTactic object.
 * Input was generated by ent.
 */
export type CreateAttckTacticInput = {
  attckID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAttckTechniqueAssetInput is used for create AttckTechniqueAsset object.
 * Input was generated by ent.
 */
export type CreateAttckTechniqueAssetInput = {
  assetID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueID: Scalars['ID']['input'];
};

/**
 * CreateAttckTechniqueInput is used for create AttckTechnique object.
 * Input was generated by ent.
 */
export type CreateAttckTechniqueInput = {
  attckID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  srcID?: InputMaybe<Scalars['String']['input']>;
  tacticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  techniqueAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  techniqueMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAttckTechniqueMitigationInput is used for create AttckTechniqueMitigation object.
 * Input was generated by ent.
 */
export type CreateAttckTechniqueMitigationInput = {
  description: Scalars['String']['input'];
  mitigationID: Scalars['ID']['input'];
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueID: Scalars['ID']['input'];
};

/**
 * CreateAuthTokenInput is used for create AuthToken object.
 * Input was generated by ent.
 */
export type CreateAuthTokenInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  expiresAtTime: Scalars['Time']['input'];
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  issuedforID?: InputMaybe<Scalars['ID']['input']>;
  issuerID: Scalars['ID']['input'];
  lastAccessTime?: InputMaybe<Scalars['Time']['input']>;
  purpose?: InputMaybe<AuthTokenPurpose>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateCRACybersecRiskAssessmentInput is used for create CRACybersecRiskAssessment object.
 * Input was generated by ent.
 */
export type CreateCraCybersecRiskAssessmentInput = {
  craID: Scalars['ID']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCraCybersecRiskAssessmentRawInput = {
  CRACybersecRiskAssessmentID: Scalars['ID']['input'];
  /**  When not provided: Default value is OPEN  */
  Completeness?: InputMaybe<CraCybersecRiskAssessmentUploadCompleteness>;
};

/**
 * CreateCRACybersecRiskAssessmentUploadInput is used for create CRACybersecRiskAssessmentUpload object.
 * Input was generated by ent.
 */
export type CreateCraCybersecRiskAssessmentUploadInput = {
  completeness?: InputMaybe<CraCybersecRiskAssessmentUploadCompleteness>;
  craCybersecRiskAssessmentID: Scalars['ID']['input'];
  fileAssetID: Scalars['ID']['input'];
};

/**
 * CreateCRADocumentationInput is used for create CRADocumentation object.
 * Input was generated by ent.
 */
export type CreateCraDocumentationInput = {
  craID: Scalars['ID']['input'];
  hasIntendedPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  hasProcessReference?: InputMaybe<Scalars['Boolean']['input']>;
  hasProductVisual?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecDesignArchitecture?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateCRADocumentationUploadInput is used for create CRADocumentationUpload object.
 * Input was generated by ent.
 */
export type CreateCraDocumentationUploadInput = {
  category?: InputMaybe<CraDocumentationUploadCategory>;
  craDocumentationID: Scalars['ID']['input'];
  createdByID: Scalars['ID']['input'];
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<CraDocumentationUploadKind>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCraDocumentationUploadRawInput = {
  CRADocumentationID: Scalars['ID']['input'];
  Category: CraDocumentationUploadCategory;
  Kind: CraDocumentationUploadKind;
  Link?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateCRAGeneralInput is used for create CRAGeneral object.
 * Input was generated by ent.
 */
export type CreateCraGeneralInput = {
  craID: Scalars['ID']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  productCategory?: InputMaybe<CraGeneralProductCategory>;
  productLifetime?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeEndDate?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDate?: InputMaybe<Scalars['Time']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productVersion?: InputMaybe<Scalars['String']['input']>;
  projectManagerID?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleID?: InputMaybe<Scalars['ID']['input']>;
  supportPeriod?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodInformation?: InputMaybe<Scalars['String']['input']>;
  supportPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateCRAInput is used for create CRA object.
 * Input was generated by ent.
 */
export type CreateCraInput = {
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  projectID: Scalars['ID']['input'];
  type?: InputMaybe<CraType>;
};

/**
 * CreateCRAModuleCommentInput is used for create CRAModuleComment object.
 * Input was generated by ent.
 */
export type CreateCraModuleCommentInput = {
  action?: InputMaybe<CraModuleCommentAction>;
  content: Scalars['String']['input'];
  /**
   * Ref to CRA entity meaning it is not only to CRA but also to CRADocumentation,
   * CRARiskAssessment, CRAVulnerabilityHandling, ...
   */
  craRefID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

/**
 * CreateCRAUploadInput is used for create CRAUpload object.
 * Input was generated by ent.
 */
export type CreateCraUploadInput = {
  craID: Scalars['ID']['input'];
  fileAssetID: Scalars['ID']['input'];
};

/**
 * CreateCRAVulnerabilityHandlingInput is used for create CRAVulnerabilityHandling object.
 * Input was generated by ent.
 */
export type CreateCraVulnerabilityHandlingInput = {
  craID: Scalars['ID']['input'];
  customerContact?: InputMaybe<Scalars['String']['input']>;
  customerContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  seContact?: InputMaybe<Scalars['String']['input']>;
  seContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateCRAVulnerabilityHandlingUploadInput is used for create CRAVulnerabilityHandlingUpload object.
 * Input was generated by ent.
 */
export type CreateCraVulnerabilityHandlingUploadInput = {
  craVulnerabilityHandlingID: Scalars['ID']['input'];
  fileAssetID: Scalars['ID']['input'];
};

/**
 * CreateCVSSOverridesInput is used for create CVSSOverrides object.
 * Input was generated by ent.
 */
export type CreateCvssOverridesInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  cvssID?: InputMaybe<Scalars['ID']['input']>;
  cvssVector: Scalars['String']['input'];
  notificationID: Scalars['ID']['input'];
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CvssOverridesType>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentCreateRequestCommentInput is used for create ComponentCreateRequestComment object.
 * Input was generated by ent.
 */
export type CreateComponentCreateRequestCommentInput = {
  comment: Scalars['String']['input'];
  componentCreateRequestsID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

/**
 * CreateComponentCreateRequestInput is used for create ComponentCreateRequest object.
 * Input was generated by ent.
 */
export type CreateComponentCreateRequestInput = {
  componentCreateRequestCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentCreateRequestStatusID: Scalars['ID']['input'];
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentName: Scalars['String']['input'];
  componentSourcesID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVersion: Scalars['String']['input'];
  externalComponentID?: InputMaybe<Scalars['String']['input']>;
  externalRequestRef?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatus?: InputMaybe<Scalars['String']['input']>;
  referenceSecurity?: InputMaybe<Scalars['String']['input']>;
  referenceWeb?: InputMaybe<Scalars['String']['input']>;
  requestPriority: ComponentCreateRequestRequestPriority;
  requesterID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateComponentCreateRequestRawInput = {
  componentName: Scalars['String']['input'];
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVersion: Scalars['String']['input'];
  referenceSecurity?: InputMaybe<Scalars['String']['input']>;
  referenceWeb?: InputMaybe<Scalars['String']['input']>;
  requestPriority: ComponentCreateRequestRequestPriority;
};

export type CreateComponentCreateRequestWithStatusTransitionsOutput = {
  __typename?: 'CreateComponentCreateRequestWithStatusTransitionsOutput';
  request: ComponentCreateRequest;
  statusTransitions: Array<ComponentCreateRequestViewAllowedStatusTransition>;
};

/**
 * CreateComponentExternalIdentifierInput is used for create ComponentExternalIdentifier object.
 * Input was generated by ent.
 */
export type CreateComponentExternalIdentifierInput = {
  componentID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  externalIdentifier: Scalars['String']['input'];
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ComponentExternalIdentifierSource>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentInput is used for create Component object.
 * Input was generated by ent.
 */
export type CreateComponentInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  componentVendorID: Scalars['ID']['input'];
  cpeName?: InputMaybe<Scalars['String']['input']>;
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['Time']['input']>;
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  projectID?: InputMaybe<Scalars['ID']['input']>;
  securityURL?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateComponentMappingInput is used for create ComponentMapping object.
 * Input was generated by ent.
 */
export type CreateComponentMappingInput = {
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentsID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateComponentNotificationInput is used for create ComponentNotification object.
 * Input was generated by ent.
 */
export type CreateComponentNotificationInput = {
  componentID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  mitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentRawInput is used for create ComponentRaw object.
 * Input was generated by ent.
 */
export type CreateComponentRawInput = {
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  componentSourcesID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  cpe23?: InputMaybe<Scalars['String']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  externalID: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  references?: InputMaybe<Array<Scalars['String']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vendorName: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/**
 * CreateComponentRawNotificationRawInput is used for create ComponentRawNotificationRaw object.
 * Input was generated by ent.
 */
export type CreateComponentRawNotificationRawInput = {
  componentRawsID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  notificationRawsID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentRawNotificationVilocifyRelationshipInput is used for create
 * ComponentRawNotificationVilocifyRelationship object.
 * Input was generated by ent.
 */
export type CreateComponentRawNotificationVilocifyRelationshipInput = {
  componentRawsID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  notificationVilocifyID: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentRawVulnerabilityRawInput is used for create ComponentRawVulnerabilityRaw object.
 * Input was generated by ent.
 */
export type CreateComponentRawVulnerabilityRawInput = {
  componentRawsID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityRawsID: Scalars['ID']['input'];
};

/**
 * CreateComponentSuggestionInput is used for create ComponentSuggestion object.
 * Input was generated by ent.
 */
export type CreateComponentSuggestionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  forName: Scalars['String']['input'];
  forVendor: Scalars['String']['input'];
  forVersion: Scalars['String']['input'];
  gotName: Scalars['String']['input'];
  gotVendor: Scalars['String']['input'];
  gotVersion: Scalars['String']['input'];
  isMatch?: InputMaybe<Scalars['Boolean']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateComponentSyncLogInput is used for create ComponentSyncLog object.
 * Input was generated by ent.
 */
export type CreateComponentSyncLogInput = {
  componentSourcesID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  status: ComponentSyncLogStatus;
  syncEndTime?: InputMaybe<Scalars['Time']['input']>;
  syncStartTime: Scalars['Time']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentVendorAssessmentInput is used for create ComponentVendorAssessment object.
 * Input was generated by ent.
 */
export type CreateComponentVendorAssessmentInput = {
  completionTime?: InputMaybe<Scalars['Time']['input']>;
  componentVendorID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ComponentVendorAssessmentResult>;
  status?: InputMaybe<ComponentVendorAssessmentStatus>;
  type?: InputMaybe<ComponentVendorAssessmentType>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateComponentVendorInput is used for create ComponentVendor object.
 * Input was generated by ent.
 */
export type CreateComponentVendorInput = {
  componentCreateRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ifa?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/**
 * CreateCountryStandardInput is used for create CountryStandard object.
 * Input was generated by ent.
 */
export type CreateCountryStandardInput = {
  countryID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  standardID: Scalars['ID']['input'];
};

/**
 * CreateFileAssetInput is used for create FileAsset object.
 * Input was generated by ent.
 */
export type CreateFileAssetInput = {
  contentType: Scalars['String']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  projectHierarchyFilesID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  /** actual entity which owns the file like task or project hierarchy */
  refID: Scalars['ID']['input'];
  /** size in bytes */
  size: Scalars['Int']['input'];
  storagekey: Scalars['String']['input'];
  taskCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskEvidenceID?: InputMaybe<Scalars['ID']['input']>;
  traReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateMaturityLevelInput is used for create MaturityLevel object.
 * Input was generated by ent.
 */
export type CreateMaturityLevelInput = {
  name: Scalars['String']['input'];
};

/**
 * CreateMeasureInput is used for create Measure object.
 * Input was generated by ent.
 */
export type CreateMeasureInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  howto?: InputMaybe<Scalars['String']['input']>;
  justification: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectID?: InputMaybe<Scalars['ID']['input']>;
  resources?: InputMaybe<Scalars['String']['input']>;
  type: MeasureType;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateToComponentID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateMitigationInput is used for create Mitigation object.
 * Input was generated by ent.
 */
export type CreateMitigationInput = {
  assetItemID: Scalars['ID']['input'];
  assignee: MitigationAssignee;
  measureID?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status: MitigationStatus;
  statusReason?: InputMaybe<Scalars['String']['input']>;
  workcycleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateMitigationTestInput is used for create MitigationTest object.
 * Input was generated by ent.
 */
export type CreateMitigationTestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  envName?: InputMaybe<Scalars['String']['input']>;
  measureID: Scalars['ID']['input'];
  mitigationID: Scalars['ID']['input'];
  result: MitigationTestResult;
  testerID: Scalars['ID']['input'];
};

export type CreateMitigationTestRawInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  envName?: InputMaybe<Scalars['String']['input']>;
  measureID: Scalars['ID']['input'];
  mitigationID: Scalars['ID']['input'];
  result: MitigationTestResult;
};

/**
 * CreateNVDMatchCriteriaInput is used for create NVDMatchCriteria object.
 * Input was generated by ent.
 */
export type CreateNvdMatchCriteriaInput = {
  componentNvdID: Scalars['String']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  isActive: Scalars['Boolean']['input'];
  matchCriteriaID: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotificationInput is used for create Notification object.
 * Input was generated by ent.
 */
export type CreateNotificationInput = {
  action: NotificationAction;
  attachments?: InputMaybe<Array<NotificationAttachment>>;
  body: Scalars['String']['input'];
  cfeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  confidentialityLevel?: InputMaybe<NotificationConfidentialityLevel>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  cvssBaseScore?: InputMaybe<Scalars['Float']['input']>;
  cvssID?: InputMaybe<Scalars['ID']['input']>;
  cvssOveralScore?: InputMaybe<Scalars['Float']['input']>;
  cvssOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  cvssTemporalScore?: InputMaybe<Scalars['Float']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cweIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalID: Scalars['String']['input'];
  impact?: InputMaybe<Scalars['String']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  legalNotice?: InputMaybe<Scalars['String']['input']>;
  prerequisite?: InputMaybe<Scalars['String']['input']>;
  priority: NotificationPriority;
  publishDate: Scalars['Time']['input'];
  references?: InputMaybe<Array<Scalars['String']['input']>>;
  reproduce?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<NotificationResource>>;
  solutionDetails?: InputMaybe<Scalars['String']['input']>;
  solutionStatus: Scalars['String']['input'];
  source?: InputMaybe<NotificationSource>;
  title: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vendorAdvisories?: InputMaybe<Array<NotificationVendorAdvisory>>;
};

/**
 * CreateNotificationRawInput is used for create NotificationRaw object.
 * Input was generated by ent.
 */
export type CreateNotificationRawInput = {
  action: Scalars['String']['input'];
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  componentSourcesID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  cvss?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalID: Scalars['String']['input'];
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  priority: Scalars['String']['input'];
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  references?: InputMaybe<Array<Scalars['String']['input']>>;
  solution?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vendorAdvisories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * CreateNotificationRawVulnerabilityRawInput is used for create NotificationRawVulnerabilityRaw object.
 * Input was generated by ent.
 */
export type CreateNotificationRawVulnerabilityRawInput = {
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  notificationRawsID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityRawsID: Scalars['ID']['input'];
};

/**
 * CreateNotificationRawVulnerabilityVilocifyRelationshipInput is used for create
 * NotificationRawVulnerabilityVilocifyRelationship object.
 * Input was generated by ent.
 */
export type CreateNotificationRawVulnerabilityVilocifyRelationshipInput = {
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  notificationRawsID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityVilocifyID: Scalars['String']['input'];
};

/**
 * CreateOrganizationInput is used for create Organization object.
 * Input was generated by ent.
 */
export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
  parentOrganizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrganizationRawInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentOrganizationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateOrganizationUserInput is used for create OrganizationUser object.
 * Input was generated by ent.
 */
export type CreateOrganizationUserInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  organizationID: Scalars['ID']['input'];
  role: OrganizationUserRole;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateProjectAttributeInput is used for create ProjectAttribute object.
 * Input was generated by ent.
 */
export type CreateProjectAttributeInput = {
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectAttributeType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectAttributeRawInput = {
  label: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  type: ProjectAttributeType;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateProjectAttributeTemplateInput is used for create ProjectAttributeTemplate object.
 * Input was generated by ent.
 */
export type CreateProjectAttributeTemplateInput = {
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectTypeID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectAttributeTemplateType>;
};

/**
 * CreateProjectCountryInput is used for create ProjectCountry object.
 * Input was generated by ent.
 */
export type CreateProjectCountryInput = {
  countryID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  projectID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateProjectGuidanceInput is used for create ProjectGuidance object.
 * Input was generated by ent.
 */
export type CreateProjectGuidanceInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  projectGuidanceRequirementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStandardProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeID: Scalars['ID']['input'];
  standardProfileID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  version: Scalars['Int']['input'];
};

/**
 * CreateProjectGuidanceRequirementInput is used for create ProjectGuidanceRequirement object.
 * Input was generated by ent.
 */
export type CreateProjectGuidanceRequirementInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  projectGuidanceID: Scalars['ID']['input'];
  projectMilestoneID: Scalars['ID']['input'];
  requirementID: Scalars['ID']['input'];
  taskTemplateID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateProjectHierarchyAssetInput is used for create ProjectHierarchyAsset object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyAssetInput = {
  assetID: Scalars['ID']['input'];
  projectHierarchyID: Scalars['ID']['input'];
};

/**
 * CreateProjectHierarchyAttributeDefinitionInput is used for create ProjectHierarchyAttributeDefinition object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyAttributeDefinitionInput = {
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  projectHierarchyTypeID: Scalars['ID']['input'];
  projectID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectHierarchyAttributeDefinitionType>;
};

/**
 * CreateProjectHierarchyAttributeInput is used for create ProjectHierarchyAttribute object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyAttributeInput = {
  projectHierarchyAttributeDefinitionID: Scalars['ID']['input'];
  projectHierarchyID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateProjectHierarchyFileInput is used for create ProjectHierarchyFile object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyFileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileAssetID: Scalars['ID']['input'];
  projectHierarchyID: Scalars['ID']['input'];
};

export type CreateProjectHierarchyFileRawInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  projectHierarchyID: Scalars['ID']['input'];
};

/**
 * CreateProjectHierarchyInput is used for create ProjectHierarchy object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyInput = {
  commodityManager?: InputMaybe<Scalars['String']['input']>;
  criticality?: InputMaybe<ProjectHierarchyCriticality>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  parentHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  typeID: Scalars['ID']['input'];
};

/**
 * CreateProjectHierarchyTodoInput is used for create ProjectHierarchyTodo object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyTodoInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  projectHierarchyID: Scalars['ID']['input'];
  /** sequence number to order rows in scope of single project hierarchy */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  status: ProjectHierarchyTodoStatus;
  title: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

export type CreateProjectHierarchyTodoRawInput = {
  description: Scalars['String']['input'];
  status: ProjectHierarchyTodoStatus;
  title: Scalars['String']['input'];
};

/**
 * CreateProjectHierarchyTypeInput is used for create ProjectHierarchyType object.
 * Input was generated by ent.
 */
export type CreateProjectHierarchyTypeInput = {
  name: Scalars['String']['input'];
  projectHierarchyAttributeDefinitionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProjectInput = {
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationStreet?: InputMaybe<Scalars['String']['input']>;
  milestoneID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  plantExternalID?: InputMaybe<Scalars['String']['input']>;
  plantName?: InputMaybe<Scalars['String']['input']>;
  pointInput?: InputMaybe<PointInput>;
  standardProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  statusID: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  typeID: Scalars['ID']['input'];
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateProjectMilestoneInput is used for create ProjectMilestone object.
 * Input was generated by ent.
 */
export type CreateProjectMilestoneInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectPhaseID: Scalars['ID']['input'];
  /** sequence number to order rows within one project phase */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateProjectPhaseInput is used for create ProjectPhase object.
 * Input was generated by ent.
 */
export type CreateProjectPhaseInput = {
  name: Scalars['String']['input'];
  projectTypeID: Scalars['ID']['input'];
  /** sequence number to order rows within one project type */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateProjectStandardProfileInput is used for create ProjectStandardProfile object.
 * Input was generated by ent.
 */
export type CreateProjectStandardProfileInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  projectGuidanceID: Scalars['ID']['input'];
  projectID: Scalars['ID']['input'];
  standardProfileID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateProjectStatusInput is used for create ProjectStatus object.
 * Input was generated by ent.
 */
export type CreateProjectStatusInput = {
  name: Scalars['String']['input'];
};

/**
 * CreateProjectTagInput is used for create ProjectTag object.
 * Input was generated by ent.
 */
export type CreateProjectTagInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  projectID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateProjectTypeInput is used for create ProjectType object.
 * Input was generated by ent.
 */
export type CreateProjectTypeInput = {
  assetRelationAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectAttributeTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateProjectUserInput is used for create ProjectUser object.
 * Input was generated by ent.
 */
export type CreateProjectUserInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  projectID: Scalars['ID']['input'];
  roleID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateProjectUserRoleInput is used for create ProjectUserRole object.
 * Input was generated by ent.
 */
export type CreateProjectUserRoleInput = {
  name: Scalars['String']['input'];
};

/**
 * CreateProjectZoneInput is used for create ProjectZone object.
 * Input was generated by ent.
 */
export type CreateProjectZoneInput = {
  assetsCount?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  exposureRating?: InputMaybe<ProjectZoneExposureRating>;
  name: Scalars['String']['input'];
  parentZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
};

/**
 * CreateProjectZoneStandardProfileInput is used for create ProjectZoneStandardProfile object.
 * Input was generated by ent.
 */
export type CreateProjectZoneStandardProfileInput = {
  projectZoneID: Scalars['ID']['input'];
  standardProfileID: Scalars['ID']['input'];
};

/**
 * CreateProjectZoneStandardProfileRequirementCommentInput is used for create
 * ProjectZoneStandardProfileRequirementComment object.
 * Input was generated by ent.
 */
export type CreateProjectZoneStandardProfileRequirementCommentInput = {
  comment: Scalars['String']['input'];
  projectZoneStandardProfileID: Scalars['ID']['input'];
  requirementCommentStatus?: InputMaybe<ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus>;
  requirementID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateProjectZoneStandardProfileRequirementCommentRawInput = {
  comment: Scalars['String']['input'];
  projectZoneID: Scalars['ID']['input'];
  requirementCommentStatus: ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus;
  requirementID: Scalars['ID']['input'];
  standardProfileID: Scalars['ID']['input'];
};

/**
 * CreateRequirementMappingInput is used for create RequirementMapping object.
 * Input was generated by ent.
 */
export type CreateRequirementMappingInput = {
  childRequirementID: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  parentRequirementID: Scalars['ID']['input'];
};

/**
 * CreateSecurityLevelInput is used for create SecurityLevel object.
 * Input was generated by ent.
 */
export type CreateSecurityLevelInput = {
  name: Scalars['String']['input'];
};

/**
 * CreateStandardInput is used for create Standard object.
 * Input was generated by ent.
 */
export type CreateStandardInput = {
  craType?: InputMaybe<StandardCraType>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  releasedAt: Scalars['Time']['input'];
  revisedFromID?: InputMaybe<Scalars['ID']['input']>;
  validFrom: Scalars['Time']['input'];
  validTo: Scalars['Time']['input'];
};

/**
 * CreateSurveyClassificationClassActivityInput is used for create SurveyClassificationClassActivity object.
 * Input was generated by ent.
 */
export type CreateSurveyClassificationClassActivityInput = {
  additionalDescription?: InputMaybe<Scalars['String']['input']>;
  classificationClassID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  necessity?: InputMaybe<SurveyClassificationClassActivityNecessity>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/**
 * CreateSurveyClassificationClassInput is used for create SurveyClassificationClass object.
 * Input was generated by ent.
 */
export type CreateSurveyClassificationClassInput = {
  activityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  formID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  surveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyScaleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateSurveyFormContentInput is used for create SurveyFormContent object.
 * Input was generated by ent.
 */
export type CreateSurveyFormContentInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  formID: Scalars['ID']['input'];
  profileID: Scalars['ID']['input'];
  questionID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  topicClusterTypeID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSurveyFormInput is used for create SurveyForm object.
 * Input was generated by ent.
 */
export type CreateSurveyFormInput = {
  authorID: Scalars['ID']['input'];
  classificationclassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<SurveyFormKind>;
  profileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  topicclustertypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  version: Scalars['Int']['input'];
};

/**
 * CreateSurveyInput is used for create Survey object.
 * Input was generated by ent.
 */
export type CreateSurveyInput = {
  actionTransitionLog: Scalars['String']['input'];
  answers: Scalars['String']['input'];
  approved1At?: InputMaybe<Scalars['Time']['input']>;
  approved2At?: InputMaybe<Scalars['Time']['input']>;
  approver1UserID?: InputMaybe<Scalars['ID']['input']>;
  approver2UserID?: InputMaybe<Scalars['ID']['input']>;
  authorID: Scalars['ID']['input'];
  classificationClassID: Scalars['ID']['input'];
  classificationScore?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conductedAt?: InputMaybe<Scalars['Time']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  declinedAt?: InputMaybe<Scalars['Time']['input']>;
  declinerUserID?: InputMaybe<Scalars['ID']['input']>;
  externalDocumentID?: InputMaybe<Scalars['String']['input']>;
  formID: Scalars['ID']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  optimisticLockVersion?: InputMaybe<Scalars['Int']['input']>;
  profileID: Scalars['ID']['input'];
  projectID: Scalars['ID']['input'];
  status?: InputMaybe<SurveyStatus>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSurveyProfileInput is used for create SurveyProfile object.
 * Input was generated by ent.
 */
export type CreateSurveyProfileInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  formID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  perequisties: Scalars['String']['input'];
  securityActivities: Scalars['String']['input'];
  surveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyScaleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyTemplateProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSurveyQuestionInput is used for create SurveyQuestion object.
 * Input was generated by ent.
 */
export type CreateSurveyQuestionInput = {
  answerHeader: Scalars['String']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  formID: Scalars['ID']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  questionGuidance: Scalars['String']['input'];
  surveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyQuestionOptionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  topic: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSurveyQuestionOptionInput is used for create SurveyQuestionOption object.
 * Input was generated by ent.
 */
export type CreateSurveyQuestionOptionInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  questionID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * CreateSurveyScaleInput is used for create SurveyScale object.
 * Input was generated by ent.
 */
export type CreateSurveyScaleInput = {
  classificationClassID: Scalars['ID']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  profileID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  upperLimit: Scalars['Int']['input'];
};

/**
 * CreateSurveyTemplateInput is used for create SurveyTemplate object.
 * Input was generated by ent.
 */
export type CreateSurveyTemplateInput = {
  answers: Scalars['String']['input'];
  authorID: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  formID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  profileID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSurveyTopicClusterTypeInput is used for create SurveyTopicClusterType object.
 * Input was generated by ent.
 */
export type CreateSurveyTopicClusterTypeInput = {
  calculationMethod: Scalars['String']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  formID: Scalars['ID']['input'];
  multiplier?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  surveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTRAInput is used for create TRA object.
 * Input was generated by ent.
 */
export type CreateTraInput = {
  approved1At?: InputMaybe<Scalars['Time']['input']>;
  approved2At?: InputMaybe<Scalars['Time']['input']>;
  approver1ID?: InputMaybe<Scalars['ID']['input']>;
  approver2ID?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  createdByID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  historyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  lockedAt?: InputMaybe<Scalars['Time']['input']>;
  lockedByID?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  participantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectID: Scalars['ID']['input'];
  reportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<TraStatus>;
  title: Scalars['String']['input'];
};

/**
 * CreateTRAParticipantInput is used for create TRAParticipant object.
 * Input was generated by ent.
 */
export type CreateTraParticipantInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  traID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

export type CreateTraRawInput = {
  approver1?: InputMaybe<Scalars['ID']['input']>;
  approver2?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  description: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  projectID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/**
 * CreateTRAReportInput is used for create TRAReport object.
 * Input was generated by ent.
 */
export type CreateTraReportInput = {
  authorID: Scalars['ID']['input'];
  classification?: InputMaybe<TraReportClassification>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  /** this is document type, file extension */
  extension: Scalars['String']['input'];
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  traID: Scalars['ID']['input'];
};

export type CreateTraReportRawInput = {
  /** classification/visibility of report */
  classification: TraReportClassification;
  /** report description */
  description: Scalars['String']['input'];
  /** content extension like: pdf, doc, docx, csv, etc. */
  extension: TraReportExtension;
  /** meaningful title of report */
  title: Scalars['String']['input'];
  /** ID of TRA to which report will be added */
  traID: Scalars['ID']['input'];
};

/**
 * CreateTaskCommentInput is used for create TaskComment object.
 * Input was generated by ent.
 */
export type CreateTaskCommentInput = {
  content: Scalars['String']['input'];
  createTime?: InputMaybe<Scalars['Time']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  taskID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

export type CreateTaskCommentRawInput = {
  content: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};

/**
 * CreateTaskDeliverableInput is used for create TaskDeliverable object.
 * Input was generated by ent.
 */
export type CreateTaskDeliverableInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  isChecked?: InputMaybe<Scalars['Boolean']['input']>;
  taskID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTaskEvidenceInput is used for create TaskEvidence object.
 * Input was generated by ent.
 */
export type CreateTaskEvidenceInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createdByID: Scalars['ID']['input'];
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<TaskEvidenceKind>;
  link?: InputMaybe<Scalars['String']['input']>;
  taskID: Scalars['ID']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

export type CreateTaskEvidenceRawInput = {
  kind: TaskEvidenceKind;
  link?: InputMaybe<Scalars['String']['input']>;
  taskID: Scalars['ID']['input'];
};

/**
 * CreateTaskInput is used for create Task object.
 * Input was generated by ent.
 */
export type CreateTaskInput = {
  assigneeID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<TaskKind>;
  lastChangedAt?: InputMaybe<Scalars['Time']['input']>;
  parentTaskID?: InputMaybe<Scalars['ID']['input']>;
  priority: TaskPriority;
  projectID: Scalars['ID']['input'];
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  source: TaskSource;
  /** this is id ref to source which can be projects.id or mitigations.id or tras.id or ...., see source ENUM */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status: TaskStatus;
  title: Scalars['String']['input'];
  topic?: InputMaybe<TaskTopic>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

export type CreateTaskRawInput = {
  assigneeID?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  kind: TaskKind;
  priority: TaskPriority;
  projectID: Scalars['ID']['input'];
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TaskSource>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status: TaskStatus;
  title: Scalars['String']['input'];
  topic: TaskTopic;
};

/**
 * CreateTaskTemplateInput is used for create TaskTemplate object.
 * Input was generated by ent.
 */
export type CreateTaskTemplateInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  deliverables?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  priority: TaskTemplatePriority;
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topic?: InputMaybe<TaskTemplateTopic>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type CreateUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  are: Scalars['String']['input'];
  assetRelationAttributeDefinitionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetRelationAttributeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetRelationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentCreateRequestCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentCreateRequestsModifierIDIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentCreateRequestsRequesterIDIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  craModuleCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdFileAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdTaskEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gid: Scalars['String']['input'];
  issuedforIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastName: Scalars['String']['input'];
  location: Scalars['String']['input'];
  mitigationTestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationSettingID?: InputMaybe<Scalars['ID']['input']>;
  orgCode: Scalars['String']['input'];
  organizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneStandardProfilesRequirementCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityResponsibleProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyAprrover1IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyAprrover2IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyAuthorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyDeclinerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyFormIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyTemplateAuthorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  traParticipantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateUserNotificationSettingInput is used for create UserNotificationSetting object.
 * Input was generated by ent.
 */
export type CreateUserNotificationSettingInput = {
  createTime?: InputMaybe<Scalars['Time']['input']>;
  enable: Scalars['Boolean']['input'];
  frequency?: InputMaybe<UserNotificationSettingFrequency>;
  projects?: InputMaybe<Array<UserNotificationSettingProjectConfiguration>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateVulnerabilityCVSSRawInput is used for create VulnerabilityCVSSRaw object.
 * Input was generated by ent.
 */
export type CreateVulnerabilityCvssRawInput = {
  baseScore: Scalars['Float']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vector: Scalars['String']['input'];
  version: Scalars['String']['input'];
  vulnerabilityRawsID: Scalars['ID']['input'];
};

/**
 * CreateVulnerabilityRawComponentNVDRelationshipInput is used for create VulnerabilityRawComponentNVDRelationship object.
 * Input was generated by ent.
 */
export type CreateVulnerabilityRawComponentNvdRelationshipInput = {
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  cveNvdID: Scalars['String']['input'];
  matchCriteriaID: Scalars['String']['input'];
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityRawsID: Scalars['ID']['input'];
};

/**
 * CreateVulnerabilityRawInput is used for create VulnerabilityRaw object.
 * Input was generated by ent.
 */
export type CreateVulnerabilityRawInput = {
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  componentSourcesID: Scalars['ID']['input'];
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  createTime?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  externalID: Scalars['String']['input'];
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  weakness?: InputMaybe<Scalars['String']['input']>;
};

export type Cve = {
  __typename?: 'Cve';
  code: Scalars['String']['output'];
  cvssBaseScore?: Maybe<Scalars['Float']['output']>;
  cvssExploitabilityScore?: Maybe<Scalars['Float']['output']>;
  cvssImpactScore?: Maybe<Scalars['Float']['output']>;
  cvssVector?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUpdateDate: Scalars['Time']['output'];
  publishDate: Scalars['Time']['output'];
  source: CveSource;
  weakness?: Maybe<Scalars['String']['output']>;
};

export enum CveSource {
  Nvd = 'NVD',
  Svm = 'SVM'
}

/**
 * CveWhereInput is used for filtering Cve objects.
 * Input was generated by ent.
 */
export type CveWhereInput = {
  and?: InputMaybe<Array<CveWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  bodyContains?: InputMaybe<Scalars['String']['input']>;
  bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyGT?: InputMaybe<Scalars['String']['input']>;
  bodyGTE?: InputMaybe<Scalars['String']['input']>;
  bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bodyLT?: InputMaybe<Scalars['String']['input']>;
  bodyLTE?: InputMaybe<Scalars['String']['input']>;
  bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cvss_base_score field predicates */
  cvssBaseScore?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreGT?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssBaseScoreIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cvssBaseScoreLT?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssBaseScoreNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cvss_exploitability_score field predicates */
  cvssExploitabilityScore?: InputMaybe<Scalars['Float']['input']>;
  cvssExploitabilityScoreGT?: InputMaybe<Scalars['Float']['input']>;
  cvssExploitabilityScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  cvssExploitabilityScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssExploitabilityScoreIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cvssExploitabilityScoreLT?: InputMaybe<Scalars['Float']['input']>;
  cvssExploitabilityScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  cvssExploitabilityScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  cvssExploitabilityScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssExploitabilityScoreNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cvss_impact_score field predicates */
  cvssImpactScore?: InputMaybe<Scalars['Float']['input']>;
  cvssImpactScoreGT?: InputMaybe<Scalars['Float']['input']>;
  cvssImpactScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  cvssImpactScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssImpactScoreIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cvssImpactScoreLT?: InputMaybe<Scalars['Float']['input']>;
  cvssImpactScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  cvssImpactScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  cvssImpactScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssImpactScoreNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cvss_vector field predicates */
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cvssVectorContains?: InputMaybe<Scalars['String']['input']>;
  cvssVectorContainsFold?: InputMaybe<Scalars['String']['input']>;
  cvssVectorEqualFold?: InputMaybe<Scalars['String']['input']>;
  cvssVectorGT?: InputMaybe<Scalars['String']['input']>;
  cvssVectorGTE?: InputMaybe<Scalars['String']['input']>;
  cvssVectorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cvssVectorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cvssVectorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cvssVectorIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cvssVectorLT?: InputMaybe<Scalars['String']['input']>;
  cvssVectorLTE?: InputMaybe<Scalars['String']['input']>;
  cvssVectorNEQ?: InputMaybe<Scalars['String']['input']>;
  cvssVectorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cvssVectorNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** notification_cves edge predicates */
  hasNotificationCves?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationCvesWith?: InputMaybe<Array<NotificationCveWhereInput>>;
  /** notifications edge predicates */
  hasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationsWith?: InputMaybe<Array<NotificationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_update_date field predicates */
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<CveWhereInput>;
  or?: InputMaybe<Array<CveWhereInput>>;
  /** publish_date field predicates */
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  publishDateGT?: InputMaybe<Scalars['Time']['input']>;
  publishDateGTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateLT?: InputMaybe<Scalars['Time']['input']>;
  publishDateLTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  publishDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** source field predicates */
  source?: InputMaybe<CveSource>;
  sourceIn?: InputMaybe<Array<CveSource>>;
  sourceNEQ?: InputMaybe<CveSource>;
  sourceNotIn?: InputMaybe<Array<CveSource>>;
  /** sourceStatus field predicates */
  sourcestatus?: InputMaybe<Scalars['String']['input']>;
  sourcestatusContains?: InputMaybe<Scalars['String']['input']>;
  sourcestatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  sourcestatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  sourcestatusGT?: InputMaybe<Scalars['String']['input']>;
  sourcestatusGTE?: InputMaybe<Scalars['String']['input']>;
  sourcestatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sourcestatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sourcestatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcestatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourcestatusLT?: InputMaybe<Scalars['String']['input']>;
  sourcestatusLTE?: InputMaybe<Scalars['String']['input']>;
  sourcestatusNEQ?: InputMaybe<Scalars['String']['input']>;
  sourcestatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcestatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** weakness field predicates */
  weakness?: InputMaybe<Scalars['String']['input']>;
  weaknessContains?: InputMaybe<Scalars['String']['input']>;
  weaknessContainsFold?: InputMaybe<Scalars['String']['input']>;
  weaknessEqualFold?: InputMaybe<Scalars['String']['input']>;
  weaknessGT?: InputMaybe<Scalars['String']['input']>;
  weaknessGTE?: InputMaybe<Scalars['String']['input']>;
  weaknessHasPrefix?: InputMaybe<Scalars['String']['input']>;
  weaknessHasSuffix?: InputMaybe<Scalars['String']['input']>;
  weaknessIn?: InputMaybe<Array<Scalars['String']['input']>>;
  weaknessIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  weaknessLT?: InputMaybe<Scalars['String']['input']>;
  weaknessLTE?: InputMaybe<Scalars['String']['input']>;
  weaknessNEQ?: InputMaybe<Scalars['String']['input']>;
  weaknessNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  weaknessNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CweWhereInput is used for filtering Cwe objects.
 * Input was generated by ent.
 */
export type CweWhereInput = {
  and?: InputMaybe<Array<CweWhereInput>>;
  /** cwe field predicates */
  cwe?: InputMaybe<Scalars['Int']['input']>;
  cweGT?: InputMaybe<Scalars['Int']['input']>;
  cweGTE?: InputMaybe<Scalars['Int']['input']>;
  cweIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cweLT?: InputMaybe<Scalars['Int']['input']>;
  cweLTE?: InputMaybe<Scalars['Int']['input']>;
  cweNEQ?: InputMaybe<Scalars['Int']['input']>;
  cweNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notification_cwes edge predicates */
  hasNotificationCwes?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationCwesWith?: InputMaybe<Array<NotificationCweWhereInput>>;
  /** notifications edge predicates */
  hasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationsWith?: InputMaybe<Array<NotificationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<CweWhereInput>;
  or?: InputMaybe<Array<CweWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeactivateUserInput = {
  id: Scalars['ID']['input'];
};

export type EncodedFile = {
  __typename?: 'EncodedFile';
  content: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EncodedFileOrError = EncodedFile | ErrNotAuthorized;

export type ErrInvalidInput = Error & {
  __typename?: 'ErrInvalidInput';
  message: Scalars['String']['output'];
  parameters: Array<Scalars['String']['output']>;
  reasons: Array<Scalars['String']['output']>;
};

export type ErrInvalidToken = Error & {
  __typename?: 'ErrInvalidToken';
  message: Scalars['String']['output'];
};

export type ErrNotAuthorized = Error & {
  __typename?: 'ErrNotAuthorized';
  cause: AuthorizationError;
  message: Scalars['String']['output'];
};

export type ErrSubjectNotAuthorized = Error & {
  __typename?: 'ErrSubjectNotAuthorized';
  action: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type ErrUserNotActive = Error & {
  __typename?: 'ErrUserNotActive';
  message: Scalars['String']['output'];
};

export type ErrUserNotFound = Error & {
  __typename?: 'ErrUserNotFound';
  message: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type FileAsset = {
  __typename?: 'FileAsset';
  contentType: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  /** Who created/uploaded the file asset, may be null */
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** ID of the project which owns the file */
  projectID: Scalars['ID']['output'];
  /** ID of the project's entity which owns the file, ie.: task or project hierarchy */
  refID: Scalars['ID']['output'];
  size: Scalars['Int']['output'];
  updateTime: Scalars['Time']['output'];
};

/**
 * FileAssetWhereInput is used for filtering FileAsset objects.
 * Input was generated by ent.
 */
export type FileAssetWhereInput = {
  and?: InputMaybe<Array<FileAssetWhereInput>>;
  /** content_type field predicates */
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentTypeContains?: InputMaybe<Scalars['String']['input']>;
  contentTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  contentTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  contentTypeGT?: InputMaybe<Scalars['String']['input']>;
  contentTypeGTE?: InputMaybe<Scalars['String']['input']>;
  contentTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contentTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contentTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentTypeLT?: InputMaybe<Scalars['String']['input']>;
  contentTypeLTE?: InputMaybe<Scalars['String']['input']>;
  contentTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  contentTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContains?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDLT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDLTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_hierarchy_files edge predicates */
  hasProjectHierarchyFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyFilesWith?: InputMaybe<Array<ProjectHierarchyFileWhereInput>>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** task_comment edge predicates */
  hasTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskCommentWith?: InputMaybe<Array<TaskCommentWhereInput>>;
  /** task_evidence edge predicates */
  hasTaskEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskEvidenceWith?: InputMaybe<Array<TaskEvidenceWhereInput>>;
  /** tra_report edge predicates */
  hasTraReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasTraReportWith?: InputMaybe<Array<TraReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<FileAssetWhereInput>;
  or?: InputMaybe<Array<FileAssetWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ref_id field predicates */
  refID?: InputMaybe<Scalars['ID']['input']>;
  refIDContains?: InputMaybe<Scalars['ID']['input']>;
  refIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  refIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  refIDGT?: InputMaybe<Scalars['ID']['input']>;
  refIDGTE?: InputMaybe<Scalars['ID']['input']>;
  refIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  refIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  refIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refIDLT?: InputMaybe<Scalars['ID']['input']>;
  refIDLTE?: InputMaybe<Scalars['ID']['input']>;
  refIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  refIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** size field predicates */
  size?: InputMaybe<Scalars['Int']['input']>;
  sizeGT?: InputMaybe<Scalars['Int']['input']>;
  sizeGTE?: InputMaybe<Scalars['Int']['input']>;
  sizeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizeLT?: InputMaybe<Scalars['Int']['input']>;
  sizeLTE?: InputMaybe<Scalars['Int']['input']>;
  sizeNEQ?: InputMaybe<Scalars['Int']['input']>;
  sizeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** storageKey field predicates */
  storagekey?: InputMaybe<Scalars['String']['input']>;
  storagekeyContains?: InputMaybe<Scalars['String']['input']>;
  storagekeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  storagekeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  storagekeyGT?: InputMaybe<Scalars['String']['input']>;
  storagekeyGTE?: InputMaybe<Scalars['String']['input']>;
  storagekeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  storagekeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  storagekeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  storagekeyLT?: InputMaybe<Scalars['String']['input']>;
  storagekeyLTE?: InputMaybe<Scalars['String']['input']>;
  storagekeyNEQ?: InputMaybe<Scalars['String']['input']>;
  storagekeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  edges: Array<LocationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Location;
};

export type LocationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<LocationOrderField>;
};

export enum LocationOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * LocationWhereInput is used for filtering Location objects.
 * Input was generated by ent.
 */
export type LocationWhereInput = {
  and?: InputMaybe<Array<LocationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<LocationWhereInput>;
  or?: InputMaybe<Array<LocationWhereInput>>;
};

export type MaintenanceData = {
  __typename?: 'MaintenanceData';
  message?: Maybe<Scalars['String']['output']>;
};

export type MappingCoverage = {
  __typename?: 'MappingCoverage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * MappingCoverageWhereInput is used for filtering MappingCoverage objects.
 * Input was generated by ent.
 */
export type MappingCoverageWhereInput = {
  and?: InputMaybe<Array<MappingCoverageWhereInput>>;
  /** requirement_mappings edge predicates */
  hasRequirementMappings?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementMappingsWith?: InputMaybe<Array<RequirementMappingWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<MappingCoverageWhereInput>;
  or?: InputMaybe<Array<MappingCoverageWhereInput>>;
};

export type MaturityLevel = {
  __typename?: 'MaturityLevel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MaturityLevelConnection = {
  __typename?: 'MaturityLevelConnection';
  edges: Array<MaturityLevelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MaturityLevelEdge = {
  __typename?: 'MaturityLevelEdge';
  cursor: Scalars['Cursor']['output'];
  node: MaturityLevel;
};

export type MaturityLevelOrder = {
  direction: OrderDirection;
  field?: InputMaybe<MaturityLevelOrderField>;
};

export enum MaturityLevelOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * MaturityLevelWhereInput is used for filtering MaturityLevel objects.
 * Input was generated by ent.
 */
export type MaturityLevelWhereInput = {
  and?: InputMaybe<Array<MaturityLevelWhereInput>>;
  /** requirements edge predicates */
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementsWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<MaturityLevelWhereInput>;
  or?: InputMaybe<Array<MaturityLevelWhereInput>>;
};

export type Measure = {
  __typename?: 'Measure';
  createTime: Scalars['Time']['output'];
  howto?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  justification?: Maybe<Scalars['String']['output']>;
  mitigations?: Maybe<Array<Mitigation>>;
  name: Scalars['String']['output'];
  project: Project;
  resources?: Maybe<Scalars['String']['output']>;
  type: MeasureType;
  updateTime: Scalars['Time']['output'];
  updateToComponent?: Maybe<Component>;
};

export type MeasureConnection = {
  __typename?: 'MeasureConnection';
  edges: Array<MeasureEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MeasureEdge = {
  __typename?: 'MeasureEdge';
  cursor: Scalars['Cursor']['output'];
  node: Measure;
};

export type MeasureOrder = {
  direction: OrderDirection;
  field?: InputMaybe<MeasureOrderField>;
};

export enum MeasureOrderField {
  Howto = 'HOWTO',
  Justification = 'JUSTIFICATION',
  Name = 'NAME',
  Resources = 'RESOURCES',
  Type = 'TYPE'
}

export enum MeasureType {
  Compensatingfix = 'COMPENSATINGFIX',
  Ignorandaccepttherisk = 'IGNORANDACCEPTTHERISK',
  Notapplicable = 'NOTAPPLICABLE',
  Updatecomponent = 'UPDATECOMPONENT'
}

/**
 * MeasureWhereInput is used for filtering Measure objects.
 * Input was generated by ent.
 */
export type MeasureWhereInput = {
  and?: InputMaybe<Array<MeasureWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** mitigation_tests edge predicates */
  hasMitigationTests?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationTestsWith?: InputMaybe<Array<MitigationTestWhereInput>>;
  /** mitigations edge predicates */
  hasMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationsWith?: InputMaybe<Array<MitigationWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** update_to_component edge predicates */
  hasUpdateToComponent?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateToComponentWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** howto field predicates */
  howto?: InputMaybe<Scalars['String']['input']>;
  howtoContains?: InputMaybe<Scalars['String']['input']>;
  howtoContainsFold?: InputMaybe<Scalars['String']['input']>;
  howtoEqualFold?: InputMaybe<Scalars['String']['input']>;
  howtoGT?: InputMaybe<Scalars['String']['input']>;
  howtoGTE?: InputMaybe<Scalars['String']['input']>;
  howtoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  howtoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  howtoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  howtoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  howtoLT?: InputMaybe<Scalars['String']['input']>;
  howtoLTE?: InputMaybe<Scalars['String']['input']>;
  howtoNEQ?: InputMaybe<Scalars['String']['input']>;
  howtoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  howtoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** justification field predicates */
  justification?: InputMaybe<Scalars['String']['input']>;
  justificationContains?: InputMaybe<Scalars['String']['input']>;
  justificationContainsFold?: InputMaybe<Scalars['String']['input']>;
  justificationEqualFold?: InputMaybe<Scalars['String']['input']>;
  justificationGT?: InputMaybe<Scalars['String']['input']>;
  justificationGTE?: InputMaybe<Scalars['String']['input']>;
  justificationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  justificationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  justificationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  justificationLT?: InputMaybe<Scalars['String']['input']>;
  justificationLTE?: InputMaybe<Scalars['String']['input']>;
  justificationNEQ?: InputMaybe<Scalars['String']['input']>;
  justificationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<MeasureWhereInput>;
  or?: InputMaybe<Array<MeasureWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** resources field predicates */
  resources?: InputMaybe<Scalars['String']['input']>;
  resourcesContains?: InputMaybe<Scalars['String']['input']>;
  resourcesContainsFold?: InputMaybe<Scalars['String']['input']>;
  resourcesEqualFold?: InputMaybe<Scalars['String']['input']>;
  resourcesGT?: InputMaybe<Scalars['String']['input']>;
  resourcesGTE?: InputMaybe<Scalars['String']['input']>;
  resourcesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  resourcesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  resourcesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  resourcesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  resourcesLT?: InputMaybe<Scalars['String']['input']>;
  resourcesLTE?: InputMaybe<Scalars['String']['input']>;
  resourcesNEQ?: InputMaybe<Scalars['String']['input']>;
  resourcesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  resourcesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  type?: InputMaybe<MeasureType>;
  typeIn?: InputMaybe<Array<MeasureType>>;
  typeNEQ?: InputMaybe<MeasureType>;
  typeNotIn?: InputMaybe<Array<MeasureType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** update_to_component_id field predicates */
  updateToComponentID?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDContains?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDGT?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateToComponentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updateToComponentIDLT?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  updateToComponentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateToComponentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mitigation = {
  __typename?: 'Mitigation';
  assetItem: AssetItem;
  assignee: MitigationAssignee;
  componentNotification?: Maybe<ComponentNotification>;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  measure?: Maybe<Measure>;
  mitigationTests?: Maybe<Array<Maybe<MitigationTest>>>;
  status: MitigationStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['Time']['output'];
  workcycle?: Maybe<Task>;
};

export enum MitigationAssignee {
  Customer = 'CUSTOMER',
  None = 'NONE',
  Siemensenergy = 'SIEMENSENERGY'
}

export type MitigationConnection = {
  __typename?: 'MitigationConnection';
  edges: Array<MitigationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MitigationEdge = {
  __typename?: 'MitigationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Mitigation;
};

export type MitigationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<MitigationOrderField>;
};

export enum MitigationOrderField {
  Assetitemid = 'ASSETITEMID',
  Assignee = 'ASSIGNEE',
  Componentnotificationid = 'COMPONENTNOTIFICATIONID',
  Measureid = 'MEASUREID',
  Status = 'STATUS',
  Statusreason = 'STATUSREASON',
  Workcycleid = 'WORKCYCLEID'
}

export enum MitigationStatus {
  Completed = 'COMPLETED',
  Measureremoved = 'MEASUREREMOVED',
  Obsolete = 'OBSOLETE',
  Planned = 'PLANNED',
  Revoked = 'REVOKED'
}

export type MitigationTest = {
  __typename?: 'MitigationTest';
  comment?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['Time']['output'];
  envName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  measure: Measure;
  mitigation: Mitigation;
  result: MitigationTestResult;
  tester: User;
  updateTime: Scalars['Time']['output'];
};

export enum MitigationTestResult {
  Failed = 'FAILED',
  Notapplicable = 'NOTAPPLICABLE',
  Nottested = 'NOTTESTED',
  Partiallypassed = 'PARTIALLYPASSED',
  Passsed = 'PASSSED'
}

/**
 * MitigationTestWhereInput is used for filtering MitigationTest objects.
 * Input was generated by ent.
 */
export type MitigationTestWhereInput = {
  and?: InputMaybe<Array<MitigationTestWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** env_name field predicates */
  envName?: InputMaybe<Scalars['String']['input']>;
  envNameContains?: InputMaybe<Scalars['String']['input']>;
  envNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  envNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  envNameGT?: InputMaybe<Scalars['String']['input']>;
  envNameGTE?: InputMaybe<Scalars['String']['input']>;
  envNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  envNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  envNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  envNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  envNameLT?: InputMaybe<Scalars['String']['input']>;
  envNameLTE?: InputMaybe<Scalars['String']['input']>;
  envNameNEQ?: InputMaybe<Scalars['String']['input']>;
  envNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  envNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** measure edge predicates */
  hasMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  hasMeasureWith?: InputMaybe<Array<MeasureWhereInput>>;
  /** mitigation edge predicates */
  hasMitigation?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationWith?: InputMaybe<Array<MitigationWhereInput>>;
  /** tester edge predicates */
  hasTester?: InputMaybe<Scalars['Boolean']['input']>;
  hasTesterWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** measure_id field predicates */
  measureID?: InputMaybe<Scalars['ID']['input']>;
  measureIDContains?: InputMaybe<Scalars['ID']['input']>;
  measureIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  measureIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  measureIDGT?: InputMaybe<Scalars['ID']['input']>;
  measureIDGTE?: InputMaybe<Scalars['ID']['input']>;
  measureIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  measureIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  measureIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  measureIDLT?: InputMaybe<Scalars['ID']['input']>;
  measureIDLTE?: InputMaybe<Scalars['ID']['input']>;
  measureIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  measureIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** mitigation_id field predicates */
  mitigationID?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDContains?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDGT?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mitigationIDLT?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<MitigationTestWhereInput>;
  or?: InputMaybe<Array<MitigationTestWhereInput>>;
  /** result field predicates */
  result?: InputMaybe<MitigationTestResult>;
  resultIn?: InputMaybe<Array<MitigationTestResult>>;
  resultNEQ?: InputMaybe<MitigationTestResult>;
  resultNotIn?: InputMaybe<Array<MitigationTestResult>>;
  /** tester_id field predicates */
  testerID?: InputMaybe<Scalars['ID']['input']>;
  testerIDContains?: InputMaybe<Scalars['ID']['input']>;
  testerIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  testerIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  testerIDGT?: InputMaybe<Scalars['ID']['input']>;
  testerIDGTE?: InputMaybe<Scalars['ID']['input']>;
  testerIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  testerIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  testerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  testerIDLT?: InputMaybe<Scalars['ID']['input']>;
  testerIDLTE?: InputMaybe<Scalars['ID']['input']>;
  testerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  testerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * MitigationWhereInput is used for filtering Mitigation objects.
 * Input was generated by ent.
 */
export type MitigationWhereInput = {
  and?: InputMaybe<Array<MitigationWhereInput>>;
  /** asset_item_id field predicates */
  assetItemID?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetItemIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** assignee field predicates */
  assignee?: InputMaybe<MitigationAssignee>;
  assigneeIn?: InputMaybe<Array<MitigationAssignee>>;
  assigneeNEQ?: InputMaybe<MitigationAssignee>;
  assigneeNotIn?: InputMaybe<Array<MitigationAssignee>>;
  /** component_notification_id field predicates */
  componentNotificationID?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentNotificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentNotificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset_item edge predicates */
  hasAssetItem?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemWith?: InputMaybe<Array<AssetItemWhereInput>>;
  /** component_notification edge predicates */
  hasComponentNotification?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentNotificationWith?: InputMaybe<Array<ComponentNotificationWhereInput>>;
  /** measure edge predicates */
  hasMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  hasMeasureWith?: InputMaybe<Array<MeasureWhereInput>>;
  /** mitigation_tests edge predicates */
  hasMitigationTests?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationTestsWith?: InputMaybe<Array<MitigationTestWhereInput>>;
  /** workcycle edge predicates */
  hasWorkcycle?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkcycleWith?: InputMaybe<Array<TaskWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** measure_id field predicates */
  measureID?: InputMaybe<Scalars['ID']['input']>;
  measureIDContains?: InputMaybe<Scalars['ID']['input']>;
  measureIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  measureIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  measureIDGT?: InputMaybe<Scalars['ID']['input']>;
  measureIDGTE?: InputMaybe<Scalars['ID']['input']>;
  measureIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  measureIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  measureIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  measureIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  measureIDLT?: InputMaybe<Scalars['ID']['input']>;
  measureIDLTE?: InputMaybe<Scalars['ID']['input']>;
  measureIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  measureIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  measureIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<MitigationWhereInput>;
  or?: InputMaybe<Array<MitigationWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<MitigationStatus>;
  statusIn?: InputMaybe<Array<MitigationStatus>>;
  statusNEQ?: InputMaybe<MitigationStatus>;
  statusNotIn?: InputMaybe<Array<MitigationStatus>>;
  /** status_reason field predicates */
  statusReason?: InputMaybe<Scalars['String']['input']>;
  statusReasonContains?: InputMaybe<Scalars['String']['input']>;
  statusReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  statusReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  statusReasonGT?: InputMaybe<Scalars['String']['input']>;
  statusReasonGTE?: InputMaybe<Scalars['String']['input']>;
  statusReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  statusReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  statusReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusReasonLT?: InputMaybe<Scalars['String']['input']>;
  statusReasonLTE?: InputMaybe<Scalars['String']['input']>;
  statusReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  statusReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** workcycle_id field predicates */
  workcycleID?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDContains?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDGT?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDGTE?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  workcycleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workcycleIDLT?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDLTE?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  workcycleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  workcycleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUser: User;
  copyProject?: Maybe<CopyProjectResult>;
  /**
   *  Copies all todos from one projectHierarchy to another, new todos are always
   * added at the end of the sequence and are in status NOTSTARTED
   */
  copyProjectHierarchyTodos: Array<ProjectHierarchyTodo>;
  /**  Creates API token  */
  createAPIToken: CreateApiTokenResponse;
  createAsset: Array<Asset>;
  createAssetAttributeDefinition: Array<AssetAttributeDefinition>;
  createAssetItem: Array<AssetItem>;
  createAssetItemAttributeDefinition: Array<AssetItemAttributeDefinition>;
  createAssetRelation?: Maybe<AssetRelation>;
  createAssetRelationAttributeDefinitionsForProject: Array<AssetRelationAttributeDefinition>;
  createAssetType: AssetType;
  /**  upload file to CRACybersecRiskAssessment uploads  */
  createCRACybersecRiskAssessmentUpload: CraCybersecRiskAssessmentUpload;
  createCRADocumentationUpload: CraDocumentationUpload;
  /**  upload file to CRA evidences  */
  createCRAUpload: CraUpload;
  createCRAVulnerabilityHandlingUpload: CraVulnerabilityHandlingUpload;
  createComponent?: Maybe<Component>;
  createComponentCreateRequest?: Maybe<CreateComponentCreateRequestWithStatusTransitionsOutput>;
  createComponentVendor: ComponentVendor;
  createMaturityLevel: MaturityLevel;
  createMeasure: Measure;
  createMitigationTests: Array<MitigationTest>;
  createOrganization: Organization;
  createProject?: Maybe<Project>;
  createProjectAttribute: Array<ProjectAttribute>;
  createProjectHierarchyAsset: Array<ProjectHierarchyAsset>;
  createProjectHierarchyAttributeDefinition: Array<ProjectHierarchyAttributeDefinition>;
  createProjectHierarchyFile: ProjectHierarchyFile;
  /**  New entries are always added at the end of the sequence  */
  createProjectHierarchyTodos: Array<ProjectHierarchyTodo>;
  createProjectPhase: ProjectPhase;
  createProjectStatus: ProjectStatus;
  createProjectType: ProjectType;
  createProjectZoneStandardProfile: ProjectZoneStandardProfile;
  createProjectZoneStandardProfileRequirementComment: ProjectZoneStandardProfileRequirementComment;
  createRequirementMapping: RequirementMapping;
  createSecurityLevel: SecurityLevel;
  createStandard: Standard;
  createTRA: Tra;
  /**
   *  Adds report data, payload contains report content, so this mutation is not
   * generaiting reports itself but just adds to given tra.
   */
  createTRAReport: TraReport;
  createTask: Task;
  createTaskComment: TaskComment;
  createTaskEvidence: TaskEvidence;
  deactivateUser: User;
  deleteAsset: Array<Asset>;
  deleteAssetAttributeDefinition: Array<AssetAttributeDefinition>;
  deleteAssetItem: Array<AssetItem>;
  deleteAssetItemAttributeDefinition: Array<AssetItemAttributeDefinition>;
  deleteAssetRelationAttributeDefinitionsForProject: Array<AssetRelationAttributeDefinition>;
  deleteAssetRelationsForProject: Array<AssetRelation>;
  /**  delete CRACybersecRiskAssessment upload, returns ID of deleted CRACybersecRiskAssessment upload  */
  deleteCRACybersecRiskAssessmentUpload: Scalars['ID']['output'];
  /**  delete CRADocumentation upload, returns ID of deleted CRADocumentation upload  */
  deleteCRADocumentationUpload: Scalars['ID']['output'];
  /**  delete CRA upload, returns ID of deleted CRA upload  */
  deleteCRAUpload: Scalars['ID']['output'];
  /**  delete CRAVulnerabilityHandling upload, returns ID of deleted CRAVulnerabilityHandling upload  */
  deleteCRAVulnerabilityHandlingUpload: Scalars['ID']['output'];
  deleteComponentCreateRequest?: Maybe<ComponentCreateRequest>;
  deleteProject?: Maybe<Project>;
  deleteProjectAttribute: Array<ProjectAttribute>;
  /**  only not published can be deleted  */
  deleteProjectGuidance: ProjectGuidance;
  deleteProjectHierarchy: ProjectHierarchy;
  deleteProjectHierarchyAsset: Array<ProjectHierarchyAsset>;
  deleteProjectHierarchyAttributeDefinition: Array<ProjectHierarchyAttributeDefinition>;
  deleteProjectHierarchyFiles: Array<ProjectHierarchyFile>;
  /**  Deletes todos by projectHierarchyTodoIDs */
  deleteProjectHierarchyTodos: Array<ProjectHierarchyTodo>;
  deleteProjectTasks: Array<Task>;
  deleteProjectZone: ProjectZone;
  deleteSurvey: Survey;
  deleteTaskEvidence: TaskEvidence;
  importAssetRelationsList: ProjectAssetRelationsImportSummary;
  importAssetsList: ProjectImportAssetsSummary;
  importComponentVendorAssessments: ComponentVendorAssessmentImportSummary;
  importSBOM: ProjectImportSbomSummary;
  importStandards: StandardImportSummary;
  importTaskTemplates: TaskTemplatesImportSummary;
  importUsers: UserImportSummary;
  lockTRA: Tra;
  overrideCVSS: Scalars['Boolean']['output'];
  publishProjectGuidance: ProjectGuidance;
  reviewComponentCreateRequest?: Maybe<ComponentCreateRequest>;
  saveCRA: Cra;
  saveCRADocumentation: CraDocumentation;
  saveCRAGeneral: CraGeneral;
  saveCRAVulnerabilityHandling: CraVulnerabilityHandling;
  saveMitigationsBulk: Array<Mitigation>;
  /**  creates or updates existing not published project guidance  */
  saveProjectGuidance: ProjectGuidance;
  saveProjectHierarchy: ProjectHierarchy;
  saveProjectZone: ProjectZone;
  saveSurvey: Survey;
  saveSurveyTemplate: SurveyTemplate;
  saveTaskDeliverables: Array<TaskDeliverable>;
  saveUserNotificationSetting: UserNotificationSetting;
  /**  set CRA as completed or incompleted  */
  setCRACompletion: Cra;
  /**  set CRACybersecRiskAssessment as completed or incompleted  */
  setCRACybersecRiskAssessmentCompletion: CraCybersecRiskAssessment;
  /**  set CRA as completed or incompleted  */
  setCRADocumentationCompletion: CraDocumentation;
  /**  set CRAGeneral as completed or incompleted  */
  setCRAGeneralCompletion: CraGeneral;
  /**  set CRAVulnerabilityHandling as completed or incompleted  */
  setCRAVulnerabilityHandlingCompletion: CraVulnerabilityHandling;
  setCompletenessCRACybersecRiskAssessmentUpload: CraCybersecRiskAssessmentUpload;
  setMetrics20: Cvss20;
  setMetrics30: Cvss30;
  setMetrics31: Cvss30;
  setMetrics40: Cvss40;
  setMitigationsStatus: Array<Mitigation>;
  setProjectUsers?: Maybe<Array<Maybe<ProjectUser>>>;
  setSurveyState: Survey;
  setTRAParticipants?: Maybe<Array<TraParticipant>>;
  setTRAState: Tra;
  setUserOrganizations?: Maybe<Array<OrganizationUser>>;
  surveyFormImport: SurveyFormImportSummary;
  surveyFormPublish: SurveyForm;
  synchronizeAttck: Attck;
  unlockTRA: Tra;
  updateAssetAttributeDefinitionSequence: Array<AssetAttributeDefinition>;
  updateAssetItem: Array<AssetItem>;
  updateAssetItemAttributeDefinitionSequence: Array<AssetItemAttributeDefinition>;
  updateAssetRelationForProject?: Maybe<AssetRelation>;
  updateAssets: Array<Asset>;
  updateAssetsProjectZone: Array<Asset>;
  updateComponentCreateRequest?: Maybe<ComponentCreateRequest>;
  updateMeasure: Measure;
  updateMitigationTests: Array<MitigationTest>;
  updateOrganization: Organization;
  updateProject?: Maybe<Project>;
  updateProjectAttributeSequence: Array<ProjectAttribute>;
  updateProjectAttributeValue: Array<ProjectAttribute>;
  updateProjectHierarchyAttributeDefinitionSequence: Array<ProjectHierarchyAttributeDefinition>;
  /**  Not provided properties will be skipped, when seqNo provided then it will push other todos down below (0 means first)  */
  updateProjectHierarchyTodo?: Maybe<ProjectHierarchyTodo>;
  updateTRA: Tra;
  updateTasks: Array<Task>;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationCopyProjectArgs = {
  input: CopyProjectInput;
};


export type MutationCopyProjectHierarchyTodosArgs = {
  projectHierarchySourceID: Scalars['ID']['input'];
  projectHierarchyTargetID: Scalars['ID']['input'];
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreateAssetArgs = {
  input: Array<CreateAssetRawInput>;
};


export type MutationCreateAssetAttributeDefinitionArgs = {
  input: Array<CreateAssetAttributeDefinitionRawInput>;
};


export type MutationCreateAssetItemArgs = {
  input: Array<CreateAssetItemRawInput>;
};


export type MutationCreateAssetItemAttributeDefinitionArgs = {
  input: Array<CreateAssetItemAttributeDefinitionRawInput>;
};


export type MutationCreateAssetRelationArgs = {
  input: CreateAssetRelationRawInput;
};


export type MutationCreateAssetRelationAttributeDefinitionsForProjectArgs = {
  input: Array<CreateAssetRelationAttributeDefinitionRawInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationCreateAssetTypeArgs = {
  input: CreateAssetTypeInput;
};


export type MutationCreateCraCybersecRiskAssessmentUploadArgs = {
  craCybersecurityRiskAssessmentID: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationCreateCraDocumentationUploadArgs = {
  input: CreateCraDocumentationUploadRawInput;
  upload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateCraUploadArgs = {
  craID: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationCreateCraVulnerabilityHandlingUploadArgs = {
  craVulnerabilityHandlingID: Scalars['ID']['input'];
  upload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateComponentArgs = {
  input: CreateComponentInput;
};


export type MutationCreateComponentCreateRequestArgs = {
  input: CreateComponentCreateRequestRawInput;
};


export type MutationCreateComponentVendorArgs = {
  input: CreateComponentVendorInput;
};


export type MutationCreateMaturityLevelArgs = {
  input: CreateMaturityLevelInput;
};


export type MutationCreateMeasureArgs = {
  input: CreateMeasureInput;
};


export type MutationCreateMitigationTestsArgs = {
  input: Array<CreateMitigationTestRawInput>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationRawInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectAttributeArgs = {
  input: Array<CreateProjectAttributeRawInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationCreateProjectHierarchyAssetArgs = {
  assetIDs: BulkIdInput;
  projectHierarchyID: Scalars['ID']['input'];
};


export type MutationCreateProjectHierarchyAttributeDefinitionArgs = {
  input: Array<CreateProjectHierarchyAttributeDefinitionInput>;
};


export type MutationCreateProjectHierarchyFileArgs = {
  input: CreateProjectHierarchyFileRawInput;
  upload: Scalars['Upload']['input'];
};


export type MutationCreateProjectHierarchyTodosArgs = {
  input: Array<CreateProjectHierarchyTodoRawInput>;
  projectHierarchyID: Scalars['ID']['input'];
};


export type MutationCreateProjectPhaseArgs = {
  input: CreateProjectPhaseInput;
};


export type MutationCreateProjectStatusArgs = {
  input: CreateProjectStatusInput;
};


export type MutationCreateProjectTypeArgs = {
  input: CreateProjectTypeInput;
};


export type MutationCreateProjectZoneStandardProfileArgs = {
  input: CreateProjectZoneStandardProfileInput;
};


export type MutationCreateProjectZoneStandardProfileRequirementCommentArgs = {
  input: CreateProjectZoneStandardProfileRequirementCommentRawInput;
};


export type MutationCreateRequirementMappingArgs = {
  input: CreateRequirementMappingInput;
};


export type MutationCreateSecurityLevelArgs = {
  input: CreateSecurityLevelInput;
};


export type MutationCreateStandardArgs = {
  input: CreateStandardInput;
};


export type MutationCreateTraArgs = {
  input: CreateTraRawInput;
};


export type MutationCreateTraReportArgs = {
  input: CreateTraReportRawInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskRawInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentRawInput;
};


export type MutationCreateTaskEvidenceArgs = {
  input: CreateTaskEvidenceRawInput;
  upload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type MutationDeleteAssetArgs = {
  input: BulkIdInput;
};


export type MutationDeleteAssetAttributeDefinitionArgs = {
  input: BulkIdInput;
};


export type MutationDeleteAssetItemArgs = {
  input: BulkIdInput;
};


export type MutationDeleteAssetItemAttributeDefinitionArgs = {
  input: BulkIdInput;
};


export type MutationDeleteAssetRelationAttributeDefinitionsForProjectArgs = {
  ids: Array<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
};


export type MutationDeleteAssetRelationsForProjectArgs = {
  ids: Array<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
};


export type MutationDeleteCraCybersecRiskAssessmentUploadArgs = {
  craCybersecurityRiskAssessmentUploadID: Scalars['ID']['input'];
};


export type MutationDeleteCraDocumentationUploadArgs = {
  craDocumentationUploadID: Scalars['ID']['input'];
};


export type MutationDeleteCraUploadArgs = {
  craUploadID: Scalars['ID']['input'];
};


export type MutationDeleteCraVulnerabilityHandlingUploadArgs = {
  craVulnerabilityHandlingUploadID: Scalars['ID']['input'];
};


export type MutationDeleteComponentCreateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectAttributeArgs = {
  input: BulkIdInput;
  projectID: Scalars['ID']['input'];
};


export type MutationDeleteProjectGuidanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectHierarchyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectHierarchyAssetArgs = {
  input: BulkIdInput;
  projectHierarchyID: Scalars['ID']['input'];
};


export type MutationDeleteProjectHierarchyAttributeDefinitionArgs = {
  input: BulkIdInput;
};


export type MutationDeleteProjectHierarchyFilesArgs = {
  input: BulkIdInput;
};


export type MutationDeleteProjectHierarchyTodosArgs = {
  input: BulkIdInput;
};


export type MutationDeleteProjectTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
};


export type MutationDeleteProjectZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSurveyArgs = {
  surveyID: Scalars['ID']['input'];
};


export type MutationDeleteTaskEvidenceArgs = {
  taskEvidenceID: Scalars['ID']['input'];
  taskID: Scalars['ID']['input'];
};


export type MutationImportAssetRelationsListArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
};


export type MutationImportAssetsListArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
};


export type MutationImportComponentVendorAssessmentsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportSbomArgs = {
  file: Scalars['Upload']['input'];
  input: ProjectImportSbomInput;
};


export type MutationImportStandardsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportTaskTemplatesArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportUsersArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationLockTraArgs = {
  traID: Scalars['ID']['input'];
};


export type MutationOverrideCvssArgs = {
  input: OverrideCvssInput;
};


export type MutationPublishProjectGuidanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReviewComponentCreateRequestArgs = {
  input: ReviewComponentCreateRequestRawInput;
};


export type MutationSaveCraArgs = {
  input: SaveCraInput;
};


export type MutationSaveCraDocumentationArgs = {
  input: SaveCraDocumentationInput;
};


export type MutationSaveCraGeneralArgs = {
  input: SaveCraGeneralInput;
};


export type MutationSaveCraVulnerabilityHandlingArgs = {
  input: SaveCraVulnerabilityHandlingInput;
};


export type MutationSaveMitigationsBulkArgs = {
  input: SaveMitigationBulkInput;
};


export type MutationSaveProjectGuidanceArgs = {
  input: SaveProjectGuidanceInput;
};


export type MutationSaveProjectHierarchyArgs = {
  input: SaveProjectHierarchyInput;
};


export type MutationSaveProjectZoneArgs = {
  input: SaveProjectZoneInput;
};


export type MutationSaveSurveyArgs = {
  input: SaveSurveyInput;
};


export type MutationSaveSurveyTemplateArgs = {
  input: SaveSurveyTemplateInput;
};


export type MutationSaveTaskDeliverablesArgs = {
  input: Array<SaveTaskDeliverableInput>;
  taskID: Scalars['ID']['input'];
};


export type MutationSaveUserNotificationSettingArgs = {
  input: SaveUserNotificationSettingInput;
};


export type MutationSetCraCompletionArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationSetCraCybersecRiskAssessmentCompletionArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationSetCraDocumentationCompletionArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationSetCraGeneralCompletionArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationSetCraVulnerabilityHandlingCompletionArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationSetCompletenessCraCybersecRiskAssessmentUploadArgs = {
  completeness: CraCybersecRiskAssessmentUploadCompleteness;
  craCybersecurityRiskAssessmentUploadID: Scalars['ID']['input'];
};


export type MutationSetMetrics20Args = {
  input: SetMetricsInput20;
};


export type MutationSetMetrics30Args = {
  input: SetMetricsInput30;
};


export type MutationSetMetrics31Args = {
  input: SetMetricsInput31;
};


export type MutationSetMetrics40Args = {
  input: SetMetricsInput40;
};


export type MutationSetMitigationsStatusArgs = {
  input: SetMitigationssStatusInput;
};


export type MutationSetProjectUsersArgs = {
  input: SetProjectUsersInput;
};


export type MutationSetSurveyStateArgs = {
  optimisticLockVersion: Scalars['Int']['input'];
  state: SurveySetStateStatus;
  surveyID: Scalars['ID']['input'];
};


export type MutationSetTraParticipantsArgs = {
  input: SetTraParticipantsInput;
};


export type MutationSetTraStateArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  state: TraSetStateStatus;
  traID: Scalars['ID']['input'];
};


export type MutationSetUserOrganizationsArgs = {
  input: SetUserOrganizationsInput;
};


export type MutationSurveyFormImportArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationSurveyFormPublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlockTraArgs = {
  traID: Scalars['ID']['input'];
};


export type MutationUpdateAssetAttributeDefinitionSequenceArgs = {
  input: Array<UpdateAssetAttributeDefinitionSequenceRawInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationUpdateAssetItemArgs = {
  input: UpdateAssetItemBulkInput;
};


export type MutationUpdateAssetItemAttributeDefinitionSequenceArgs = {
  input: Array<UpdateAssetItemAttributeDefinitionSequenceRawInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationUpdateAssetRelationForProjectArgs = {
  input: UpdateAssetRelationRawInput;
  projectID: Scalars['ID']['input'];
};


export type MutationUpdateAssetsArgs = {
  input: UpdateAssetBulkInput;
};


export type MutationUpdateAssetsProjectZoneArgs = {
  input: UpdateAssetsProjectZoneInput;
};


export type MutationUpdateComponentCreateRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateComponentCreateRequestRawInput;
};


export type MutationUpdateMeasureArgs = {
  input: UpdateMeasureRawInput;
};


export type MutationUpdateMitigationTestsArgs = {
  input: UpdateMitigationTestBulkInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationRawInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectAttributeSequenceArgs = {
  input: Array<UpdateProjectAttributeSequenceRawInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationUpdateProjectAttributeValueArgs = {
  input: Array<UpdateProjectAttributeValueInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationUpdateProjectHierarchyAttributeDefinitionSequenceArgs = {
  input: Array<UpdateProjectHierarchyAttributeDefinitionSequenceRawInput>;
  projectID: Scalars['ID']['input'];
};


export type MutationUpdateProjectHierarchyTodoArgs = {
  input?: InputMaybe<UpdateProjectHierarchyTodoRawInput>;
};


export type MutationUpdateTraArgs = {
  input: UpdateTraRawInput;
};


export type MutationUpdateTasksArgs = {
  input: UpdateTaskBulkInput;
};

/**
 * NVDMatchCriteriaWhereInput is used for filtering NVDMatchCriteria objects.
 * Input was generated by ent.
 */
export type NvdMatchCriteriaWhereInput = {
  and?: InputMaybe<Array<NvdMatchCriteriaWhereInput>>;
  /** component_nvd_id field predicates */
  componentNvdID?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDContains?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDGT?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDGTE?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentNvdIDLT?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDLTE?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDNEQ?: InputMaybe<Scalars['String']['input']>;
  componentNvdIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** match_criteria_id field predicates */
  matchCriteriaID?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDContains?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDGT?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDGTE?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  matchCriteriaIDLT?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDLTE?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDNEQ?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NvdMatchCriteriaWhereInput>;
  or?: InputMaybe<Array<NvdMatchCriteriaWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Notification = {
  __typename?: 'Notification';
  action: NotificationAction;
  affectedAssetItemsCount?: Maybe<Scalars['Int']['output']>;
  affectedAssetsCount?: Maybe<Scalars['Int']['output']>;
  affectedComponentsCount?: Maybe<Scalars['Int']['output']>;
  attachments?: Maybe<Array<NotificationAttachmentOutput>>;
  body: Scalars['String']['output'];
  components?: Maybe<Array<Maybe<Component>>>;
  createTime: Scalars['Time']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  customizedCVSS?: Maybe<Cvss>;
  cves?: Maybe<Array<Maybe<Cve>>>;
  cvss?: Maybe<Cvss>;
  /** @deprecated Use cvss.baseScore instead */
  cvssBaseScore?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use cvss.overalScore instead */
  cvssOveralScore?: Maybe<Scalars['Float']['output']>;
  cvssOverrideVector?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cvss.temporalScore instead */
  cvssTemporalScore?: Maybe<Scalars['Float']['output']>;
  cvssVector?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cvss instead */
  initialCVSS?: Maybe<Cvss>;
  lastUpdateDate?: Maybe<Scalars['Time']['output']>;
  legalNotice?: Maybe<Scalars['String']['output']>;
  prerequisite?: Maybe<Scalars['String']['output']>;
  priority: NotificationPriority;
  publishDate: Scalars['Time']['output'];
  references?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reproduce?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<NotificationResourceOutput>>;
  solutionDetails?: Maybe<Scalars['String']['output']>;
  solutionStatus: Scalars['String']['output'];
  source: NotificationSource;
  title: Scalars['String']['output'];
  updateTime: Scalars['Time']['output'];
  vendorAdvisories?: Maybe<Array<NotificationVendorAdvisoryOutput>>;
};

/** The set of notification actions */
export enum NotificationAction {
  /** Update to Fixed Version */
  A01Updatetofixedversion = 'A01UPDATETOFIXEDVERSION',
  /** Implement Workaround */
  A02Implementworkaround = 'A02IMPLEMENTWORKAROUND',
  /** Apply Patch */
  A03Applypatch = 'A03APPLYPATCH',
  /** Follow Recommendation */
  A04Followrecommendation = 'A04FOLLOWRECOMMENDATION',
  /** Wait for Official Solution */
  A05Waitforofficialsolution = 'A05WAITFOROFFICIALSOLUTION'
}

export type NotificationAttachment = {
  id: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NotificationAttachmentOutput = {
  __typename?: 'NotificationAttachmentOutput';
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum NotificationConfidentialityLevel {
  Confidential = 'CONFIDENTIAL',
  Internal = 'INTERNAL',
  None = 'NONE'
}

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * NotificationCveWhereInput is used for filtering NotificationCve objects.
 * Input was generated by ent.
 */
export type NotificationCveWhereInput = {
  and?: InputMaybe<Array<NotificationCveWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotificationCveWhereInput>;
  or?: InputMaybe<Array<NotificationCveWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * NotificationCweWhereInput is used for filtering NotificationCwe objects.
 * Input was generated by ent.
 */
export type NotificationCweWhereInput = {
  and?: InputMaybe<Array<NotificationCweWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotificationCweWhereInput>;
  or?: InputMaybe<Array<NotificationCweWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Notification;
};

export type NotificationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<NotificationOrderField>;
};

export enum NotificationOrderField {
  Createtime = 'CREATETIME',
  Cvssoverallscore = 'CVSSOVERALLSCORE',
  Cvssvector = 'CVSSVECTOR',
  CvssOverrideScore = 'CVSS_OVERRIDE_SCORE',
  CvssScore = 'CVSS_SCORE',
  Id = 'ID',
  Impact = 'IMPACT',
  Lastupdatedate = 'LASTUPDATEDATE',
  Notificationaction = 'NOTIFICATIONACTION',
  Notificationpriority = 'NOTIFICATIONPRIORITY',
  Notificationsource = 'NOTIFICATIONSOURCE',
  Publishdate = 'PUBLISHDATE',
  Solutionstatus = 'SOLUTIONSTATUS',
  Title = 'TITLE',
  Updatetime = 'UPDATETIME'
}

/** The set of notification priorities */
export enum NotificationPriority {
  /**
   * Critical - Typically used for remote attacks with critical impact which cause
   * full compromise of the system. Investigate immediately and follow recommended
   * action as soon as possible with urgency.
   */
  P01Critical = 'P01CRITICAL',
  /**
   * Major - Typically used for remote or local attacks with significant impact but
   * no full compromise of system. Investigate as soon as possible and follow
   * recommended action.
   */
  P02Major = 'P02MAJOR',
  /**
   * Minor - Typically used for local attacks with minor impact to system. Follow
   * the recommended action in a reasonable amount of time.
   */
  P03Minor = 'P03MINOR',
  /**
   * Information - Typically used for notifications that are not directly related
   * to vulnerabilities but could have a security impact nonetheless, e.g. updates
   * of trusted root CAs or time zone information.
   */
  P04Information = 'P04INFORMATION',
  /**
   * Withdrawn - The vulnerability has been withdrawn either by the vendor or
   * Siemens ProductCERT. It is no longer valid and can be disregarded.
   */
  P05Withdrawn = 'P05WITHDRAWN'
}

/**
 * NotificationRawVulnerabilityRawWhereInput is used for filtering NotificationRawVulnerabilityRaw objects.
 * Input was generated by ent.
 */
export type NotificationRawVulnerabilityRawWhereInput = {
  and?: InputMaybe<Array<NotificationRawVulnerabilityRawWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** notification_raws edge predicates */
  hasNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsWith?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** vulnerability_raws edge predicates */
  hasVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawsWith?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotificationRawVulnerabilityRawWhereInput>;
  /** notification_raws_id field predicates */
  notificationRawsID?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<NotificationRawVulnerabilityRawWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vulnerability_raws_id field predicates */
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vulnerabilityRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * NotificationRawVulnerabilityVilocifyRelationshipWhereInput is used for filtering
 * NotificationRawVulnerabilityVilocifyRelationship objects.
 * Input was generated by ent.
 */
export type NotificationRawVulnerabilityVilocifyRelationshipWhereInput = {
  and?: InputMaybe<Array<NotificationRawVulnerabilityVilocifyRelationshipWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** notification_raws edge predicates */
  hasNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsWith?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotificationRawVulnerabilityVilocifyRelationshipWhereInput>;
  /** notification_raws_id field predicates */
  notificationRawsID?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<NotificationRawVulnerabilityVilocifyRelationshipWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vulnerability_vilocify_id field predicates */
  vulnerabilityVilocifyID?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDContains?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDGT?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDGTE?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vulnerabilityVilocifyIDLT?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDLTE?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityVilocifyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * NotificationRawWhereInput is used for filtering NotificationRaw objects.
 * Input was generated by ent.
 */
export type NotificationRawWhereInput = {
  /** action field predicates */
  action?: InputMaybe<Scalars['String']['input']>;
  actionContains?: InputMaybe<Scalars['String']['input']>;
  actionContainsFold?: InputMaybe<Scalars['String']['input']>;
  actionEqualFold?: InputMaybe<Scalars['String']['input']>;
  actionGT?: InputMaybe<Scalars['String']['input']>;
  actionGTE?: InputMaybe<Scalars['String']['input']>;
  actionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  actionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  actionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  actionLT?: InputMaybe<Scalars['String']['input']>;
  actionLTE?: InputMaybe<Scalars['String']['input']>;
  actionNEQ?: InputMaybe<Scalars['String']['input']>;
  actionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cvss field predicates */
  cvss?: InputMaybe<Scalars['String']['input']>;
  cvssContains?: InputMaybe<Scalars['String']['input']>;
  cvssContainsFold?: InputMaybe<Scalars['String']['input']>;
  cvssEqualFold?: InputMaybe<Scalars['String']['input']>;
  cvssGT?: InputMaybe<Scalars['String']['input']>;
  cvssGTE?: InputMaybe<Scalars['String']['input']>;
  cvssHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cvssHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cvssIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cvssIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cvssLT?: InputMaybe<Scalars['String']['input']>;
  cvssLTE?: InputMaybe<Scalars['String']['input']>;
  cvssNEQ?: InputMaybe<Scalars['String']['input']>;
  cvssNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cvssNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_raws_notification_raws edge predicates */
  hasComponentRawsNotificationRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsNotificationRawsWith?: InputMaybe<Array<ComponentRawNotificationRawWhereInput>>;
  /** component_sources edge predicates */
  hasComponentSources?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSourcesWith?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** notification_raw_vulnerability_vilocify_relationships edge predicates */
  hasNotificationRawVulnerabilityVilocifyRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawVulnerabilityVilocifyRelationshipsWith?: InputMaybe<Array<NotificationRawVulnerabilityVilocifyRelationshipWhereInput>>;
  /** notification_raws_vulnerability_raws edge predicates */
  hasNotificationRawsVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsVulnerabilityRawsWith?: InputMaybe<Array<NotificationRawVulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_update_date field predicates */
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdateDateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NotificationRawWhereInput>;
  or?: InputMaybe<Array<NotificationRawWhereInput>>;
  /** priority field predicates */
  priority?: InputMaybe<Scalars['String']['input']>;
  priorityContains?: InputMaybe<Scalars['String']['input']>;
  priorityContainsFold?: InputMaybe<Scalars['String']['input']>;
  priorityEqualFold?: InputMaybe<Scalars['String']['input']>;
  priorityGT?: InputMaybe<Scalars['String']['input']>;
  priorityGTE?: InputMaybe<Scalars['String']['input']>;
  priorityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  priorityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  priorityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  priorityLT?: InputMaybe<Scalars['String']['input']>;
  priorityLTE?: InputMaybe<Scalars['String']['input']>;
  priorityNEQ?: InputMaybe<Scalars['String']['input']>;
  priorityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** publish_date field predicates */
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  publishDateGT?: InputMaybe<Scalars['Time']['input']>;
  publishDateGTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  publishDateLT?: InputMaybe<Scalars['Time']['input']>;
  publishDateLTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  publishDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** solution field predicates */
  solution?: InputMaybe<Scalars['String']['input']>;
  solutionContains?: InputMaybe<Scalars['String']['input']>;
  solutionContainsFold?: InputMaybe<Scalars['String']['input']>;
  solutionEqualFold?: InputMaybe<Scalars['String']['input']>;
  solutionGT?: InputMaybe<Scalars['String']['input']>;
  solutionGTE?: InputMaybe<Scalars['String']['input']>;
  solutionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  solutionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  solutionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  solutionLT?: InputMaybe<Scalars['String']['input']>;
  solutionLTE?: InputMaybe<Scalars['String']['input']>;
  solutionNEQ?: InputMaybe<Scalars['String']['input']>;
  solutionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** source_id field predicates */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type NotificationReadModel = {
  __typename?: 'NotificationReadModel';
  action: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  cvss?: Maybe<Cvss>;
  cvssBaseScore: Scalars['Float']['output'];
  cvssOveralScore: Scalars['Float']['output'];
  cvssTemporalScore: Scalars['Float']['output'];
  cvssVector: Scalars['String']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUpdateDate?: Maybe<Scalars['Time']['output']>;
  priority: Scalars['String']['output'];
  publishDate: Scalars['Time']['output'];
  solutionStatus: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['Time']['output'];
};

export type NotificationResource = {
  other?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationResourceOutput = {
  __typename?: 'NotificationResourceOutput';
  other?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationSource {
  SeCysAr = 'SE_CYS_AR',
  Svm = 'SVM'
}

export enum NotificationStatusExportFilter {
  All = 'ALL',
  Onlyclosed = 'ONLYCLOSED',
  Onlyopen = 'ONLYOPEN'
}

export type NotificationSummary = {
  componentsTotal: Scalars['Int']['input'];
  priority: NotificationPriority;
  total: Scalars['Int']['input'];
};

export type NotificationSummaryOutput = {
  __typename?: 'NotificationSummaryOutput';
  componentsTotal: Scalars['Int']['output'];
  priority: NotificationPriority;
  total: Scalars['Int']['output'];
};

export type NotificationVendorAdvisory = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationVendorAdvisoryOutput = {
  __typename?: 'NotificationVendorAdvisoryOutput';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

/**
 * NotificationWhereInput is used for filtering Notification objects.
 * Input was generated by ent.
 */
export type NotificationWhereInput = {
  /** action field predicates */
  action?: InputMaybe<NotificationAction>;
  actionIn?: InputMaybe<Array<NotificationAction>>;
  actionNEQ?: InputMaybe<NotificationAction>;
  actionNotIn?: InputMaybe<Array<NotificationAction>>;
  and?: InputMaybe<Array<NotificationWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  bodyContains?: InputMaybe<Scalars['String']['input']>;
  bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyGT?: InputMaybe<Scalars['String']['input']>;
  bodyGTE?: InputMaybe<Scalars['String']['input']>;
  bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyLT?: InputMaybe<Scalars['String']['input']>;
  bodyLTE?: InputMaybe<Scalars['String']['input']>;
  bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** confidentiality_level field predicates */
  confidentialityLevel?: InputMaybe<NotificationConfidentialityLevel>;
  confidentialityLevelIn?: InputMaybe<Array<NotificationConfidentialityLevel>>;
  confidentialityLevelNEQ?: InputMaybe<NotificationConfidentialityLevel>;
  confidentialityLevelNotIn?: InputMaybe<Array<NotificationConfidentialityLevel>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cvss_base_score field predicates */
  cvssBaseScore?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreGT?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssBaseScoreLT?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  cvssBaseScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** cvss_overal_score field predicates */
  cvssOveralScore?: InputMaybe<Scalars['Float']['input']>;
  cvssOveralScoreGT?: InputMaybe<Scalars['Float']['input']>;
  cvssOveralScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  cvssOveralScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssOveralScoreLT?: InputMaybe<Scalars['Float']['input']>;
  cvssOveralScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  cvssOveralScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  cvssOveralScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** cvss_temporal_score field predicates */
  cvssTemporalScore?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScoreGT?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  cvssTemporalScoreLT?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** cvss_vector field predicates */
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cvssVectorContains?: InputMaybe<Scalars['String']['input']>;
  cvssVectorContainsFold?: InputMaybe<Scalars['String']['input']>;
  cvssVectorEqualFold?: InputMaybe<Scalars['String']['input']>;
  cvssVectorGT?: InputMaybe<Scalars['String']['input']>;
  cvssVectorGTE?: InputMaybe<Scalars['String']['input']>;
  cvssVectorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cvssVectorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cvssVectorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cvssVectorLT?: InputMaybe<Scalars['String']['input']>;
  cvssVectorLTE?: InputMaybe<Scalars['String']['input']>;
  cvssVectorNEQ?: InputMaybe<Scalars['String']['input']>;
  cvssVectorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_notifications edge predicates */
  hasComponentNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentNotificationsWith?: InputMaybe<Array<ComponentNotificationWhereInput>>;
  /** components edge predicates */
  hasComponents?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentsWith?: InputMaybe<Array<ComponentWhereInput>>;
  hasCustomizedCVSSWith?: InputMaybe<Array<CvssWhereInput>>;
  /** cves edge predicates */
  hasCves?: InputMaybe<Scalars['Boolean']['input']>;
  hasCvesWith?: InputMaybe<Array<CveWhereInput>>;
  /** cvss edge predicates */
  hasCvss?: InputMaybe<Scalars['Boolean']['input']>;
  /** cvss_overrides edge predicates */
  hasCvssOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasCvssOverridesWith?: InputMaybe<Array<CvssOverridesWhereInput>>;
  hasCvssWith?: InputMaybe<Array<CvssWhereInput>>;
  /** cwes edge predicates */
  hasCwes?: InputMaybe<Scalars['Boolean']['input']>;
  hasCwesWith?: InputMaybe<Array<CweWhereInput>>;
  /** notification_cves edge predicates */
  hasNotificationCves?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationCvesWith?: InputMaybe<Array<NotificationCveWhereInput>>;
  /** notification_cwes edge predicates */
  hasNotificationCwes?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationCwesWith?: InputMaybe<Array<NotificationCweWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** impact field predicates */
  impact?: InputMaybe<Scalars['String']['input']>;
  impactContains?: InputMaybe<Scalars['String']['input']>;
  impactContainsFold?: InputMaybe<Scalars['String']['input']>;
  impactEqualFold?: InputMaybe<Scalars['String']['input']>;
  impactGT?: InputMaybe<Scalars['String']['input']>;
  impactGTE?: InputMaybe<Scalars['String']['input']>;
  impactHasPrefix?: InputMaybe<Scalars['String']['input']>;
  impactHasSuffix?: InputMaybe<Scalars['String']['input']>;
  impactIn?: InputMaybe<Array<Scalars['String']['input']>>;
  impactIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  impactLT?: InputMaybe<Scalars['String']['input']>;
  impactLTE?: InputMaybe<Scalars['String']['input']>;
  impactNEQ?: InputMaybe<Scalars['String']['input']>;
  impactNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  impactNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_update_date field predicates */
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdateDateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_notice field predicates */
  legalNotice?: InputMaybe<Scalars['String']['input']>;
  legalNoticeContains?: InputMaybe<Scalars['String']['input']>;
  legalNoticeContainsFold?: InputMaybe<Scalars['String']['input']>;
  legalNoticeEqualFold?: InputMaybe<Scalars['String']['input']>;
  legalNoticeGT?: InputMaybe<Scalars['String']['input']>;
  legalNoticeGTE?: InputMaybe<Scalars['String']['input']>;
  legalNoticeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  legalNoticeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  legalNoticeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  legalNoticeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNoticeLT?: InputMaybe<Scalars['String']['input']>;
  legalNoticeLTE?: InputMaybe<Scalars['String']['input']>;
  legalNoticeNEQ?: InputMaybe<Scalars['String']['input']>;
  legalNoticeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  legalNoticeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NotificationWhereInput>;
  or?: InputMaybe<Array<NotificationWhereInput>>;
  /** prerequisite field predicates */
  prerequisite?: InputMaybe<Scalars['String']['input']>;
  prerequisiteContains?: InputMaybe<Scalars['String']['input']>;
  prerequisiteContainsFold?: InputMaybe<Scalars['String']['input']>;
  prerequisiteEqualFold?: InputMaybe<Scalars['String']['input']>;
  prerequisiteGT?: InputMaybe<Scalars['String']['input']>;
  prerequisiteGTE?: InputMaybe<Scalars['String']['input']>;
  prerequisiteHasPrefix?: InputMaybe<Scalars['String']['input']>;
  prerequisiteHasSuffix?: InputMaybe<Scalars['String']['input']>;
  prerequisiteIn?: InputMaybe<Array<Scalars['String']['input']>>;
  prerequisiteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  prerequisiteLT?: InputMaybe<Scalars['String']['input']>;
  prerequisiteLTE?: InputMaybe<Scalars['String']['input']>;
  prerequisiteNEQ?: InputMaybe<Scalars['String']['input']>;
  prerequisiteNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  prerequisiteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** priority field predicates */
  priority?: InputMaybe<NotificationPriority>;
  priorityIn?: InputMaybe<Array<NotificationPriority>>;
  priorityNEQ?: InputMaybe<NotificationPriority>;
  priorityNotIn?: InputMaybe<Array<NotificationPriority>>;
  /** publish_date field predicates */
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  publishDateGT?: InputMaybe<Scalars['Time']['input']>;
  publishDateGTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateLT?: InputMaybe<Scalars['Time']['input']>;
  publishDateLTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  publishDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** reproduce field predicates */
  reproduce?: InputMaybe<Scalars['String']['input']>;
  reproduceContains?: InputMaybe<Scalars['String']['input']>;
  reproduceContainsFold?: InputMaybe<Scalars['String']['input']>;
  reproduceEqualFold?: InputMaybe<Scalars['String']['input']>;
  reproduceGT?: InputMaybe<Scalars['String']['input']>;
  reproduceGTE?: InputMaybe<Scalars['String']['input']>;
  reproduceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  reproduceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  reproduceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reproduceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reproduceLT?: InputMaybe<Scalars['String']['input']>;
  reproduceLTE?: InputMaybe<Scalars['String']['input']>;
  reproduceNEQ?: InputMaybe<Scalars['String']['input']>;
  reproduceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reproduceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** solution_details field predicates */
  solutionDetails?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsContains?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsContainsFold?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsEqualFold?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsGT?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsGTE?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionDetailsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  solutionDetailsLT?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsLTE?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsNEQ?: InputMaybe<Scalars['String']['input']>;
  solutionDetailsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionDetailsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** solution_status field predicates */
  solutionStatus?: InputMaybe<Scalars['String']['input']>;
  solutionStatusContains?: InputMaybe<Scalars['String']['input']>;
  solutionStatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  solutionStatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  solutionStatusGT?: InputMaybe<Scalars['String']['input']>;
  solutionStatusGTE?: InputMaybe<Scalars['String']['input']>;
  solutionStatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  solutionStatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  solutionStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionStatusLT?: InputMaybe<Scalars['String']['input']>;
  solutionStatusLTE?: InputMaybe<Scalars['String']['input']>;
  solutionStatusNEQ?: InputMaybe<Scalars['String']['input']>;
  solutionStatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** source field predicates */
  source?: InputMaybe<NotificationSource>;
  sourceIn?: InputMaybe<Array<NotificationSource>>;
  sourceNEQ?: InputMaybe<NotificationSource>;
  sourceNotIn?: InputMaybe<Array<NotificationSource>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum OperationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrgCode = {
  __typename?: 'OrgCode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrgCodeConnection = {
  __typename?: 'OrgCodeConnection';
  edges: Array<OrgCodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrgCodeEdge = {
  __typename?: 'OrgCodeEdge';
  cursor: Scalars['Cursor']['output'];
  node: OrgCode;
};

export type OrgCodeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<OrgCodeOrderField>;
};

export enum OrgCodeOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * OrgCodeWhereInput is used for filtering OrgCode objects.
 * Input was generated by ent.
 */
export type OrgCodeWhereInput = {
  and?: InputMaybe<Array<OrgCodeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrgCodeWhereInput>;
  or?: InputMaybe<Array<OrgCodeWhereInput>>;
};

export type Organization = {
  __typename?: 'Organization';
  children: Array<Organization>;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentOrganization?: Maybe<Organization>;
  updateTime: Scalars['Time']['output'];
  users?: Maybe<Array<OrganizationUser>>;
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Organization;
};

export type OrganizationNode = {
  __typename?: 'OrganizationNode';
  children: Array<OrganizationNode>;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentOrganization?: Maybe<OrganizationNode>;
  updateTime: Scalars['Time']['output'];
};

export type OrganizationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<OrganizationOrderField>;
};

export enum OrganizationOrderField {
  Id = 'ID',
  Name = 'NAME'
}

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  role: OrganizationUserRole;
  user: User;
};

export enum OrganizationUserRole {
  Icso = 'ICSO'
}

/**
 * OrganizationUserWhereInput is used for filtering OrganizationUser objects.
 * Input was generated by ent.
 */
export type OrganizationUserWhereInput = {
  and?: InputMaybe<Array<OrganizationUserWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganizationUserWhereInput>;
  or?: InputMaybe<Array<OrganizationUserWhereInput>>;
  /** role field predicates */
  role?: InputMaybe<OrganizationUserRole>;
  roleIn?: InputMaybe<Array<OrganizationUserRole>>;
  roleNEQ?: InputMaybe<OrganizationUserRole>;
  roleNotIn?: InputMaybe<Array<OrganizationUserRole>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * OrganizationWhereInput is used for filtering Organization objects.
 * Input was generated by ent.
 */
export type OrganizationWhereInput = {
  and?: InputMaybe<Array<OrganizationWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** organization_users edge predicates */
  hasOrganizationUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationUsersWith?: InputMaybe<Array<OrganizationUserWhereInput>>;
  /** parent_organization edge predicates */
  hasParentOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** project_hierarchies edge predicates */
  hasProjectHierarchies?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchiesWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** projects edge predicates */
  hasProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** survey_template_organizations edge predicates */
  hasSurveyTemplateOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyTemplateOrganizationsWith?: InputMaybe<Array<SurveyTemplateWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganizationWhereInput>;
  or?: InputMaybe<Array<OrganizationWhereInput>>;
  /** parent_organization_id field predicates */
  parentOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDContains?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDGT?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentOrganizationIDLT?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentOrganizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OverrideCvssInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  notificationID: Scalars['ID']['input'];
  type: CvssOverridesType;
  vector: Scalars['String']['input'];
  zoneID?: InputMaybe<Scalars['ID']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Point = {
  __typename?: 'Point';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/**  Defaults to Erlangen, Germany  */
export type PointInput = {
  latitude?: Scalars['Float']['input'];
  longitude?: Scalars['Float']['input'];
};

export type PortalDashboard = {
  __typename?: 'PortalDashboard';
  assetItems: PortalDashboardAssetItems;
  inProgressTasks: PortalDashboardTasks;
  notStartedTasks: PortalDashboardTasks;
  notifications: PortalDashboardNotifications;
  projectZones: PortalDashboardProjectZones;
  projects: PortalDashboardProjects;
};

export type PortalDashboardAssetItems = {
  __typename?: 'PortalDashboardAssetItems';
  totalCount: Scalars['Int']['output'];
};

export type PortalDashboardNotifications = {
  __typename?: 'PortalDashboardNotifications';
  nodes: Array<NotificationReadModel>;
  totalCount: Scalars['Int']['output'];
};

export type PortalDashboardProjectZones = {
  __typename?: 'PortalDashboardProjectZones';
  totalCount: Scalars['Int']['output'];
};

export type PortalDashboardProjects = {
  __typename?: 'PortalDashboardProjects';
  nodes: Array<ProjectReadModel>;
  totalCount: Scalars['Int']['output'];
};

export type PortalDashboardTasks = {
  __typename?: 'PortalDashboardTasks';
  nodes: Array<TaskReadModel>;
  totalCount: Scalars['Int']['output'];
};

export type Project = {
  __typename?: 'Project';
  assetsUpdateTime?: Maybe<Scalars['Time']['output']>;
  createTime?: Maybe<Scalars['Time']['output']>;
  creator?: Maybe<User>;
  customerAddress?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationStreet?: Maybe<Scalars['String']['output']>;
  milestone?: Maybe<ProjectMilestone>;
  name: Scalars['String']['output'];
  notifications: NotificationConnection;
  organization?: Maybe<Organization>;
  participants?: Maybe<Array<Maybe<ProjectParticipant>>>;
  plantExternalID?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Point>;
  projectAttributes?: Maybe<Array<ProjectAttribute>>;
  projectCountries?: Maybe<Array<ProjectCountry>>;
  projectHierarchies?: Maybe<Array<ProjectHierarchy>>;
  projectStandardProfiles?: Maybe<Array<ProjectStandardProfile>>;
  securityResponsible?: Maybe<User>;
  status?: Maybe<ProjectStatus>;
  tags?: Maybe<Array<ProjectTag>>;
  type?: Maybe<ProjectType>;
  updateTime?: Maybe<Scalars['Time']['output']>;
  /** @deprecated Use field: participants */
  users?: Maybe<Array<Maybe<ProjectUser>>>;
};


export type ProjectNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrder>;
  projectZoneIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};

export type ProjectAffectedByNotification = {
  __typename?: 'ProjectAffectedByNotification';
  affectedAssetsCount: Scalars['Int']['output'];
  affectedComponentsCount: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationID: Scalars['ID']['output'];
  plantExternalID?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  projectPhaseID: Scalars['ID']['output'];
  projectStatusID: Scalars['ID']['output'];
  project_type_id: Scalars['ID']['output'];
  userID: Scalars['ID']['output'];
};

export type ProjectAffectedByNotificationConnection = {
  __typename?: 'ProjectAffectedByNotificationConnection';
  edges: Array<ProjectAffectedByNotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectAffectedByNotificationEdge = {
  __typename?: 'ProjectAffectedByNotificationEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectAffectedByNotification;
};

export type ProjectAffectedByNotificationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectAffectedByNotificationOrderField>;
};

export enum ProjectAffectedByNotificationOrderField {
  Affectedassetscount = 'AFFECTEDASSETSCOUNT',
  Affectedcomponentscount = 'AFFECTEDCOMPONENTSCOUNT',
  Customerid = 'CUSTOMERID',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Organizationid = 'ORGANIZATIONID',
  Projectphaseid = 'PROJECTPHASEID',
  Projectstatusid = 'PROJECTSTATUSID',
  Projecttypeid = 'PROJECTTYPEID'
}

/**
 * ProjectAffectedByNotificationWhereInput is used for filtering ProjectAffectedByNotificationView objects.
 * Input was generated by ent.
 */
export type ProjectAffectedByNotificationWhereInput = {
  /** affected_assets_count field predicates */
  affectedAssetsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedAssetsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedAssetsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** affected_components_count field predicates */
  affectedComponentsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedComponentsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<ProjectAffectedByNotificationWhereInput>>;
  /** customer_address field predicates */
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerAddressContains?: InputMaybe<Scalars['String']['input']>;
  customerAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerAddressGT?: InputMaybe<Scalars['String']['input']>;
  customerAddressGTE?: InputMaybe<Scalars['String']['input']>;
  customerAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerAddressLT?: InputMaybe<Scalars['String']['input']>;
  customerAddressLTE?: InputMaybe<Scalars['String']['input']>;
  customerAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  customerAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_email field predicates */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerEmailContains?: InputMaybe<Scalars['String']['input']>;
  customerEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailGT?: InputMaybe<Scalars['String']['input']>;
  customerEmailGTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerEmailLT?: InputMaybe<Scalars['String']['input']>;
  customerEmailLTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  customerEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_name field predicates */
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerNameContains?: InputMaybe<Scalars['String']['input']>;
  customerNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerNameGT?: InputMaybe<Scalars['String']['input']>;
  customerNameGTE?: InputMaybe<Scalars['String']['input']>;
  customerNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerNameLT?: InputMaybe<Scalars['String']['input']>;
  customerNameLTE?: InputMaybe<Scalars['String']['input']>;
  customerNameNEQ?: InputMaybe<Scalars['String']['input']>;
  customerNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_phone field predicates */
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerPhoneContains?: InputMaybe<Scalars['String']['input']>;
  customerPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerPhoneGT?: InputMaybe<Scalars['String']['input']>;
  customerPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  customerPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerPhoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerPhoneLT?: InputMaybe<Scalars['String']['input']>;
  customerPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  customerPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  customerPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerPhoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** location_city field predicates */
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCityContains?: InputMaybe<Scalars['String']['input']>;
  locationCityContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationCityEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationCityGT?: InputMaybe<Scalars['String']['input']>;
  locationCityGTE?: InputMaybe<Scalars['String']['input']>;
  locationCityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationCityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationCityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationCityLT?: InputMaybe<Scalars['String']['input']>;
  locationCityLTE?: InputMaybe<Scalars['String']['input']>;
  locationCityNEQ?: InputMaybe<Scalars['String']['input']>;
  locationCityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** location_country field predicates */
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryContains?: InputMaybe<Scalars['String']['input']>;
  locationCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationCountryGT?: InputMaybe<Scalars['String']['input']>;
  locationCountryGTE?: InputMaybe<Scalars['String']['input']>;
  locationCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCountryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationCountryLT?: InputMaybe<Scalars['String']['input']>;
  locationCountryLTE?: InputMaybe<Scalars['String']['input']>;
  locationCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  locationCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCountryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** location_postal_code field predicates */
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeContains?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeGT?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeGTE?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationPostalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationPostalCodeLT?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeLTE?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationPostalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** location_street field predicates */
  locationStreet?: InputMaybe<Scalars['String']['input']>;
  locationStreetContains?: InputMaybe<Scalars['String']['input']>;
  locationStreetContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationStreetEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationStreetGT?: InputMaybe<Scalars['String']['input']>;
  locationStreetGTE?: InputMaybe<Scalars['String']['input']>;
  locationStreetHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationStreetHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationStreetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationStreetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationStreetLT?: InputMaybe<Scalars['String']['input']>;
  locationStreetLTE?: InputMaybe<Scalars['String']['input']>;
  locationStreetNEQ?: InputMaybe<Scalars['String']['input']>;
  locationStreetNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationStreetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectAffectedByNotificationWhereInput>;
  /** notification_id field predicates */
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<ProjectAffectedByNotificationWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContains?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** plant_external_id field predicates */
  plantExternalID?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDContains?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDGT?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDGTE?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantExternalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plantExternalIDLT?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDLTE?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantExternalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** plant_name field predicates */
  plantName?: InputMaybe<Scalars['String']['input']>;
  plantNameContains?: InputMaybe<Scalars['String']['input']>;
  plantNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  plantNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  plantNameGT?: InputMaybe<Scalars['String']['input']>;
  plantNameGTE?: InputMaybe<Scalars['String']['input']>;
  plantNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  plantNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  plantNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plantNameLT?: InputMaybe<Scalars['String']['input']>;
  plantNameLTE?: InputMaybe<Scalars['String']['input']>;
  plantNameNEQ?: InputMaybe<Scalars['String']['input']>;
  plantNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_phase_id field predicates */
  projectPhaseID?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectPhaseIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_status_id field predicates */
  projectStatusID?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStatusIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectAssetRelationsImportSummary = {
  __typename?: 'ProjectAssetRelationsImportSummary';
  assetRelationAttributesCreated: Scalars['Int']['output'];
  assetRelationAttributesUpdated: Scalars['Int']['output'];
  assetRelationsCreated: Scalars['Int']['output'];
  assetRelationsUpdated: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedRows?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  successful: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unsuccessful: Scalars['Int']['output'];
};

export type ProjectAttribute = {
  __typename?: 'ProjectAttribute';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  type: ProjectAttributeType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ProjectAttributeTemplateType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * ProjectAttributeTemplateWhereInput is used for filtering ProjectAttributeTemplate objects.
 * Input was generated by ent.
 */
export type ProjectAttributeTemplateWhereInput = {
  and?: InputMaybe<Array<ProjectAttributeTemplateWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectAttributeTemplateWhereInput>;
  or?: InputMaybe<Array<ProjectAttributeTemplateWhereInput>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<ProjectAttributeTemplateType>;
  typeIn?: InputMaybe<Array<ProjectAttributeTemplateType>>;
  typeNEQ?: InputMaybe<ProjectAttributeTemplateType>;
  typeNotIn?: InputMaybe<Array<ProjectAttributeTemplateType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum ProjectAttributeType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * ProjectAttributeWhereInput is used for filtering ProjectAttribute objects.
 * Input was generated by ent.
 */
export type ProjectAttributeWhereInput = {
  and?: InputMaybe<Array<ProjectAttributeWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectAttributeWhereInput>;
  or?: InputMaybe<Array<ProjectAttributeWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<ProjectAttributeType>;
  typeIn?: InputMaybe<Array<ProjectAttributeType>>;
  typeNEQ?: InputMaybe<ProjectAttributeType>;
  typeNotIn?: InputMaybe<Array<ProjectAttributeType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectComponentNotification = {
  __typename?: 'ProjectComponentNotification';
  assetAlias: Scalars['String']['output'];
  assetID: Scalars['ID']['output'];
  assetItemID: Scalars['ID']['output'];
  assetItemName: Scalars['String']['output'];
  assetName: Scalars['String']['output'];
  assetRating: Scalars['String']['output'];
  assetStatus: Scalars['String']['output'];
  assetTypeID: Scalars['ID']['output'];
  assetTypeName: Scalars['String']['output'];
  componentCpeName?: Maybe<Scalars['String']['output']>;
  componentEolReached: Scalars['Boolean']['output'];
  componentID: Scalars['ID']['output'];
  componentIsValid: Scalars['Boolean']['output'];
  componentName: Scalars['String']['output'];
  componentVendorID: Scalars['ID']['output'];
  componentVendorName: Scalars['String']['output'];
  componentVersion: Scalars['String']['output'];
  customizedCVSS?: Maybe<Cvss>;
  id: Scalars['ID']['output'];
  measureID?: Maybe<Scalars['ID']['output']>;
  measureName?: Maybe<Scalars['String']['output']>;
  measureType?: Maybe<Scalars['String']['output']>;
  mitigationAssignee?: Maybe<Scalars['String']['output']>;
  mitigationID?: Maybe<Scalars['ID']['output']>;
  mitigationStatus?: Maybe<Scalars['String']['output']>;
  mitigationTestID?: Maybe<Scalars['ID']['output']>;
  mitigationTestResult?: Maybe<Scalars['String']['output']>;
  notificationCvssBaseScore?: Maybe<Scalars['Float']['output']>;
  notificationCvssOveralScore?: Maybe<Scalars['Float']['output']>;
  notificationCvssTemporalScore?: Maybe<Scalars['Float']['output']>;
  notificationCvssVector?: Maybe<Scalars['String']['output']>;
  notificationID: Scalars['ID']['output'];
  notificationImpact?: Maybe<Scalars['String']['output']>;
  notificationLastUpdateDate?: Maybe<Scalars['Time']['output']>;
  notificationPriority: Scalars['String']['output'];
  notificationPublishDate: Scalars['Time']['output'];
  notificationSource: Scalars['String']['output'];
  notificationTitle: Scalars['String']['output'];
  projectID: Scalars['ID']['output'];
  projectZoneExposureRating: Scalars['String']['output'];
  projectZoneID: Scalars['ID']['output'];
  projectZoneName: Scalars['String']['output'];
};

export type ProjectComponentNotificationConnection = {
  __typename?: 'ProjectComponentNotificationConnection';
  edges: Array<ProjectComponentNotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectComponentNotificationEdge = {
  __typename?: 'ProjectComponentNotificationEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectComponentNotification;
};

export type ProjectComponentNotificationOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectComponentNotificationOrderField>;
};

export enum ProjectComponentNotificationOrderField {
  Assetid = 'ASSETID',
  Assetitemid = 'ASSETITEMID',
  Assetrating = 'ASSETRATING',
  Assetstatus = 'ASSETSTATUS',
  Assettypename = 'ASSETTYPENAME',
  Componentid = 'COMPONENTID',
  Componentname = 'COMPONENTNAME',
  Componentvendorid = 'COMPONENTVENDORID',
  Componentversion = 'COMPONENTVERSION',
  Measureid = 'MEASUREID',
  Mitigationid = 'MITIGATIONID',
  Mitigationtestid = 'MITIGATIONTESTID',
  Notificationid = 'NOTIFICATIONID',
  Notificationlastupdatedate = 'NOTIFICATIONLASTUPDATEDATE',
  Notificationpriority = 'NOTIFICATIONPRIORITY',
  Notificationpublishdate = 'NOTIFICATIONPUBLISHDATE',
  Notificationtitle = 'NOTIFICATIONTITLE',
  Projectid = 'PROJECTID',
  Projectzoneexposurerating = 'PROJECTZONEEXPOSURERATING',
  Projectzoneid = 'PROJECTZONEID',
  Projectzonename = 'PROJECTZONENAME'
}

/**
 * ProjectComponentNotificationWhereInput is used for filtering ProjectComponentNotificationView objects.
 * Input was generated by ent.
 */
export type ProjectComponentNotificationWhereInput = {
  and?: InputMaybe<Array<ProjectComponentNotificationWhereInput>>;
  /** asset_alias field predicates */
  assetAlias?: InputMaybe<Scalars['String']['input']>;
  assetAliasContains?: InputMaybe<Scalars['String']['input']>;
  assetAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetAliasGT?: InputMaybe<Scalars['String']['input']>;
  assetAliasGTE?: InputMaybe<Scalars['String']['input']>;
  assetAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetAliasLT?: InputMaybe<Scalars['String']['input']>;
  assetAliasLTE?: InputMaybe<Scalars['String']['input']>;
  assetAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  assetAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_item_description field predicates */
  assetItemDescription?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetItemDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  assetItemDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_item_id field predicates */
  assetItemID?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetItemIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetItemIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_item_name field predicates */
  assetItemName?: InputMaybe<Scalars['String']['input']>;
  assetItemNameContains?: InputMaybe<Scalars['String']['input']>;
  assetItemNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetItemNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetItemNameGT?: InputMaybe<Scalars['String']['input']>;
  assetItemNameGTE?: InputMaybe<Scalars['String']['input']>;
  assetItemNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetItemNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetItemNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetItemNameLT?: InputMaybe<Scalars['String']['input']>;
  assetItemNameLTE?: InputMaybe<Scalars['String']['input']>;
  assetItemNameNEQ?: InputMaybe<Scalars['String']['input']>;
  assetItemNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_item_type field predicates */
  assetItemType?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeContains?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeGT?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeGTE?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetItemTypeLT?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeLTE?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  assetItemTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_name field predicates */
  assetName?: InputMaybe<Scalars['String']['input']>;
  assetNameContains?: InputMaybe<Scalars['String']['input']>;
  assetNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetNameGT?: InputMaybe<Scalars['String']['input']>;
  assetNameGTE?: InputMaybe<Scalars['String']['input']>;
  assetNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetNameLT?: InputMaybe<Scalars['String']['input']>;
  assetNameLTE?: InputMaybe<Scalars['String']['input']>;
  assetNameNEQ?: InputMaybe<Scalars['String']['input']>;
  assetNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_rating field predicates */
  assetRating?: InputMaybe<Scalars['String']['input']>;
  assetRatingContains?: InputMaybe<Scalars['String']['input']>;
  assetRatingContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetRatingEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetRatingGT?: InputMaybe<Scalars['String']['input']>;
  assetRatingGTE?: InputMaybe<Scalars['String']['input']>;
  assetRatingHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetRatingHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetRatingIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetRatingLT?: InputMaybe<Scalars['String']['input']>;
  assetRatingLTE?: InputMaybe<Scalars['String']['input']>;
  assetRatingNEQ?: InputMaybe<Scalars['String']['input']>;
  assetRatingNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_status field predicates */
  assetStatus?: InputMaybe<Scalars['String']['input']>;
  assetStatusContains?: InputMaybe<Scalars['String']['input']>;
  assetStatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetStatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetStatusGT?: InputMaybe<Scalars['String']['input']>;
  assetStatusGTE?: InputMaybe<Scalars['String']['input']>;
  assetStatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetStatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetStatusLT?: InputMaybe<Scalars['String']['input']>;
  assetStatusLTE?: InputMaybe<Scalars['String']['input']>;
  assetStatusNEQ?: InputMaybe<Scalars['String']['input']>;
  assetStatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_type_name field predicates */
  assetTypeName?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameContains?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameGT?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameGTE?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTypeNameLT?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameLTE?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  assetTypeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_cpe_name field predicates */
  componentCpeName?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameContains?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameGT?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentCpeNameLT?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentCpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_eol_reached field predicates */
  componentEolReached?: InputMaybe<Scalars['Boolean']['input']>;
  componentEolReachedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_id field predicates */
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_is_valid field predicates */
  componentIsValid?: InputMaybe<Scalars['Boolean']['input']>;
  componentIsValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** component_name field predicates */
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentNameContains?: InputMaybe<Scalars['String']['input']>;
  componentNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentNameGT?: InputMaybe<Scalars['String']['input']>;
  componentNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentNameLT?: InputMaybe<Scalars['String']['input']>;
  componentNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_vendor_id field predicates */
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContains?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  componentVendorIDLT?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  componentVendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** component_vendor_name field predicates */
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContains?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameGTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVendorNameLT?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameLTE?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVendorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_version field predicates */
  componentVersion?: InputMaybe<Scalars['String']['input']>;
  componentVersionContains?: InputMaybe<Scalars['String']['input']>;
  componentVersionContainsFold?: InputMaybe<Scalars['String']['input']>;
  componentVersionEqualFold?: InputMaybe<Scalars['String']['input']>;
  componentVersionGT?: InputMaybe<Scalars['String']['input']>;
  componentVersionGTE?: InputMaybe<Scalars['String']['input']>;
  componentVersionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  componentVersionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  componentVersionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  componentVersionLT?: InputMaybe<Scalars['String']['input']>;
  componentVersionLTE?: InputMaybe<Scalars['String']['input']>;
  componentVersionNEQ?: InputMaybe<Scalars['String']['input']>;
  componentVersionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** measure_id field predicates */
  measureID?: InputMaybe<Scalars['ID']['input']>;
  measureIDContains?: InputMaybe<Scalars['ID']['input']>;
  measureIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  measureIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  measureIDGT?: InputMaybe<Scalars['ID']['input']>;
  measureIDGTE?: InputMaybe<Scalars['ID']['input']>;
  measureIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  measureIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  measureIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  measureIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  measureIDLT?: InputMaybe<Scalars['ID']['input']>;
  measureIDLTE?: InputMaybe<Scalars['ID']['input']>;
  measureIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  measureIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  measureIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** measure_name field predicates */
  measureName?: InputMaybe<Scalars['String']['input']>;
  measureNameContains?: InputMaybe<Scalars['String']['input']>;
  measureNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  measureNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  measureNameGT?: InputMaybe<Scalars['String']['input']>;
  measureNameGTE?: InputMaybe<Scalars['String']['input']>;
  measureNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  measureNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  measureNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  measureNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  measureNameLT?: InputMaybe<Scalars['String']['input']>;
  measureNameLTE?: InputMaybe<Scalars['String']['input']>;
  measureNameNEQ?: InputMaybe<Scalars['String']['input']>;
  measureNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  measureNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** measure_type field predicates */
  measureType?: InputMaybe<Scalars['String']['input']>;
  measureTypeContains?: InputMaybe<Scalars['String']['input']>;
  measureTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  measureTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  measureTypeGT?: InputMaybe<Scalars['String']['input']>;
  measureTypeGTE?: InputMaybe<Scalars['String']['input']>;
  measureTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  measureTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  measureTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  measureTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  measureTypeLT?: InputMaybe<Scalars['String']['input']>;
  measureTypeLTE?: InputMaybe<Scalars['String']['input']>;
  measureTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  measureTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  measureTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mitigation_assignee field predicates */
  mitigationAssignee?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeContains?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeContainsFold?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeEqualFold?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeGT?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeGTE?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mitigationAssigneeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mitigationAssigneeLT?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeLTE?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeNEQ?: InputMaybe<Scalars['String']['input']>;
  mitigationAssigneeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mitigationAssigneeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mitigation_id field predicates */
  mitigationID?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDContains?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDGT?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mitigationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mitigationIDLT?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  mitigationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mitigationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mitigation_status field predicates */
  mitigationStatus?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusContains?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusGT?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusGTE?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mitigationStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mitigationStatusLT?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusLTE?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusNEQ?: InputMaybe<Scalars['String']['input']>;
  mitigationStatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mitigationStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mitigation_test_id field predicates */
  mitigationTestID?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDContains?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDGT?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDGTE?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mitigationTestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mitigationTestIDLT?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDLTE?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  mitigationTestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mitigationTestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mitigation_test_result field predicates */
  mitigationTestResult?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultContains?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultContainsFold?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultEqualFold?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultGT?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultGTE?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mitigationTestResultIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mitigationTestResultLT?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultLTE?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultNEQ?: InputMaybe<Scalars['String']['input']>;
  mitigationTestResultNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mitigationTestResultNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ProjectComponentNotificationWhereInput>;
  /** notification_confidentiality_level field predicates */
  notificationConfidentialityLevel?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelContains?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelGT?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelGTE?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationConfidentialityLevelLT?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelLTE?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationConfidentialityLevelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notification_cvss_base_score field predicates */
  notificationCvssBaseScore?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssBaseScoreGT?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssBaseScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssBaseScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  notificationCvssBaseScoreLT?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssBaseScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssBaseScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssBaseScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** notification_cvss_overal_score field predicates */
  notificationCvssOveralScore?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssOveralScoreGT?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssOveralScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssOveralScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  notificationCvssOveralScoreLT?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssOveralScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssOveralScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssOveralScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** notification_cvss_temporal_score field predicates */
  notificationCvssTemporalScore?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssTemporalScoreGT?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssTemporalScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssTemporalScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  notificationCvssTemporalScoreLT?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssTemporalScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssTemporalScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  notificationCvssTemporalScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** notification_cvss_vector field predicates */
  notificationCvssVector?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorContains?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorGT?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorGTE?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationCvssVectorIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCvssVectorLT?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorLTE?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationCvssVectorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationCvssVectorNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** notification_id field predicates */
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContains?: InputMaybe<Scalars['ID']['input']>;
  notificationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  notificationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationIDLT?: InputMaybe<Scalars['ID']['input']>;
  notificationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  notificationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** notification_impact field predicates */
  notificationImpact?: InputMaybe<Scalars['String']['input']>;
  notificationImpactContains?: InputMaybe<Scalars['String']['input']>;
  notificationImpactContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationImpactEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationImpactGT?: InputMaybe<Scalars['String']['input']>;
  notificationImpactGTE?: InputMaybe<Scalars['String']['input']>;
  notificationImpactHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationImpactHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationImpactIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationImpactIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notificationImpactLT?: InputMaybe<Scalars['String']['input']>;
  notificationImpactLTE?: InputMaybe<Scalars['String']['input']>;
  notificationImpactNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationImpactNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationImpactNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** notification_last_update_date field predicates */
  notificationLastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  notificationLastUpdateDateGT?: InputMaybe<Scalars['Time']['input']>;
  notificationLastUpdateDateGTE?: InputMaybe<Scalars['Time']['input']>;
  notificationLastUpdateDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  notificationLastUpdateDateLT?: InputMaybe<Scalars['Time']['input']>;
  notificationLastUpdateDateLTE?: InputMaybe<Scalars['Time']['input']>;
  notificationLastUpdateDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  notificationLastUpdateDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** notification_priority field predicates */
  notificationPriority?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityContains?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityGT?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityGTE?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationPriorityLT?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityLTE?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationPriorityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notification_publish_date field predicates */
  notificationPublishDate?: InputMaybe<Scalars['Time']['input']>;
  notificationPublishDateGT?: InputMaybe<Scalars['Time']['input']>;
  notificationPublishDateGTE?: InputMaybe<Scalars['Time']['input']>;
  notificationPublishDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  notificationPublishDateLT?: InputMaybe<Scalars['Time']['input']>;
  notificationPublishDateLTE?: InputMaybe<Scalars['Time']['input']>;
  notificationPublishDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  notificationPublishDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** notification_source field predicates */
  notificationSource?: InputMaybe<Scalars['String']['input']>;
  notificationSourceContains?: InputMaybe<Scalars['String']['input']>;
  notificationSourceContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationSourceEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationSourceGT?: InputMaybe<Scalars['String']['input']>;
  notificationSourceGTE?: InputMaybe<Scalars['String']['input']>;
  notificationSourceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationSourceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationSourceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationSourceLT?: InputMaybe<Scalars['String']['input']>;
  notificationSourceLTE?: InputMaybe<Scalars['String']['input']>;
  notificationSourceNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationSourceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notification_title field predicates */
  notificationTitle?: InputMaybe<Scalars['String']['input']>;
  notificationTitleContains?: InputMaybe<Scalars['String']['input']>;
  notificationTitleContainsFold?: InputMaybe<Scalars['String']['input']>;
  notificationTitleEqualFold?: InputMaybe<Scalars['String']['input']>;
  notificationTitleGT?: InputMaybe<Scalars['String']['input']>;
  notificationTitleGTE?: InputMaybe<Scalars['String']['input']>;
  notificationTitleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notificationTitleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notificationTitleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationTitleLT?: InputMaybe<Scalars['String']['input']>;
  notificationTitleLTE?: InputMaybe<Scalars['String']['input']>;
  notificationTitleNEQ?: InputMaybe<Scalars['String']['input']>;
  notificationTitleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<ProjectComponentNotificationWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_zone_exposure_rating field predicates */
  projectZoneExposureRating?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingContains?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingContainsFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingEqualFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingGT?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingGTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingHasPrefix?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingHasSuffix?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectZoneExposureRatingLT?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingLTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingNEQ?: InputMaybe<Scalars['String']['input']>;
  projectZoneExposureRatingNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_zone_name field predicates */
  projectZoneName?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameContains?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameGT?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameGTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectZoneNameLT?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameLTE?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameNEQ?: InputMaybe<Scalars['String']['input']>;
  projectZoneNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectConnectionOrError = ErrNotAuthorized | ProjectConnection;

export type ProjectCountry = {
  __typename?: 'ProjectCountry';
  country: Country;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  updateTime: Scalars['Time']['output'];
};

/**
 * ProjectCountryWhereInput is used for filtering ProjectCountry objects.
 * Input was generated by ent.
 */
export type ProjectCountryWhereInput = {
  and?: InputMaybe<Array<ProjectCountryWhereInput>>;
  /** country_id field predicates */
  countryID?: InputMaybe<Scalars['ID']['input']>;
  countryIDContains?: InputMaybe<Scalars['ID']['input']>;
  countryIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  countryIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  countryIDGT?: InputMaybe<Scalars['ID']['input']>;
  countryIDGTE?: InputMaybe<Scalars['ID']['input']>;
  countryIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  countryIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  countryIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDLT?: InputMaybe<Scalars['ID']['input']>;
  countryIDLTE?: InputMaybe<Scalars['ID']['input']>;
  countryIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  countryIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** country edge predicates */
  hasCountry?: InputMaybe<Scalars['Boolean']['input']>;
  hasCountryWith?: InputMaybe<Array<CountryWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectCountryWhereInput>;
  or?: InputMaybe<Array<ProjectCountryWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectDashboardSummaryCards = {
  __typename?: 'ProjectDashboardSummaryCards';
  assetsCount: Scalars['Int']['output'];
  componentsCount: Scalars['Int']['output'];
  mitigationsCount: Scalars['Int']['output'];
  projectZonesCount: Scalars['Int']['output'];
  survey?: Maybe<ProjectDashboardSummaryCardsSurvey>;
  tasksCompletedCount: Scalars['Int']['output'];
  tasksCount: Scalars['Int']['output'];
  trasCount: Scalars['Int']['output'];
  trasInProgressCount: Scalars['Int']['output'];
  trasReadyForApprovalCount: Scalars['Int']['output'];
};

export type ProjectDashboardSummaryCardsSurvey = {
  __typename?: 'ProjectDashboardSummaryCardsSurvey';
  classificationClassID: Scalars['ID']['output'];
  classificationClassName: Scalars['String']['output'];
  classificationScore: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: SurveyStatus;
};

export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  cursor: Scalars['Cursor']['output'];
  node: Project;
};

/**
 * Has infuence on assets export, When nothing provided all assets will be
 * exported, not allowed to provide both ProjectHierarchyID and ProjectZoneID.
 */
export type ProjectExportAssetsOptions = {
  /** default: false, only interpreted when ProjectHierarchyID or ProjectZoneID is provided */
  includeSubtreeAssets?: InputMaybe<Scalars['Boolean']['input']>;
  /** default: empty, provide when export on project hierarchy is needed */
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  /** default: empty, provide when export on project zone is needed */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectGuidance = {
  __typename?: 'ProjectGuidance';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projectType: ProjectType;
  standardProfile: StandardProfile;
  updateTime: Scalars['Time']['output'];
  version: Scalars['Int']['output'];
};

export type ProjectGuidanceConnection = {
  __typename?: 'ProjectGuidanceConnection';
  edges: Array<ProjectGuidanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectGuidanceEdge = {
  __typename?: 'ProjectGuidanceEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectGuidance;
};

export type ProjectGuidanceOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectGuidanceOrderField>;
};

export enum ProjectGuidanceOrderField {
  Id = 'ID',
  Ispublished = 'ISPUBLISHED',
  Name = 'NAME',
  Projecttypeid = 'PROJECTTYPEID',
  Version = 'VERSION'
}

export type ProjectGuidanceRequirement = {
  __typename?: 'ProjectGuidanceRequirement';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  projectGuidance: ProjectGuidance;
  projectMilestone: ProjectMilestone;
  requirement: Requirement;
  taskTemplate: TaskTemplate;
  updateTime: Scalars['Time']['output'];
};

export type ProjectGuidanceRequirementConnection = {
  __typename?: 'ProjectGuidanceRequirementConnection';
  edges: Array<ProjectGuidanceRequirementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectGuidanceRequirementEdge = {
  __typename?: 'ProjectGuidanceRequirementEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectGuidanceRequirement;
};

export type ProjectGuidanceRequirementOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectGuidanceRequirementOrderField>;
};

export enum ProjectGuidanceRequirementOrderField {
  Id = 'ID'
}

/**
 * ProjectGuidanceRequirementWhereInput is used for filtering ProjectGuidanceRequirement objects.
 * Input was generated by ent.
 */
export type ProjectGuidanceRequirementWhereInput = {
  and?: InputMaybe<Array<ProjectGuidanceRequirementWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_guidance edge predicates */
  hasProjectGuidance?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectGuidanceWith?: InputMaybe<Array<ProjectGuidanceWhereInput>>;
  /** project_milestone edge predicates */
  hasProjectMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectMilestoneWith?: InputMaybe<Array<ProjectMilestoneWhereInput>>;
  /** requirement edge predicates */
  hasRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** task_template edge predicates */
  hasTaskTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskTemplateWith?: InputMaybe<Array<TaskTemplateWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectGuidanceRequirementWhereInput>;
  or?: InputMaybe<Array<ProjectGuidanceRequirementWhereInput>>;
  /** project_guidance_id field predicates */
  projectGuidanceID?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectGuidanceIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_milestone_id field predicates */
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectMilestoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** requirement_id field predicates */
  requirementID?: InputMaybe<Scalars['ID']['input']>;
  requirementIDContains?: InputMaybe<Scalars['ID']['input']>;
  requirementIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  requirementIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  requirementIDGT?: InputMaybe<Scalars['ID']['input']>;
  requirementIDGTE?: InputMaybe<Scalars['ID']['input']>;
  requirementIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  requirementIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  requirementIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requirementIDLT?: InputMaybe<Scalars['ID']['input']>;
  requirementIDLTE?: InputMaybe<Scalars['ID']['input']>;
  requirementIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requirementIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** task_template_id field predicates */
  taskTemplateID?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDContains?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDGT?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDGTE?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskTemplateIDLT?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDLTE?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  taskTemplateIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ProjectGuidanceWhereInput is used for filtering ProjectGuidance objects.
 * Input was generated by ent.
 */
export type ProjectGuidanceWhereInput = {
  and?: InputMaybe<Array<ProjectGuidanceWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_guidance_requirements edge predicates */
  hasProjectGuidanceRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectGuidanceRequirementsWith?: InputMaybe<Array<ProjectGuidanceRequirementWhereInput>>;
  /** project_standard_profiles edge predicates */
  hasProjectStandardProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectStandardProfilesWith?: InputMaybe<Array<ProjectStandardProfileWhereInput>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** standard_profile edge predicates */
  hasStandardProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfileWith?: InputMaybe<Array<StandardProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_published field predicates */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectGuidanceWhereInput>;
  or?: InputMaybe<Array<ProjectGuidanceWhereInput>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** standard_profile_id field predicates */
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['Int']['input']>;
  versionGT?: InputMaybe<Scalars['Int']['input']>;
  versionGTE?: InputMaybe<Scalars['Int']['input']>;
  versionIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  versionLT?: InputMaybe<Scalars['Int']['input']>;
  versionLTE?: InputMaybe<Scalars['Int']['input']>;
  versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProjectHierarchy = {
  __typename?: 'ProjectHierarchy';
  children: Array<ProjectHierarchy>;
  commodityManager?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['Time']['output'];
  criticality: ProjectHierarchyCriticality;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  parentHierarchy?: Maybe<ProjectHierarchy>;
  project: Project;
  projectHierarchyAssets: Array<ProjectHierarchyAsset>;
  projectHierarchyAttributes?: Maybe<Array<ProjectHierarchyAttribute>>;
  projectHierarchyFiles: Array<ProjectHierarchyFile>;
  projectHierarchyTodos: Array<ProjectHierarchyTodo>;
  supplierName?: Maybe<Scalars['String']['output']>;
  type: ProjectHierarchyType;
  updateTime: Scalars['Time']['output'];
};

export type ProjectHierarchyAsset = {
  __typename?: 'ProjectHierarchyAsset';
  asset: Asset;
  assetID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  projectHierarchyID: Scalars['ID']['output'];
};

/**
 * ProjectHierarchyAssetWhereInput is used for filtering ProjectHierarchyAsset objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyAssetWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyAssetWhereInput>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetIDContains?: InputMaybe<Scalars['ID']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assetIDGT?: InputMaybe<Scalars['ID']['input']>;
  assetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetIDLT?: InputMaybe<Scalars['ID']['input']>;
  assetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** asset edge predicates */
  hasAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetWith?: InputMaybe<Array<AssetWhereInput>>;
  /** project_hierarchy edge predicates */
  hasProjectHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectHierarchyAssetWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyAssetWhereInput>>;
  /** project_hierarchy_id field predicates */
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectHierarchyAttribute = {
  __typename?: 'ProjectHierarchyAttribute';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  projectHierarchy: ProjectHierarchy;
  projectHierarchyAttributeDefinition: ProjectHierarchyAttributeDefinition;
  updateTime?: Maybe<Scalars['Time']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProjectHierarchyAttributeDefinition = {
  __typename?: 'ProjectHierarchyAttributeDefinition';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isMandatory: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  project: Project;
  projectHierarchyAttributes?: Maybe<Array<ProjectHierarchyAttribute>>;
  projectHierarchyType: ProjectHierarchyType;
  sequence: Scalars['Int']['output'];
  type: ProjectHierarchyAttributeDefinitionType;
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type ProjectHierarchyAttributeDefinitionConnection = {
  __typename?: 'ProjectHierarchyAttributeDefinitionConnection';
  edges: Array<ProjectHierarchyAttributeDefinitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectHierarchyAttributeDefinitionEdge = {
  __typename?: 'ProjectHierarchyAttributeDefinitionEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectHierarchyAttributeDefinition;
};

export type ProjectHierarchyAttributeDefinitionOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectHierarchyAttributeDefinitionOrderField>;
};

export enum ProjectHierarchyAttributeDefinitionOrderField {
  Id = 'ID',
  Label = 'LABEL',
  Projecthierarchytypeid = 'PROJECTHIERARCHYTYPEID',
  Sequence = 'SEQUENCE',
  Type = 'TYPE'
}

export enum ProjectHierarchyAttributeDefinitionTemplateType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * ProjectHierarchyAttributeDefinitionTemplateWhereInput is used for filtering
 * ProjectHierarchyAttributeDefinitionTemplate objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyAttributeDefinitionTemplateWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionTemplateWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_hierarchy_type edge predicates */
  hasProjectHierarchyType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyTypeWith?: InputMaybe<Array<ProjectHierarchyTypeWhereInput>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectHierarchyAttributeDefinitionTemplateWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionTemplateWhereInput>>;
  /** project_hierarchy_type_id field predicates */
  projectHierarchyTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<ProjectHierarchyAttributeDefinitionTemplateType>;
  typeIn?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionTemplateType>>;
  typeNEQ?: InputMaybe<ProjectHierarchyAttributeDefinitionTemplateType>;
  typeNotIn?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionTemplateType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum ProjectHierarchyAttributeDefinitionType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * ProjectHierarchyAttributeDefinitionWhereInput is used for filtering ProjectHierarchyAttributeDefinition objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyAttributeDefinitionWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_hierarchy_attributes edge predicates */
  hasProjectHierarchyAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributesWith?: InputMaybe<Array<ProjectHierarchyAttributeWhereInput>>;
  /** project_hierarchy_type edge predicates */
  hasProjectHierarchyType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyTypeWith?: InputMaybe<Array<ProjectHierarchyTypeWhereInput>>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectHierarchyAttributeDefinitionWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionWhereInput>>;
  /** project_hierarchy_type_id field predicates */
  projectHierarchyTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<ProjectHierarchyAttributeDefinitionType>;
  typeIn?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionType>>;
  typeNEQ?: InputMaybe<ProjectHierarchyAttributeDefinitionType>;
  typeNotIn?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionType>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ProjectHierarchyAttributeWhereInput is used for filtering ProjectHierarchyAttribute objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyAttributeWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyAttributeWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_hierarchy edge predicates */
  hasProjectHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_hierarchy_attribute_definition edge predicates */
  hasProjectHierarchyAttributeDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributeDefinitionWith?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionWhereInput>>;
  hasProjectHierarchyWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectHierarchyAttributeWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyAttributeWhereInput>>;
  /** project_hierarchy_attribute_definition_id field predicates */
  projectHierarchyAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyAttributeDefinitionIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyAttributeDefinitionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_hierarchy_id field predicates */
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectHierarchyConnection = {
  __typename?: 'ProjectHierarchyConnection';
  edges: Array<ProjectHierarchyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ProjectHierarchyCriticality {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ProjectHierarchyEdge = {
  __typename?: 'ProjectHierarchyEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectHierarchy;
};

export type ProjectHierarchyFile = {
  __typename?: 'ProjectHierarchyFile';
  createTime: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileAsset: FileAsset;
  id: Scalars['ID']['output'];
  projectHierarchyID: Scalars['ID']['output'];
  updateTime: Scalars['Time']['output'];
};

/**
 * ProjectHierarchyFileWhereInput is used for filtering ProjectHierarchyFile objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyFileWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyFileWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** project_hierarchy edge predicates */
  hasProjectHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectHierarchyFileWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyFileWhereInput>>;
  /** project_hierarchy_id field predicates */
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectHierarchyOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectHierarchyOrderField>;
};

export enum ProjectHierarchyOrderField {
  Criticality = 'CRITICALITY',
  Id = 'ID',
  Name = 'NAME',
  Organizationid = 'ORGANIZATIONID',
  Parentid = 'PARENTID',
  Projecthierarchytypeid = 'PROJECTHIERARCHYTYPEID',
  Projectid = 'PROJECTID'
}

export type ProjectHierarchyTodo = {
  __typename?: 'ProjectHierarchyTodo';
  createTime: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  projectHierarchy: ProjectHierarchy;
  seqNo: Scalars['Int']['output'];
  status: ProjectHierarchyTodoStatus;
  title: Scalars['String']['output'];
  updateTime: Scalars['Time']['output'];
};

export type ProjectHierarchyTodoConnection = {
  __typename?: 'ProjectHierarchyTodoConnection';
  edges: Array<ProjectHierarchyTodoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectHierarchyTodoEdge = {
  __typename?: 'ProjectHierarchyTodoEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectHierarchyTodo;
};

export type ProjectHierarchyTodoOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectHierarchyTodoOrderField>;
};

export enum ProjectHierarchyTodoOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Seqno = 'SEQNO',
  Status = 'STATUS',
  Title = 'TITLE',
  Updatetime = 'UPDATETIME'
}

export enum ProjectHierarchyTodoStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Notstarted = 'NOTSTARTED',
  Onhold = 'ONHOLD'
}

/**
 * ProjectHierarchyTodoWhereInput is used for filtering ProjectHierarchyTodo objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyTodoWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyTodoWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** project_hierarchy edge predicates */
  hasProjectHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectHierarchyTodoWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyTodoWhereInput>>;
  /** project_hierarchy_id field predicates */
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** seq_no field predicates */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  seqNoGT?: InputMaybe<Scalars['Int']['input']>;
  seqNoGTE?: InputMaybe<Scalars['Int']['input']>;
  seqNoIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  seqNoLT?: InputMaybe<Scalars['Int']['input']>;
  seqNoLTE?: InputMaybe<Scalars['Int']['input']>;
  seqNoNEQ?: InputMaybe<Scalars['Int']['input']>;
  seqNoNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** status field predicates */
  status?: InputMaybe<ProjectHierarchyTodoStatus>;
  statusIn?: InputMaybe<Array<ProjectHierarchyTodoStatus>>;
  statusNEQ?: InputMaybe<ProjectHierarchyTodoStatus>;
  statusNotIn?: InputMaybe<Array<ProjectHierarchyTodoStatus>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectHierarchyType = {
  __typename?: 'ProjectHierarchyType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProjectHierarchyTypeConnection = {
  __typename?: 'ProjectHierarchyTypeConnection';
  edges: Array<ProjectHierarchyTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectHierarchyTypeEdge = {
  __typename?: 'ProjectHierarchyTypeEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectHierarchyType;
};

export type ProjectHierarchyTypeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectHierarchyTypeOrderField>;
};

export enum ProjectHierarchyTypeOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * ProjectHierarchyTypeWhereInput is used for filtering ProjectHierarchyType objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyTypeWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyTypeWhereInput>>;
  /** project_hierarchies edge predicates */
  hasProjectHierarchies?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchiesWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** project_hierarchy_attribute_definition_templates edge predicates */
  hasProjectHierarchyAttributeDefinitionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributeDefinitionTemplatesWith?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionTemplateWhereInput>>;
  /** project_hierarchy_attribute_definitions edge predicates */
  hasProjectHierarchyAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributeDefinitionsWith?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectHierarchyTypeWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyTypeWhereInput>>;
};

/**
 * ProjectHierarchyWhereInput is used for filtering ProjectHierarchy objects.
 * Input was generated by ent.
 */
export type ProjectHierarchyWhereInput = {
  and?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** commodity_manager field predicates */
  commodityManager?: InputMaybe<Scalars['String']['input']>;
  commodityManagerContains?: InputMaybe<Scalars['String']['input']>;
  commodityManagerContainsFold?: InputMaybe<Scalars['String']['input']>;
  commodityManagerEqualFold?: InputMaybe<Scalars['String']['input']>;
  commodityManagerGT?: InputMaybe<Scalars['String']['input']>;
  commodityManagerGTE?: InputMaybe<Scalars['String']['input']>;
  commodityManagerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commodityManagerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commodityManagerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commodityManagerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  commodityManagerLT?: InputMaybe<Scalars['String']['input']>;
  commodityManagerLTE?: InputMaybe<Scalars['String']['input']>;
  commodityManagerNEQ?: InputMaybe<Scalars['String']['input']>;
  commodityManagerNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commodityManagerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** criticality field predicates */
  criticality?: InputMaybe<ProjectHierarchyCriticality>;
  criticalityIn?: InputMaybe<Array<ProjectHierarchyCriticality>>;
  criticalityNEQ?: InputMaybe<ProjectHierarchyCriticality>;
  criticalityNotIn?: InputMaybe<Array<ProjectHierarchyCriticality>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** parent_hierarchy edge predicates */
  hasParentHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentHierarchyWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_hierarchy_assets edge predicates */
  hasProjectHierarchyAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAssetsWith?: InputMaybe<Array<ProjectHierarchyAssetWhereInput>>;
  /** project_hierarchy_attributes edge predicates */
  hasProjectHierarchyAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributesWith?: InputMaybe<Array<ProjectHierarchyAttributeWhereInput>>;
  /** project_hierarchy_files edge predicates */
  hasProjectHierarchyFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyFilesWith?: InputMaybe<Array<ProjectHierarchyFileWhereInput>>;
  /** project_hierarchy_todos edge predicates */
  hasProjectHierarchyTodos?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyTodosWith?: InputMaybe<Array<ProjectHierarchyTodoWhereInput>>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** type edge predicates */
  hasType?: InputMaybe<Scalars['Boolean']['input']>;
  hasTypeWith?: InputMaybe<Array<ProjectHierarchyTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectHierarchyWhereInput>;
  or?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContains?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** parent_id field predicates */
  parentID?: InputMaybe<Scalars['ID']['input']>;
  parentIDContains?: InputMaybe<Scalars['ID']['input']>;
  parentIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  parentIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  parentIDGT?: InputMaybe<Scalars['ID']['input']>;
  parentIDGTE?: InputMaybe<Scalars['ID']['input']>;
  parentIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  parentIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  parentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentIDLT?: InputMaybe<Scalars['ID']['input']>;
  parentIDLTE?: InputMaybe<Scalars['ID']['input']>;
  parentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_hierarchy_type_id field predicates */
  projectHierarchyTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectHierarchyTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** supplier_name field predicates */
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierNameContains?: InputMaybe<Scalars['String']['input']>;
  supplierNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  supplierNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  supplierNameGT?: InputMaybe<Scalars['String']['input']>;
  supplierNameGTE?: InputMaybe<Scalars['String']['input']>;
  supplierNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  supplierNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  supplierNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supplierNameLT?: InputMaybe<Scalars['String']['input']>;
  supplierNameLTE?: InputMaybe<Scalars['String']['input']>;
  supplierNameNEQ?: InputMaybe<Scalars['String']['input']>;
  supplierNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectImportAssetsSummary = {
  __typename?: 'ProjectImportAssetsSummary';
  assetItemsCreated: Scalars['Int']['output'];
  assetItemsUpdated: Scalars['Int']['output'];
  assetsCreated: Scalars['Int']['output'];
  assetsUpdated: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedRows?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  projectZonesUpdated: Scalars['Int']['output'];
  successful: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unsuccessful: Scalars['Int']['output'];
};

export type ProjectImportAssetsSummaryOrError = ErrNotAuthorized | ProjectImportAssetsSummary;

export type ProjectImportSbomInput = {
  /**  if not provided then assigned to the default one  */
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  /**  if not provided then assigned to the root one  */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectImportSbomSummary = {
  __typename?: 'ProjectImportSBOMSummary';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  totalComponents: Scalars['Int']['output'];
};

export type ProjectMilestone = {
  __typename?: 'ProjectMilestone';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectPhase: ProjectPhase;
  seqNo: Scalars['Int']['output'];
};

export type ProjectMilestoneConnection = {
  __typename?: 'ProjectMilestoneConnection';
  edges: Array<ProjectMilestoneEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectMilestoneEdge = {
  __typename?: 'ProjectMilestoneEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectMilestone;
};

export type ProjectMilestoneOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectMilestoneOrderField>;
};

export enum ProjectMilestoneOrderField {
  Id = 'ID',
  Name = 'NAME',
  Seqno = 'SEQNO'
}

/**
 * ProjectMilestoneWhereInput is used for filtering ProjectMilestone objects.
 * Input was generated by ent.
 */
export type ProjectMilestoneWhereInput = {
  and?: InputMaybe<Array<ProjectMilestoneWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** project_guidance_requirements edge predicates */
  hasProjectGuidanceRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectGuidanceRequirementsWith?: InputMaybe<Array<ProjectGuidanceRequirementWhereInput>>;
  /** project_phase edge predicates */
  hasProjectPhase?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectPhaseWith?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  /** projects edge predicates */
  hasProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** tasks edge predicates */
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  hasTasksWith?: InputMaybe<Array<TaskWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectMilestoneWhereInput>;
  or?: InputMaybe<Array<ProjectMilestoneWhereInput>>;
  /** project_phase_id field predicates */
  projectPhaseID?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectPhaseIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** seq_no field predicates */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  seqNoGT?: InputMaybe<Scalars['Int']['input']>;
  seqNoGTE?: InputMaybe<Scalars['Int']['input']>;
  seqNoIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  seqNoLT?: InputMaybe<Scalars['Int']['input']>;
  seqNoLTE?: InputMaybe<Scalars['Int']['input']>;
  seqNoNEQ?: InputMaybe<Scalars['Int']['input']>;
  seqNoNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProjectOrError = ErrNotAuthorized | Project;

export type ProjectOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectOrderField>;
};

export enum ProjectOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Name = 'NAME',
  Updatetime = 'UPDATETIME'
}

export type ProjectParticipant = OrganizationUser | ProjectUser;

export type ProjectPhase = {
  __typename?: 'ProjectPhase';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectMilestones?: Maybe<Array<Maybe<ProjectMilestone>>>;
  projectTypeID: Scalars['ID']['output'];
  seqNo: Scalars['Int']['output'];
};

export type ProjectPhaseConnection = {
  __typename?: 'ProjectPhaseConnection';
  edges: Array<ProjectPhaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectPhaseEdge = {
  __typename?: 'ProjectPhaseEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectPhase;
};

export type ProjectPhaseOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectPhaseOrderField>;
};

export enum ProjectPhaseOrderField {
  Id = 'ID',
  Name = 'NAME',
  Seqno = 'SEQNO'
}

/**
 * ProjectPhaseWhereInput is used for filtering ProjectPhase objects.
 * Input was generated by ent.
 */
export type ProjectPhaseWhereInput = {
  and?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  /** project_milestones edge predicates */
  hasProjectMilestones?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectMilestonesWith?: InputMaybe<Array<ProjectMilestoneWhereInput>>;
  /** project_type edge predicates */
  hasProjectType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectPhaseWhereInput>;
  or?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** seq_no field predicates */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  seqNoGT?: InputMaybe<Scalars['Int']['input']>;
  seqNoGTE?: InputMaybe<Scalars['Int']['input']>;
  seqNoIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  seqNoLT?: InputMaybe<Scalars['Int']['input']>;
  seqNoLTE?: InputMaybe<Scalars['Int']['input']>;
  seqNoNEQ?: InputMaybe<Scalars['Int']['input']>;
  seqNoNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProjectReadModel = {
  __typename?: 'ProjectReadModel';
  assetsUpdateTime?: Maybe<Scalars['Time']['output']>;
  createTime: Scalars['Time']['output'];
  creatorID: Scalars['ID']['output'];
  customerAddress?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationStreet?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationID: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  plantExternalID?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['String']['output']>;
  pointGeo?: Maybe<Point>;
  projectMilestoneID: Scalars['ID']['output'];
  projectMilestoneName: Scalars['String']['output'];
  projectStatusID: Scalars['ID']['output'];
  projectStatusName: Scalars['String']['output'];
  projectTypeID: Scalars['ID']['output'];
  projectTypeName: Scalars['String']['output'];
  securityResponsibleID?: Maybe<Scalars['ID']['output']>;
  updateTime: Scalars['Time']['output'];
};

export type ProjectReadModelConnection = {
  __typename?: 'ProjectReadModelConnection';
  edges: Array<ProjectReadModelEdge>;
  totalCount: Scalars['Int']['output'];
};

export type ProjectReadModelEdge = {
  __typename?: 'ProjectReadModelEdge';
  node: ProjectReadModel;
};

export type ProjectReadModelOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectReadModelOrderField>;
};

export enum ProjectReadModelOrderField {
  CreateTime = 'CREATE_TIME',
  Id = 'ID',
  Name = 'NAME',
  UpdateTime = 'UPDATE_TIME'
}

export type ProjectReadModelWhereInput = {
  creatorID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  milestoneID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  statusID?: InputMaybe<Scalars['ID']['input']>;
  typeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * ProjectRelationTypeWhereInput is used for filtering ProjectRelationType objects.
 * Input was generated by ent.
 */
export type ProjectRelationTypeWhereInput = {
  and?: InputMaybe<Array<ProjectRelationTypeWhereInput>>;
  /** project_relation edge predicates */
  hasProjectRelation?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectRelationWith?: InputMaybe<Array<ProjectRelationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectRelationTypeWhereInput>;
  or?: InputMaybe<Array<ProjectRelationTypeWhereInput>>;
};

/**
 * ProjectRelationWhereInput is used for filtering ProjectRelation objects.
 * Input was generated by ent.
 */
export type ProjectRelationWhereInput = {
  and?: InputMaybe<Array<ProjectRelationWhereInput>>;
  /** parent_project edge predicates */
  hasParentProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_relation_type edge predicates */
  hasProjectRelationType?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectRelationTypeWith?: InputMaybe<Array<ProjectRelationTypeWhereInput>>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectRelationWhereInput>;
  or?: InputMaybe<Array<ProjectRelationWhereInput>>;
};

export type ProjectStandardProfile = {
  __typename?: 'ProjectStandardProfile';
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  projectGuidance?: Maybe<ProjectGuidance>;
  standardProfile?: Maybe<StandardProfile>;
};

/**
 * ProjectStandardProfileWhereInput is used for filtering ProjectStandardProfile objects.
 * Input was generated by ent.
 */
export type ProjectStandardProfileWhereInput = {
  and?: InputMaybe<Array<ProjectStandardProfileWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_guidance edge predicates */
  hasProjectGuidance?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectGuidanceWith?: InputMaybe<Array<ProjectGuidanceWhereInput>>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** standard_profile edge predicates */
  hasStandardProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfileWith?: InputMaybe<Array<StandardProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectStandardProfileWhereInput>;
  or?: InputMaybe<Array<ProjectStandardProfileWhereInput>>;
  /** project_guidance_id field predicates */
  projectGuidanceID?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectGuidanceIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectGuidanceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** standard_profile_id field predicates */
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProjectStatusConnection = {
  __typename?: 'ProjectStatusConnection';
  edges: Array<ProjectStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectStatusEdge = {
  __typename?: 'ProjectStatusEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectStatus;
};

export type ProjectStatusOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectStatusOrderField>;
};

export enum ProjectStatusOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * ProjectStatusWhereInput is used for filtering ProjectStatus objects.
 * Input was generated by ent.
 */
export type ProjectStatusWhereInput = {
  and?: InputMaybe<Array<ProjectStatusWhereInput>>;
  /** projects edge predicates */
  hasProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectStatusWhereInput>;
  or?: InputMaybe<Array<ProjectStatusWhereInput>>;
};

export type ProjectTag = {
  __typename?: 'ProjectTag';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updateTime: Scalars['Time']['output'];
};

/**
 * ProjectTagWhereInput is used for filtering ProjectTag objects.
 * Input was generated by ent.
 */
export type ProjectTagWhereInput = {
  and?: InputMaybe<Array<ProjectTagWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectTagWhereInput>;
  or?: InputMaybe<Array<ProjectTagWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProjectTypeConnection = {
  __typename?: 'ProjectTypeConnection';
  edges: Array<ProjectTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectTypeEdge = {
  __typename?: 'ProjectTypeEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectType;
};

export type ProjectTypeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectTypeOrderField>;
};

export enum ProjectTypeOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * ProjectTypeWhereInput is used for filtering ProjectType objects.
 * Input was generated by ent.
 */
export type ProjectTypeWhereInput = {
  and?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_relation_attribute_definition_templates edge predicates */
  hasAssetRelationAttributeDefinitionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributeDefinitionTemplatesWith?: InputMaybe<Array<AssetRelationAttributeDefinitionTemplateWhereInput>>;
  /** project_attribute_templates edge predicates */
  hasProjectAttributeTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectAttributeTemplatesWith?: InputMaybe<Array<ProjectAttributeTemplateWhereInput>>;
  /** project_hierarchy_attribute_definition_templates edge predicates */
  hasProjectHierarchyAttributeDefinitionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributeDefinitionTemplatesWith?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionTemplateWhereInput>>;
  /** project_types edge predicates */
  hasProjectTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectTypesWith?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  /** projects edge predicates */
  hasProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectTypeWhereInput>;
  or?: InputMaybe<Array<ProjectTypeWhereInput>>;
};

export type ProjectUser = {
  __typename?: 'ProjectUser';
  id: Scalars['ID']['output'];
  role?: Maybe<ProjectUserRole>;
  user: User;
};

export type ProjectUserInput = {
  roleID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type ProjectUserOrError = ErrNotAuthorized | ProjectUser;

export type ProjectUserRole = {
  __typename?: 'ProjectUserRole';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * ProjectUserRoleWhereInput is used for filtering ProjectUserRole objects.
 * Input was generated by ent.
 */
export type ProjectUserRoleWhereInput = {
  and?: InputMaybe<Array<ProjectUserRoleWhereInput>>;
  /** project_users edge predicates */
  hasProjectUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectUsersWith?: InputMaybe<Array<ProjectUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectUserRoleWhereInput>;
  or?: InputMaybe<Array<ProjectUserRoleWhereInput>>;
};

/**
 * ProjectUserWhereInput is used for filtering ProjectUser objects.
 * Input was generated by ent.
 */
export type ProjectUserWhereInput = {
  and?: InputMaybe<Array<ProjectUserWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectUserWhereInput>;
  or?: InputMaybe<Array<ProjectUserWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * ProjectWhereInput is used for filtering Project objects.
 * Input was generated by ent.
 */
export type ProjectWhereInput = {
  and?: InputMaybe<Array<ProjectWhereInput>>;
  /** assets_update_time field predicates */
  assetsUpdateTime?: InputMaybe<Scalars['Time']['input']>;
  assetsUpdateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  assetsUpdateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  assetsUpdateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  assetsUpdateTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetsUpdateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  assetsUpdateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  assetsUpdateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  assetsUpdateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  assetsUpdateTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** creator_id field predicates */
  creatorID?: InputMaybe<Scalars['ID']['input']>;
  creatorIDContains?: InputMaybe<Scalars['ID']['input']>;
  creatorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  creatorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  creatorIDGT?: InputMaybe<Scalars['ID']['input']>;
  creatorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  creatorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  creatorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  creatorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  creatorIDLT?: InputMaybe<Scalars['ID']['input']>;
  creatorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  creatorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  creatorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** customer_address field predicates */
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerAddressContains?: InputMaybe<Scalars['String']['input']>;
  customerAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerAddressGT?: InputMaybe<Scalars['String']['input']>;
  customerAddressGTE?: InputMaybe<Scalars['String']['input']>;
  customerAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerAddressLT?: InputMaybe<Scalars['String']['input']>;
  customerAddressLTE?: InputMaybe<Scalars['String']['input']>;
  customerAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  customerAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_email field predicates */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerEmailContains?: InputMaybe<Scalars['String']['input']>;
  customerEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailGT?: InputMaybe<Scalars['String']['input']>;
  customerEmailGTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerEmailLT?: InputMaybe<Scalars['String']['input']>;
  customerEmailLTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  customerEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_name field predicates */
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerNameContains?: InputMaybe<Scalars['String']['input']>;
  customerNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerNameGT?: InputMaybe<Scalars['String']['input']>;
  customerNameGTE?: InputMaybe<Scalars['String']['input']>;
  customerNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerNameLT?: InputMaybe<Scalars['String']['input']>;
  customerNameLTE?: InputMaybe<Scalars['String']['input']>;
  customerNameNEQ?: InputMaybe<Scalars['String']['input']>;
  customerNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_phone field predicates */
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerPhoneContains?: InputMaybe<Scalars['String']['input']>;
  customerPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerPhoneGT?: InputMaybe<Scalars['String']['input']>;
  customerPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  customerPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerPhoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerPhoneLT?: InputMaybe<Scalars['String']['input']>;
  customerPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  customerPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  customerPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerPhoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** file_encryption_key field predicates */
  fileEncryptionKey?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyContains?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyGT?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyGTE?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileEncryptionKeyLT?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyLTE?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  fileEncryptionKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_attribute_definitions edge predicates */
  hasAssetAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetAttributeDefinitionsWith?: InputMaybe<Array<AssetAttributeDefinitionWhereInput>>;
  /** asset_item_attribute_definitions edge predicates */
  hasAssetItemAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetItemAttributeDefinitionsWith?: InputMaybe<Array<AssetItemAttributeDefinitionWhereInput>>;
  /** asset_relation_attribute_definitions edge predicates */
  hasAssetRelationAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributeDefinitionsWith?: InputMaybe<Array<AssetRelationAttributeDefinitionWhereInput>>;
  /** asset_relations edge predicates */
  hasAssetRelations?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationsWith?: InputMaybe<Array<AssetRelationWhereInput>>;
  /** component_suggestion edge predicates */
  hasComponentSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSuggestionWith?: InputMaybe<Array<ComponentSuggestionWhereInput>>;
  /** components edge predicates */
  hasComponents?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentsWith?: InputMaybe<Array<ComponentWhereInput>>;
  /** cras edge predicates */
  hasCras?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrasWith?: InputMaybe<Array<CraWhereInput>>;
  /** creator edge predicates */
  hasCreator?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatorWith?: InputMaybe<Array<UserWhereInput>>;
  /** file_assets edge predicates */
  hasFileAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetsWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** measures edge predicates */
  hasMeasures?: InputMaybe<Scalars['Boolean']['input']>;
  hasMeasuresWith?: InputMaybe<Array<MeasureWhereInput>>;
  /** milestone edge predicates */
  hasMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  hasMilestoneWith?: InputMaybe<Array<ProjectMilestoneWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** parent_project_relation edge predicates */
  hasParentProjectRelation?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentProjectRelationWith?: InputMaybe<Array<ProjectRelationWhereInput>>;
  /** project_attributes edge predicates */
  hasProjectAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectAttributesWith?: InputMaybe<Array<ProjectAttributeWhereInput>>;
  /** project_countries edge predicates */
  hasProjectCountries?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectCountriesWith?: InputMaybe<Array<ProjectCountryWhereInput>>;
  /** project_hierarchies edge predicates */
  hasProjectHierarchies?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchiesWith?: InputMaybe<Array<ProjectHierarchyWhereInput>>;
  /** project_hierarchy_attribute_definitions edge predicates */
  hasProjectHierarchyAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectHierarchyAttributeDefinitionsWith?: InputMaybe<Array<ProjectHierarchyAttributeDefinitionWhereInput>>;
  /** project_relation edge predicates */
  hasProjectRelation?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectRelationWith?: InputMaybe<Array<ProjectRelationWhereInput>>;
  /** project_standard_profiles edge predicates */
  hasProjectStandardProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectStandardProfilesWith?: InputMaybe<Array<ProjectStandardProfileWhereInput>>;
  /** project_users edge predicates */
  hasProjectUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectUsersWith?: InputMaybe<Array<ProjectUserWhereInput>>;
  /** project_zone edge predicates */
  hasProjectZone?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneWith?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** security_responsible edge predicates */
  hasSecurityResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecurityResponsibleWith?: InputMaybe<Array<UserWhereInput>>;
  /** status edge predicates */
  hasStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatusWith?: InputMaybe<Array<ProjectStatusWhereInput>>;
  /** surveys edge predicates */
  hasSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveysWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** tags edge predicates */
  hasTags?: InputMaybe<Scalars['Boolean']['input']>;
  hasTagsWith?: InputMaybe<Array<ProjectTagWhereInput>>;
  /** task edge predicates */
  hasTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskWith?: InputMaybe<Array<TaskWhereInput>>;
  /** tras edge predicates */
  hasTras?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrasWith?: InputMaybe<Array<TraWhereInput>>;
  /** type edge predicates */
  hasType?: InputMaybe<Scalars['Boolean']['input']>;
  hasTypeWith?: InputMaybe<Array<ProjectTypeWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** location_city field predicates */
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCityContains?: InputMaybe<Scalars['String']['input']>;
  locationCityContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationCityEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationCityGT?: InputMaybe<Scalars['String']['input']>;
  locationCityGTE?: InputMaybe<Scalars['String']['input']>;
  locationCityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationCityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationCityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationCityLT?: InputMaybe<Scalars['String']['input']>;
  locationCityLTE?: InputMaybe<Scalars['String']['input']>;
  locationCityNEQ?: InputMaybe<Scalars['String']['input']>;
  locationCityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** location_country field predicates */
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryContains?: InputMaybe<Scalars['String']['input']>;
  locationCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationCountryGT?: InputMaybe<Scalars['String']['input']>;
  locationCountryGTE?: InputMaybe<Scalars['String']['input']>;
  locationCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCountryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationCountryLT?: InputMaybe<Scalars['String']['input']>;
  locationCountryLTE?: InputMaybe<Scalars['String']['input']>;
  locationCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  locationCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCountryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** location_postal_code field predicates */
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeContains?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeGT?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeGTE?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationPostalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationPostalCodeLT?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeLTE?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  locationPostalCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationPostalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** location_street field predicates */
  locationStreet?: InputMaybe<Scalars['String']['input']>;
  locationStreetContains?: InputMaybe<Scalars['String']['input']>;
  locationStreetContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationStreetEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationStreetGT?: InputMaybe<Scalars['String']['input']>;
  locationStreetGTE?: InputMaybe<Scalars['String']['input']>;
  locationStreetHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationStreetHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationStreetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationStreetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  locationStreetLT?: InputMaybe<Scalars['String']['input']>;
  locationStreetLTE?: InputMaybe<Scalars['String']['input']>;
  locationStreetNEQ?: InputMaybe<Scalars['String']['input']>;
  locationStreetNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationStreetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectWhereInput>;
  or?: InputMaybe<Array<ProjectWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContains?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** plant_external_id field predicates */
  plantExternalID?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDContains?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDGT?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDGTE?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantExternalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plantExternalIDLT?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDLTE?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  plantExternalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantExternalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** plant_name field predicates */
  plantName?: InputMaybe<Scalars['String']['input']>;
  plantNameContains?: InputMaybe<Scalars['String']['input']>;
  plantNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  plantNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  plantNameGT?: InputMaybe<Scalars['String']['input']>;
  plantNameGTE?: InputMaybe<Scalars['String']['input']>;
  plantNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  plantNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  plantNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plantNameLT?: InputMaybe<Scalars['String']['input']>;
  plantNameLTE?: InputMaybe<Scalars['String']['input']>;
  plantNameNEQ?: InputMaybe<Scalars['String']['input']>;
  plantNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plantNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_milestone_id field predicates */
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectMilestoneIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectMilestoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectMilestoneIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_status_id field predicates */
  projectStatusID?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStatusIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectStatusIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectStatusIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStatusIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_type_id field predicates */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectTypeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_responsible_id field predicates */
  securityResponsibleID?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDContains?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDGT?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDGTE?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityResponsibleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityResponsibleIDLT?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDLTE?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityResponsibleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ProjectZone = {
  __typename?: 'ProjectZone';
  assets?: Maybe<Array<Maybe<Asset>>>;
  assetsCount: Scalars['Int']['output'];
  createTime: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  exposureRating: ProjectZoneExposureRating;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentZone?: Maybe<ProjectZone>;
  project: Project;
  updateTime: Scalars['Time']['output'];
};

export type ProjectZoneConnection = {
  __typename?: 'ProjectZoneConnection';
  edges: Array<ProjectZoneEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectZoneEdge = {
  __typename?: 'ProjectZoneEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectZone;
};

export enum ProjectZoneExposureRating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ProjectZoneNode = {
  __typename?: 'ProjectZoneNode';
  affectedComponentsCount?: Maybe<Scalars['Int']['output']>;
  assetsCount: Scalars['Int']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  children: Array<ProjectZoneNode>;
  exposureRating: ProjectZoneExposureRating;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unresolvedNotificationsCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProjectZoneNotificationExposureRating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * ProjectZoneNotificationWhereInput is used for filtering ProjectZonesNotificationsView objects.
 * Input was generated by ent.
 */
export type ProjectZoneNotificationWhereInput = {
  /** affected_components_count field predicates */
  affectedComponentsCount?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountGT?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  affectedComponentsCountLT?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  affectedComponentsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<ProjectZoneNotificationWhereInput>>;
  /** assets_count field predicates */
  assetsCount?: InputMaybe<Scalars['Int']['input']>;
  assetsCountGT?: InputMaybe<Scalars['Int']['input']>;
  assetsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  assetsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  assetsCountLT?: InputMaybe<Scalars['Int']['input']>;
  assetsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  assetsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  assetsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** exposure_rating field predicates */
  exposureRating?: InputMaybe<ProjectZoneNotificationExposureRating>;
  exposureRatingIn?: InputMaybe<Array<ProjectZoneNotificationExposureRating>>;
  exposureRatingNEQ?: InputMaybe<ProjectZoneNotificationExposureRating>;
  exposureRatingNotIn?: InputMaybe<Array<ProjectZoneNotificationExposureRating>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectZoneNotificationWhereInput>;
  or?: InputMaybe<Array<ProjectZoneNotificationWhereInput>>;
  /** parent_zone_id field predicates */
  parentZoneID?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentZoneIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentZoneIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** unresolved_notifications_count field predicates */
  unresolvedNotificationsCount?: InputMaybe<Scalars['Int']['input']>;
  unresolvedNotificationsCountGT?: InputMaybe<Scalars['Int']['input']>;
  unresolvedNotificationsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  unresolvedNotificationsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  unresolvedNotificationsCountLT?: InputMaybe<Scalars['Int']['input']>;
  unresolvedNotificationsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  unresolvedNotificationsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  unresolvedNotificationsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectZoneOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectZoneOrderField>;
};

export enum ProjectZoneOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Name = 'NAME',
  Parentzoneid = 'PARENTZONEID',
  Projectid = 'PROJECTID',
  Updatetime = 'UPDATETIME',
  Zoneexposurerating = 'ZONEEXPOSURERATING'
}

export type ProjectZoneStandardProfile = {
  __typename?: 'ProjectZoneStandardProfile';
  id: Scalars['ID']['output'];
  projectZone: ProjectZone;
  standardProfile: StandardProfile;
};

export type ProjectZoneStandardProfileConnection = {
  __typename?: 'ProjectZoneStandardProfileConnection';
  edges: Array<ProjectZoneStandardProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectZoneStandardProfileEdge = {
  __typename?: 'ProjectZoneStandardProfileEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectZoneStandardProfile;
};

export type ProjectZoneStandardProfileOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectZoneStandardProfileOrderField>;
};

export enum ProjectZoneStandardProfileOrderField {
  Id = 'ID',
  Projectzoneid = 'PROJECTZONEID',
  Standardprofileid = 'STANDARDPROFILEID'
}

export type ProjectZoneStandardProfileRequirementComment = {
  __typename?: 'ProjectZoneStandardProfileRequirementComment';
  comment: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  projectZoneStandardProfile: ProjectZoneStandardProfile;
  requirement: Requirement;
  requirementCommentStatus: ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus;
  user: User;
};

export type ProjectZoneStandardProfileRequirementCommentConnection = {
  __typename?: 'ProjectZoneStandardProfileRequirementCommentConnection';
  edges: Array<ProjectZoneStandardProfileRequirementCommentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectZoneStandardProfileRequirementCommentEdge = {
  __typename?: 'ProjectZoneStandardProfileRequirementCommentEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProjectZoneStandardProfileRequirementComment;
};

export type ProjectZoneStandardProfileRequirementCommentOrder = {
  direction: OrderDirection;
  field?: InputMaybe<ProjectZoneStandardProfileRequirementCommentOrderField>;
};

export enum ProjectZoneStandardProfileRequirementCommentOrderField {
  Comment = 'COMMENT',
  Createtime = 'CREATETIME',
  Id = 'ID',
  Projectzonestandardprofileid = 'PROJECTZONESTANDARDPROFILEID',
  Requirementcommentstatus = 'REQUIREMENTCOMMENTSTATUS',
  Requirementid = 'REQUIREMENTID',
  Userid = 'USERID'
}

export enum ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus {
  Comply = 'COMPLY',
  Notapplicable = 'NOTAPPLICABLE',
  Notcomply = 'NOTCOMPLY',
  Partiallycomply = 'PARTIALLYCOMPLY'
}

/**
 * ProjectZoneStandardProfileRequirementCommentWhereInput is used for filtering
 * ProjectZoneStandardProfileRequirementComment objects.
 * Input was generated by ent.
 */
export type ProjectZoneStandardProfileRequirementCommentWhereInput = {
  and?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** project_zone_standard_profile edge predicates */
  hasProjectZoneStandardProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneStandardProfileWith?: InputMaybe<Array<ProjectZoneStandardProfileWhereInput>>;
  /** requirement edge predicates */
  hasRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectZoneStandardProfileRequirementCommentWhereInput>;
  or?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentWhereInput>>;
  /** project_zone_standard_profile_id field predicates */
  projectZoneStandardProfileID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneStandardProfileIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneStandardProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** requirement_comment_status field predicates */
  requirementCommentStatus?: InputMaybe<ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus>;
  requirementCommentStatusIn?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus>>;
  requirementCommentStatusNEQ?: InputMaybe<ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus>;
  requirementCommentStatusNotIn?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus>>;
  /** requirement_id field predicates */
  requirementID?: InputMaybe<Scalars['ID']['input']>;
  requirementIDContains?: InputMaybe<Scalars['ID']['input']>;
  requirementIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  requirementIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  requirementIDGT?: InputMaybe<Scalars['ID']['input']>;
  requirementIDGTE?: InputMaybe<Scalars['ID']['input']>;
  requirementIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  requirementIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  requirementIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requirementIDLT?: InputMaybe<Scalars['ID']['input']>;
  requirementIDLTE?: InputMaybe<Scalars['ID']['input']>;
  requirementIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requirementIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * ProjectZoneStandardProfileWhereInput is used for filtering ProjectZoneStandardProfile objects.
 * Input was generated by ent.
 */
export type ProjectZoneStandardProfileWhereInput = {
  and?: InputMaybe<Array<ProjectZoneStandardProfileWhereInput>>;
  /** project_zone edge predicates */
  hasProjectZone?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_zone_standard_profiles_requirement_comment edge predicates */
  hasProjectZoneStandardProfilesRequirementComment?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneStandardProfilesRequirementCommentWith?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentWhereInput>>;
  hasProjectZoneWith?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** standard_profile edge predicates */
  hasStandardProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfileWith?: InputMaybe<Array<StandardProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProjectZoneStandardProfileWhereInput>;
  or?: InputMaybe<Array<ProjectZoneStandardProfileWhereInput>>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** standard_profile_id field predicates */
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * ProjectZoneWhereInput is used for filtering ProjectZone objects.
 * Input was generated by ent.
 */
export type ProjectZoneWhereInput = {
  and?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** assets_count field predicates */
  assetsCount?: InputMaybe<Scalars['Int']['input']>;
  assetsCountGT?: InputMaybe<Scalars['Int']['input']>;
  assetsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  assetsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  assetsCountLT?: InputMaybe<Scalars['Int']['input']>;
  assetsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  assetsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  assetsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** exposure_rating field predicates */
  exposureRating?: InputMaybe<ProjectZoneExposureRating>;
  exposureRatingIn?: InputMaybe<Array<ProjectZoneExposureRating>>;
  exposureRatingNEQ?: InputMaybe<ProjectZoneExposureRating>;
  exposureRatingNotIn?: InputMaybe<Array<ProjectZoneExposureRating>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<AssetWhereInput>>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** cvss_overrides edge predicates */
  hasCvssOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasCvssOverridesWith?: InputMaybe<Array<CvssOverridesWhereInput>>;
  /** parent_zone edge predicates */
  hasParentZone?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentZoneWith?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** project_zone_standard_profiles edge predicates */
  hasProjectZoneStandardProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneStandardProfilesWith?: InputMaybe<Array<ProjectZoneStandardProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ProjectZoneWhereInput>;
  or?: InputMaybe<Array<ProjectZoneWhereInput>>;
  /** parent_zone_id field predicates */
  parentZoneID?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentZoneIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentZoneIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Query = {
  __typename?: 'Query';
  ProjectHierarchyTypes: ProjectHierarchyTypeConnection;
  SPEs: SpeConnection;
  ares: AreConnection;
  assetAttributeDefinitionsForProject?: Maybe<AssetAttributeDefinitionConnection>;
  assetItemAttributeDefinitionsForProject?: Maybe<AssetItemAttributeDefinitionConnection>;
  assetItems: AssetItemConnection;
  assetItemsProjectNotificationsCount: AssetItemsProjectNotificationCountConnection;
  assetRelationAttributeDefinitionsForProject: AssetRelationAttributeDefinitionConnection;
  assetRelationsForProject: AssetRelationConnection;
  assetTypes: AssetTypeConnection;
  assets: AssetConnection;
  assetsInProject: AssetConnection;
  assetsView: AssetViewConnection;
  attckLatest: Attck;
  attcks: AttckConnection;
  auditLogHistory: AuditLogHistoryConnection;
  auditLogs: AuditLogConnection;
  componentCreateRequestStatus: ComponentCreateRequestStatusConnection;
  componentCreateRequestStatusTransitions: ComponentCreateRequestStatusTransitionConnection;
  componentCreateRequests: ComponentCreateRequestConnection;
  componentCreateRequestsView: ComponentCreateRequestViewConnection;
  componentSources: ComponentSourceConnection;
  componentVendors: ComponentVendorConnection;
  components: ComponentConnection;
  componentsAffectedByNotification: ComponentAffectedByNotificationConnection;
  componentsAffectedByNotificationInProject: ComponentAffectedByNotificationProjectConnection;
  componentsInProject: ComponentInProjectConnection;
  componentsWithSources: ComponentWithSourcesConnection;
  countries: CountryConnection;
  countryStandards: CountryStandardConnection;
  craComments: Array<CraModuleComment>;
  craCybersecRiskAssessmentComments: Array<CraModuleComment>;
  craDocumentationComments: Array<CraModuleComment>;
  craGeneralComments: Array<CraModuleComment>;
  craVulnerabilityHandlingComments: Array<CraModuleComment>;
  /**  Returns all CRAs for a given project, right now we only have one type and only one CRA per type per project is allowed.  */
  crasForProject: Array<Cra>;
  downloadCRACybersecurityRiskAssessmentUploadFile: EncodedFile;
  downloadCRADocumentationUploadFile: EncodedFile;
  downloadCRAUploadFile: EncodedFile;
  downloadCRAVulnerabilityHandlingUploadFile: EncodedFile;
  downloadProjectHierarchyFile: EncodedFile;
  downloadTRAReportContent: EncodedFile;
  downloadTaskEvidenceFile: EncodedFile;
  exportAssetRelations?: Maybe<EncodedFile>;
  exportAssetsList: EncodedFile;
  exportComponentVendorAssessments: EncodedFile;
  /**  Generates excel report with measures and mitigations  */
  exportProjectMeasuresMitigationsReport?: Maybe<EncodedFile>;
  exportProjectMitigationStatus?: Maybe<EncodedFile>;
  exportProjectSBOM?: Maybe<EncodedFile>;
  /**  Exports project tasks as excel document  */
  exportProjectTasks?: Maybe<EncodedFile>;
  exportTaskTemplates: EncodedFile;
  exportUsers: EncodedFile;
  getCRACybersecRiskAssessmentForCRA: CraCybersecRiskAssessment;
  getCRADocumentationForCRA: CraDocumentation;
  getCRAGeneralForCRA: CraGeneral;
  getCRAVulnerabilityHandlingForCRA: CraVulnerabilityHandling;
  getProjectDashboardSummaryCards?: Maybe<ProjectDashboardSummaryCards>;
  locations: LocationConnection;
  maintenanceData: MaintenanceData;
  maturityLevels: MaturityLevelConnection;
  me: User;
  measures?: Maybe<MeasureConnection>;
  mitigations?: Maybe<MitigationConnection>;
  notifications: NotificationConnection;
  notificationsImpactTypes?: Maybe<Array<Scalars['String']['output']>>;
  notificationsSummaryInProject?: Maybe<Array<Maybe<NotificationSummaryOutput>>>;
  orgCodes: OrgCodeConnection;
  organizations: OrganizationConnection;
  parseVector: Cvss;
  parseVector20: Cvss20;
  portalDashboard: PortalDashboard;
  projectAssetsConfigurationReport: EncodedFile;
  projectAssetsReport: EncodedFile;
  projectComponentsNotifications: ProjectComponentNotificationConnection;
  projectGuidanceRequirements: ProjectGuidanceRequirementConnection;
  projectGuidances: ProjectGuidanceConnection;
  projectHierarchies: ProjectHierarchyConnection;
  projectHierarchyAttributeDefinitionsForProject?: Maybe<ProjectHierarchyAttributeDefinitionConnection>;
  projectHierarchyTodos?: Maybe<ProjectHierarchyTodoConnection>;
  projectMilestones: ProjectMilestoneConnection;
  projectNotificationsReport?: Maybe<EncodedFile>;
  /**
   * Exports project Notifications report as Word document
   *   Will give you: application/vnd.openxmlformats-officedocument.wordprocessingml.document" OR "application/zip"
   */
  projectNotificationsReportDoc?: Maybe<EncodedFile>;
  projectPhases: ProjectPhaseConnection;
  projectProjectZonesHierarchy: Array<ProjectZoneNode>;
  projectSecurityNotificationReportByAssetVulnerabilityManagementReport: EncodedFile;
  projectSecurityNotificationReportVulnerabilityManagementReport: EncodedFile;
  projectStatuses: ProjectStatusConnection;
  projectSurvey?: Maybe<Survey>;
  projectSurveyReport?: Maybe<EncodedFile>;
  /**  Returns list of project tags that are available for current user  */
  projectTagsMe: Array<Scalars['String']['output']>;
  projectTypes: ProjectTypeConnection;
  projectZoneStandardProfileRequirementComments: ProjectZoneStandardProfileRequirementCommentConnection;
  projectZoneStandardProfileRequirementCommentsGet: Array<Maybe<ProjectZoneStandardProfileRequirementComment>>;
  projectZoneStandardProfiles: ProjectZoneStandardProfileConnection;
  projectZones: ProjectZoneConnection;
  projects?: Maybe<ProjectConnection>;
  projectsAffectedByNotification: ProjectAffectedByNotificationConnection;
  projectsReadModel?: Maybe<ProjectReadModelConnection>;
  requirementMappings: RequirementMappingConnection;
  requirements: RequirementConnection;
  requirementsForTask: Array<Requirement>;
  requirementsOnProjectZone: RequirementOnProjectZoneConnection;
  requirementsWithSPEs: RequirementWithSpeConnection;
  requirementsWithStandardProfiles: RequirementWithStandardProfileConnection;
  securityLevels: SecurityLevelConnection;
  standardProfiles: StandardProfileConnection;
  standards: StandardConnection;
  subSPEs: SubSpeConnection;
  surveyClassificationClasses: SurveyClassificationClassConnection;
  surveyFormContents?: Maybe<SurveyFormContentConnection>;
  surveyFormExport?: Maybe<EncodedFile>;
  surveyForms: SurveyFormConnection;
  surveyProfiles: SurveyProfileConnection;
  surveyTemplates: SurveyTemplateConnection;
  taskTemplates: TaskTemplateConnection;
  tasks?: Maybe<TaskConnection>;
  traTemplateLatestForVariant?: Maybe<TraTemplate>;
  traTemplateVariants?: Maybe<Array<Scalars['String']['output']>>;
  traTemplates: TraTemplateConnection;
  tras?: Maybe<TraConnection>;
  userNotificationSetting?: Maybe<UserNotificationSetting>;
  users: UserConnection;
};


export type QueryProjectHierarchyTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectHierarchyTypeOrder>;
  where?: InputMaybe<ProjectHierarchyTypeWhereInput>;
};


export type QuerySpEsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeOrder>;
  where?: InputMaybe<SpeWhereInput>;
};


export type QueryAresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AreOrder>;
  where?: InputMaybe<AreWhereInput>;
};


export type QueryAssetAttributeDefinitionsForProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetAttributeDefinitionOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<AssetAttributeDefinitionWhereInput>;
};


export type QueryAssetItemAttributeDefinitionsForProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetItemAttributeDefinitionOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<AssetItemAttributeDefinitionWhereInput>;
};


export type QueryAssetItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetItemOrder>;
  where?: InputMaybe<AssetItemWhereInput>;
};


export type QueryAssetItemsProjectNotificationsCountArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetItemsProjectNotificationCountOrder>;
  where?: InputMaybe<AssetItemsProjectNotificationCountWhereInput>;
};


export type QueryAssetRelationAttributeDefinitionsForProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetRelationAttributeDefinitionOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<AssetRelationAttributeDefinitionWhereInput>;
};


export type QueryAssetRelationsForProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetRelationOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<AssetRelationWhereInput>;
};


export type QueryAssetTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTypeOrder>;
  where?: InputMaybe<AssetTypeWhereInput>;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetOrder>;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsInProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetOrder>;
  orderByProjectZone?: InputMaybe<ProjectZoneOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsViewArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetViewOrder>;
  where?: InputMaybe<AssetViewWhereInput>;
};


export type QueryAttcksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AttckOrder>;
  where?: InputMaybe<AttckWhereInput>;
};


export type QueryAuditLogHistoryArgs = {
  entityID: Scalars['ID']['input'];
};


export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AuditLogOrder>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type QueryComponentCreateRequestStatusArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentCreateRequestStatusOrder>;
  where?: InputMaybe<ComponentCreateRequestStatusWhereInput>;
};


export type QueryComponentCreateRequestStatusTransitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentCreateRequestStatusTransitionOrder>;
  where?: InputMaybe<ComponentCreateRequestStatusTransitionWhereInput>;
};


export type QueryComponentCreateRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentCreateRequestOrder>;
  where?: InputMaybe<ComponentCreateRequestWhereInput>;
};


export type QueryComponentCreateRequestsViewArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentCreateRequestOrder>;
  where?: InputMaybe<ComponentCreateRequestWhereInput>;
};


export type QueryComponentSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentSourceOrder>;
  where?: InputMaybe<ComponentSourceWhereInput>;
};


export type QueryComponentVendorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentVendorOrder>;
  where?: InputMaybe<ComponentVendorWhereInput>;
};


export type QueryComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentOrder>;
  where?: InputMaybe<ComponentWhereInput>;
};


export type QueryComponentsAffectedByNotificationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationID: Scalars['ID']['input'];
  orderBy?: InputMaybe<ComponentAffectedByNotificationOrder>;
  where?: InputMaybe<ComponentAffectedByNotificationWhereInput>;
};


export type QueryComponentsAffectedByNotificationInProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentAffectedByNotificationProjectOrder>;
  where?: InputMaybe<ComponentAffectedByNotificationProjectWhereInput>;
};


export type QueryComponentsInProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentInProjectOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<ComponentInProjectWhereInput>;
};


export type QueryComponentsWithSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentOrder>;
  where?: InputMaybe<ComponentWhereInput>;
};


export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CountryOrder>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryCountryStandardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CountryStandardOrder>;
  where?: InputMaybe<CountryStandardWhereInput>;
};


export type QueryCraCommentsArgs = {
  craID: Scalars['ID']['input'];
};


export type QueryCraCybersecRiskAssessmentCommentsArgs = {
  craCybersecRiskAssessmentID: Scalars['ID']['input'];
};


export type QueryCraDocumentationCommentsArgs = {
  craDocumentationID: Scalars['ID']['input'];
};


export type QueryCraGeneralCommentsArgs = {
  craGeneral: Scalars['ID']['input'];
};


export type QueryCraVulnerabilityHandlingCommentsArgs = {
  craVulnerabilityHandlingID: Scalars['ID']['input'];
};


export type QueryCrasForProjectArgs = {
  projectID: Scalars['ID']['input'];
};


export type QueryDownloadCraCybersecurityRiskAssessmentUploadFileArgs = {
  craCybersecurityRiskAssessmentUploadID: Scalars['ID']['input'];
};


export type QueryDownloadCraDocumentationUploadFileArgs = {
  craDocumentationUploadID: Scalars['ID']['input'];
};


export type QueryDownloadCraUploadFileArgs = {
  craUploadID: Scalars['ID']['input'];
};


export type QueryDownloadCraVulnerabilityHandlingUploadFileArgs = {
  craVulnerabilityHandlingUploadID: Scalars['ID']['input'];
};


export type QueryDownloadProjectHierarchyFileArgs = {
  projectHierarchyFileID: Scalars['ID']['input'];
};


export type QueryDownloadTraReportContentArgs = {
  traReportID: Scalars['ID']['input'];
};


export type QueryDownloadTaskEvidenceFileArgs = {
  taskEvidenceID: Scalars['ID']['input'];
};


export type QueryExportAssetRelationsArgs = {
  projectID: Scalars['ID']['input'];
};


export type QueryExportAssetsListArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ProjectExportAssetsOptions>;
};


export type QueryExportProjectMeasuresMitigationsReportArgs = {
  id: Scalars['ID']['input'];
  withIgnoreAndAcceptTheRisk?: InputMaybe<Scalars['Boolean']['input']>;
  withNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  workcyckleID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExportProjectMitigationStatusArgs = {
  filterNotificationStatus: NotificationStatusExportFilter;
  id: Scalars['ID']['input'];
};


export type QueryExportProjectSbomArgs = {
  format: SbomExportFormat;
  id: Scalars['ID']['input'];
  includeComponentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  includeVulnerabilities?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExportProjectTasksArgs = {
  id: Scalars['ID']['input'];
  taskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetCraCybersecRiskAssessmentForCraArgs = {
  craID: Scalars['ID']['input'];
};


export type QueryGetCraDocumentationForCraArgs = {
  craID: Scalars['ID']['input'];
};


export type QueryGetCraGeneralForCraArgs = {
  craID: Scalars['ID']['input'];
};


export type QueryGetCraVulnerabilityHandlingForCraArgs = {
  craID: Scalars['ID']['input'];
};


export type QueryGetProjectDashboardSummaryCardsArgs = {
  projectID: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationOrder>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryMaturityLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MaturityLevelOrder>;
  where?: InputMaybe<MaturityLevelWhereInput>;
};


export type QueryMeasuresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MeasureOrder>;
  where?: InputMaybe<MeasureWhereInput>;
};


export type QueryMitigationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MitigationOrder>;
  where?: InputMaybe<MitigationWhereInput>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryNotificationsSummaryInProjectArgs = {
  projectID: Scalars['ID']['input'];
};


export type QueryOrgCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrgCodeOrder>;
  where?: InputMaybe<OrgCodeWhereInput>;
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryParseVectorArgs = {
  vector: Scalars['String']['input'];
};


export type QueryParseVector20Args = {
  vector: Scalars['String']['input'];
};


export type QueryProjectAssetsConfigurationReportArgs = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectAssetsReportArgs = {
  projectID: Scalars['ID']['input'];
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectComponentsNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectComponentNotificationOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<ProjectComponentNotificationWhereInput>;
};


export type QueryProjectGuidanceRequirementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectGuidanceRequirementOrder>;
  where?: InputMaybe<ProjectGuidanceRequirementWhereInput>;
};


export type QueryProjectGuidancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectGuidanceOrder>;
  where?: InputMaybe<ProjectGuidanceWhereInput>;
};


export type QueryProjectHierarchiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectHierarchyOrder>;
  where?: InputMaybe<ProjectHierarchyWhereInput>;
};


export type QueryProjectHierarchyAttributeDefinitionsForProjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectHierarchyAttributeDefinitionOrder>;
  projectID: Scalars['ID']['input'];
  where?: InputMaybe<ProjectHierarchyAttributeDefinitionWhereInput>;
};


export type QueryProjectHierarchyTodosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectHierarchyTodoOrder>;
  where?: InputMaybe<ProjectHierarchyTodoWhereInput>;
};


export type QueryProjectMilestonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectMilestoneOrder>;
  where?: InputMaybe<ProjectMilestoneWhereInput>;
};


export type QueryProjectNotificationsReportArgs = {
  from: Scalars['Time']['input'];
  id: Scalars['ID']['input'];
  includeAffected?: InputMaybe<Scalars['Boolean']['input']>;
  includeMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['Time']['input'];
};


export type QueryProjectNotificationsReportDocArgs = {
  from: Scalars['Time']['input'];
  id: Scalars['ID']['input'];
  includeAffected?: InputMaybe<Scalars['Boolean']['input']>;
  includeMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['Time']['input'];
};


export type QueryProjectPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectPhaseOrder>;
  where?: InputMaybe<ProjectPhaseWhereInput>;
};


export type QueryProjectProjectZonesHierarchyArgs = {
  projectID: Scalars['ID']['input'];
};


export type QueryProjectSecurityNotificationReportByAssetVulnerabilityManagementReportArgs = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['Time']['input'];
  includeMitigations: Scalars['Boolean']['input'];
  projectID: Scalars['ID']['input'];
  projectZoneID: Scalars['ID']['input'];
  to: Scalars['Time']['input'];
};


export type QueryProjectSecurityNotificationReportVulnerabilityManagementReportArgs = {
  from: Scalars['Time']['input'];
  includeAssets: Scalars['Boolean']['input'];
  includeMitigations: Scalars['Boolean']['input'];
  projectID: Scalars['ID']['input'];
  to: Scalars['Time']['input'];
};


export type QueryProjectStatusesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectStatusOrder>;
  where?: InputMaybe<ProjectStatusWhereInput>;
};


export type QueryProjectSurveyArgs = {
  projectID: Scalars['ID']['input'];
};


export type QueryProjectSurveyReportArgs = {
  projectID: Scalars['ID']['input'];
  surveyKind: SurveyFormKind;
};


export type QueryProjectTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectTypeOrder>;
  where?: InputMaybe<ProjectTypeWhereInput>;
};


export type QueryProjectZoneStandardProfileRequirementCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectZoneStandardProfileRequirementCommentOrder>;
  where?: InputMaybe<ProjectZoneStandardProfileRequirementCommentWhereInput>;
};


export type QueryProjectZoneStandardProfileRequirementCommentsGetArgs = {
  projectZoneID: Scalars['ID']['input'];
  requirementID: Scalars['ID']['input'];
  standardProfileID: Scalars['ID']['input'];
};


export type QueryProjectZoneStandardProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectZoneStandardProfileOrder>;
  where?: InputMaybe<ProjectZoneStandardProfileWhereInput>;
};


export type QueryProjectZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectZoneOrder>;
  where?: InputMaybe<ProjectZoneWhereInput>;
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type QueryProjectsAffectedByNotificationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationID: Scalars['ID']['input'];
  orderBy?: InputMaybe<ProjectAffectedByNotificationOrder>;
  where?: InputMaybe<ProjectAffectedByNotificationWhereInput>;
};


export type QueryProjectsReadModelArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectReadModelOrder>;
  where?: InputMaybe<ProjectReadModelWhereInput>;
};


export type QueryRequirementMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequirementMappingOrder>;
  where?: InputMaybe<RequirementMappingWhereInput>;
};


export type QueryRequirementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequirementOrder>;
  orderBySPE?: InputMaybe<SpeOrder>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type QueryRequirementsForTaskArgs = {
  taskID: Scalars['ID']['input'];
};


export type QueryRequirementsOnProjectZoneArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequirementOnProjectZoneOrder>;
  where?: InputMaybe<RequirementOnProjectZoneWhereInput>;
};


export type QueryRequirementsWithSpEsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequirementWithSpeOrder>;
  where?: InputMaybe<RequirementWithSpeWhereInput>;
};


export type QueryRequirementsWithStandardProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequirementWithStandardProfileOrder>;
  where?: InputMaybe<RequirementWithStandardProfileWhereInput>;
};


export type QuerySecurityLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityLevelOrder>;
  where?: InputMaybe<SecurityLevelWhereInput>;
};


export type QueryStandardProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StandardProfileOrder>;
  where?: InputMaybe<StandardProfileWhereInput>;
};


export type QueryStandardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StandardOrder>;
  where?: InputMaybe<StandardWhereInput>;
};


export type QuerySubSpEsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubSpeOrder>;
  where?: InputMaybe<SubSpeWhereInput>;
};


export type QuerySurveyClassificationClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SurveyClassificationClassOrder>;
  where?: InputMaybe<SurveyClassificationClassWhereInput>;
};


export type QuerySurveyFormContentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SurveyFormContentOrder>;
  where?: InputMaybe<SurveyFormContentWhereInput>;
};


export type QuerySurveyFormExportArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySurveyFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SurveyFormOrder>;
  where?: InputMaybe<SurveyFormWhereInput>;
};


export type QuerySurveyProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SurveyProfileOrder>;
  where?: InputMaybe<SurveyProfileWhereInput>;
};


export type QuerySurveyTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SurveyTemplateOrder>;
  where?: InputMaybe<SurveyTemplateWhereInput>;
};


export type QueryTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaskTemplateOrder>;
  where?: InputMaybe<TaskTemplateWhereInput>;
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaskOrder>;
  where?: InputMaybe<TaskWhereInput>;
};


export type QueryTraTemplateLatestForVariantArgs = {
  variant: Scalars['String']['input'];
};


export type QueryTraTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TraTemplateOrder>;
  where?: InputMaybe<TraTemplateWhereInput>;
};


export type QueryTrasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TraOrder>;
  where?: InputMaybe<TraWhereInput>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrder>;
  where?: InputMaybe<UserWhereInput>;
};

export type Requirement = {
  __typename?: 'Requirement';
  alias: Scalars['String']['output'];
  description: Scalars['String']['output'];
  guidance: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementationGuidance?: Maybe<Scalars['String']['output']>;
  maturityLevel?: Maybe<MaturityLevel>;
  name: Scalars['String']['output'];
  securityLevel?: Maybe<SecurityLevel>;
  standard?: Maybe<Standard>;
  standardProfiles?: Maybe<Array<Maybe<StandardProfile>>>;
  subSPE?: Maybe<SubSpe>;
};

export type RequirementConnection = {
  __typename?: 'RequirementConnection';
  edges: Array<RequirementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RequirementEdge = {
  __typename?: 'RequirementEdge';
  cursor: Scalars['Cursor']['output'];
  node: Requirement;
};

export type RequirementMapping = {
  __typename?: 'RequirementMapping';
  childRequirement: Requirement;
  comment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mappingCoverage?: Maybe<MappingCoverage>;
  parentRequirement: Requirement;
};

export type RequirementMappingConnection = {
  __typename?: 'RequirementMappingConnection';
  edges: Array<RequirementMappingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RequirementMappingEdge = {
  __typename?: 'RequirementMappingEdge';
  cursor: Scalars['Cursor']['output'];
  node: RequirementMapping;
};

export type RequirementMappingOrder = {
  direction: OrderDirection;
  field?: InputMaybe<RequirementMappingOrderField>;
};

export enum RequirementMappingOrderField {
  Comment = 'COMMENT',
  Id = 'ID'
}

/**
 * RequirementMappingWhereInput is used for filtering RequirementMapping objects.
 * Input was generated by ent.
 */
export type RequirementMappingWhereInput = {
  and?: InputMaybe<Array<RequirementMappingWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** child_requirement edge predicates */
  hasChildRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildRequirementWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** mapping_coverage edge predicates */
  hasMappingCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMappingCoverageWith?: InputMaybe<Array<MappingCoverageWhereInput>>;
  /** parent_requirement edge predicates */
  hasParentRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentRequirementWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RequirementMappingWhereInput>;
  or?: InputMaybe<Array<RequirementMappingWhereInput>>;
};

export type RequirementOnProjectZone = {
  __typename?: 'RequirementOnProjectZone';
  alias: Scalars['String']['output'];
  description: Scalars['String']['output'];
  guidance: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementationGuidance?: Maybe<Scalars['String']['output']>;
  maturityLevelID?: Maybe<Scalars['ID']['output']>;
  maturityLevelName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  projectZoneID: Scalars['ID']['output'];
  requirementCommentCreateTime?: Maybe<Scalars['Time']['output']>;
  requirementCommentStatus?: Maybe<RequirementOnProjectZoneRequirementCommentStatus>;
  securityLevelID?: Maybe<Scalars['ID']['output']>;
  securityLevelName?: Maybe<Scalars['String']['output']>;
  speAlias?: Maybe<Scalars['String']['output']>;
  speDescription?: Maybe<Scalars['String']['output']>;
  speID?: Maybe<Scalars['ID']['output']>;
  speName?: Maybe<Scalars['String']['output']>;
  standardID?: Maybe<Scalars['ID']['output']>;
  standardName?: Maybe<Scalars['String']['output']>;
  standardProfileAlias?: Maybe<Scalars['String']['output']>;
  standardProfileID?: Maybe<Scalars['ID']['output']>;
  standardProfileName?: Maybe<Scalars['String']['output']>;
  subSpeAlias?: Maybe<Scalars['String']['output']>;
  subSpeDescription?: Maybe<Scalars['String']['output']>;
  subSpeID?: Maybe<Scalars['ID']['output']>;
  subSpeName?: Maybe<Scalars['String']['output']>;
};

export type RequirementOnProjectZoneConnection = {
  __typename?: 'RequirementOnProjectZoneConnection';
  edges: Array<RequirementOnProjectZoneEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RequirementOnProjectZoneEdge = {
  __typename?: 'RequirementOnProjectZoneEdge';
  cursor: Scalars['Cursor']['output'];
  node: RequirementOnProjectZone;
};

export type RequirementOnProjectZoneOrder = {
  direction: OrderDirection;
  field?: InputMaybe<RequirementOnProjectZoneOrderField>;
};

export enum RequirementOnProjectZoneOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Guidance = 'GUIDANCE',
  Id = 'ID',
  Maturitylevelid = 'MATURITYLEVELID',
  Maturitylevelname = 'MATURITYLEVELNAME',
  Name = 'NAME',
  Projectzoneid = 'PROJECTZONEID',
  Requirementcommentcreatetime = 'REQUIREMENTCOMMENTCREATETIME',
  Requirementcommentstatus = 'REQUIREMENTCOMMENTSTATUS',
  Securitylevelid = 'SECURITYLEVELID',
  Securitylevelname = 'SECURITYLEVELNAME',
  Spealias = 'SPEALIAS',
  Spedescription = 'SPEDESCRIPTION',
  Speid = 'SPEID',
  Spename = 'SPENAME',
  Standardid = 'STANDARDID',
  Standardname = 'STANDARDNAME',
  Standardprofilealias = 'STANDARDPROFILEALIAS',
  Standardprofilename = 'STANDARDPROFILENAME',
  Subspealias = 'SUBSPEALIAS',
  Subspedescription = 'SUBSPEDESCRIPTION',
  Subspeid = 'SUBSPEID',
  Subspename = 'SUBSPENAME'
}

export enum RequirementOnProjectZoneRequirementCommentStatus {
  Comply = 'COMPLY',
  Notapplicable = 'NOTAPPLICABLE',
  Notcomply = 'NOTCOMPLY',
  Partiallycomply = 'PARTIALLYCOMPLY'
}

/**
 * RequirementOnProjectZoneWhereInput is used for filtering RequirementOnProjectZoneView objects.
 * Input was generated by ent.
 */
export type RequirementOnProjectZoneWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<RequirementOnProjectZoneWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** guidance field predicates */
  guidance?: InputMaybe<Scalars['String']['input']>;
  guidanceContains?: InputMaybe<Scalars['String']['input']>;
  guidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  guidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  guidanceGT?: InputMaybe<Scalars['String']['input']>;
  guidanceGTE?: InputMaybe<Scalars['String']['input']>;
  guidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  guidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  guidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  guidanceLT?: InputMaybe<Scalars['String']['input']>;
  guidanceLTE?: InputMaybe<Scalars['String']['input']>;
  guidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  guidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implementation_guidance field predicates */
  implementationGuidance?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContains?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  implementationGuidanceLT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceLTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_id field predicates */
  maturityLevelID?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maturityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_name field predicates */
  maturityLevelName?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameContains?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameGT?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameGTE?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  maturityLevelNameLT?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameLTE?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RequirementOnProjectZoneWhereInput>;
  or?: InputMaybe<Array<RequirementOnProjectZoneWhereInput>>;
  /** project_zone_id field predicates */
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectZoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectZoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectZoneIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requirement_comment_create_time field predicates */
  requirementCommentCreateTime?: InputMaybe<Scalars['Time']['input']>;
  requirementCommentCreateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  requirementCommentCreateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  requirementCommentCreateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  requirementCommentCreateTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requirementCommentCreateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  requirementCommentCreateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  requirementCommentCreateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  requirementCommentCreateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  requirementCommentCreateTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requirement_comment_status field predicates */
  requirementCommentStatus?: InputMaybe<RequirementOnProjectZoneRequirementCommentStatus>;
  requirementCommentStatusIn?: InputMaybe<Array<RequirementOnProjectZoneRequirementCommentStatus>>;
  requirementCommentStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requirementCommentStatusNEQ?: InputMaybe<RequirementOnProjectZoneRequirementCommentStatus>;
  requirementCommentStatusNotIn?: InputMaybe<Array<RequirementOnProjectZoneRequirementCommentStatus>>;
  requirementCommentStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_level_id field predicates */
  securityLevelID?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_level_name field predicates */
  securityLevelName?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameContains?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameGT?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameGTE?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityLevelNameLT?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameLTE?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_alias field predicates */
  speAlias?: InputMaybe<Scalars['String']['input']>;
  speAliasContains?: InputMaybe<Scalars['String']['input']>;
  speAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  speAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  speAliasGT?: InputMaybe<Scalars['String']['input']>;
  speAliasGTE?: InputMaybe<Scalars['String']['input']>;
  speAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speAliasLT?: InputMaybe<Scalars['String']['input']>;
  speAliasLTE?: InputMaybe<Scalars['String']['input']>;
  speAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  speAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_description field predicates */
  speDescription?: InputMaybe<Scalars['String']['input']>;
  speDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  speDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  speDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  speDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  speDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  speDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  speDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  speDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  speDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_id field predicates */
  speID?: InputMaybe<Scalars['ID']['input']>;
  speIDContains?: InputMaybe<Scalars['ID']['input']>;
  speIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  speIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  speIDGT?: InputMaybe<Scalars['ID']['input']>;
  speIDGTE?: InputMaybe<Scalars['ID']['input']>;
  speIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  speIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  speIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  speIDLT?: InputMaybe<Scalars['ID']['input']>;
  speIDLTE?: InputMaybe<Scalars['ID']['input']>;
  speIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  speIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** spe_name field predicates */
  speName?: InputMaybe<Scalars['String']['input']>;
  speNameContains?: InputMaybe<Scalars['String']['input']>;
  speNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  speNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  speNameGT?: InputMaybe<Scalars['String']['input']>;
  speNameGTE?: InputMaybe<Scalars['String']['input']>;
  speNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speNameLT?: InputMaybe<Scalars['String']['input']>;
  speNameLTE?: InputMaybe<Scalars['String']['input']>;
  speNameNEQ?: InputMaybe<Scalars['String']['input']>;
  speNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** standard_id field predicates */
  standardID?: InputMaybe<Scalars['ID']['input']>;
  standardIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_name field predicates */
  standardName?: InputMaybe<Scalars['String']['input']>;
  standardNameContains?: InputMaybe<Scalars['String']['input']>;
  standardNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardNameGT?: InputMaybe<Scalars['String']['input']>;
  standardNameGTE?: InputMaybe<Scalars['String']['input']>;
  standardNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardNameLT?: InputMaybe<Scalars['String']['input']>;
  standardNameLTE?: InputMaybe<Scalars['String']['input']>;
  standardNameNEQ?: InputMaybe<Scalars['String']['input']>;
  standardNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_alias field predicates */
  standardProfileAlias?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasContains?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasGT?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasGTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileAliasIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardProfileAliasLT?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasLTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileAliasNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_id field predicates */
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardProfileIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_name field predicates */
  standardProfileName?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameContains?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameGT?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameGTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardProfileNameLT?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameLTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_alias field predicates */
  subSpeAlias?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasContains?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasGT?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeAliasLT?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sub_spe_description field predicates */
  subSpeDescription?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sub_spe_id field predicates */
  subSpeID?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContains?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subSpeIDLT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_name field predicates */
  subSpeName?: InputMaybe<Scalars['String']['input']>;
  subSpeNameContains?: InputMaybe<Scalars['String']['input']>;
  subSpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeNameGT?: InputMaybe<Scalars['String']['input']>;
  subSpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeNameLT?: InputMaybe<Scalars['String']['input']>;
  subSpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RequirementOrder = {
  direction: OrderDirection;
  field?: InputMaybe<RequirementOrderField>;
};

export enum RequirementOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Guidance = 'GUIDANCE',
  Id = 'ID',
  Maturitylevelid = 'MATURITYLEVELID',
  Name = 'NAME',
  Revisedintoid = 'REVISEDINTOID',
  Securitylevelid = 'SECURITYLEVELID',
  Standardid = 'STANDARDID',
  Subspeid = 'SUBSPEID'
}

/**
 * RequirementWhereInput is used for filtering Requirement objects.
 * Input was generated by ent.
 */
export type RequirementWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<RequirementWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** guidance field predicates */
  guidance?: InputMaybe<Scalars['String']['input']>;
  guidanceContains?: InputMaybe<Scalars['String']['input']>;
  guidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  guidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  guidanceGT?: InputMaybe<Scalars['String']['input']>;
  guidanceGTE?: InputMaybe<Scalars['String']['input']>;
  guidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  guidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  guidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  guidanceLT?: InputMaybe<Scalars['String']['input']>;
  guidanceLTE?: InputMaybe<Scalars['String']['input']>;
  guidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  guidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** maturity_level edge predicates */
  hasMaturityLevel?: InputMaybe<Scalars['Boolean']['input']>;
  hasMaturityLevelWith?: InputMaybe<Array<MaturityLevelWhereInput>>;
  /** project_guidance_requirements edge predicates */
  hasProjectGuidanceRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectGuidanceRequirementsWith?: InputMaybe<Array<ProjectGuidanceRequirementWhereInput>>;
  /** project_zone_standard_profiles_requirement_comment edge predicates */
  hasProjectZoneStandardProfilesRequirementComment?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneStandardProfilesRequirementCommentWith?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentWhereInput>>;
  /** revised_from edge predicates */
  hasRevisedFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevisedFromWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** revised_into edge predicates */
  hasRevisedInto?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevisedIntoWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** security_level edge predicates */
  hasSecurityLevel?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecurityLevelWith?: InputMaybe<Array<SecurityLevelWhereInput>>;
  /** standard edge predicates */
  hasStandard?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_requirements edge predicates */
  hasStandardProfileRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfileRequirementsWith?: InputMaybe<Array<StandardProfileRequirementWhereInput>>;
  /** standard_profiles edge predicates */
  hasStandardProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfilesWith?: InputMaybe<Array<StandardProfileWhereInput>>;
  hasStandardWith?: InputMaybe<Array<StandardWhereInput>>;
  /** sub_spe edge predicates */
  hasSubSpe?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubSpeWith?: InputMaybe<Array<SubSpeWhereInput>>;
  /** tags edge predicates */
  hasTags?: InputMaybe<Scalars['Boolean']['input']>;
  hasTagsWith?: InputMaybe<Array<TagWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implementation_guidance field predicates */
  implementationGuidance?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContains?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  implementationGuidanceLT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceLTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_id field predicates */
  maturityLevelID?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maturityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RequirementWhereInput>;
  or?: InputMaybe<Array<RequirementWhereInput>>;
  /** revised_into_id field predicates */
  revisedIntoID?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDContains?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDGT?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDGTE?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisedIntoIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  revisedIntoIDLT?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDLTE?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisedIntoIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_level_id field predicates */
  securityLevelID?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_id field predicates */
  standardID?: InputMaybe<Scalars['ID']['input']>;
  standardIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_id field predicates */
  subSpeID?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContains?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subSpeIDLT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequirementWithSpe = {
  __typename?: 'RequirementWithSPE';
  alias: Scalars['String']['output'];
  description: Scalars['String']['output'];
  guidance: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementationGuidance?: Maybe<Scalars['String']['output']>;
  maturityLevelID?: Maybe<Scalars['ID']['output']>;
  maturityLevelName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  securityLevelID?: Maybe<Scalars['ID']['output']>;
  securityLevelName?: Maybe<Scalars['String']['output']>;
  speAlias?: Maybe<Scalars['String']['output']>;
  speDescription?: Maybe<Scalars['String']['output']>;
  speID?: Maybe<Scalars['ID']['output']>;
  speName?: Maybe<Scalars['String']['output']>;
  standardID?: Maybe<Scalars['ID']['output']>;
  standardName?: Maybe<Scalars['String']['output']>;
  subSpeAlias?: Maybe<Scalars['String']['output']>;
  subSpeDescription?: Maybe<Scalars['String']['output']>;
  subSpeID?: Maybe<Scalars['ID']['output']>;
  subSpeName?: Maybe<Scalars['String']['output']>;
};

export type RequirementWithSpeConnection = {
  __typename?: 'RequirementWithSPEConnection';
  edges: Array<RequirementWithSpeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RequirementWithSpeEdge = {
  __typename?: 'RequirementWithSPEEdge';
  cursor: Scalars['Cursor']['output'];
  node: RequirementWithSpe;
};

export type RequirementWithSpeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<RequirementWithSpeOrderField>;
};

export enum RequirementWithSpeOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Guidance = 'GUIDANCE',
  Id = 'ID',
  Maturitylevelid = 'MATURITYLEVELID',
  Maturitylevelname = 'MATURITYLEVELNAME',
  Name = 'NAME',
  Securitylevelid = 'SECURITYLEVELID',
  Securitylevelname = 'SECURITYLEVELNAME',
  Spealias = 'SPEALIAS',
  Spedescription = 'SPEDESCRIPTION',
  Speid = 'SPEID',
  Spename = 'SPENAME',
  Standardid = 'STANDARDID',
  Standardname = 'STANDARDNAME',
  Subspealias = 'SUBSPEALIAS',
  Subspedescription = 'SUBSPEDESCRIPTION',
  Subspeid = 'SUBSPEID',
  Subspename = 'SUBSPENAME'
}

/**
 * RequirementWithSPEWhereInput is used for filtering RequirementWithSPEView objects.
 * Input was generated by ent.
 */
export type RequirementWithSpeWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<RequirementWithSpeWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** guidance field predicates */
  guidance?: InputMaybe<Scalars['String']['input']>;
  guidanceContains?: InputMaybe<Scalars['String']['input']>;
  guidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  guidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  guidanceGT?: InputMaybe<Scalars['String']['input']>;
  guidanceGTE?: InputMaybe<Scalars['String']['input']>;
  guidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  guidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  guidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  guidanceLT?: InputMaybe<Scalars['String']['input']>;
  guidanceLTE?: InputMaybe<Scalars['String']['input']>;
  guidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  guidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implementation_guidance field predicates */
  implementationGuidance?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContains?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  implementationGuidanceLT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceLTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_id field predicates */
  maturityLevelID?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maturityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_name field predicates */
  maturityLevelName?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameContains?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameGT?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameGTE?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  maturityLevelNameLT?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameLTE?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RequirementWithSpeWhereInput>;
  or?: InputMaybe<Array<RequirementWithSpeWhereInput>>;
  /** security_level_id field predicates */
  securityLevelID?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_level_name field predicates */
  securityLevelName?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameContains?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameGT?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameGTE?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityLevelNameLT?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameLTE?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_alias field predicates */
  speAlias?: InputMaybe<Scalars['String']['input']>;
  speAliasContains?: InputMaybe<Scalars['String']['input']>;
  speAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  speAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  speAliasGT?: InputMaybe<Scalars['String']['input']>;
  speAliasGTE?: InputMaybe<Scalars['String']['input']>;
  speAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speAliasLT?: InputMaybe<Scalars['String']['input']>;
  speAliasLTE?: InputMaybe<Scalars['String']['input']>;
  speAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  speAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_description field predicates */
  speDescription?: InputMaybe<Scalars['String']['input']>;
  speDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  speDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  speDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  speDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  speDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  speDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  speDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  speDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  speDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_id field predicates */
  speID?: InputMaybe<Scalars['ID']['input']>;
  speIDContains?: InputMaybe<Scalars['ID']['input']>;
  speIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  speIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  speIDGT?: InputMaybe<Scalars['ID']['input']>;
  speIDGTE?: InputMaybe<Scalars['ID']['input']>;
  speIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  speIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  speIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  speIDLT?: InputMaybe<Scalars['ID']['input']>;
  speIDLTE?: InputMaybe<Scalars['ID']['input']>;
  speIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  speIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** spe_name field predicates */
  speName?: InputMaybe<Scalars['String']['input']>;
  speNameContains?: InputMaybe<Scalars['String']['input']>;
  speNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  speNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  speNameGT?: InputMaybe<Scalars['String']['input']>;
  speNameGTE?: InputMaybe<Scalars['String']['input']>;
  speNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speNameLT?: InputMaybe<Scalars['String']['input']>;
  speNameLTE?: InputMaybe<Scalars['String']['input']>;
  speNameNEQ?: InputMaybe<Scalars['String']['input']>;
  speNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** standard_id field predicates */
  standardID?: InputMaybe<Scalars['ID']['input']>;
  standardIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_name field predicates */
  standardName?: InputMaybe<Scalars['String']['input']>;
  standardNameContains?: InputMaybe<Scalars['String']['input']>;
  standardNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardNameGT?: InputMaybe<Scalars['String']['input']>;
  standardNameGTE?: InputMaybe<Scalars['String']['input']>;
  standardNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardNameLT?: InputMaybe<Scalars['String']['input']>;
  standardNameLTE?: InputMaybe<Scalars['String']['input']>;
  standardNameNEQ?: InputMaybe<Scalars['String']['input']>;
  standardNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_alias field predicates */
  subSpeAlias?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasContains?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasGT?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeAliasLT?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sub_spe_description field predicates */
  subSpeDescription?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sub_spe_id field predicates */
  subSpeID?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContains?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subSpeIDLT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_name field predicates */
  subSpeName?: InputMaybe<Scalars['String']['input']>;
  subSpeNameContains?: InputMaybe<Scalars['String']['input']>;
  subSpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeNameGT?: InputMaybe<Scalars['String']['input']>;
  subSpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeNameLT?: InputMaybe<Scalars['String']['input']>;
  subSpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RequirementWithStandardProfile = {
  __typename?: 'RequirementWithStandardProfile';
  alias: Scalars['String']['output'];
  description: Scalars['String']['output'];
  guidance: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementationGuidance?: Maybe<Scalars['String']['output']>;
  maturityLevelID?: Maybe<Scalars['ID']['output']>;
  maturityLevelName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  securityLevelID?: Maybe<Scalars['ID']['output']>;
  securityLevelName?: Maybe<Scalars['String']['output']>;
  speAlias?: Maybe<Scalars['String']['output']>;
  speDescription?: Maybe<Scalars['String']['output']>;
  speID?: Maybe<Scalars['ID']['output']>;
  speName?: Maybe<Scalars['String']['output']>;
  standardID?: Maybe<Scalars['ID']['output']>;
  standardName?: Maybe<Scalars['String']['output']>;
  standardProfileAlias?: Maybe<Scalars['String']['output']>;
  standardProfileID?: Maybe<Scalars['ID']['output']>;
  standardProfileName?: Maybe<Scalars['String']['output']>;
  subSpeAlias?: Maybe<Scalars['String']['output']>;
  subSpeDescription?: Maybe<Scalars['String']['output']>;
  subSpeID?: Maybe<Scalars['ID']['output']>;
  subSpeName?: Maybe<Scalars['String']['output']>;
};

export type RequirementWithStandardProfileConnection = {
  __typename?: 'RequirementWithStandardProfileConnection';
  edges: Array<RequirementWithStandardProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RequirementWithStandardProfileEdge = {
  __typename?: 'RequirementWithStandardProfileEdge';
  cursor: Scalars['Cursor']['output'];
  node: RequirementWithStandardProfile;
};

export type RequirementWithStandardProfileOrder = {
  direction: OrderDirection;
  field?: InputMaybe<RequirementWithStandardProfileOrderField>;
};

export enum RequirementWithStandardProfileOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Guidance = 'GUIDANCE',
  Id = 'ID',
  Maturitylevelid = 'MATURITYLEVELID',
  Maturitylevelname = 'MATURITYLEVELNAME',
  Name = 'NAME',
  Securitylevelid = 'SECURITYLEVELID',
  Securitylevelname = 'SECURITYLEVELNAME',
  Spealias = 'SPEALIAS',
  Spedescription = 'SPEDESCRIPTION',
  Speid = 'SPEID',
  Spename = 'SPENAME',
  Standardid = 'STANDARDID',
  Standardname = 'STANDARDNAME',
  Standardprofilealias = 'STANDARDPROFILEALIAS',
  Standardprofilename = 'STANDARDPROFILENAME',
  Subspealias = 'SUBSPEALIAS',
  Subspedescription = 'SUBSPEDESCRIPTION',
  Subspeid = 'SUBSPEID',
  Subspename = 'SUBSPENAME'
}

/**
 * RequirementWithStandardProfileWhereInput is used for filtering RequirementWithStandardProfileView objects.
 * Input was generated by ent.
 */
export type RequirementWithStandardProfileWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<RequirementWithStandardProfileWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** guidance field predicates */
  guidance?: InputMaybe<Scalars['String']['input']>;
  guidanceContains?: InputMaybe<Scalars['String']['input']>;
  guidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  guidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  guidanceGT?: InputMaybe<Scalars['String']['input']>;
  guidanceGTE?: InputMaybe<Scalars['String']['input']>;
  guidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  guidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  guidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  guidanceLT?: InputMaybe<Scalars['String']['input']>;
  guidanceLTE?: InputMaybe<Scalars['String']['input']>;
  guidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  guidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implementation_guidance field predicates */
  implementationGuidance?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContains?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  implementationGuidanceLT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceLTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_id field predicates */
  maturityLevelID?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maturityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  maturityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  maturityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** maturity_level_name field predicates */
  maturityLevelName?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameContains?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameGT?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameGTE?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  maturityLevelNameLT?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameLTE?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  maturityLevelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RequirementWithStandardProfileWhereInput>;
  or?: InputMaybe<Array<RequirementWithStandardProfileWhereInput>>;
  /** security_level_id field predicates */
  securityLevelID?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContains?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityLevelIDLT?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  securityLevelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityLevelIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_level_name field predicates */
  securityLevelName?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameContains?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameGT?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameGTE?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityLevelNameLT?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameLTE?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  securityLevelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_alias field predicates */
  speAlias?: InputMaybe<Scalars['String']['input']>;
  speAliasContains?: InputMaybe<Scalars['String']['input']>;
  speAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  speAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  speAliasGT?: InputMaybe<Scalars['String']['input']>;
  speAliasGTE?: InputMaybe<Scalars['String']['input']>;
  speAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speAliasLT?: InputMaybe<Scalars['String']['input']>;
  speAliasLTE?: InputMaybe<Scalars['String']['input']>;
  speAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  speAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_description field predicates */
  speDescription?: InputMaybe<Scalars['String']['input']>;
  speDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  speDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  speDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  speDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  speDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  speDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  speDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  speDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  speDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** spe_id field predicates */
  speID?: InputMaybe<Scalars['ID']['input']>;
  speIDContains?: InputMaybe<Scalars['ID']['input']>;
  speIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  speIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  speIDGT?: InputMaybe<Scalars['ID']['input']>;
  speIDGTE?: InputMaybe<Scalars['ID']['input']>;
  speIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  speIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  speIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  speIDLT?: InputMaybe<Scalars['ID']['input']>;
  speIDLTE?: InputMaybe<Scalars['ID']['input']>;
  speIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  speIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** spe_name field predicates */
  speName?: InputMaybe<Scalars['String']['input']>;
  speNameContains?: InputMaybe<Scalars['String']['input']>;
  speNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  speNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  speNameGT?: InputMaybe<Scalars['String']['input']>;
  speNameGTE?: InputMaybe<Scalars['String']['input']>;
  speNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speNameLT?: InputMaybe<Scalars['String']['input']>;
  speNameLTE?: InputMaybe<Scalars['String']['input']>;
  speNameNEQ?: InputMaybe<Scalars['String']['input']>;
  speNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** standard_id field predicates */
  standardID?: InputMaybe<Scalars['ID']['input']>;
  standardIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_name field predicates */
  standardName?: InputMaybe<Scalars['String']['input']>;
  standardNameContains?: InputMaybe<Scalars['String']['input']>;
  standardNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardNameGT?: InputMaybe<Scalars['String']['input']>;
  standardNameGTE?: InputMaybe<Scalars['String']['input']>;
  standardNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardNameLT?: InputMaybe<Scalars['String']['input']>;
  standardNameLTE?: InputMaybe<Scalars['String']['input']>;
  standardNameNEQ?: InputMaybe<Scalars['String']['input']>;
  standardNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_alias field predicates */
  standardProfileAlias?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasContains?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasGT?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasGTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileAliasIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardProfileAliasLT?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasLTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  standardProfileAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileAliasNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_id field predicates */
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardProfileIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_name field predicates */
  standardProfileName?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameContains?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameGT?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameGTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardProfileNameLT?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameLTE?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  standardProfileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  standardProfileNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_alias field predicates */
  subSpeAlias?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasContains?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasGT?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeAliasLT?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeAliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sub_spe_description field predicates */
  subSpeDescription?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sub_spe_id field predicates */
  subSpeID?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContains?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subSpeIDLT?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  subSpeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSpeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spe_name field predicates */
  subSpeName?: InputMaybe<Scalars['String']['input']>;
  subSpeNameContains?: InputMaybe<Scalars['String']['input']>;
  subSpeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  subSpeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  subSpeNameGT?: InputMaybe<Scalars['String']['input']>;
  subSpeNameGTE?: InputMaybe<Scalars['String']['input']>;
  subSpeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subSpeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subSpeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subSpeNameLT?: InputMaybe<Scalars['String']['input']>;
  subSpeNameLTE?: InputMaybe<Scalars['String']['input']>;
  subSpeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  subSpeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReviewComponentCreateRequestRawInput = {
  comment: Scalars['String']['input'];
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentSourceID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  proposedStatusID: Scalars['ID']['input'];
};

export enum SbomExportFormat {
  Json = 'JSON',
  Xml = 'XML'
}

export type Spe = {
  __typename?: 'SPE';
  alias: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subSPEs?: Maybe<Array<Maybe<SubSpe>>>;
};

export type SpeConnection = {
  __typename?: 'SPEConnection';
  edges: Array<SpeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SpeEdge = {
  __typename?: 'SPEEdge';
  cursor: Scalars['Cursor']['output'];
  node: Spe;
};

export type SpeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SpeOrderField>;
};

export enum SpeOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME'
}

/**
 * SPEWhereInput is used for filtering SPE objects.
 * Input was generated by ent.
 */
export type SpeWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<SpeWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_spes edge predicates */
  hasSubSpes?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubSpesWith?: InputMaybe<Array<SubSpeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SpeWhereInput>;
  or?: InputMaybe<Array<SpeWhereInput>>;
};

export type SaveCraDocumentationInput = {
  craID: Scalars['ID']['input'];
  hasIntendedPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  hasProcessReference?: InputMaybe<Scalars['Boolean']['input']>;
  hasProductVisual?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecDesignArchitecture?: InputMaybe<Scalars['Boolean']['input']>;
  /**  When not provided new CRADocumentation will be created. When provided existing CRADocumentation will be updated.  */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveCraGeneralInput = {
  craID: Scalars['ID']['input'];
  /**  When not provided new CRAGeneral will be created. When provided existing CRAGeneral will be updated.  */
  id?: InputMaybe<Scalars['ID']['input']>;
  productCategory?: InputMaybe<CraGeneralProductCategory>;
  productLifetime?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeEndDate?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDate?: InputMaybe<Scalars['Time']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productVersion?: InputMaybe<Scalars['String']['input']>;
  projectManagerUserID?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleUserID?: InputMaybe<Scalars['ID']['input']>;
  supportPeriod?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodInformation?: InputMaybe<Scalars['String']['input']>;
  supportPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
};

export type SaveCraInput = {
  /**  When not provided new CRA will be created. When provided existing CRA will be updated.  */
  id?: InputMaybe<Scalars['ID']['input']>;
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  projectID: Scalars['ID']['input'];
  type?: InputMaybe<CraType>;
};

export type SaveCraVulnerabilityHandlingInput = {
  craID: Scalars['ID']['input'];
  customerContact?: InputMaybe<Scalars['String']['input']>;
  customerContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
  /**
   *  When not provided new CRAVulnerabilityHandling will be created. When provided
   * existing CRAVulnerabilityHandling will be updated.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  seContact?: InputMaybe<Scalars['String']['input']>;
  seContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
};

export type SaveMitigationBulkEntry = {
  assetItemID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notificationID?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveMitigationBulkInput = {
  assignee: MitigationAssignee;
  measure?: InputMaybe<CreateMeasureInput>;
  measureID?: InputMaybe<Scalars['ID']['input']>;
  mitigations: Array<SaveMitigationBulkEntry>;
  workcycle?: InputMaybe<CreateTaskRawInput>;
  workcycleID?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProjectGuidanceInput = {
  /**  When not provided new guidance will be created. When provided existing guidance will be updated.  */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /**  only user when creating, not possible to update  */
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  /**  when empty then all config requirements will be deleted  */
  requirementsConfig?: InputMaybe<Array<SaveProjectGuidanceRequirementConfigInput>>;
  /**  only user when creating, not possible to update  */
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProjectGuidanceRequirementConfigInput = {
  projectMilestoneID: Scalars['ID']['input'];
  requirementID: Scalars['ID']['input'];
  taskTemplateID: Scalars['ID']['input'];
};

export type SaveProjectHierarchyAttributeRawInput = {
  projectHierarchyAttributeDefinitionID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProjectHierarchyInput = {
  attributes?: InputMaybe<Array<SaveProjectHierarchyAttributeRawInput>>;
  commodityManager?: InputMaybe<Scalars['String']['input']>;
  criticality: ProjectHierarchyCriticality;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  typeID: Scalars['ID']['input'];
};

export type SaveProjectZoneInput = {
  description: Scalars['String']['input'];
  exposureRating: ProjectZoneExposureRating;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  standardProfileIDs: Array<Scalars['ID']['input']>;
};

export type SaveSurveyInput = {
  answers?: InputMaybe<Scalars['String']['input']>;
  approver1UserID?: InputMaybe<Scalars['ID']['input']>;
  approver2UserID?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  externalDocumentID?: InputMaybe<Scalars['String']['input']>;
  formID: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  optimisticLockVersion: Scalars['Int']['input'];
  profileID: Scalars['ID']['input'];
  projectID: Scalars['ID']['input'];
};

export type SaveSurveyTemplateInput = {
  answers: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  formID: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  profileID: Scalars['ID']['input'];
};

export type SaveTaskDeliverableInput = {
  id: Scalars['ID']['input'];
  isChecked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveUserNotificationSettingInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<UserNotificationSettingFrequency>;
  id?: InputMaybe<Scalars['ID']['input']>;
  projects?: InputMaybe<Array<InputMaybe<UserNotificationSettingProjectConfiguration>>>;
};

export type SecurityLevel = {
  __typename?: 'SecurityLevel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SecurityLevelConnection = {
  __typename?: 'SecurityLevelConnection';
  edges: Array<SecurityLevelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SecurityLevelEdge = {
  __typename?: 'SecurityLevelEdge';
  cursor: Scalars['Cursor']['output'];
  node: SecurityLevel;
};

export type SecurityLevelOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SecurityLevelOrderField>;
};

export enum SecurityLevelOrderField {
  Id = 'ID',
  Name = 'NAME'
}

/**
 * SecurityLevelWhereInput is used for filtering SecurityLevel objects.
 * Input was generated by ent.
 */
export type SecurityLevelWhereInput = {
  and?: InputMaybe<Array<SecurityLevelWhereInput>>;
  /** requirements edge predicates */
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementsWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SecurityLevelWhereInput>;
  or?: InputMaybe<Array<SecurityLevelWhereInput>>;
};

export type SetMetricsInput20 = {
  metrics?: InputMaybe<Cvss20Input>;
  vector?: InputMaybe<Scalars['String']['input']>;
};

export type SetMetricsInput30 = {
  metrics?: InputMaybe<Cvss30Input>;
  vector?: InputMaybe<Scalars['String']['input']>;
};

export type SetMetricsInput31 = {
  metrics?: InputMaybe<Cvss30Input>;
  vector?: InputMaybe<Scalars['String']['input']>;
};

export type SetMetricsInput40 = {
  metrics?: InputMaybe<Cvss40Input>;
  vector?: InputMaybe<Scalars['String']['input']>;
};

export type SetMitigationssStatusInput = {
  ids: Array<Scalars['ID']['input']>;
  status?: InputMaybe<MitigationStatus>;
};

export type SetProjectUsersInput = {
  id: Scalars['ID']['input'];
  users?: InputMaybe<Array<ProjectUserInput>>;
};

export type SetTraParticipantsInput = {
  id: Scalars['ID']['input'];
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SetUserOrganizationsInput = {
  userID: Scalars['ID']['input'];
  userOrganizations: Array<UserOrganizationInput>;
};

export type Standard = {
  __typename?: 'Standard';
  country?: Maybe<Country>;
  craType?: Maybe<StandardCraType>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementationGuidance?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  releasedAt: Scalars['Time']['output'];
  requirements?: Maybe<Array<Maybe<Requirement>>>;
  requirementsCount: Scalars['Int']['output'];
  standardProfiles?: Maybe<Array<Maybe<StandardProfile>>>;
  validFrom: Scalars['Time']['output'];
  validTo?: Maybe<Scalars['Time']['output']>;
};

export type StandardConnection = {
  __typename?: 'StandardConnection';
  edges: Array<StandardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum StandardCraType {
  CraEu = 'CRA_EU'
}

export type StandardEdge = {
  __typename?: 'StandardEdge';
  cursor: Scalars['Cursor']['output'];
  node: Standard;
};

export type StandardImportSummary = {
  __typename?: 'StandardImportSummary';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mappings?: Maybe<StandardImportSummaryStats>;
  requirements?: Maybe<StandardImportSummaryStats>;
  standards?: Maybe<StandardImportSummaryStats>;
};

export type StandardImportSummaryStats = {
  __typename?: 'StandardImportSummaryStats';
  failedRows?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  missing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  successful: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unsuccessful: Scalars['Int']['output'];
};

export type StandardOrder = {
  direction: OrderDirection;
  field?: InputMaybe<StandardOrderField>;
};

export enum StandardOrderField {
  Countryid = 'COUNTRYID',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Releasedat = 'RELEASEDAT',
  Requirementscount = 'REQUIREMENTSCOUNT',
  Revisedintoid = 'REVISEDINTOID',
  Validfrom = 'VALIDFROM',
  Validto = 'VALIDTO'
}

export type StandardProfile = {
  __typename?: 'StandardProfile';
  alias: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  standard?: Maybe<Standard>;
};

export type StandardProfileConnection = {
  __typename?: 'StandardProfileConnection';
  edges: Array<StandardProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StandardProfileEdge = {
  __typename?: 'StandardProfileEdge';
  cursor: Scalars['Cursor']['output'];
  node: StandardProfile;
};

export type StandardProfileOrder = {
  direction: OrderDirection;
  field?: InputMaybe<StandardProfileOrderField>;
};

export enum StandardProfileOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Standardid = 'STANDARDID'
}

/**
 * StandardProfileRequirementWhereInput is used for filtering StandardProfileRequirement objects.
 * Input was generated by ent.
 */
export type StandardProfileRequirementWhereInput = {
  and?: InputMaybe<Array<StandardProfileRequirementWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<StandardProfileRequirementWhereInput>;
  or?: InputMaybe<Array<StandardProfileRequirementWhereInput>>;
};

/**
 * StandardProfileWhereInput is used for filtering StandardProfile objects.
 * Input was generated by ent.
 */
export type StandardProfileWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<StandardProfileWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requirements edge predicates */
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementsWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** standard edge predicates */
  hasStandard?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile edge predicates */
  hasStandardProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** standard_profile_requirements edge predicates */
  hasStandardProfileRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfileRequirementsWith?: InputMaybe<Array<StandardProfileRequirementWhereInput>>;
  hasStandardProfileWith?: InputMaybe<Array<ProjectZoneStandardProfileWhereInput>>;
  hasStandardWith?: InputMaybe<Array<StandardWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<StandardProfileWhereInput>;
  or?: InputMaybe<Array<StandardProfileWhereInput>>;
  /** standard_id field predicates */
  standardID?: InputMaybe<Scalars['ID']['input']>;
  standardIDContains?: InputMaybe<Scalars['ID']['input']>;
  standardIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  standardIDGT?: InputMaybe<Scalars['ID']['input']>;
  standardIDGTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  standardIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  standardIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  standardIDLT?: InputMaybe<Scalars['ID']['input']>;
  standardIDLTE?: InputMaybe<Scalars['ID']['input']>;
  standardIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  standardIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * StandardWhereInput is used for filtering Standard objects.
 * Input was generated by ent.
 */
export type StandardWhereInput = {
  and?: InputMaybe<Array<StandardWhereInput>>;
  /** country_id field predicates */
  countryID?: InputMaybe<Scalars['ID']['input']>;
  countryIDContains?: InputMaybe<Scalars['ID']['input']>;
  countryIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  countryIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  countryIDGT?: InputMaybe<Scalars['ID']['input']>;
  countryIDGTE?: InputMaybe<Scalars['ID']['input']>;
  countryIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  countryIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  countryIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDLT?: InputMaybe<Scalars['ID']['input']>;
  countryIDLTE?: InputMaybe<Scalars['ID']['input']>;
  countryIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  countryIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** cra_type field predicates */
  craType?: InputMaybe<StandardCraType>;
  craTypeIn?: InputMaybe<Array<StandardCraType>>;
  craTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  craTypeNEQ?: InputMaybe<StandardCraType>;
  craTypeNotIn?: InputMaybe<Array<StandardCraType>>;
  craTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** country edge predicates */
  hasCountry?: InputMaybe<Scalars['Boolean']['input']>;
  /** country_standards edge predicates */
  hasCountryStandards?: InputMaybe<Scalars['Boolean']['input']>;
  hasCountryStandardsWith?: InputMaybe<Array<CountryStandardWhereInput>>;
  hasCountryWith?: InputMaybe<Array<CountryWhereInput>>;
  /** requirements edge predicates */
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementsWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** revised_from edge predicates */
  hasRevisedFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevisedFromWith?: InputMaybe<Array<StandardWhereInput>>;
  /** revised_into edge predicates */
  hasRevisedInto?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevisedIntoWith?: InputMaybe<Array<StandardWhereInput>>;
  /** standard_profiles edge predicates */
  hasStandardProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardProfilesWith?: InputMaybe<Array<StandardProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implementation_guidance field predicates */
  implementationGuidance?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContains?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceGTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  implementationGuidanceLT?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceLTE?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  implementationGuidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  implementationGuidanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<StandardWhereInput>;
  or?: InputMaybe<Array<StandardWhereInput>>;
  /** released_at field predicates */
  releasedAt?: InputMaybe<Scalars['Time']['input']>;
  releasedAtGT?: InputMaybe<Scalars['Time']['input']>;
  releasedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  releasedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  releasedAtLT?: InputMaybe<Scalars['Time']['input']>;
  releasedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  releasedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  releasedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** requirements_count field predicates */
  requirementsCount?: InputMaybe<Scalars['Int']['input']>;
  requirementsCountGT?: InputMaybe<Scalars['Int']['input']>;
  requirementsCountGTE?: InputMaybe<Scalars['Int']['input']>;
  requirementsCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  requirementsCountLT?: InputMaybe<Scalars['Int']['input']>;
  requirementsCountLTE?: InputMaybe<Scalars['Int']['input']>;
  requirementsCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  requirementsCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** revised_into_id field predicates */
  revisedIntoID?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDContains?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDGT?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDGTE?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisedIntoIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  revisedIntoIDLT?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDLTE?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisedIntoIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** valid_from field predicates */
  validFrom?: InputMaybe<Scalars['Time']['input']>;
  validFromGT?: InputMaybe<Scalars['Time']['input']>;
  validFromGTE?: InputMaybe<Scalars['Time']['input']>;
  validFromIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  validFromLT?: InputMaybe<Scalars['Time']['input']>;
  validFromLTE?: InputMaybe<Scalars['Time']['input']>;
  validFromNEQ?: InputMaybe<Scalars['Time']['input']>;
  validFromNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** valid_to field predicates */
  validTo?: InputMaybe<Scalars['Time']['input']>;
  validToGT?: InputMaybe<Scalars['Time']['input']>;
  validToGTE?: InputMaybe<Scalars['Time']['input']>;
  validToIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  validToLT?: InputMaybe<Scalars['Time']['input']>;
  validToLTE?: InputMaybe<Scalars['Time']['input']>;
  validToNEQ?: InputMaybe<Scalars['Time']['input']>;
  validToNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SubSpe = {
  __typename?: 'SubSPE';
  alias: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requirements?: Maybe<Array<Maybe<Requirement>>>;
  spe?: Maybe<Spe>;
};

export type SubSpeConnection = {
  __typename?: 'SubSPEConnection';
  edges: Array<SubSpeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubSpeEdge = {
  __typename?: 'SubSPEEdge';
  cursor: Scalars['Cursor']['output'];
  node: SubSpe;
};

export type SubSpeOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SubSpeOrderField>;
};

export enum SubSpeOrderField {
  Alias = 'ALIAS',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Speid = 'SPEID'
}

/**
 * SubSPEWhereInput is used for filtering SubSPE objects.
 * Input was generated by ent.
 */
export type SubSpeWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<SubSpeWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requirements edge predicates */
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementsWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** spe edge predicates */
  hasSpe?: InputMaybe<Scalars['Boolean']['input']>;
  hasSpeWith?: InputMaybe<Array<SpeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SubSpeWhereInput>;
  or?: InputMaybe<Array<SubSpeWhereInput>>;
  /** spe_id field predicates */
  speID?: InputMaybe<Scalars['ID']['input']>;
  speIDContains?: InputMaybe<Scalars['ID']['input']>;
  speIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  speIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  speIDGT?: InputMaybe<Scalars['ID']['input']>;
  speIDGTE?: InputMaybe<Scalars['ID']['input']>;
  speIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  speIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  speIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  speIDLT?: InputMaybe<Scalars['ID']['input']>;
  speIDLTE?: InputMaybe<Scalars['ID']['input']>;
  speIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  speIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  speIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  userEvents: UserEvent;
};

export type Survey = {
  __typename?: 'Survey';
  actionTransitionLog: Scalars['String']['output'];
  answers: Scalars['String']['output'];
  approved1At?: Maybe<Scalars['Time']['output']>;
  approved2At?: Maybe<Scalars['Time']['output']>;
  approver1User?: Maybe<User>;
  approver2User?: Maybe<User>;
  author: User;
  classificationClass: SurveyClassificationClass;
  classificationScore: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  conductedAt?: Maybe<Scalars['Time']['output']>;
  declinedAt?: Maybe<Scalars['Time']['output']>;
  declinerUser?: Maybe<User>;
  externalDocumentID?: Maybe<Scalars['String']['output']>;
  form: SurveyForm;
  id: Scalars['ID']['output'];
  isApproved: Scalars['Boolean']['output'];
  optimisticLockVersion: Scalars['Int']['output'];
  profile: SurveyProfile;
  project: Project;
  status: SurveyStatus;
};

export type SurveyClassificationClass = {
  __typename?: 'SurveyClassificationClass';
  activities: Array<Maybe<SurveyClassificationClassActivity>>;
  description: Scalars['String']['output'];
  form: SurveyForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  surveyScales: Array<Maybe<SurveyScale>>;
};

export type SurveyClassificationClassActivity = {
  __typename?: 'SurveyClassificationClassActivity';
  additionalDescription?: Maybe<Scalars['String']['output']>;
  classificationClass: SurveyClassificationClass;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  necessity: SurveyClassificationClassActivityNecessity;
  sequence: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum SurveyClassificationClassActivityNecessity {
  Mandatory = 'MANDATORY',
  Optional = 'OPTIONAL',
  Recommended = 'RECOMMENDED'
}

/**
 * SurveyClassificationClassActivityWhereInput is used for filtering SurveyClassificationClassActivity objects.
 * Input was generated by ent.
 */
export type SurveyClassificationClassActivityWhereInput = {
  /** additional_description field predicates */
  additionalDescription?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  additionalDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  additionalDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<SurveyClassificationClassActivityWhereInput>>;
  /** classification_class_id field predicates */
  classificationClassID?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDContains?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDGT?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDGTE?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  classificationClassIDLT?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDLTE?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** classification_class edge predicates */
  hasClassificationClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasClassificationClassWith?: InputMaybe<Array<SurveyClassificationClassWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** necessity field predicates */
  necessity?: InputMaybe<SurveyClassificationClassActivityNecessity>;
  necessityIn?: InputMaybe<Array<SurveyClassificationClassActivityNecessity>>;
  necessityNEQ?: InputMaybe<SurveyClassificationClassActivityNecessity>;
  necessityNotIn?: InputMaybe<Array<SurveyClassificationClassActivityNecessity>>;
  not?: InputMaybe<SurveyClassificationClassActivityWhereInput>;
  or?: InputMaybe<Array<SurveyClassificationClassActivityWhereInput>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SurveyClassificationClassConnection = {
  __typename?: 'SurveyClassificationClassConnection';
  edges: Array<SurveyClassificationClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyClassificationClassEdge = {
  __typename?: 'SurveyClassificationClassEdge';
  cursor: Scalars['Cursor']['output'];
  node: SurveyClassificationClass;
};

export type SurveyClassificationClassOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SurveyClassificationClassOrderField>;
};

export enum SurveyClassificationClassOrderField {
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME'
}

/**
 * SurveyClassificationClassWhereInput is used for filtering SurveyClassificationClass objects.
 * Input was generated by ent.
 */
export type SurveyClassificationClassWhereInput = {
  and?: InputMaybe<Array<SurveyClassificationClassWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** activities edge predicates */
  hasActivities?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivitiesWith?: InputMaybe<Array<SurveyClassificationClassActivityWhereInput>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** survey_scales edge predicates */
  hasSurveyScales?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyScalesWith?: InputMaybe<Array<SurveyScaleWhereInput>>;
  /** surveys edge predicates */
  hasSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveysWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SurveyClassificationClassWhereInput>;
  or?: InputMaybe<Array<SurveyClassificationClassWhereInput>>;
};

export type SurveyForm = {
  __typename?: 'SurveyForm';
  author: User;
  classificationClasses: Array<Maybe<SurveyClassificationClass>>;
  contents: Array<Maybe<SurveyFormContent>>;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  kind: SurveyFormKind;
  profiles: Array<Maybe<SurveyProfile>>;
  questions: Array<Maybe<SurveyQuestion>>;
  topicClusterTypes: Array<Maybe<SurveyTopicClusterType>>;
  updateTime: Scalars['Time']['output'];
  version: Scalars['Int']['output'];
};

export type SurveyFormConnection = {
  __typename?: 'SurveyFormConnection';
  edges: Array<SurveyFormEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyFormContent = {
  __typename?: 'SurveyFormContent';
  form: SurveyForm;
  id: Scalars['ID']['output'];
  profile: SurveyProfile;
  question?: Maybe<SurveyQuestion>;
  sequence: Scalars['Int']['output'];
  topicClusterType: SurveyTopicClusterType;
};

export type SurveyFormContentConnection = {
  __typename?: 'SurveyFormContentConnection';
  edges: Array<SurveyFormContentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyFormContentEdge = {
  __typename?: 'SurveyFormContentEdge';
  cursor: Scalars['Cursor']['output'];
  node: SurveyFormContent;
};

export type SurveyFormContentOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SurveyFormContentOrderField>;
};

export enum SurveyFormContentOrderField {
  Formid = 'FORMID',
  Profileid = 'PROFILEID',
  Questionid = 'QUESTIONID',
  Sequence = 'SEQUENCE',
  Topicclustertypeid = 'TOPICCLUSTERTYPEID'
}

/**
 * SurveyFormContentWhereInput is used for filtering SurveyFormContent objects.
 * Input was generated by ent.
 */
export type SurveyFormContentWhereInput = {
  and?: InputMaybe<Array<SurveyFormContentWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** profile edge predicates */
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfileWith?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** question edge predicates */
  hasQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuestionWith?: InputMaybe<Array<SurveyQuestionWhereInput>>;
  /** topic_cluster_type edge predicates */
  hasTopicClusterType?: InputMaybe<Scalars['Boolean']['input']>;
  hasTopicClusterTypeWith?: InputMaybe<Array<SurveyTopicClusterTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<SurveyFormContentWhereInput>;
  or?: InputMaybe<Array<SurveyFormContentWhereInput>>;
  /** profile_id field predicates */
  profileID?: InputMaybe<Scalars['ID']['input']>;
  profileIDContains?: InputMaybe<Scalars['ID']['input']>;
  profileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDGT?: InputMaybe<Scalars['ID']['input']>;
  profileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  profileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  profileIDLT?: InputMaybe<Scalars['ID']['input']>;
  profileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  profileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** question_id field predicates */
  questionID?: InputMaybe<Scalars['ID']['input']>;
  questionIDContains?: InputMaybe<Scalars['ID']['input']>;
  questionIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  questionIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  questionIDGT?: InputMaybe<Scalars['ID']['input']>;
  questionIDGTE?: InputMaybe<Scalars['ID']['input']>;
  questionIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  questionIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  questionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionIDLT?: InputMaybe<Scalars['ID']['input']>;
  questionIDLTE?: InputMaybe<Scalars['ID']['input']>;
  questionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  questionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** topic_cluster_type_id field predicates */
  topicClusterTypeID?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDContains?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDGT?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  topicClusterTypeIDLT?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  topicClusterTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SurveyFormEdge = {
  __typename?: 'SurveyFormEdge';
  cursor: Scalars['Cursor']['output'];
  node: SurveyForm;
};

export type SurveyFormImportSummary = {
  __typename?: 'SurveyFormImportSummary';
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SurveyFormKind {
  Pssclassification = 'PSSCLASSIFICATION'
}

export type SurveyFormOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SurveyFormOrderField>;
};

export enum SurveyFormOrderField {
  Author = 'AUTHOR',
  Id = 'ID',
  Ispublished = 'ISPUBLISHED',
  Kind = 'KIND',
  Validfrom = 'VALIDFROM',
  Validto = 'VALIDTO',
  Version = 'VERSION'
}

/**
 * SurveyFormWhereInput is used for filtering SurveyForm objects.
 * Input was generated by ent.
 */
export type SurveyFormWhereInput = {
  and?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** author_id field predicates */
  authorID?: InputMaybe<Scalars['ID']['input']>;
  authorIDContains?: InputMaybe<Scalars['ID']['input']>;
  authorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDGT?: InputMaybe<Scalars['ID']['input']>;
  authorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  authorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  authorIDLT?: InputMaybe<Scalars['ID']['input']>;
  authorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  authorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** author edge predicates */
  hasAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hasAuthorWith?: InputMaybe<Array<UserWhereInput>>;
  /** classificationClasses edge predicates */
  hasClassificationClasses?: InputMaybe<Scalars['Boolean']['input']>;
  hasClassificationClassesWith?: InputMaybe<Array<SurveyClassificationClassWhereInput>>;
  /** contents edge predicates */
  hasContents?: InputMaybe<Scalars['Boolean']['input']>;
  hasContentsWith?: InputMaybe<Array<SurveyFormContentWhereInput>>;
  /** profiles edge predicates */
  hasProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilesWith?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** questions edge predicates */
  hasQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuestionsWith?: InputMaybe<Array<SurveyQuestionWhereInput>>;
  /** surveys edge predicates */
  hasSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveysWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** template edge predicates */
  hasTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateWith?: InputMaybe<Array<SurveyTemplateWhereInput>>;
  /** topicClusterTypes edge predicates */
  hasTopicClusterTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasTopicClusterTypesWith?: InputMaybe<Array<SurveyTopicClusterTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_published field predicates */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<SurveyFormKind>;
  kindIn?: InputMaybe<Array<SurveyFormKind>>;
  kindNEQ?: InputMaybe<SurveyFormKind>;
  kindNotIn?: InputMaybe<Array<SurveyFormKind>>;
  not?: InputMaybe<SurveyFormWhereInput>;
  or?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['Int']['input']>;
  versionGT?: InputMaybe<Scalars['Int']['input']>;
  versionGTE?: InputMaybe<Scalars['Int']['input']>;
  versionIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  versionLT?: InputMaybe<Scalars['Int']['input']>;
  versionLTE?: InputMaybe<Scalars['Int']['input']>;
  versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SurveyProfile = {
  __typename?: 'SurveyProfile';
  form: SurveyForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  perequisties: Scalars['String']['output'];
  securityActivities: Scalars['String']['output'];
};

export type SurveyProfileConnection = {
  __typename?: 'SurveyProfileConnection';
  edges: Array<SurveyProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyProfileEdge = {
  __typename?: 'SurveyProfileEdge';
  cursor: Scalars['Cursor']['output'];
  node: SurveyProfile;
};

export type SurveyProfileOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SurveyProfileOrderField>;
};

export enum SurveyProfileOrderField {
  Id = 'ID',
  Name = 'NAME',
  Perequisties = 'PEREQUISTIES',
  Securityactivities = 'SECURITYACTIVITIES'
}

/**
 * SurveyProfileWhereInput is used for filtering SurveyProfile objects.
 * Input was generated by ent.
 */
export type SurveyProfileWhereInput = {
  and?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** survey_form_contents edge predicates */
  hasSurveyFormContents?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyFormContentsWith?: InputMaybe<Array<SurveyFormContentWhereInput>>;
  /** survey_scales edge predicates */
  hasSurveyScales?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyScalesWith?: InputMaybe<Array<SurveyScaleWhereInput>>;
  /** survey_template_profiles edge predicates */
  hasSurveyTemplateProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyTemplateProfilesWith?: InputMaybe<Array<SurveyTemplateWhereInput>>;
  /** surveys edge predicates */
  hasSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveysWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SurveyProfileWhereInput>;
  or?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** perequisties field predicates */
  perequisties?: InputMaybe<Scalars['String']['input']>;
  perequistiesContains?: InputMaybe<Scalars['String']['input']>;
  perequistiesContainsFold?: InputMaybe<Scalars['String']['input']>;
  perequistiesEqualFold?: InputMaybe<Scalars['String']['input']>;
  perequistiesGT?: InputMaybe<Scalars['String']['input']>;
  perequistiesGTE?: InputMaybe<Scalars['String']['input']>;
  perequistiesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  perequistiesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  perequistiesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  perequistiesLT?: InputMaybe<Scalars['String']['input']>;
  perequistiesLTE?: InputMaybe<Scalars['String']['input']>;
  perequistiesNEQ?: InputMaybe<Scalars['String']['input']>;
  perequistiesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** security_activities field predicates */
  securityActivities?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesContains?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesContainsFold?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesEqualFold?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesGT?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesGTE?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  securityActivitiesLT?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesLTE?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesNEQ?: InputMaybe<Scalars['String']['input']>;
  securityActivitiesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  answerHeader: Scalars['String']['output'];
  form: SurveyForm;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  questionGuidance: Scalars['String']['output'];
  surveyQuestionOptions?: Maybe<Array<Maybe<SurveyQuestionOption>>>;
  topic: Scalars['String']['output'];
};

export type SurveyQuestionOption = {
  __typename?: 'SurveyQuestionOption';
  id: Scalars['ID']['output'];
  question: SurveyQuestion;
  sequence: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/**
 * SurveyQuestionOptionWhereInput is used for filtering SurveyQuestionOption objects.
 * Input was generated by ent.
 */
export type SurveyQuestionOptionWhereInput = {
  and?: InputMaybe<Array<SurveyQuestionOptionWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** question edge predicates */
  hasQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuestionWith?: InputMaybe<Array<SurveyQuestionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<SurveyQuestionOptionWhereInput>;
  or?: InputMaybe<Array<SurveyQuestionOptionWhereInput>>;
  /** question_id field predicates */
  questionID?: InputMaybe<Scalars['ID']['input']>;
  questionIDContains?: InputMaybe<Scalars['ID']['input']>;
  questionIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  questionIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  questionIDGT?: InputMaybe<Scalars['ID']['input']>;
  questionIDGTE?: InputMaybe<Scalars['ID']['input']>;
  questionIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  questionIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  questionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionIDLT?: InputMaybe<Scalars['ID']['input']>;
  questionIDLTE?: InputMaybe<Scalars['ID']['input']>;
  questionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  questionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** text field predicates */
  text?: InputMaybe<Scalars['String']['input']>;
  textContains?: InputMaybe<Scalars['String']['input']>;
  textContainsFold?: InputMaybe<Scalars['String']['input']>;
  textEqualFold?: InputMaybe<Scalars['String']['input']>;
  textGT?: InputMaybe<Scalars['String']['input']>;
  textGTE?: InputMaybe<Scalars['String']['input']>;
  textHasPrefix?: InputMaybe<Scalars['String']['input']>;
  textHasSuffix?: InputMaybe<Scalars['String']['input']>;
  textIn?: InputMaybe<Array<Scalars['String']['input']>>;
  textLT?: InputMaybe<Scalars['String']['input']>;
  textLTE?: InputMaybe<Scalars['String']['input']>;
  textNEQ?: InputMaybe<Scalars['String']['input']>;
  textNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['Float']['input']>;
  valueGT?: InputMaybe<Scalars['Float']['input']>;
  valueGTE?: InputMaybe<Scalars['Float']['input']>;
  valueIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  valueLT?: InputMaybe<Scalars['Float']['input']>;
  valueLTE?: InputMaybe<Scalars['Float']['input']>;
  valueNEQ?: InputMaybe<Scalars['Float']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/**
 * SurveyQuestionWhereInput is used for filtering SurveyQuestion objects.
 * Input was generated by ent.
 */
export type SurveyQuestionWhereInput = {
  and?: InputMaybe<Array<SurveyQuestionWhereInput>>;
  /** answer_header field predicates */
  answerHeader?: InputMaybe<Scalars['String']['input']>;
  answerHeaderContains?: InputMaybe<Scalars['String']['input']>;
  answerHeaderContainsFold?: InputMaybe<Scalars['String']['input']>;
  answerHeaderEqualFold?: InputMaybe<Scalars['String']['input']>;
  answerHeaderGT?: InputMaybe<Scalars['String']['input']>;
  answerHeaderGTE?: InputMaybe<Scalars['String']['input']>;
  answerHeaderHasPrefix?: InputMaybe<Scalars['String']['input']>;
  answerHeaderHasSuffix?: InputMaybe<Scalars['String']['input']>;
  answerHeaderIn?: InputMaybe<Array<Scalars['String']['input']>>;
  answerHeaderLT?: InputMaybe<Scalars['String']['input']>;
  answerHeaderLTE?: InputMaybe<Scalars['String']['input']>;
  answerHeaderNEQ?: InputMaybe<Scalars['String']['input']>;
  answerHeaderNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** survey_form_contents edge predicates */
  hasSurveyFormContents?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyFormContentsWith?: InputMaybe<Array<SurveyFormContentWhereInput>>;
  /** survey_question_options edge predicates */
  hasSurveyQuestionOptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyQuestionOptionsWith?: InputMaybe<Array<SurveyQuestionOptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_published field predicates */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SurveyQuestionWhereInput>;
  or?: InputMaybe<Array<SurveyQuestionWhereInput>>;
  /** question field predicates */
  question?: InputMaybe<Scalars['String']['input']>;
  questionContains?: InputMaybe<Scalars['String']['input']>;
  questionContainsFold?: InputMaybe<Scalars['String']['input']>;
  questionEqualFold?: InputMaybe<Scalars['String']['input']>;
  questionGT?: InputMaybe<Scalars['String']['input']>;
  questionGTE?: InputMaybe<Scalars['String']['input']>;
  /** question_guidance field predicates */
  questionGuidance?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceContains?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceContainsFold?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceEqualFold?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceGT?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceGTE?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  questionGuidanceLT?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceLTE?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceNEQ?: InputMaybe<Scalars['String']['input']>;
  questionGuidanceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  questionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  questionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  questionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  questionLT?: InputMaybe<Scalars['String']['input']>;
  questionLTE?: InputMaybe<Scalars['String']['input']>;
  questionNEQ?: InputMaybe<Scalars['String']['input']>;
  questionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** topic field predicates */
  topic?: InputMaybe<Scalars['String']['input']>;
  topicContains?: InputMaybe<Scalars['String']['input']>;
  topicContainsFold?: InputMaybe<Scalars['String']['input']>;
  topicEqualFold?: InputMaybe<Scalars['String']['input']>;
  topicGT?: InputMaybe<Scalars['String']['input']>;
  topicGTE?: InputMaybe<Scalars['String']['input']>;
  topicHasPrefix?: InputMaybe<Scalars['String']['input']>;
  topicHasSuffix?: InputMaybe<Scalars['String']['input']>;
  topicIn?: InputMaybe<Array<Scalars['String']['input']>>;
  topicLT?: InputMaybe<Scalars['String']['input']>;
  topicLTE?: InputMaybe<Scalars['String']['input']>;
  topicNEQ?: InputMaybe<Scalars['String']['input']>;
  topicNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SurveyScale = {
  __typename?: 'SurveyScale';
  classificationClass: SurveyClassificationClass;
  id: Scalars['ID']['output'];
  profile: SurveyProfile;
  upperLimit: Scalars['Int']['output'];
};

/**
 * SurveyScaleWhereInput is used for filtering SurveyScale objects.
 * Input was generated by ent.
 */
export type SurveyScaleWhereInput = {
  and?: InputMaybe<Array<SurveyScaleWhereInput>>;
  /** classification_class_id field predicates */
  classificationClassID?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDContains?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDGT?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDGTE?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  classificationClassIDLT?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDLTE?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** classification_class edge predicates */
  hasClassificationClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasClassificationClassWith?: InputMaybe<Array<SurveyClassificationClassWhereInput>>;
  /** profile edge predicates */
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfileWith?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<SurveyScaleWhereInput>;
  or?: InputMaybe<Array<SurveyScaleWhereInput>>;
  /** profile_id field predicates */
  profileID?: InputMaybe<Scalars['ID']['input']>;
  profileIDContains?: InputMaybe<Scalars['ID']['input']>;
  profileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDGT?: InputMaybe<Scalars['ID']['input']>;
  profileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  profileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  profileIDLT?: InputMaybe<Scalars['ID']['input']>;
  profileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  profileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** upper_limit field predicates */
  upperLimit?: InputMaybe<Scalars['Int']['input']>;
  upperLimitGT?: InputMaybe<Scalars['Int']['input']>;
  upperLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  upperLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  upperLimitLT?: InputMaybe<Scalars['Int']['input']>;
  upperLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  upperLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  upperLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum SurveySetStateStatus {
  Approve = 'APPROVE',
  Decline = 'DECLINE'
}

export enum SurveyStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Readyforapproval1 = 'READYFORAPPROVAL1',
  Readyforapproval2 = 'READYFORAPPROVAL2'
}

export type SurveyTemplate = {
  __typename?: 'SurveyTemplate';
  answers: Scalars['String']['output'];
  author: User;
  comment: Scalars['String']['output'];
  form: SurveyForm;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  profile: SurveyProfile;
};

export type SurveyTemplateConnection = {
  __typename?: 'SurveyTemplateConnection';
  edges: Array<SurveyTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyTemplateEdge = {
  __typename?: 'SurveyTemplateEdge';
  cursor: Scalars['Cursor']['output'];
  node: SurveyTemplate;
};

export type SurveyTemplateOrder = {
  direction: OrderDirection;
  field?: InputMaybe<SurveyTemplateOrderField>;
};

export enum SurveyTemplateOrderField {
  Authorid = 'AUTHORID',
  Createtime = 'CREATETIME',
  Formid = 'FORMID',
  Id = 'ID',
  Name = 'NAME',
  Organizationid = 'ORGANIZATIONID',
  Profileid = 'PROFILEID',
  Updatetime = 'UPDATETIME'
}

/**
 * SurveyTemplateWhereInput is used for filtering SurveyTemplate objects.
 * Input was generated by ent.
 */
export type SurveyTemplateWhereInput = {
  and?: InputMaybe<Array<SurveyTemplateWhereInput>>;
  /** answers field predicates */
  answers?: InputMaybe<Scalars['String']['input']>;
  answersContains?: InputMaybe<Scalars['String']['input']>;
  answersContainsFold?: InputMaybe<Scalars['String']['input']>;
  answersEqualFold?: InputMaybe<Scalars['String']['input']>;
  answersGT?: InputMaybe<Scalars['String']['input']>;
  answersGTE?: InputMaybe<Scalars['String']['input']>;
  answersHasPrefix?: InputMaybe<Scalars['String']['input']>;
  answersHasSuffix?: InputMaybe<Scalars['String']['input']>;
  answersIn?: InputMaybe<Array<Scalars['String']['input']>>;
  answersLT?: InputMaybe<Scalars['String']['input']>;
  answersLTE?: InputMaybe<Scalars['String']['input']>;
  answersNEQ?: InputMaybe<Scalars['String']['input']>;
  answersNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** author_id field predicates */
  authorID?: InputMaybe<Scalars['ID']['input']>;
  authorIDContains?: InputMaybe<Scalars['ID']['input']>;
  authorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDGT?: InputMaybe<Scalars['ID']['input']>;
  authorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  authorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  authorIDLT?: InputMaybe<Scalars['ID']['input']>;
  authorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  authorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** author edge predicates */
  hasAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hasAuthorWith?: InputMaybe<Array<UserWhereInput>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** profile edge predicates */
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfileWith?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SurveyTemplateWhereInput>;
  or?: InputMaybe<Array<SurveyTemplateWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContains?: InputMaybe<Scalars['ID']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** profile_id field predicates */
  profileID?: InputMaybe<Scalars['ID']['input']>;
  profileIDContains?: InputMaybe<Scalars['ID']['input']>;
  profileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDGT?: InputMaybe<Scalars['ID']['input']>;
  profileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  profileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  profileIDLT?: InputMaybe<Scalars['ID']['input']>;
  profileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  profileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SurveyTopicClusterType = {
  __typename?: 'SurveyTopicClusterType';
  calculationMethod: Scalars['String']['output'];
  form: SurveyForm;
  id: Scalars['ID']['output'];
  multiplier: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/**
 * SurveyTopicClusterTypeWhereInput is used for filtering SurveyTopicClusterType objects.
 * Input was generated by ent.
 */
export type SurveyTopicClusterTypeWhereInput = {
  and?: InputMaybe<Array<SurveyTopicClusterTypeWhereInput>>;
  /** calculation_method field predicates */
  calculationMethod?: InputMaybe<Scalars['String']['input']>;
  calculationMethodContains?: InputMaybe<Scalars['String']['input']>;
  calculationMethodContainsFold?: InputMaybe<Scalars['String']['input']>;
  calculationMethodEqualFold?: InputMaybe<Scalars['String']['input']>;
  calculationMethodGT?: InputMaybe<Scalars['String']['input']>;
  calculationMethodGTE?: InputMaybe<Scalars['String']['input']>;
  calculationMethodHasPrefix?: InputMaybe<Scalars['String']['input']>;
  calculationMethodHasSuffix?: InputMaybe<Scalars['String']['input']>;
  calculationMethodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  calculationMethodLT?: InputMaybe<Scalars['String']['input']>;
  calculationMethodLTE?: InputMaybe<Scalars['String']['input']>;
  calculationMethodNEQ?: InputMaybe<Scalars['String']['input']>;
  calculationMethodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** survey_form_contents edge predicates */
  hasSurveyFormContents?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyFormContentsWith?: InputMaybe<Array<SurveyFormContentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** multiplier field predicates */
  multiplier?: InputMaybe<Scalars['Int']['input']>;
  multiplierGT?: InputMaybe<Scalars['Int']['input']>;
  multiplierGTE?: InputMaybe<Scalars['Int']['input']>;
  multiplierIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  multiplierLT?: InputMaybe<Scalars['Int']['input']>;
  multiplierLTE?: InputMaybe<Scalars['Int']['input']>;
  multiplierNEQ?: InputMaybe<Scalars['Int']['input']>;
  multiplierNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SurveyTopicClusterTypeWhereInput>;
  or?: InputMaybe<Array<SurveyTopicClusterTypeWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * SurveyWhereInput is used for filtering Survey objects.
 * Input was generated by ent.
 */
export type SurveyWhereInput = {
  /** action_transition_log field predicates */
  actionTransitionLog?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogContains?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogContainsFold?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogEqualFold?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogGT?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogGTE?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogHasPrefix?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogHasSuffix?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogIn?: InputMaybe<Array<Scalars['String']['input']>>;
  actionTransitionLogLT?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogLTE?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogNEQ?: InputMaybe<Scalars['String']['input']>;
  actionTransitionLogNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<SurveyWhereInput>>;
  /** answers field predicates */
  answers?: InputMaybe<Scalars['String']['input']>;
  answersContains?: InputMaybe<Scalars['String']['input']>;
  answersContainsFold?: InputMaybe<Scalars['String']['input']>;
  answersEqualFold?: InputMaybe<Scalars['String']['input']>;
  answersGT?: InputMaybe<Scalars['String']['input']>;
  answersGTE?: InputMaybe<Scalars['String']['input']>;
  answersHasPrefix?: InputMaybe<Scalars['String']['input']>;
  answersHasSuffix?: InputMaybe<Scalars['String']['input']>;
  answersIn?: InputMaybe<Array<Scalars['String']['input']>>;
  answersLT?: InputMaybe<Scalars['String']['input']>;
  answersLTE?: InputMaybe<Scalars['String']['input']>;
  answersNEQ?: InputMaybe<Scalars['String']['input']>;
  answersNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** approved1_at field predicates */
  approved1At?: InputMaybe<Scalars['Time']['input']>;
  approved1AtGT?: InputMaybe<Scalars['Time']['input']>;
  approved1AtGTE?: InputMaybe<Scalars['Time']['input']>;
  approved1AtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved1AtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approved1AtLT?: InputMaybe<Scalars['Time']['input']>;
  approved1AtLTE?: InputMaybe<Scalars['Time']['input']>;
  approved1AtNEQ?: InputMaybe<Scalars['Time']['input']>;
  approved1AtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved1AtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approved2_at field predicates */
  approved2At?: InputMaybe<Scalars['Time']['input']>;
  approved2AtGT?: InputMaybe<Scalars['Time']['input']>;
  approved2AtGTE?: InputMaybe<Scalars['Time']['input']>;
  approved2AtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved2AtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approved2AtLT?: InputMaybe<Scalars['Time']['input']>;
  approved2AtLTE?: InputMaybe<Scalars['Time']['input']>;
  approved2AtNEQ?: InputMaybe<Scalars['Time']['input']>;
  approved2AtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved2AtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approver1_user_id field predicates */
  approver1UserID?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDContains?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDGT?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver1UserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approver1UserIDLT?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver1UserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approver2_user_id field predicates */
  approver2UserID?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDContains?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDGT?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver2UserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approver2UserIDLT?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver2UserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** author_id field predicates */
  authorID?: InputMaybe<Scalars['ID']['input']>;
  authorIDContains?: InputMaybe<Scalars['ID']['input']>;
  authorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDGT?: InputMaybe<Scalars['ID']['input']>;
  authorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  authorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  authorIDLT?: InputMaybe<Scalars['ID']['input']>;
  authorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  authorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** classification_class_id field predicates */
  classificationClassID?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDContains?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDGT?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDGTE?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  classificationClassIDLT?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDLTE?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  classificationClassIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** classification_score field predicates */
  classificationScore?: InputMaybe<Scalars['Int']['input']>;
  classificationScoreGT?: InputMaybe<Scalars['Int']['input']>;
  classificationScoreGTE?: InputMaybe<Scalars['Int']['input']>;
  classificationScoreIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  classificationScoreLT?: InputMaybe<Scalars['Int']['input']>;
  classificationScoreLTE?: InputMaybe<Scalars['Int']['input']>;
  classificationScoreNEQ?: InputMaybe<Scalars['Int']['input']>;
  classificationScoreNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** conducted_at field predicates */
  conductedAt?: InputMaybe<Scalars['Time']['input']>;
  conductedAtGT?: InputMaybe<Scalars['Time']['input']>;
  conductedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  conductedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  conductedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  conductedAtLT?: InputMaybe<Scalars['Time']['input']>;
  conductedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  conductedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  conductedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  conductedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** declined_at field predicates */
  declinedAt?: InputMaybe<Scalars['Time']['input']>;
  declinedAtGT?: InputMaybe<Scalars['Time']['input']>;
  declinedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  declinedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  declinedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  declinedAtLT?: InputMaybe<Scalars['Time']['input']>;
  declinedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  declinedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  declinedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  declinedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** decliner_user_id field predicates */
  declinerUserID?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDContains?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  declinerUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  declinerUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  declinerUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  declinerUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_document_id field predicates */
  externalDocumentID?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDContains?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDGT?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalDocumentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalDocumentIDLT?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalDocumentIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalDocumentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** form_id field predicates */
  formID?: InputMaybe<Scalars['ID']['input']>;
  formIDContains?: InputMaybe<Scalars['ID']['input']>;
  formIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  formIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  formIDGT?: InputMaybe<Scalars['ID']['input']>;
  formIDGTE?: InputMaybe<Scalars['ID']['input']>;
  formIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  formIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  formIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  formIDLT?: InputMaybe<Scalars['ID']['input']>;
  formIDLTE?: InputMaybe<Scalars['ID']['input']>;
  formIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  formIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** approver1_user edge predicates */
  hasApprover1User?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprover1UserWith?: InputMaybe<Array<UserWhereInput>>;
  /** approver2_user edge predicates */
  hasApprover2User?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprover2UserWith?: InputMaybe<Array<UserWhereInput>>;
  /** author edge predicates */
  hasAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hasAuthorWith?: InputMaybe<Array<UserWhereInput>>;
  /** classification_class edge predicates */
  hasClassificationClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasClassificationClassWith?: InputMaybe<Array<SurveyClassificationClassWhereInput>>;
  /** decliner_user edge predicates */
  hasDeclinerUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeclinerUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** profile edge predicates */
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfileWith?: InputMaybe<Array<SurveyProfileWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_approved field predicates */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isApprovedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SurveyWhereInput>;
  /** optimistic_lock_version field predicates */
  optimisticLockVersion?: InputMaybe<Scalars['Int']['input']>;
  optimisticLockVersionGT?: InputMaybe<Scalars['Int']['input']>;
  optimisticLockVersionGTE?: InputMaybe<Scalars['Int']['input']>;
  optimisticLockVersionIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  optimisticLockVersionLT?: InputMaybe<Scalars['Int']['input']>;
  optimisticLockVersionLTE?: InputMaybe<Scalars['Int']['input']>;
  optimisticLockVersionNEQ?: InputMaybe<Scalars['Int']['input']>;
  optimisticLockVersionNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  or?: InputMaybe<Array<SurveyWhereInput>>;
  /** profile_id field predicates */
  profileID?: InputMaybe<Scalars['ID']['input']>;
  profileIDContains?: InputMaybe<Scalars['ID']['input']>;
  profileIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  profileIDGT?: InputMaybe<Scalars['ID']['input']>;
  profileIDGTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  profileIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  profileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  profileIDLT?: InputMaybe<Scalars['ID']['input']>;
  profileIDLTE?: InputMaybe<Scalars['ID']['input']>;
  profileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  profileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<SurveyStatus>;
  statusIn?: InputMaybe<Array<SurveyStatus>>;
  statusNEQ?: InputMaybe<SurveyStatus>;
  statusNotIn?: InputMaybe<Array<SurveyStatus>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Tra = {
  __typename?: 'TRA';
  approved1At?: Maybe<Scalars['Time']['output']>;
  approved2At?: Maybe<Scalars['Time']['output']>;
  approver1?: Maybe<User>;
  approver2?: Maybe<User>;
  body: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  history?: Maybe<Array<Maybe<TraHistory>>>;
  id: Scalars['ID']['output'];
  lockedAt?: Maybe<Scalars['Time']['output']>;
  lockedBy?: Maybe<User>;
  metadata?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<TraParticipant>>;
  project: Project;
  reports?: Maybe<Array<TraReport>>;
  status: TraStatus;
  title: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['Time']['output']>;
};

export type TraConnection = {
  __typename?: 'TRAConnection';
  edges: Array<TraEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TraEdge = {
  __typename?: 'TRAEdge';
  cursor: Scalars['Cursor']['output'];
  node: Tra;
};

export type TraHistory = {
  __typename?: 'TRAHistory';
  comment?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  status: TraHistoryStatus;
  tra: Tra;
  updateTime?: Maybe<Scalars['Time']['output']>;
  user: User;
};

export enum TraHistoryStatus {
  Approve = 'APPROVE',
  Decline = 'DECLINE'
}

/**
 * TRAHistoryWhereInput is used for filtering TRAHistory objects.
 * Input was generated by ent.
 */
export type TraHistoryWhereInput = {
  and?: InputMaybe<Array<TraHistoryWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** tra edge predicates */
  hasTra?: InputMaybe<Scalars['Boolean']['input']>;
  hasTraWith?: InputMaybe<Array<TraWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TraHistoryWhereInput>;
  or?: InputMaybe<Array<TraHistoryWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<TraHistoryStatus>;
  statusIn?: InputMaybe<Array<TraHistoryStatus>>;
  statusNEQ?: InputMaybe<TraHistoryStatus>;
  statusNotIn?: InputMaybe<Array<TraHistoryStatus>>;
  /** tra_id field predicates */
  traID?: InputMaybe<Scalars['ID']['input']>;
  traIDContains?: InputMaybe<Scalars['ID']['input']>;
  traIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  traIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  traIDGT?: InputMaybe<Scalars['ID']['input']>;
  traIDGTE?: InputMaybe<Scalars['ID']['input']>;
  traIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  traIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  traIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  traIDLT?: InputMaybe<Scalars['ID']['input']>;
  traIDLTE?: InputMaybe<Scalars['ID']['input']>;
  traIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  traIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TraOrder = {
  direction: OrderDirection;
  field?: InputMaybe<TraOrderField>;
};

export enum TraOrderField {
  Approved1At = 'APPROVED1AT',
  Approved2At = 'APPROVED2AT',
  Createdbyid = 'CREATEDBYID',
  Id = 'ID',
  Lockedat = 'LOCKEDAT',
  Lockedbyid = 'LOCKEDBYID',
  Projectid = 'PROJECTID',
  Status = 'STATUS',
  Title = 'TITLE'
}

export type TraParticipant = {
  __typename?: 'TRAParticipant';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  tra: Tra;
  updateTime?: Maybe<Scalars['Time']['output']>;
  user: User;
};

/**
 * TRAParticipantWhereInput is used for filtering TRAParticipant objects.
 * Input was generated by ent.
 */
export type TraParticipantWhereInput = {
  and?: InputMaybe<Array<TraParticipantWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** tra edge predicates */
  hasTra?: InputMaybe<Scalars['Boolean']['input']>;
  hasTraWith?: InputMaybe<Array<TraWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TraParticipantWhereInput>;
  or?: InputMaybe<Array<TraParticipantWhereInput>>;
  /** tra_id field predicates */
  traID?: InputMaybe<Scalars['ID']['input']>;
  traIDContains?: InputMaybe<Scalars['ID']['input']>;
  traIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  traIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  traIDGT?: InputMaybe<Scalars['ID']['input']>;
  traIDGTE?: InputMaybe<Scalars['ID']['input']>;
  traIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  traIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  traIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  traIDLT?: InputMaybe<Scalars['ID']['input']>;
  traIDLTE?: InputMaybe<Scalars['ID']['input']>;
  traIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  traIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TraReport = {
  __typename?: 'TRAReport';
  author: User;
  classification: TraReportClassification;
  createTime: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  tra: Tra;
};

export enum TraReportClassification {
  Confidential = 'CONFIDENTIAL',
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export enum TraReportExtension {
  Csv = 'csv',
  Docx = 'docx',
  Pdf = 'pdf',
  Xlsx = 'xlsx'
}

/**
 * TRAReportWhereInput is used for filtering TRAReport objects.
 * Input was generated by ent.
 */
export type TraReportWhereInput = {
  and?: InputMaybe<Array<TraReportWhereInput>>;
  /** author_id field predicates */
  authorID?: InputMaybe<Scalars['ID']['input']>;
  authorIDContains?: InputMaybe<Scalars['ID']['input']>;
  authorIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  authorIDGT?: InputMaybe<Scalars['ID']['input']>;
  authorIDGTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  authorIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  authorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  authorIDLT?: InputMaybe<Scalars['ID']['input']>;
  authorIDLTE?: InputMaybe<Scalars['ID']['input']>;
  authorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  authorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** classification field predicates */
  classification?: InputMaybe<TraReportClassification>;
  classificationIn?: InputMaybe<Array<TraReportClassification>>;
  classificationNEQ?: InputMaybe<TraReportClassification>;
  classificationNotIn?: InputMaybe<Array<TraReportClassification>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** extension field predicates */
  extension?: InputMaybe<Scalars['String']['input']>;
  extensionContains?: InputMaybe<Scalars['String']['input']>;
  extensionContainsFold?: InputMaybe<Scalars['String']['input']>;
  extensionEqualFold?: InputMaybe<Scalars['String']['input']>;
  extensionGT?: InputMaybe<Scalars['String']['input']>;
  extensionGTE?: InputMaybe<Scalars['String']['input']>;
  extensionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  extensionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  extensionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  extensionLT?: InputMaybe<Scalars['String']['input']>;
  extensionLTE?: InputMaybe<Scalars['String']['input']>;
  extensionNEQ?: InputMaybe<Scalars['String']['input']>;
  extensionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** author edge predicates */
  hasAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hasAuthorWith?: InputMaybe<Array<UserWhereInput>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** tra edge predicates */
  hasTra?: InputMaybe<Scalars['Boolean']['input']>;
  hasTraWith?: InputMaybe<Array<TraWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TraReportWhereInput>;
  or?: InputMaybe<Array<TraReportWhereInput>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** tra_id field predicates */
  traID?: InputMaybe<Scalars['ID']['input']>;
  traIDContains?: InputMaybe<Scalars['ID']['input']>;
  traIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  traIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  traIDGT?: InputMaybe<Scalars['ID']['input']>;
  traIDGTE?: InputMaybe<Scalars['ID']['input']>;
  traIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  traIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  traIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  traIDLT?: InputMaybe<Scalars['ID']['input']>;
  traIDLTE?: InputMaybe<Scalars['ID']['input']>;
  traIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  traIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum TraSetStateStatus {
  Approve = 'APPROVE',
  Decline = 'DECLINE'
}

export enum TraStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Inprogress = 'INPROGRESS',
  Readyforapproval1 = 'READYFORAPPROVAL1',
  Readyforapproval2 = 'READYFORAPPROVAL2'
}

export type TraTemplate = {
  __typename?: 'TRATemplate';
  body: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type TraTemplateConnection = {
  __typename?: 'TRATemplateConnection';
  edges: Array<TraTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TraTemplateEdge = {
  __typename?: 'TRATemplateEdge';
  cursor: Scalars['Cursor']['output'];
  node: TraTemplate;
};

export type TraTemplateOrder = {
  direction: OrderDirection;
  field?: InputMaybe<TraTemplateOrderField>;
};

export enum TraTemplateOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Title = 'TITLE',
  Variant = 'VARIANT'
}

/**
 * TRATemplateWhereInput is used for filtering TRATemplate objects.
 * Input was generated by ent.
 */
export type TraTemplateWhereInput = {
  and?: InputMaybe<Array<TraTemplateWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  bodyContains?: InputMaybe<Scalars['String']['input']>;
  bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyGT?: InputMaybe<Scalars['String']['input']>;
  bodyGTE?: InputMaybe<Scalars['String']['input']>;
  bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyLT?: InputMaybe<Scalars['String']['input']>;
  bodyLTE?: InputMaybe<Scalars['String']['input']>;
  bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TraTemplateWhereInput>;
  or?: InputMaybe<Array<TraTemplateWhereInput>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** variant field predicates */
  variant?: InputMaybe<Scalars['String']['input']>;
  variantContains?: InputMaybe<Scalars['String']['input']>;
  variantContainsFold?: InputMaybe<Scalars['String']['input']>;
  variantEqualFold?: InputMaybe<Scalars['String']['input']>;
  variantGT?: InputMaybe<Scalars['String']['input']>;
  variantGTE?: InputMaybe<Scalars['String']['input']>;
  variantHasPrefix?: InputMaybe<Scalars['String']['input']>;
  variantHasSuffix?: InputMaybe<Scalars['String']['input']>;
  variantIn?: InputMaybe<Array<Scalars['String']['input']>>;
  variantLT?: InputMaybe<Scalars['String']['input']>;
  variantLTE?: InputMaybe<Scalars['String']['input']>;
  variantNEQ?: InputMaybe<Scalars['String']['input']>;
  variantNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TRAWhereInput is used for filtering TRA objects.
 * Input was generated by ent.
 */
export type TraWhereInput = {
  and?: InputMaybe<Array<TraWhereInput>>;
  /** approved1_at field predicates */
  approved1At?: InputMaybe<Scalars['Time']['input']>;
  approved1AtGT?: InputMaybe<Scalars['Time']['input']>;
  approved1AtGTE?: InputMaybe<Scalars['Time']['input']>;
  approved1AtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved1AtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approved1AtLT?: InputMaybe<Scalars['Time']['input']>;
  approved1AtLTE?: InputMaybe<Scalars['Time']['input']>;
  approved1AtNEQ?: InputMaybe<Scalars['Time']['input']>;
  approved1AtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved1AtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approved2_at field predicates */
  approved2At?: InputMaybe<Scalars['Time']['input']>;
  approved2AtGT?: InputMaybe<Scalars['Time']['input']>;
  approved2AtGTE?: InputMaybe<Scalars['Time']['input']>;
  approved2AtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved2AtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approved2AtLT?: InputMaybe<Scalars['Time']['input']>;
  approved2AtLTE?: InputMaybe<Scalars['Time']['input']>;
  approved2AtNEQ?: InputMaybe<Scalars['Time']['input']>;
  approved2AtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approved2AtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approver1_user_id field predicates */
  approver1UserID?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDContains?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDGT?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver1UserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approver1UserIDLT?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approver1UserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver1UserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approver2_user_id field predicates */
  approver2UserID?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDContains?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDGT?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver2UserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approver2UserIDLT?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approver2UserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approver2UserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  bodyContains?: InputMaybe<Scalars['String']['input']>;
  bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyGT?: InputMaybe<Scalars['String']['input']>;
  bodyGTE?: InputMaybe<Scalars['String']['input']>;
  bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyLT?: InputMaybe<Scalars['String']['input']>;
  bodyLTE?: InputMaybe<Scalars['String']['input']>;
  bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContains?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDLT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDLTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** approver1 edge predicates */
  hasApprover1?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprover1With?: InputMaybe<Array<UserWhereInput>>;
  /** approver2 edge predicates */
  hasApprover2?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprover2With?: InputMaybe<Array<UserWhereInput>>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** history edge predicates */
  hasHistory?: InputMaybe<Scalars['Boolean']['input']>;
  hasHistoryWith?: InputMaybe<Array<TraHistoryWhereInput>>;
  /** locked_by edge predicates */
  hasLockedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasLockedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** participants edge predicates */
  hasParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  hasParticipantsWith?: InputMaybe<Array<TraParticipantWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** reports edge predicates */
  hasReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportsWith?: InputMaybe<Array<TraReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** locked_at field predicates */
  lockedAt?: InputMaybe<Scalars['Time']['input']>;
  lockedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lockedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lockedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lockedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lockedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lockedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lockedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lockedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** locked_by_id field predicates */
  lockedByID?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDContains?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDGT?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDGTE?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  lockedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lockedByIDLT?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDLTE?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  lockedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  lockedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** metadata field predicates */
  metadata?: InputMaybe<Scalars['String']['input']>;
  metadataContains?: InputMaybe<Scalars['String']['input']>;
  metadataContainsFold?: InputMaybe<Scalars['String']['input']>;
  metadataEqualFold?: InputMaybe<Scalars['String']['input']>;
  metadataGT?: InputMaybe<Scalars['String']['input']>;
  metadataGTE?: InputMaybe<Scalars['String']['input']>;
  metadataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  metadataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  metadataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  metadataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  metadataLT?: InputMaybe<Scalars['String']['input']>;
  metadataLTE?: InputMaybe<Scalars['String']['input']>;
  metadataNEQ?: InputMaybe<Scalars['String']['input']>;
  metadataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  metadataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TraWhereInput>;
  or?: InputMaybe<Array<TraWhereInput>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<TraStatus>;
  statusIn?: InputMaybe<Array<TraStatus>>;
  statusNEQ?: InputMaybe<TraStatus>;
  statusNotIn?: InputMaybe<Array<TraStatus>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * TagWhereInput is used for filtering Tag objects.
 * Input was generated by ent.
 */
export type TagWhereInput = {
  and?: InputMaybe<Array<TagWhereInput>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** requirements edge predicates */
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequirementsWith?: InputMaybe<Array<RequirementWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<TagWhereInput>;
  or?: InputMaybe<Array<TagWhereInput>>;
};

export type Task = {
  __typename?: 'Task';
  assignee?: Maybe<User>;
  createTime: Scalars['Time']['output'];
  deliverables: Array<TaskDeliverable>;
  description: Scalars['String']['output'];
  dueAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isApplicable: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  kind: TaskKind;
  parentTask?: Maybe<Task>;
  priority?: Maybe<TaskPriority>;
  project: Project;
  projectMilestone?: Maybe<ProjectMilestone>;
  referenceDocuments: Scalars['String']['output'];
  source: TaskSource;
  startAt?: Maybe<Scalars['Time']['output']>;
  status: TaskStatus;
  subtasks?: Maybe<Array<Task>>;
  taskComments: Array<TaskComment>;
  taskEvidences: Array<TaskEvidence>;
  title: Scalars['String']['output'];
  topic?: Maybe<TaskTopic>;
  updateTime: Scalars['Time']['output'];
};

export type TaskComment = {
  __typename?: 'TaskComment';
  content: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  fileAsset?: Maybe<FileAsset>;
  id: Scalars['ID']['output'];
  task: Task;
  updateTime: Scalars['Time']['output'];
  user: User;
};

/**
 * TaskCommentWhereInput is used for filtering TaskComment objects.
 * Input was generated by ent.
 */
export type TaskCommentWhereInput = {
  and?: InputMaybe<Array<TaskCommentWhereInput>>;
  /** content field predicates */
  content?: InputMaybe<Scalars['String']['input']>;
  contentContains?: InputMaybe<Scalars['String']['input']>;
  contentContainsFold?: InputMaybe<Scalars['String']['input']>;
  contentEqualFold?: InputMaybe<Scalars['String']['input']>;
  contentGT?: InputMaybe<Scalars['String']['input']>;
  contentGTE?: InputMaybe<Scalars['String']['input']>;
  contentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentLT?: InputMaybe<Scalars['String']['input']>;
  contentLTE?: InputMaybe<Scalars['String']['input']>;
  contentNEQ?: InputMaybe<Scalars['String']['input']>;
  contentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** task edge predicates */
  hasTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskWith?: InputMaybe<Array<TaskWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TaskCommentWhereInput>;
  or?: InputMaybe<Array<TaskCommentWhereInput>>;
  /** task_id field predicates */
  taskID?: InputMaybe<Scalars['ID']['input']>;
  taskIDContains?: InputMaybe<Scalars['ID']['input']>;
  taskIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  taskIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  taskIDGT?: InputMaybe<Scalars['ID']['input']>;
  taskIDGTE?: InputMaybe<Scalars['ID']['input']>;
  taskIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  taskIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  taskIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIDLT?: InputMaybe<Scalars['ID']['input']>;
  taskIDLTE?: InputMaybe<Scalars['ID']['input']>;
  taskIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  taskIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TaskConnection = {
  __typename?: 'TaskConnection';
  edges: Array<TaskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskDeliverable = {
  __typename?: 'TaskDeliverable';
  createTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isChecked: Scalars['Boolean']['output'];
  task: Task;
  title: Scalars['String']['output'];
  updateTime: Scalars['Time']['output'];
};

export type TaskDeliverableOrder = {
  direction: OrderDirection;
  field?: InputMaybe<TaskDeliverableOrderField>;
};

export enum TaskDeliverableOrderField {
  Ischecked = 'ISCHECKED',
  Title = 'TITLE'
}

/**
 * TaskDeliverableWhereInput is used for filtering TaskDeliverable objects.
 * Input was generated by ent.
 */
export type TaskDeliverableWhereInput = {
  and?: InputMaybe<Array<TaskDeliverableWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** task edge predicates */
  hasTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskWith?: InputMaybe<Array<TaskWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_checked field predicates */
  isChecked?: InputMaybe<Scalars['Boolean']['input']>;
  isCheckedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TaskDeliverableWhereInput>;
  or?: InputMaybe<Array<TaskDeliverableWhereInput>>;
  /** task_id field predicates */
  taskID?: InputMaybe<Scalars['ID']['input']>;
  taskIDContains?: InputMaybe<Scalars['ID']['input']>;
  taskIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  taskIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  taskIDGT?: InputMaybe<Scalars['ID']['input']>;
  taskIDGTE?: InputMaybe<Scalars['ID']['input']>;
  taskIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  taskIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  taskIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIDLT?: InputMaybe<Scalars['ID']['input']>;
  taskIDLTE?: InputMaybe<Scalars['ID']['input']>;
  taskIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  taskIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type TaskEdge = {
  __typename?: 'TaskEdge';
  cursor: Scalars['Cursor']['output'];
  node: Task;
};

export type TaskEvidence = {
  __typename?: 'TaskEvidence';
  createTime: Scalars['Time']['output'];
  createdBy: User;
  fileAsset?: Maybe<FileAsset>;
  id: Scalars['ID']['output'];
  kind: TaskEvidenceKind;
  link?: Maybe<Scalars['String']['output']>;
  task: Task;
  updateTime: Scalars['Time']['output'];
};

export enum TaskEvidenceKind {
  File = 'FILE',
  Link = 'LINK'
}

/**
 * TaskEvidenceWhereInput is used for filtering TaskEvidence objects.
 * Input was generated by ent.
 */
export type TaskEvidenceWhereInput = {
  and?: InputMaybe<Array<TaskEvidenceWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContains?: InputMaybe<Scalars['ID']['input']>;
  createdByIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDGTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDLT?: InputMaybe<Scalars['ID']['input']>;
  createdByIDLTE?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file_asset_id field predicates */
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContains?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileAssetIDLT?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileAssetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileAssetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** file_asset edge predicates */
  hasFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileAssetWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** task edge predicates */
  hasTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskWith?: InputMaybe<Array<TaskWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<TaskEvidenceKind>;
  kindIn?: InputMaybe<Array<TaskEvidenceKind>>;
  kindNEQ?: InputMaybe<TaskEvidenceKind>;
  kindNotIn?: InputMaybe<Array<TaskEvidenceKind>>;
  /** link field predicates */
  link?: InputMaybe<Scalars['String']['input']>;
  linkContains?: InputMaybe<Scalars['String']['input']>;
  linkContainsFold?: InputMaybe<Scalars['String']['input']>;
  linkEqualFold?: InputMaybe<Scalars['String']['input']>;
  linkGT?: InputMaybe<Scalars['String']['input']>;
  linkGTE?: InputMaybe<Scalars['String']['input']>;
  linkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  linkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  linkIn?: InputMaybe<Array<Scalars['String']['input']>>;
  linkIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  linkLT?: InputMaybe<Scalars['String']['input']>;
  linkLTE?: InputMaybe<Scalars['String']['input']>;
  linkNEQ?: InputMaybe<Scalars['String']['input']>;
  linkNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  linkNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TaskEvidenceWhereInput>;
  or?: InputMaybe<Array<TaskEvidenceWhereInput>>;
  /** task_id field predicates */
  taskID?: InputMaybe<Scalars['ID']['input']>;
  taskIDContains?: InputMaybe<Scalars['ID']['input']>;
  taskIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  taskIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  taskIDGT?: InputMaybe<Scalars['ID']['input']>;
  taskIDGTE?: InputMaybe<Scalars['ID']['input']>;
  taskIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  taskIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  taskIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIDLT?: InputMaybe<Scalars['ID']['input']>;
  taskIDLTE?: InputMaybe<Scalars['ID']['input']>;
  taskIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  taskIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum TaskKind {
  Task = 'TASK',
  Workcycle = 'WORKCYCLE'
}

export type TaskOrder = {
  direction: OrderDirection;
  field?: InputMaybe<TaskOrderField>;
};

export enum TaskOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Kind = 'KIND',
  Name = 'NAME',
  Priority = 'PRIORITY',
  Updatetime = 'UPDATETIME'
}

export enum TaskPriority {
  P01Veryhigh = 'P01VERYHIGH',
  P02High = 'P02HIGH',
  P03Medium = 'P03MEDIUM',
  P04Low = 'P04LOW'
}

export type TaskReadModel = {
  __typename?: 'TaskReadModel';
  assigneeID?: Maybe<Scalars['ID']['output']>;
  createTime: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priority: TaskPriority;
  projectMilestoneID?: Maybe<Scalars['ID']['output']>;
  status: TaskStatus;
  title: Scalars['String']['output'];
  updateTime: Scalars['Time']['output'];
};

export enum TaskSource {
  Manual = 'MANUAL',
  Notification = 'NOTIFICATION',
  Template = 'TEMPLATE',
  Tra = 'TRA'
}

export enum TaskStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Notstarted = 'NOTSTARTED',
  Onhold = 'ONHOLD'
}

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  createTime: Scalars['Time']['output'];
  deliverables: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMandatory: Scalars['Boolean']['output'];
  priority: TaskTemplatePriority;
  projectGuidanceRequirements: Array<ProjectGuidanceRequirement>;
  referenceDocuments: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topic: TaskTemplateTopic;
  updateTime: Scalars['Time']['output'];
};

export type TaskTemplateConnection = {
  __typename?: 'TaskTemplateConnection';
  edges: Array<TaskTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskTemplateEdge = {
  __typename?: 'TaskTemplateEdge';
  cursor: Scalars['Cursor']['output'];
  node: TaskTemplate;
};

export type TaskTemplateOrder = {
  direction: OrderDirection;
  field?: InputMaybe<TaskTemplateOrderField>;
};

export enum TaskTemplateOrderField {
  Createtime = 'CREATETIME',
  Id = 'ID',
  Priority = 'PRIORITY',
  Title = 'TITLE',
  Topic = 'TOPIC',
  Updatetime = 'UPDATETIME'
}

export enum TaskTemplatePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Veryhigh = 'VERYHIGH'
}

export enum TaskTemplateTopic {
  Projectsecurity = 'PROJECTSECURITY',
  Requirementsengineering = 'REQUIREMENTSENGINEERING',
  Riskassessment = 'RISKASSESSMENT',
  Vulnerabilitymanagement = 'VULNERABILITYMANAGEMENT'
}

/**
 * TaskTemplateWhereInput is used for filtering TaskTemplate objects.
 * Input was generated by ent.
 */
export type TaskTemplateWhereInput = {
  and?: InputMaybe<Array<TaskTemplateWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deliverables field predicates */
  deliverables?: InputMaybe<Scalars['String']['input']>;
  deliverablesContains?: InputMaybe<Scalars['String']['input']>;
  deliverablesContainsFold?: InputMaybe<Scalars['String']['input']>;
  deliverablesEqualFold?: InputMaybe<Scalars['String']['input']>;
  deliverablesGT?: InputMaybe<Scalars['String']['input']>;
  deliverablesGTE?: InputMaybe<Scalars['String']['input']>;
  deliverablesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deliverablesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deliverablesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverablesLT?: InputMaybe<Scalars['String']['input']>;
  deliverablesLTE?: InputMaybe<Scalars['String']['input']>;
  deliverablesNEQ?: InputMaybe<Scalars['String']['input']>;
  deliverablesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** project_guidance_requirements edge predicates */
  hasProjectGuidanceRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectGuidanceRequirementsWith?: InputMaybe<Array<ProjectGuidanceRequirementWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TaskTemplateWhereInput>;
  or?: InputMaybe<Array<TaskTemplateWhereInput>>;
  /** priority field predicates */
  priority?: InputMaybe<TaskTemplatePriority>;
  priorityIn?: InputMaybe<Array<TaskTemplatePriority>>;
  priorityNEQ?: InputMaybe<TaskTemplatePriority>;
  priorityNotIn?: InputMaybe<Array<TaskTemplatePriority>>;
  /** reference_documents field predicates */
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsContains?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsContainsFold?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsEqualFold?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsGT?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsGTE?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceDocumentsLT?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsLTE?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsNEQ?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** topic field predicates */
  topic?: InputMaybe<TaskTemplateTopic>;
  topicIn?: InputMaybe<Array<TaskTemplateTopic>>;
  topicIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  topicNEQ?: InputMaybe<TaskTemplateTopic>;
  topicNotIn?: InputMaybe<Array<TaskTemplateTopic>>;
  topicNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type TaskTemplatesImportSummary = {
  __typename?: 'TaskTemplatesImportSummary';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  successful: Scalars['Int']['output'];
  templatesCreated: Scalars['Int']['output'];
  templatesUpdated: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unsuccessful: Scalars['Int']['output'];
};

export enum TaskTopic {
  Projectsecurity = 'PROJECTSECURITY',
  Requirementsengineering = 'REQUIREMENTSENGINEERING',
  Riskassessment = 'RISKASSESSMENT',
  Vulnerabilitymanagement = 'VULNERABILITYMANAGEMENT'
}

/**
 * TaskWhereInput is used for filtering Task objects.
 * Input was generated by ent.
 */
export type TaskWhereInput = {
  and?: InputMaybe<Array<TaskWhereInput>>;
  /** assignee_id field predicates */
  assigneeID?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDContains?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDGT?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assigneeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeIDLT?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assigneeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assigneeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** due_at field predicates */
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  dueAtGT?: InputMaybe<Scalars['Time']['input']>;
  dueAtGTE?: InputMaybe<Scalars['Time']['input']>;
  dueAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dueAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dueAtLT?: InputMaybe<Scalars['Time']['input']>;
  dueAtLTE?: InputMaybe<Scalars['Time']['input']>;
  dueAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  dueAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dueAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assignee edge predicates */
  hasAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssigneeWith?: InputMaybe<Array<UserWhereInput>>;
  /** deliverables edge predicates */
  hasDeliverables?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliverablesWith?: InputMaybe<Array<TaskDeliverableWhereInput>>;
  /** mitigations edge predicates */
  hasMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationsWith?: InputMaybe<Array<MitigationWhereInput>>;
  /** parent_task edge predicates */
  hasParentTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentTaskWith?: InputMaybe<Array<TaskWhereInput>>;
  /** project edge predicates */
  hasProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** project_milestone edge predicates */
  hasProjectMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectMilestoneWith?: InputMaybe<Array<ProjectMilestoneWhereInput>>;
  hasProjectWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** subtasks edge predicates */
  hasSubtasks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubtasksWith?: InputMaybe<Array<TaskWhereInput>>;
  /** task_comments edge predicates */
  hasTaskComments?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskCommentsWith?: InputMaybe<Array<TaskCommentWhereInput>>;
  /** task_evidences edge predicates */
  hasTaskEvidences?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskEvidencesWith?: InputMaybe<Array<TaskEvidenceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_applicable field predicates */
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicableNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_mandatory field predicates */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatoryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<TaskKind>;
  kindIn?: InputMaybe<Array<TaskKind>>;
  kindNEQ?: InputMaybe<TaskKind>;
  kindNotIn?: InputMaybe<Array<TaskKind>>;
  /** last_changed_at field predicates */
  lastChangedAt?: InputMaybe<Scalars['Time']['input']>;
  lastChangedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastChangedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastChangedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastChangedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastChangedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastChangedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastChangedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastChangedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastChangedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TaskWhereInput>;
  or?: InputMaybe<Array<TaskWhereInput>>;
  /** parent_task_id field predicates */
  parentTaskID?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDContains?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDGT?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDGTE?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentTaskIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentTaskIDLT?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDLTE?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentTaskIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentTaskIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** priority field predicates */
  priority?: InputMaybe<TaskPriority>;
  priorityIn?: InputMaybe<Array<TaskPriority>>;
  priorityNEQ?: InputMaybe<TaskPriority>;
  priorityNotIn?: InputMaybe<Array<TaskPriority>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** project_milestone_id field predicates */
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDContains?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDGT?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDGTE?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectMilestoneIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectMilestoneIDLT?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDLTE?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectMilestoneIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** reference_documents field predicates */
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsContains?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsContainsFold?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsEqualFold?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsGT?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsGTE?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceDocumentsLT?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsLTE?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsNEQ?: InputMaybe<Scalars['String']['input']>;
  referenceDocumentsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** source field predicates */
  source?: InputMaybe<TaskSource>;
  /** source_id field predicates */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceIn?: InputMaybe<Array<TaskSource>>;
  sourceNEQ?: InputMaybe<TaskSource>;
  sourceNotIn?: InputMaybe<Array<TaskSource>>;
  /** start_at field predicates */
  startAt?: InputMaybe<Scalars['Time']['input']>;
  startAtGT?: InputMaybe<Scalars['Time']['input']>;
  startAtGTE?: InputMaybe<Scalars['Time']['input']>;
  startAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startAtLT?: InputMaybe<Scalars['Time']['input']>;
  startAtLTE?: InputMaybe<Scalars['Time']['input']>;
  startAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  startAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<TaskStatus>;
  statusIn?: InputMaybe<Array<TaskStatus>>;
  statusNEQ?: InputMaybe<TaskStatus>;
  statusNotIn?: InputMaybe<Array<TaskStatus>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** topic field predicates */
  topic?: InputMaybe<TaskTopic>;
  topicIn?: InputMaybe<Array<TaskTopic>>;
  topicIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  topicNEQ?: InputMaybe<TaskTopic>;
  topicNotIn?: InputMaybe<Array<TaskTopic>>;
  topicNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * UpdateAreInput is used for update Are object.
 * Input was generated by ent.
 */
export type UpdateAreInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAssetAttributeDefinitionInput is used for update AssetAttributeDefinition object.
 * Input was generated by ent.
 */
export type UpdateAssetAttributeDefinitionInput = {
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAssetAttributeDefinitionSequenceRawInput = {
  id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};

/**
 * UpdateAssetAttributeInput is used for update AssetAttribute object.
 * Input was generated by ent.
 */
export type UpdateAssetAttributeInput = {
  assetAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  assetID?: InputMaybe<Scalars['ID']['input']>;
  clearValue?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetAttributeRawInput = {
  assetAttributeDefinitionID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetBulkInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  attributes?: InputMaybe<Array<UpdateAssetAttributeRawInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<AssetStatus>;
  systemRating?: InputMaybe<AssetSystemRating>;
};

/**
 * UpdateAssetInput is used for update Asset object.
 * Input was generated by ent.
 */
export type UpdateAssetInput = {
  addAssetAttributeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  alias?: InputMaybe<Scalars['String']['input']>;
  assetTypeID?: InputMaybe<Scalars['ID']['input']>;
  clearAlias?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  removeAssetAttributeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<AssetStatus>;
  systemRating?: InputMaybe<AssetSystemRating>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateAssetItemAttributeDefinitionInput is used for update AssetItemAttributeDefinition object.
 * Input was generated by ent.
 */
export type UpdateAssetItemAttributeDefinitionInput = {
  assetItemType?: InputMaybe<AssetItemAttributeDefinitionAssetItemType>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAssetItemAttributeDefinitionSequenceRawInput = {
  id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};

/**
 * UpdateAssetItemAttributeInput is used for update AssetItemAttribute object.
 * Input was generated by ent.
 */
export type UpdateAssetItemAttributeInput = {
  assetItemAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  assetItemID?: InputMaybe<Scalars['ID']['input']>;
  clearValue?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetItemAttributeRawInput = {
  assetItemAttributeDefinitionID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetItemBulkInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  attributes?: InputMaybe<Array<UpdateAssetItemAttributeRawInput>>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AssetItemType>;
};

/**
 * UpdateAssetItemInput is used for update AssetItem object.
 * Input was generated by ent.
 */
export type UpdateAssetItemInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  clearComponent?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AssetItemType>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateAssetRelationAttributeDefinitionInput is used for update AssetRelationAttributeDefinition object.
 * Input was generated by ent.
 */
export type UpdateAssetRelationAttributeDefinitionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<AssetRelationAttributeDefinitionObjectType>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<AssetRelationAttributeDefinitionRelationType>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AssetRelationAttributeDefinitionType>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateAssetRelationAttributeDefinitionTemplateInput is used for update AssetRelationAttributeDefinitionTemplate object.
 * Input was generated by ent.
 */
export type UpdateAssetRelationAttributeDefinitionTemplateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<AssetRelationAttributeDefinitionTemplateObjectType>;
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<AssetRelationAttributeDefinitionTemplateRelationType>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AssetRelationAttributeDefinitionTemplateType>;
};

/**
 * UpdateAssetRelationAttributeInput is used for update AssetRelationAttribute object.
 * Input was generated by ent.
 */
export type UpdateAssetRelationAttributeInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  assetRelationAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  assetRelationID?: InputMaybe<Scalars['ID']['input']>;
  clearAsset?: InputMaybe<Scalars['Boolean']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAssetRelationInput is used for update AssetRelation object.
 * Input was generated by ent.
 */
export type UpdateAssetRelationInput = {
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  sourceAssetID?: InputMaybe<Scalars['ID']['input']>;
  targetAssetID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AssetRelationType>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAssetRelationRawAttributeInput = {
  assetRelationAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetRelationRawInput = {
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sourceAssetID?: InputMaybe<Scalars['ID']['input']>;
  targetAssetID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AssetRelationType>;
  updateAssetRelationAttributes?: InputMaybe<Array<UpdateAssetRelationRawAttributeInput>>;
};

/**
 * UpdateAssetTypeInput is used for update AssetType object.
 * Input was generated by ent.
 */
export type UpdateAssetTypeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateAssetsProjectZoneInput = {
  IDs: Array<Scalars['ID']['input']>;
  projectZoneID: Scalars['ID']['input'];
};

/**
 * UpdateAttckAssetInput is used for update AttckAsset object.
 * Input was generated by ent.
 */
export type UpdateAttckAssetInput = {
  addTechniqueAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckID?: InputMaybe<Scalars['ID']['input']>;
  clearSrcID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTechniqueAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearURL?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeTechniqueAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  srcID?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAttckInput is used for update Attck object.
 * Input was generated by ent.
 */
export type UpdateAttckInput = {
  addAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTacticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTechniqueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearTactics?: InputMaybe<Scalars['Boolean']['input']>;
  clearTechniques?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<AttckDomain>;
  removeAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTacticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTechniqueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAttckMitigationInput is used for update AttckMitigation object.
 * Input was generated by ent.
 */
export type UpdateAttckMitigationInput = {
  addTechniqueMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearSrcID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTechniqueMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  clearURL?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeTechniqueMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  srcID?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAttckTacticInput is used for update AttckTactic object.
 * Input was generated by ent.
 */
export type UpdateAttckTacticInput = {
  addTechniqueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckID?: InputMaybe<Scalars['ID']['input']>;
  clearSrcID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTechniques?: InputMaybe<Scalars['Boolean']['input']>;
  clearURL?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeTechniqueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  srcID?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAttckTechniqueAssetInput is used for update AttckTechniqueAsset object.
 * Input was generated by ent.
 */
export type UpdateAttckTechniqueAssetInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  clearSrcID?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateAttckTechniqueInput is used for update AttckTechnique object.
 * Input was generated by ent.
 */
export type UpdateAttckTechniqueInput = {
  addTacticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTechniqueAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTechniqueMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attckID?: InputMaybe<Scalars['ID']['input']>;
  clearSrcID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTactics?: InputMaybe<Scalars['Boolean']['input']>;
  clearTechniqueAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearTechniqueMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  clearURL?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeTacticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTechniqueAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTechniqueMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  srcID?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAttckTechniqueMitigationInput is used for update AttckTechniqueMitigation object.
 * Input was generated by ent.
 */
export type UpdateAttckTechniqueMitigationInput = {
  clearSrcID?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mitigationID?: InputMaybe<Scalars['ID']['input']>;
  srcID?: InputMaybe<Scalars['String']['input']>;
  techniqueID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateAuthTokenInput is used for update AuthToken object.
 * Input was generated by ent.
 */
export type UpdateAuthTokenInput = {
  clearIssuedFor?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastAccessTime?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtTime?: InputMaybe<Scalars['Time']['input']>;
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  issuedforID?: InputMaybe<Scalars['ID']['input']>;
  issuerID?: InputMaybe<Scalars['ID']['input']>;
  lastAccessTime?: InputMaybe<Scalars['Time']['input']>;
  purpose?: InputMaybe<AuthTokenPurpose>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateCraCybersecRiskAssessmenRawtInput = {
  completeness?: InputMaybe<CraCybersecRiskAssessmentUploadCompleteness>;
  id: Scalars['ID']['input'];
};

/**
 * UpdateCRACybersecRiskAssessmentInput is used for update CRACybersecRiskAssessment object.
 * Input was generated by ent.
 */
export type UpdateCraCybersecRiskAssessmentInput = {
  craID?: InputMaybe<Scalars['ID']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateCRACybersecRiskAssessmentUploadInput is used for update CRACybersecRiskAssessmentUpload object.
 * Input was generated by ent.
 */
export type UpdateCraCybersecRiskAssessmentUploadInput = {
  completeness?: InputMaybe<CraCybersecRiskAssessmentUploadCompleteness>;
  craCybersecRiskAssessmentID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateCRADocumentationInput is used for update CRADocumentation object.
 * Input was generated by ent.
 */
export type UpdateCraDocumentationInput = {
  craID?: InputMaybe<Scalars['ID']['input']>;
  hasIntendedPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  hasProcessReference?: InputMaybe<Scalars['Boolean']['input']>;
  hasProductVisual?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecDesignArchitecture?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateCRADocumentationUploadInput is used for update CRADocumentationUpload object.
 * Input was generated by ent.
 */
export type UpdateCraDocumentationUploadInput = {
  clearFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  clearLink?: InputMaybe<Scalars['Boolean']['input']>;
  craDocumentationID?: InputMaybe<Scalars['ID']['input']>;
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCRAGeneralInput is used for update CRAGeneral object.
 * Input was generated by ent.
 */
export type UpdateCraGeneralInput = {
  clearProductCategory?: InputMaybe<Scalars['Boolean']['input']>;
  clearProductLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  clearProductLifetimeEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearProductLifetimeStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearProductName?: InputMaybe<Scalars['Boolean']['input']>;
  clearProductVersion?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectManager?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecurityResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  clearSupportPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  clearSupportPeriodEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearSupportPeriodInformation?: InputMaybe<Scalars['Boolean']['input']>;
  clearSupportPeriodStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  craID?: InputMaybe<Scalars['ID']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  productCategory?: InputMaybe<CraGeneralProductCategory>;
  productLifetime?: InputMaybe<Scalars['Int']['input']>;
  productLifetimeEndDate?: InputMaybe<Scalars['Time']['input']>;
  productLifetimeStartDate?: InputMaybe<Scalars['Time']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productVersion?: InputMaybe<Scalars['String']['input']>;
  projectManagerID?: InputMaybe<Scalars['ID']['input']>;
  securityResponsibleID?: InputMaybe<Scalars['ID']['input']>;
  supportPeriod?: InputMaybe<Scalars['Int']['input']>;
  supportPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  supportPeriodInformation?: InputMaybe<Scalars['String']['input']>;
  supportPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateCRAInput is used for update CRA object.
 * Input was generated by ent.
 */
export type UpdateCraInput = {
  clearIsApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  clearJustification?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCRAModuleCommentInput is used for update CRAModuleComment object.
 * Input was generated by ent.
 */
export type UpdateCraModuleCommentInput = {
  action?: InputMaybe<CraModuleCommentAction>;
  content?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ref to CRA entity meaning it is not only to CRA but also to CRADocumentation,
   * CRARiskAssessment, CRAVulnerabilityHandling, ...
   */
  craRefID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateCRAUploadInput is used for update CRAUpload object.
 * Input was generated by ent.
 */
export type UpdateCraUploadInput = {
  craID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateCRAVulnerabilityHandlingInput is used for update CRAVulnerabilityHandling object.
 * Input was generated by ent.
 */
export type UpdateCraVulnerabilityHandlingInput = {
  clearCustomerContact?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomerContactValidationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearSeContact?: InputMaybe<Scalars['Boolean']['input']>;
  clearSeContactValidationDate?: InputMaybe<Scalars['Boolean']['input']>;
  craID?: InputMaybe<Scalars['ID']['input']>;
  customerContact?: InputMaybe<Scalars['String']['input']>;
  customerContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  seContact?: InputMaybe<Scalars['String']['input']>;
  seContactValidationDate?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateCRAVulnerabilityHandlingUploadInput is used for update CRAVulnerabilityHandlingUpload object.
 * Input was generated by ent.
 */
export type UpdateCraVulnerabilityHandlingUploadInput = {
  craVulnerabilityHandlingID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateCVSSOverridesInput is used for update CVSSOverrides object.
 * Input was generated by ent.
 */
export type UpdateCvssOverridesInput = {
  clearCvss?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectZone?: InputMaybe<Scalars['Boolean']['input']>;
  cvssID?: InputMaybe<Scalars['ID']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CvssOverridesType>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentCreateRequestCommentInput is used for update ComponentCreateRequestComment object.
 * Input was generated by ent.
 */
export type UpdateComponentCreateRequestCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  componentCreateRequestsID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateComponentCreateRequestInput is used for update ComponentCreateRequest object.
 * Input was generated by ent.
 */
export type UpdateComponentCreateRequestInput = {
  addComponentCreateRequestCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearComponent?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentCreateRequestComments?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentVendor?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentVendorName?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalComponentID?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalRequestRef?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalRequestStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferenceSecurity?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferenceWeb?: InputMaybe<Scalars['Boolean']['input']>;
  componentCreateRequestStatusID?: InputMaybe<Scalars['ID']['input']>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentSourcesID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVersion?: InputMaybe<Scalars['String']['input']>;
  externalComponentID?: InputMaybe<Scalars['String']['input']>;
  externalRequestRef?: InputMaybe<Scalars['String']['input']>;
  externalRequestStatus?: InputMaybe<Scalars['String']['input']>;
  referenceSecurity?: InputMaybe<Scalars['String']['input']>;
  referenceWeb?: InputMaybe<Scalars['String']['input']>;
  removeComponentCreateRequestCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestPriority?: InputMaybe<ComponentCreateRequestRequestPriority>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateComponentCreateRequestRawInput = {
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  componentVendorName?: InputMaybe<Scalars['String']['input']>;
  componentVersion?: InputMaybe<Scalars['String']['input']>;
  referenceSecurity?: InputMaybe<Scalars['String']['input']>;
  referenceWeb?: InputMaybe<Scalars['String']['input']>;
  requestPriority?: InputMaybe<ComponentCreateRequestRequestPriority>;
};

/**
 * UpdateComponentExternalIdentifierInput is used for update ComponentExternalIdentifier object.
 * Input was generated by ent.
 */
export type UpdateComponentExternalIdentifierInput = {
  componentID?: InputMaybe<Scalars['ID']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ComponentExternalIdentifierSource>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentInput is used for update Component object.
 * Input was generated by ent.
 */
export type UpdateComponentInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearCpeName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEolDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSync?: InputMaybe<Scalars['Boolean']['input']>;
  clearMonitoredSince?: InputMaybe<Scalars['Boolean']['input']>;
  clearNormalizedName?: InputMaybe<Scalars['Boolean']['input']>;
  clearNormalizedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  clearProject?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecurityURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearURL?: InputMaybe<Scalars['Boolean']['input']>;
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  cpeName?: InputMaybe<Scalars['String']['input']>;
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['Time']['input']>;
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
  normalizedVersion?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  securityURL?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateComponentNotificationInput is used for update ComponentNotification object.
 * Input was generated by ent.
 */
export type UpdateComponentNotificationInput = {
  addMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearMitigations?: InputMaybe<Scalars['Boolean']['input']>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  notificationID?: InputMaybe<Scalars['ID']['input']>;
  removeMitigationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentRawInput is used for update ComponentRaw object.
 * Input was generated by ent.
 */
export type UpdateComponentRawInput = {
  appendBody?: InputMaybe<Array<Scalars['String']['input']>>;
  appendReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  clearCpe23?: InputMaybe<Scalars['Boolean']['input']>;
  clearEolDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearMonitoredSince?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferences?: InputMaybe<Scalars['Boolean']['input']>;
  componentSourcesID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  cpe23?: InputMaybe<Scalars['String']['input']>;
  eolDate?: InputMaybe<Scalars['Time']['input']>;
  eolReached?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  monitoredSince?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<Array<Scalars['String']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateComponentRawNotificationRawInput is used for update ComponentRawNotificationRaw object.
 * Input was generated by ent.
 */
export type UpdateComponentRawNotificationRawInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentRawNotificationVilocifyRelationshipInput is used for update
 * ComponentRawNotificationVilocifyRelationship object.
 * Input was generated by ent.
 */
export type UpdateComponentRawNotificationVilocifyRelationshipInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  notificationVilocifyID?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentRawVulnerabilityRawInput is used for update ComponentRawVulnerabilityRaw object.
 * Input was generated by ent.
 */
export type UpdateComponentRawVulnerabilityRawInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentRawsID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateComponentSuggestionInput is used for update ComponentSuggestion object.
 * Input was generated by ent.
 */
export type UpdateComponentSuggestionInput = {
  clearComment?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponent?: InputMaybe<Scalars['Boolean']['input']>;
  clearProject?: InputMaybe<Scalars['Boolean']['input']>;
  clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  componentID?: InputMaybe<Scalars['ID']['input']>;
  forName?: InputMaybe<Scalars['String']['input']>;
  forVendor?: InputMaybe<Scalars['String']['input']>;
  forVersion?: InputMaybe<Scalars['String']['input']>;
  gotName?: InputMaybe<Scalars['String']['input']>;
  gotVendor?: InputMaybe<Scalars['String']['input']>;
  gotVersion?: InputMaybe<Scalars['String']['input']>;
  isMatch?: InputMaybe<Scalars['Boolean']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateComponentSyncLogInput is used for update ComponentSyncLog object.
 * Input was generated by ent.
 */
export type UpdateComponentSyncLogInput = {
  clearSyncEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  componentSourcesID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ComponentSyncLogStatus>;
  syncEndTime?: InputMaybe<Scalars['Time']['input']>;
  syncStartTime?: InputMaybe<Scalars['Time']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentVendorAssessmentInput is used for update ComponentVendorAssessment object.
 * Input was generated by ent.
 */
export type UpdateComponentVendorAssessmentInput = {
  clearCompletionTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearReference?: InputMaybe<Scalars['Boolean']['input']>;
  completionTime?: InputMaybe<Scalars['Time']['input']>;
  componentVendorID?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ComponentVendorAssessmentResult>;
  status?: InputMaybe<ComponentVendorAssessmentStatus>;
  type?: InputMaybe<ComponentVendorAssessmentType>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateComponentVendorInput is used for update ComponentVendor object.
 * Input was generated by ent.
 */
export type UpdateComponentVendorInput = {
  addComponentCreateRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearComponentCreateRequests?: InputMaybe<Scalars['Boolean']['input']>;
  clearContactEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearContactName?: InputMaybe<Scalars['Boolean']['input']>;
  clearContactPhone?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearIfa?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ifa?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeComponentCreateRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateCountryStandardInput is used for update CountryStandard object.
 * Input was generated by ent.
 */
export type UpdateCountryStandardInput = {
  countryID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  standardID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateFileAssetInput is used for update FileAsset object.
 * Input was generated by ent.
 */
export type UpdateFileAssetInput = {
  addTaskCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTraReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectHierarchyFiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaskEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  clearTraReport?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectHierarchyFilesID?: InputMaybe<Scalars['ID']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  /** actual entity which owns the file like task or project hierarchy */
  refID?: InputMaybe<Scalars['ID']['input']>;
  removeTaskCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTraReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** size in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  storagekey?: InputMaybe<Scalars['String']['input']>;
  taskEvidenceID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateMaturityLevelInput is used for update MaturityLevel object.
 * Input was generated by ent.
 */
export type UpdateMaturityLevelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateMeasureInput is used for update Measure object.
 * Input was generated by ent.
 */
export type UpdateMeasureInput = {
  clearHowto?: InputMaybe<Scalars['Boolean']['input']>;
  clearProject?: InputMaybe<Scalars['Boolean']['input']>;
  clearResources?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpdateToComponent?: InputMaybe<Scalars['Boolean']['input']>;
  howto?: InputMaybe<Scalars['String']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  resources?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MeasureType>;
  updateToComponentID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMeasureRawInput = {
  howto?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateMitigationInput is used for update Mitigation object.
 * Input was generated by ent.
 */
export type UpdateMitigationInput = {
  addMitigationTestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetItemID?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<MitigationAssignee>;
  clearMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  clearMitigationTests?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkcycle?: InputMaybe<Scalars['Boolean']['input']>;
  measureID?: InputMaybe<Scalars['ID']['input']>;
  removeMitigationTestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<MitigationStatus>;
  statusReason?: InputMaybe<Scalars['String']['input']>;
  workcycleID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMitigationTestBulkInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  envName?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  result?: InputMaybe<MitigationTestResult>;
};

/**
 * UpdateMitigationTestInput is used for update MitigationTest object.
 * Input was generated by ent.
 */
export type UpdateMitigationTestInput = {
  clearComment?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnvName?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  envName?: InputMaybe<Scalars['String']['input']>;
  measureID?: InputMaybe<Scalars['ID']['input']>;
  mitigationID?: InputMaybe<Scalars['ID']['input']>;
  result?: InputMaybe<MitigationTestResult>;
  testerID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateNVDMatchCriteriaInput is used for update NVDMatchCriteria object.
 * Input was generated by ent.
 */
export type UpdateNvdMatchCriteriaInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentNvdID?: InputMaybe<Scalars['String']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  matchCriteriaID?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotificationInput is used for update Notification object.
 * Input was generated by ent.
 */
export type UpdateNotificationInput = {
  action?: InputMaybe<NotificationAction>;
  addCfeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addComponentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCvssOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCweIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendAttachments?: InputMaybe<Array<NotificationAttachment>>;
  appendReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  appendResources?: InputMaybe<Array<NotificationResource>>;
  appendVendorAdvisories?: InputMaybe<Array<NotificationVendorAdvisory>>;
  attachments?: InputMaybe<Array<NotificationAttachment>>;
  body?: InputMaybe<Scalars['String']['input']>;
  clearAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponents?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCves?: InputMaybe<Scalars['Boolean']['input']>;
  clearCvss?: InputMaybe<Scalars['Boolean']['input']>;
  clearCvssOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  clearCwes?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearImpact?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastUpdateDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalNotice?: InputMaybe<Scalars['Boolean']['input']>;
  clearPrerequisite?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferences?: InputMaybe<Scalars['Boolean']['input']>;
  clearReproduce?: InputMaybe<Scalars['Boolean']['input']>;
  clearResources?: InputMaybe<Scalars['Boolean']['input']>;
  clearSolutionDetails?: InputMaybe<Scalars['Boolean']['input']>;
  clearVendorAdvisories?: InputMaybe<Scalars['Boolean']['input']>;
  confidentialityLevel?: InputMaybe<NotificationConfidentialityLevel>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  cvssBaseScore?: InputMaybe<Scalars['Float']['input']>;
  cvssID?: InputMaybe<Scalars['ID']['input']>;
  cvssOveralScore?: InputMaybe<Scalars['Float']['input']>;
  cvssTemporalScore?: InputMaybe<Scalars['Float']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  impact?: InputMaybe<Scalars['String']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  legalNotice?: InputMaybe<Scalars['String']['input']>;
  prerequisite?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<NotificationPriority>;
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  references?: InputMaybe<Array<Scalars['String']['input']>>;
  removeCfeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeComponentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCvssOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCweIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  reproduce?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<NotificationResource>>;
  solutionDetails?: InputMaybe<Scalars['String']['input']>;
  solutionStatus?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<NotificationSource>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vendorAdvisories?: InputMaybe<Array<NotificationVendorAdvisory>>;
};

/**
 * UpdateNotificationRawInput is used for update NotificationRaw object.
 * Input was generated by ent.
 */
export type UpdateNotificationRawInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  appendBody?: InputMaybe<Array<Scalars['String']['input']>>;
  appendReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  appendVendorAdvisories?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  clearCvss?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastUpdateDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferences?: InputMaybe<Scalars['Boolean']['input']>;
  clearSolution?: InputMaybe<Scalars['Boolean']['input']>;
  clearVendorAdvisories?: InputMaybe<Scalars['Boolean']['input']>;
  componentSourcesID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  cvss?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  references?: InputMaybe<Array<Scalars['String']['input']>>;
  solution?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vendorAdvisories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * UpdateNotificationRawVulnerabilityRawInput is used for update NotificationRawVulnerabilityRaw object.
 * Input was generated by ent.
 */
export type UpdateNotificationRawVulnerabilityRawInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateNotificationRawVulnerabilityVilocifyRelationshipInput is used for update
 * NotificationRawVulnerabilityVilocifyRelationship object.
 * Input was generated by ent.
 */
export type UpdateNotificationRawVulnerabilityVilocifyRelationshipInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  notificationRawsID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityVilocifyID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateOrganizationInput is used for update Organization object.
 * Input was generated by ent.
 */
export type UpdateOrganizationInput = {
  clearParentOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentOrganizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrganizationRawInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * UpdateOrganizationUserInput is used for update OrganizationUser object.
 * Input was generated by ent.
 */
export type UpdateOrganizationUserInput = {
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<OrganizationUserRole>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProjectAttributeInput is used for update ProjectAttribute object.
 * Input was generated by ent.
 */
export type UpdateProjectAttributeInput = {
  clearValue?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectAttributeType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectAttributeSequenceRawInput = {
  id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};

/**
 * UpdateProjectAttributeTemplateInput is used for update ProjectAttributeTemplate object.
 * Input was generated by ent.
 */
export type UpdateProjectAttributeTemplateInput = {
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectAttributeTemplateType>;
};

export type UpdateProjectAttributeValueInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateProjectCountryInput is used for update ProjectCountry object.
 * Input was generated by ent.
 */
export type UpdateProjectCountryInput = {
  countryID?: InputMaybe<Scalars['ID']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateProjectGuidanceInput is used for update ProjectGuidance object.
 * Input was generated by ent.
 */
export type UpdateProjectGuidanceInput = {
  addProjectGuidanceRequirementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectStandardProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearProjectGuidanceRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectStandardProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  removeProjectGuidanceRequirementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectStandardProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateProjectHierarchyAssetInput is used for update ProjectHierarchyAsset object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyAssetInput = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProjectHierarchyAttributeDefinitionInput is used for update ProjectHierarchyAttributeDefinition object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyAttributeDefinitionInput = {
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectHierarchyTypeID?: InputMaybe<Scalars['ID']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProjectHierarchyAttributeDefinitionSequenceRawInput = {
  id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};

/**
 * UpdateProjectHierarchyAttributeInput is used for update ProjectHierarchyAttribute object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyAttributeInput = {
  clearValue?: InputMaybe<Scalars['Boolean']['input']>;
  projectHierarchyAttributeDefinitionID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateProjectHierarchyFileInput is used for update ProjectHierarchyFile object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyFileInput = {
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProjectHierarchyInput is used for update ProjectHierarchy object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyInput = {
  clearCommodityManager?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearParentHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  clearSupplierName?: InputMaybe<Scalars['Boolean']['input']>;
  commodityManager?: InputMaybe<Scalars['String']['input']>;
  criticality?: InputMaybe<ProjectHierarchyCriticality>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  parentHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  typeID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateProjectHierarchyTodoInput is used for update ProjectHierarchyTodo object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyTodoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  projectHierarchyID?: InputMaybe<Scalars['ID']['input']>;
  /** sequence number to order rows in scope of single project hierarchy */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProjectHierarchyTodoStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateProjectHierarchyTodoRawInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProjectHierarchyTodoStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateProjectHierarchyTypeInput is used for update ProjectHierarchyType object.
 * Input was generated by ent.
 */
export type UpdateProjectHierarchyTypeInput = {
  addProjectHierarchyAttributeDefinitionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectHierarchyAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectHierarchyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearProjectHierarchies?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectHierarchyAttributeDefinitionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectHierarchyAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeProjectHierarchyAttributeDefinitionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectHierarchyAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectHierarchyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateProjectInput = {
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationStreet?: InputMaybe<Scalars['String']['input']>;
  milestoneID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  plantExternalID?: InputMaybe<Scalars['String']['input']>;
  plantName?: InputMaybe<Scalars['String']['input']>;
  pointInput?: InputMaybe<PointInput>;
  securityResponsibleID?: InputMaybe<Scalars['ID']['input']>;
  statusID?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  typeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProjectMilestoneInput is used for update ProjectMilestone object.
 * Input was generated by ent.
 */
export type UpdateProjectMilestoneInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectPhaseID?: InputMaybe<Scalars['ID']['input']>;
  /** sequence number to order rows within one project phase */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateProjectPhaseInput is used for update ProjectPhase object.
 * Input was generated by ent.
 */
export type UpdateProjectPhaseInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectTypeID?: InputMaybe<Scalars['ID']['input']>;
  /** sequence number to order rows within one project type */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateProjectStatusInput is used for update ProjectStatus object.
 * Input was generated by ent.
 */
export type UpdateProjectStatusInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateProjectTypeInput is used for update ProjectType object.
 * Input was generated by ent.
 */
export type UpdateProjectTypeInput = {
  addAssetRelationAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectAttributeTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectHierarchyAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssetRelationAttributeDefinitionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectAttributeTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectHierarchyAttributeDefinitionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectTypes?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjects?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeAssetRelationAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectAttributeTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectHierarchyAttributeDefinitionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateProjectUserInput is used for update ProjectUser object.
 * Input was generated by ent.
 */
export type UpdateProjectUserInput = {
  projectID?: InputMaybe<Scalars['ID']['input']>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProjectUserRoleInput is used for update ProjectUserRole object.
 * Input was generated by ent.
 */
export type UpdateProjectUserRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateProjectZoneInput is used for update ProjectZone object.
 * Input was generated by ent.
 */
export type UpdateProjectZoneInput = {
  assetsCount?: InputMaybe<Scalars['Int']['input']>;
  clearParentZone?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exposureRating?: InputMaybe<ProjectZoneExposureRating>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentZoneID?: InputMaybe<Scalars['ID']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateProjectZoneStandardProfileInput is used for update ProjectZoneStandardProfile object.
 * Input was generated by ent.
 */
export type UpdateProjectZoneStandardProfileInput = {
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  standardProfileID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProjectZoneStandardProfileRequirementCommentInput is used for update
 * ProjectZoneStandardProfileRequirementComment object.
 * Input was generated by ent.
 */
export type UpdateProjectZoneStandardProfileRequirementCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  projectZoneStandardProfileID?: InputMaybe<Scalars['ID']['input']>;
  requirementCommentStatus?: InputMaybe<ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus>;
  requirementID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateRequirementMappingInput is used for update RequirementMapping object.
 * Input was generated by ent.
 */
export type UpdateRequirementMappingInput = {
  childRequirementID?: InputMaybe<Scalars['ID']['input']>;
  clearMappingCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  mappingCoverageID?: InputMaybe<Scalars['ID']['input']>;
  parentRequirementID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateSecurityLevelInput is used for update SecurityLevel object.
 * Input was generated by ent.
 */
export type UpdateSecurityLevelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateStandardInput is used for update Standard object.
 * Input was generated by ent.
 */
export type UpdateStandardInput = {
  clearCraType?: InputMaybe<Scalars['Boolean']['input']>;
  clearImplementationGuidance?: InputMaybe<Scalars['Boolean']['input']>;
  clearRevisedFrom?: InputMaybe<Scalars['Boolean']['input']>;
  clearRevisedInto?: InputMaybe<Scalars['Boolean']['input']>;
  countryID?: InputMaybe<Scalars['ID']['input']>;
  craType?: InputMaybe<StandardCraType>;
  description?: InputMaybe<Scalars['String']['input']>;
  implementationGuidance?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  releasedAt?: InputMaybe<Scalars['Time']['input']>;
  requirementsCount?: InputMaybe<Scalars['Int']['input']>;
  revisedFromID?: InputMaybe<Scalars['ID']['input']>;
  revisedIntoID?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Time']['input']>;
  validTo?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSurveyClassificationClassActivityInput is used for update SurveyClassificationClassActivity object.
 * Input was generated by ent.
 */
export type UpdateSurveyClassificationClassActivityInput = {
  additionalDescription?: InputMaybe<Scalars['String']['input']>;
  classificationClassID?: InputMaybe<Scalars['ID']['input']>;
  clearAdditionalDescription?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  necessity?: InputMaybe<SurveyClassificationClassActivityNecessity>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateSurveyClassificationClassInput is used for update SurveyClassificationClass object.
 * Input was generated by ent.
 */
export type UpdateSurveyClassificationClassInput = {
  addActivityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyScaleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearActivities?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyScales?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeActivityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyScaleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateSurveyFormContentInput is used for update SurveyFormContent object.
 * Input was generated by ent.
 */
export type UpdateSurveyFormContentInput = {
  formID?: InputMaybe<Scalars['ID']['input']>;
  profileID?: InputMaybe<Scalars['ID']['input']>;
  questionID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  topicClusterTypeID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSurveyFormInput is used for update SurveyForm object.
 * Input was generated by ent.
 */
export type UpdateSurveyFormInput = {
  addClassificationClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addQuestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTopicClusterTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  authorID?: InputMaybe<Scalars['ID']['input']>;
  clearClassificationClasses?: InputMaybe<Scalars['Boolean']['input']>;
  clearContents?: InputMaybe<Scalars['Boolean']['input']>;
  clearProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  clearTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTopicClusterTypes?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<SurveyFormKind>;
  removeClassificationClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeQuestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTopicClusterTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateSurveyInput is used for update Survey object.
 * Input was generated by ent.
 */
export type UpdateSurveyInput = {
  actionTransitionLog?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Scalars['String']['input']>;
  approved1At?: InputMaybe<Scalars['Time']['input']>;
  approved2At?: InputMaybe<Scalars['Time']['input']>;
  approver1UserID?: InputMaybe<Scalars['ID']['input']>;
  approver2UserID?: InputMaybe<Scalars['ID']['input']>;
  authorID?: InputMaybe<Scalars['ID']['input']>;
  classificationClassID?: InputMaybe<Scalars['ID']['input']>;
  classificationScore?: InputMaybe<Scalars['Int']['input']>;
  clearApproved1At?: InputMaybe<Scalars['Boolean']['input']>;
  clearApproved2At?: InputMaybe<Scalars['Boolean']['input']>;
  clearApprover1user?: InputMaybe<Scalars['Boolean']['input']>;
  clearApprover2user?: InputMaybe<Scalars['Boolean']['input']>;
  clearComment?: InputMaybe<Scalars['Boolean']['input']>;
  clearConductedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeclinedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeclinerUser?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalDocumentID?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conductedAt?: InputMaybe<Scalars['Time']['input']>;
  declinedAt?: InputMaybe<Scalars['Time']['input']>;
  declinerUserID?: InputMaybe<Scalars['ID']['input']>;
  externalDocumentID?: InputMaybe<Scalars['String']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  optimisticLockVersion?: InputMaybe<Scalars['Int']['input']>;
  profileID?: InputMaybe<Scalars['ID']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SurveyStatus>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSurveyProfileInput is used for update SurveyProfile object.
 * Input was generated by ent.
 */
export type UpdateSurveyProfileInput = {
  addSurveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyScaleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyTemplateProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearSurveyFormContents?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyScales?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyTemplateProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  perequisties?: InputMaybe<Scalars['String']['input']>;
  removeSurveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyScaleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyTemplateProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityActivities?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSurveyQuestionInput is used for update SurveyQuestion object.
 * Input was generated by ent.
 */
export type UpdateSurveyQuestionInput = {
  addSurveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyQuestionOptionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  answerHeader?: InputMaybe<Scalars['String']['input']>;
  clearSurveyFormContents?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyQuestionOptions?: InputMaybe<Scalars['Boolean']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  questionGuidance?: InputMaybe<Scalars['String']['input']>;
  removeSurveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyQuestionOptionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSurveyQuestionOptionInput is used for update SurveyQuestionOption object.
 * Input was generated by ent.
 */
export type UpdateSurveyQuestionOptionInput = {
  questionID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * UpdateSurveyScaleInput is used for update SurveyScale object.
 * Input was generated by ent.
 */
export type UpdateSurveyScaleInput = {
  classificationClassID?: InputMaybe<Scalars['ID']['input']>;
  profileID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  upperLimit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateSurveyTemplateInput is used for update SurveyTemplate object.
 * Input was generated by ent.
 */
export type UpdateSurveyTemplateInput = {
  answers?: InputMaybe<Scalars['String']['input']>;
  authorID?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  profileID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSurveyTopicClusterTypeInput is used for update SurveyTopicClusterType object.
 * Input was generated by ent.
 */
export type UpdateSurveyTopicClusterTypeInput = {
  addSurveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  calculationMethod?: InputMaybe<Scalars['String']['input']>;
  clearSurveyFormContents?: InputMaybe<Scalars['Boolean']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  multiplier?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeSurveyFormContentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTRAInput is used for update TRA object.
 * Input was generated by ent.
 */
export type UpdateTraInput = {
  addHistoryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addParticipantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  approved1At?: InputMaybe<Scalars['Time']['input']>;
  approved2At?: InputMaybe<Scalars['Time']['input']>;
  approver1ID?: InputMaybe<Scalars['ID']['input']>;
  approver2ID?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  clearApproved1At?: InputMaybe<Scalars['Boolean']['input']>;
  clearApproved2At?: InputMaybe<Scalars['Boolean']['input']>;
  clearApprover1?: InputMaybe<Scalars['Boolean']['input']>;
  clearApprover2?: InputMaybe<Scalars['Boolean']['input']>;
  clearHistory?: InputMaybe<Scalars['Boolean']['input']>;
  clearLockedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLockedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  clearParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  clearReports?: InputMaybe<Scalars['Boolean']['input']>;
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lockedAt?: InputMaybe<Scalars['Time']['input']>;
  lockedByID?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  removeHistoryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeParticipantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<TraStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTRAParticipantInput is used for update TRAParticipant object.
 * Input was generated by ent.
 */
export type UpdateTraParticipantInput = {
  traID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTraRawInput = {
  approver1?: InputMaybe<Scalars['ID']['input']>;
  approver2?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTRAReportInput is used for update TRAReport object.
 * Input was generated by ent.
 */
export type UpdateTraReportInput = {
  authorID?: InputMaybe<Scalars['ID']['input']>;
  classification?: InputMaybe<TraReportClassification>;
  clearFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** this is document type, file extension */
  extension?: InputMaybe<Scalars['String']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  traID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTaskBulkInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  ids: Array<Scalars['ID']['input']>;
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<TaskPriority>;
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<TaskStatus>;
};

/**
 * UpdateTaskCommentInput is used for update TaskComment object.
 * Input was generated by ent.
 */
export type UpdateTaskCommentInput = {
  clearFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  taskID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTaskDeliverableInput is used for update TaskDeliverable object.
 * Input was generated by ent.
 */
export type UpdateTaskDeliverableInput = {
  isChecked?: InputMaybe<Scalars['Boolean']['input']>;
  taskID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTaskEvidenceInput is used for update TaskEvidence object.
 * Input was generated by ent.
 */
export type UpdateTaskEvidenceInput = {
  clearFileAsset?: InputMaybe<Scalars['Boolean']['input']>;
  clearLink?: InputMaybe<Scalars['Boolean']['input']>;
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  fileAssetID?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  taskID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTaskInput is used for update Task object.
 * Input was generated by ent.
 */
export type UpdateTaskInput = {
  assigneeID?: InputMaybe<Scalars['ID']['input']>;
  clearAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  clearDueAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastChangedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearParentTask?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearTopic?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  isApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  lastChangedAt?: InputMaybe<Scalars['Time']['input']>;
  parentTaskID?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<TaskPriority>;
  projectID?: InputMaybe<Scalars['ID']['input']>;
  projectMilestoneID?: InputMaybe<Scalars['ID']['input']>;
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TaskSource>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<TaskStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<TaskTopic>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTaskTemplateInput is used for update TaskTemplate object.
 * Input was generated by ent.
 */
export type UpdateTaskTemplateInput = {
  clearTopic?: InputMaybe<Scalars['Boolean']['input']>;
  deliverables?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<TaskTemplatePriority>;
  referenceDocuments?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<TaskTemplateTopic>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export type UpdateUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addAssetRelationAttributeDefinitionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAssetRelationAttributeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAssetRelationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addComponentCreateRequestCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addComponentCreateRequestsModifierIDIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addComponentCreateRequestsRequesterIDIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addComponentSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCraModuleCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCreatedFileAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCreatedProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCreatedTaskEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIssuedForIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIssuerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMitigationTestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProjectZoneStandardProfilesRequirementCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSecurityResponsibleProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyAprrover1IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyAprrover2IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyAuthorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyDeclinerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyFormIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSurveyTemplateAuthorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTaskCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTraParticipantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  are?: InputMaybe<Scalars['String']['input']>;
  clearAssetRelationAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetRelationAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetRelations?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentCreateRequestComments?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentCreateRequestsModifierID?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentCreateRequestsRequesterID?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearCraModuleComments?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedFileAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedProjects?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedTaskEvidences?: InputMaybe<Scalars['Boolean']['input']>;
  clearIssuedFor?: InputMaybe<Scalars['Boolean']['input']>;
  clearIssuers?: InputMaybe<Scalars['Boolean']['input']>;
  clearMitigationTests?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotificationSetting?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectZoneStandardProfilesRequirementComment?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjects?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecurityResponsibleProjects?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyAprrover1s?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyAprrover2s?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyAuthors?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyDecliners?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyForms?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurveyTemplateAuthors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTask?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  clearTraParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gid?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notificationSettingID?: InputMaybe<Scalars['ID']['input']>;
  orgCode?: InputMaybe<Scalars['String']['input']>;
  removeAssetRelationAttributeDefinitionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAssetRelationAttributeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAssetRelationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeComponentCreateRequestCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeComponentCreateRequestsModifierIDIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeComponentCreateRequestsRequesterIDIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeComponentSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCraModuleCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCreatedFileAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCreatedProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCreatedTaskEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIssuedForIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIssuerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMitigationTestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProjectZoneStandardProfilesRequirementCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSecurityResponsibleProjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyAprrover1IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyAprrover2IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyAuthorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyDeclinerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyFormIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSurveyTemplateAuthorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTaskCommentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTraParticipantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateUserNotificationSettingInput is used for update UserNotificationSetting object.
 * Input was generated by ent.
 */
export type UpdateUserNotificationSettingInput = {
  appendProjects?: InputMaybe<Array<UserNotificationSettingProjectConfiguration>>;
  clearProjects?: InputMaybe<Scalars['Boolean']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<UserNotificationSettingFrequency>;
  projects?: InputMaybe<Array<UserNotificationSettingProjectConfiguration>>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateVulnerabilityCVSSRawInput is used for update VulnerabilityCVSSRaw object.
 * Input was generated by ent.
 */
export type UpdateVulnerabilityCvssRawInput = {
  baseScore?: InputMaybe<Scalars['Float']['input']>;
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vector?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateVulnerabilityRawComponentNVDRelationshipInput is used for update VulnerabilityRawComponentNVDRelationship object.
 * Input was generated by ent.
 */
export type UpdateVulnerabilityRawComponentNvdRelationshipInput = {
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  cveNvdID?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaID?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateVulnerabilityRawInput is used for update VulnerabilityRaw object.
 * Input was generated by ent.
 */
export type UpdateVulnerabilityRawInput = {
  appendBody?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastUpdateDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearWeakness?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  componentSourcesID?: InputMaybe<Scalars['ID']['input']>;
  componentSyncLogsID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  weakness?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  admin: Scalars['Boolean']['output'];
  are: Scalars['String']['output'];
  createTime: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  location: Scalars['String']['output'];
  orgCode: Scalars['String']['output'];
  organizations?: Maybe<Array<OrganizationUser>>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['Cursor']['output'];
  node: User;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  message?: Maybe<Scalars['String']['output']>;
  resourceID: Scalars['ID']['output'];
  status: OperationStatus;
  type: UserEventType;
};

export enum UserEventType {
  ProjectCopy = 'PROJECT_COPY'
}

export type UserImportSummary = {
  __typename?: 'UserImportSummary';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedRows?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  successful: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unsuccessful: Scalars['Int']['output'];
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  enable: Scalars['Boolean']['output'];
  frequency?: Maybe<UserNotificationSettingFrequency>;
  id: Scalars['ID']['output'];
  projects?: Maybe<Array<Maybe<UserNotificationSettingProjectConfigurationOutput>>>;
  userID: Scalars['ID']['output'];
};

export enum UserNotificationSettingFrequency {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type UserNotificationSettingProjectConfiguration = {
  assetsAndZonesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  cvssEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cvssMinScore?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  minLevel?: InputMaybe<UserNotificationSettingVulnerabilitiesNotificationPriority>;
  minLevelEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<UserNotificationSettingTaskNotificationPriority>;
  priorityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tasksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  vulnerabilitiesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationSettingProjectConfigurationOutput = {
  __typename?: 'UserNotificationSettingProjectConfigurationOutput';
  assetsAndZonesEnabled?: Maybe<Scalars['Boolean']['output']>;
  assignedOnly?: Maybe<Scalars['Boolean']['output']>;
  cvssEnabled?: Maybe<Scalars['Boolean']['output']>;
  cvssMinScore?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  minLevel?: Maybe<UserNotificationSettingVulnerabilitiesNotificationPriority>;
  minLevelEnabled?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<UserNotificationSettingTaskNotificationPriority>;
  priorityEnabled?: Maybe<Scalars['Boolean']['output']>;
  tasksEnabled?: Maybe<Scalars['Boolean']['output']>;
  vulnerabilitiesEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserNotificationSettingTaskNotificationPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum UserNotificationSettingVulnerabilitiesNotificationPriority {
  Low = 'LOW',
  Medium = 'MEDIUM',
  Veryhigh = 'VERYHIGH'
}

/**
 * UserNotificationSettingWhereInput is used for filtering UserNotificationSetting objects.
 * Input was generated by ent.
 */
export type UserNotificationSettingWhereInput = {
  and?: InputMaybe<Array<UserNotificationSettingWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enable field predicates */
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  enableNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** frequency field predicates */
  frequency?: InputMaybe<UserNotificationSettingFrequency>;
  frequencyIn?: InputMaybe<Array<UserNotificationSettingFrequency>>;
  frequencyNEQ?: InputMaybe<UserNotificationSettingFrequency>;
  frequencyNotIn?: InputMaybe<Array<UserNotificationSettingFrequency>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserNotificationSettingWhereInput>;
  or?: InputMaybe<Array<UserNotificationSettingWhereInput>>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDContains?: InputMaybe<Scalars['ID']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserOrder = {
  direction: OrderDirection;
  field?: InputMaybe<UserOrderField>;
};

export enum UserOrderField {
  Active = 'ACTIVE',
  Admin = 'ADMIN',
  Are = 'ARE',
  Email = 'EMAIL',
  Firstname = 'FIRSTNAME',
  Gid = 'GID',
  Id = 'ID',
  Lastname = 'LASTNAME',
  Location = 'LOCATION',
  Orgcode = 'ORGCODE'
}

export type UserOrganizationInput = {
  organizationID: Scalars['ID']['input'];
  role: OrganizationUserRole;
};

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** admin field predicates */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  adminNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<UserWhereInput>>;
  /** are field predicates */
  are?: InputMaybe<Scalars['String']['input']>;
  areContains?: InputMaybe<Scalars['String']['input']>;
  areContainsFold?: InputMaybe<Scalars['String']['input']>;
  areEqualFold?: InputMaybe<Scalars['String']['input']>;
  areGT?: InputMaybe<Scalars['String']['input']>;
  areGTE?: InputMaybe<Scalars['String']['input']>;
  areHasPrefix?: InputMaybe<Scalars['String']['input']>;
  areHasSuffix?: InputMaybe<Scalars['String']['input']>;
  areIn?: InputMaybe<Array<Scalars['String']['input']>>;
  areLT?: InputMaybe<Scalars['String']['input']>;
  areLTE?: InputMaybe<Scalars['String']['input']>;
  areNEQ?: InputMaybe<Scalars['String']['input']>;
  areNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstNameGT?: InputMaybe<Scalars['String']['input']>;
  firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameLT?: InputMaybe<Scalars['String']['input']>;
  firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** gid field predicates */
  gid?: InputMaybe<Scalars['String']['input']>;
  gidContains?: InputMaybe<Scalars['String']['input']>;
  gidContainsFold?: InputMaybe<Scalars['String']['input']>;
  gidEqualFold?: InputMaybe<Scalars['String']['input']>;
  gidGT?: InputMaybe<Scalars['String']['input']>;
  gidGTE?: InputMaybe<Scalars['String']['input']>;
  gidHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gidHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gidLT?: InputMaybe<Scalars['String']['input']>;
  gidLTE?: InputMaybe<Scalars['String']['input']>;
  gidNEQ?: InputMaybe<Scalars['String']['input']>;
  gidNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** asset_relation_attribute_definitions edge predicates */
  hasAssetRelationAttributeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributeDefinitionsWith?: InputMaybe<Array<AssetRelationAttributeDefinitionWhereInput>>;
  /** asset_relation_attributes edge predicates */
  hasAssetRelationAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationAttributesWith?: InputMaybe<Array<AssetRelationAttributeWhereInput>>;
  /** asset_relations edge predicates */
  hasAssetRelations?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetRelationsWith?: InputMaybe<Array<AssetRelationWhereInput>>;
  /** component_create_request_comments edge predicates */
  hasComponentCreateRequestComments?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestCommentsWith?: InputMaybe<Array<ComponentCreateRequestCommentWhereInput>>;
  /** component_create_requests_modifier_id edge predicates */
  hasComponentCreateRequestsModifierID?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsModifierIDWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** component_create_requests_requester_id edge predicates */
  hasComponentCreateRequestsRequesterID?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentCreateRequestsRequesterIDWith?: InputMaybe<Array<ComponentCreateRequestWhereInput>>;
  /** component_suggestion edge predicates */
  hasComponentSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSuggestionWith?: InputMaybe<Array<ComponentSuggestionWhereInput>>;
  /** cra_module_comments edge predicates */
  hasCraModuleComments?: InputMaybe<Scalars['Boolean']['input']>;
  hasCraModuleCommentsWith?: InputMaybe<Array<CraModuleCommentWhereInput>>;
  /** created_file_assets edge predicates */
  hasCreatedFileAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedFileAssetsWith?: InputMaybe<Array<FileAssetWhereInput>>;
  /** created_projects edge predicates */
  hasCreatedProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** created_task_evidences edge predicates */
  hasCreatedTaskEvidences?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedTaskEvidencesWith?: InputMaybe<Array<TaskEvidenceWhereInput>>;
  /** issuedFor edge predicates */
  hasIssuedFor?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssuedForWith?: InputMaybe<Array<AuthTokenWhereInput>>;
  /** issuers edge predicates */
  hasIssuers?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssuersWith?: InputMaybe<Array<AuthTokenWhereInput>>;
  /** mitigation_tests edge predicates */
  hasMitigationTests?: InputMaybe<Scalars['Boolean']['input']>;
  hasMitigationTestsWith?: InputMaybe<Array<MitigationTestWhereInput>>;
  /** notification_setting edge predicates */
  hasNotificationSetting?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationSettingWith?: InputMaybe<Array<UserNotificationSettingWhereInput>>;
  /** organization_users edge predicates */
  hasOrganizationUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationUsersWith?: InputMaybe<Array<OrganizationUserWhereInput>>;
  /** organizations edge predicates */
  hasOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationsWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** project_users edge predicates */
  hasProjectUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectUsersWith?: InputMaybe<Array<ProjectUserWhereInput>>;
  /** project_zone_standard_profiles_requirement_comment edge predicates */
  hasProjectZoneStandardProfilesRequirementComment?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectZoneStandardProfilesRequirementCommentWith?: InputMaybe<Array<ProjectZoneStandardProfileRequirementCommentWhereInput>>;
  /** projects edge predicates */
  hasProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** security_responsible_projects edge predicates */
  hasSecurityResponsibleProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecurityResponsibleProjectsWith?: InputMaybe<Array<ProjectWhereInput>>;
  /** survey_aprrover1s edge predicates */
  hasSurveyAprrover1s?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyAprrover1sWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** survey_aprrover2s edge predicates */
  hasSurveyAprrover2s?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyAprrover2sWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** survey_authors edge predicates */
  hasSurveyAuthors?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyAuthorsWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** survey_decliners edge predicates */
  hasSurveyDecliners?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyDeclinersWith?: InputMaybe<Array<SurveyWhereInput>>;
  /** survey_forms edge predicates */
  hasSurveyForms?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyFormsWith?: InputMaybe<Array<SurveyFormWhereInput>>;
  /** survey_template_authors edge predicates */
  hasSurveyTemplateAuthors?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurveyTemplateAuthorsWith?: InputMaybe<Array<SurveyTemplateWhereInput>>;
  /** task edge predicates */
  hasTask?: InputMaybe<Scalars['Boolean']['input']>;
  /** task_comment edge predicates */
  hasTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskCommentWith?: InputMaybe<Array<TaskCommentWhereInput>>;
  hasTaskWith?: InputMaybe<Array<TaskWhereInput>>;
  /** tra_participants edge predicates */
  hasTraParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  hasTraParticipantsWith?: InputMaybe<Array<TraParticipantWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastNameGT?: InputMaybe<Scalars['String']['input']>;
  lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameLT?: InputMaybe<Scalars['String']['input']>;
  lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** location field predicates */
  location?: InputMaybe<Scalars['String']['input']>;
  locationContains?: InputMaybe<Scalars['String']['input']>;
  locationContainsFold?: InputMaybe<Scalars['String']['input']>;
  locationEqualFold?: InputMaybe<Scalars['String']['input']>;
  locationGT?: InputMaybe<Scalars['String']['input']>;
  locationGTE?: InputMaybe<Scalars['String']['input']>;
  locationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  locationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  locationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  locationLT?: InputMaybe<Scalars['String']['input']>;
  locationLTE?: InputMaybe<Scalars['String']['input']>;
  locationNEQ?: InputMaybe<Scalars['String']['input']>;
  locationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** org_code field predicates */
  orgCode?: InputMaybe<Scalars['String']['input']>;
  orgCodeContains?: InputMaybe<Scalars['String']['input']>;
  orgCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  orgCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  orgCodeGT?: InputMaybe<Scalars['String']['input']>;
  orgCodeGTE?: InputMaybe<Scalars['String']['input']>;
  orgCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  orgCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  orgCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orgCodeLT?: InputMaybe<Scalars['String']['input']>;
  orgCodeLTE?: InputMaybe<Scalars['String']['input']>;
  orgCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  orgCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * VulnerabilityCVSSRawWhereInput is used for filtering VulnerabilityCVSSRaw objects.
 * Input was generated by ent.
 */
export type VulnerabilityCvssRawWhereInput = {
  and?: InputMaybe<Array<VulnerabilityCvssRawWhereInput>>;
  /** base_score field predicates */
  baseScore?: InputMaybe<Scalars['Float']['input']>;
  baseScoreGT?: InputMaybe<Scalars['Float']['input']>;
  baseScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  baseScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  baseScoreLT?: InputMaybe<Scalars['Float']['input']>;
  baseScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  baseScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  baseScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** vulnerability_raws edge predicates */
  hasVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawsWith?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<VulnerabilityCvssRawWhereInput>;
  or?: InputMaybe<Array<VulnerabilityCvssRawWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vector field predicates */
  vector?: InputMaybe<Scalars['String']['input']>;
  vectorContains?: InputMaybe<Scalars['String']['input']>;
  vectorContainsFold?: InputMaybe<Scalars['String']['input']>;
  vectorEqualFold?: InputMaybe<Scalars['String']['input']>;
  vectorGT?: InputMaybe<Scalars['String']['input']>;
  vectorGTE?: InputMaybe<Scalars['String']['input']>;
  vectorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vectorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vectorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vectorLT?: InputMaybe<Scalars['String']['input']>;
  vectorLTE?: InputMaybe<Scalars['String']['input']>;
  vectorNEQ?: InputMaybe<Scalars['String']['input']>;
  vectorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vulnerability_raws_id field predicates */
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vulnerabilityRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * VulnerabilityRawComponentNVDRelationshipWhereInput is used for filtering VulnerabilityRawComponentNVDRelationship objects.
 * Input was generated by ent.
 */
export type VulnerabilityRawComponentNvdRelationshipWhereInput = {
  and?: InputMaybe<Array<VulnerabilityRawComponentNvdRelationshipWhereInput>>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cve_nvd_id field predicates */
  cveNvdID?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDContains?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDGT?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDGTE?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cveNvdIDLT?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDLTE?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDNEQ?: InputMaybe<Scalars['String']['input']>;
  cveNvdIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** vulnerability_raws edge predicates */
  hasVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawsWith?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** match_criteria_id field predicates */
  matchCriteriaID?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDContains?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDGT?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDGTE?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  matchCriteriaIDLT?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDLTE?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDNEQ?: InputMaybe<Scalars['String']['input']>;
  matchCriteriaIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<VulnerabilityRawComponentNvdRelationshipWhereInput>;
  or?: InputMaybe<Array<VulnerabilityRawComponentNvdRelationshipWhereInput>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vulnerability_raws_id field predicates */
  vulnerabilityRawsID?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContains?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDGTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vulnerabilityRawsIDLT?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDLTE?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vulnerabilityRawsIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * VulnerabilityRawWhereInput is used for filtering VulnerabilityRaw objects.
 * Input was generated by ent.
 */
export type VulnerabilityRawWhereInput = {
  and?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** create_time field predicates */
  createTime?: InputMaybe<Scalars['Time']['input']>;
  createTimeGT?: InputMaybe<Scalars['Time']['input']>;
  createTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createTimeLT?: InputMaybe<Scalars['Time']['input']>;
  createTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  createTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  createTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** component_raws_vulnerability_raws edge predicates */
  hasComponentRawsVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentRawsVulnerabilityRawsWith?: InputMaybe<Array<ComponentRawVulnerabilityRawWhereInput>>;
  /** component_sources edge predicates */
  hasComponentSources?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSourcesWith?: InputMaybe<Array<ComponentSourceWhereInput>>;
  /** component_sync_logs edge predicates */
  hasComponentSyncLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasComponentSyncLogsWith?: InputMaybe<Array<ComponentSyncLogWhereInput>>;
  /** notification_raws_vulnerability_raws edge predicates */
  hasNotificationRawsVulnerabilityRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationRawsVulnerabilityRawsWith?: InputMaybe<Array<NotificationRawVulnerabilityRawWhereInput>>;
  /** vulnerability_cvss_raws edge predicates */
  hasVulnerabilityCvssRaws?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityCvssRawsWith?: InputMaybe<Array<VulnerabilityCvssRawWhereInput>>;
  /** vulnerability_raw_component_nvd_relationships edge predicates */
  hasVulnerabilityRawComponentNvdRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerabilityRawComponentNvdRelationshipsWith?: InputMaybe<Array<VulnerabilityRawComponentNvdRelationshipWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_update_date field predicates */
  lastUpdateDate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdateDateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<VulnerabilityRawWhereInput>;
  or?: InputMaybe<Array<VulnerabilityRawWhereInput>>;
  /** publish_date field predicates */
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  publishDateGT?: InputMaybe<Scalars['Time']['input']>;
  publishDateGTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  publishDateLT?: InputMaybe<Scalars['Time']['input']>;
  publishDateLTE?: InputMaybe<Scalars['Time']['input']>;
  publishDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  publishDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  publishDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** source_id field predicates */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContains?: InputMaybe<Scalars['ID']['input']>;
  sourceIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDGTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  sourceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIDLT?: InputMaybe<Scalars['ID']['input']>;
  sourceIDLTE?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sync_id field predicates */
  syncID?: InputMaybe<Scalars['ID']['input']>;
  syncIDContains?: InputMaybe<Scalars['ID']['input']>;
  syncIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  syncIDGT?: InputMaybe<Scalars['ID']['input']>;
  syncIDGTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  syncIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  syncIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  syncIDLT?: InputMaybe<Scalars['ID']['input']>;
  syncIDLTE?: InputMaybe<Scalars['ID']['input']>;
  syncIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  syncIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  syncIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_time field predicates */
  updateTime?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updateTimeLT?: InputMaybe<Scalars['Time']['input']>;
  updateTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  updateTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** weakness field predicates */
  weakness?: InputMaybe<Scalars['String']['input']>;
  weaknessContains?: InputMaybe<Scalars['String']['input']>;
  weaknessContainsFold?: InputMaybe<Scalars['String']['input']>;
  weaknessEqualFold?: InputMaybe<Scalars['String']['input']>;
  weaknessGT?: InputMaybe<Scalars['String']['input']>;
  weaknessGTE?: InputMaybe<Scalars['String']['input']>;
  weaknessHasPrefix?: InputMaybe<Scalars['String']['input']>;
  weaknessHasSuffix?: InputMaybe<Scalars['String']['input']>;
  weaknessIn?: InputMaybe<Array<Scalars['String']['input']>>;
  weaknessIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  weaknessLT?: InputMaybe<Scalars['String']['input']>;
  weaknessLTE?: InputMaybe<Scalars['String']['input']>;
  weaknessNEQ?: InputMaybe<Scalars['String']['input']>;
  weaknessNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  weaknessNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentSourceRawFragmentFragment = { __typename?: 'ComponentSourceRaw', id: string, componentName: string, sourceName: string, sourceID: string, vendorName: string, version?: string | null, createTime: string, eolDate?: string | null, cpe?: string | null };

export type ComponentFragmentFragment = { __typename?: 'Component', createTime?: string | null, updateTime?: string | null, id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', name: string, id: string, ifa?: string | null, description?: string | null, assessments?: Array<{ __typename?: 'ComponentVendorAssessment', type: ComponentVendorAssessmentType, result: ComponentVendorAssessmentResult, status: ComponentVendorAssessmentStatus }> | null } };

export type ComponentPartialFragmentFragment = { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } };

export type ComponentSearchFragmentFragment = { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } };

export type ProjectSummaryFragment = { __typename?: 'Project', id: string, name: string, description: string, plantName?: string | null, locationStreet?: string | null, locationCity?: string | null, locationPostalCode?: string | null, locationCountry?: string | null, plantExternalID?: string | null, customerName?: string | null, customerEmail?: string | null, customerPhone?: string | null, customerAddress?: string | null, projectStandardProfiles?: Array<{ __typename?: 'ProjectStandardProfile', id: string, standardProfile?: { __typename?: 'StandardProfile', id: string } | null }> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, milestone?: { __typename?: 'ProjectMilestone', id: string, name: string } | null, status?: { __typename?: 'ProjectStatus', id: string } | null, type?: { __typename?: 'ProjectType', id: string, name: string } | null, participants?: Array<{ __typename?: 'OrganizationUser', id: string, user: { __typename?: 'User', id: string } } | { __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string } } | null> | null, point?: { __typename?: 'Point', latitude: number, longitude: number } | null, creator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, projectAttributes?: Array<{ __typename?: 'ProjectAttribute', id: string, sequence: number, label: string, type: ProjectAttributeType, value?: string | null }> | null, projectCountries?: Array<{ __typename?: 'ProjectCountry', country: { __typename?: 'Country', id: string } }> | null, tags?: Array<{ __typename?: 'ProjectTag', id: string, name: string }> | null };

export type ProjectCustomerPartialFragment = { __typename?: 'Project', customerName?: string | null, customerEmail?: string | null, customerPhone?: string | null, customerAddress?: string | null };

export type ProjectLocationPartialFragment = { __typename?: 'Project', locationCountry?: string | null, locationCity?: string | null, locationPostalCode?: string | null, locationStreet?: string | null, point?: { __typename?: 'Point', latitude: number, longitude: number } | null };

export type ProjectPlantPartialFragment = { __typename?: 'Project', plantName?: string | null, plantExternalID?: string | null };

export type ProjectProfilePartialFragment = { __typename?: 'Project', projectStandardProfiles?: Array<{ __typename?: 'ProjectStandardProfile', id: string, standardProfile?: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null }> | null };

export type ProjectHierarchyPartialFragment = { __typename?: 'ProjectHierarchy', id: string, name: string, description: string, supplierName?: string | null, createTime: string, updateTime: string, criticality: ProjectHierarchyCriticality, commodityManager?: string | null, children: Array<{ __typename?: 'ProjectHierarchy', id: string }>, project: { __typename?: 'Project', id: string }, type: { __typename?: 'ProjectHierarchyType', id: string, name: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null, parentHierarchy?: { __typename?: 'ProjectHierarchy', id: string, name: string } | null, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }>, projectHierarchyAttributes?: Array<{ __typename?: 'ProjectHierarchyAttribute', id: string, value?: string | null, projectHierarchyAttributeDefinition: { __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType } }> | null };

export type MinimalUserPartialFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string };

export type ProjectUserPartialFragment = { __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, role?: { __typename?: 'ProjectUserRole', id: string, name: string } | null };

export type NotificationSettingsFragment = { __typename?: 'UserNotificationSetting', id: string, userID: string, enable: boolean, frequency?: UserNotificationSettingFrequency | null, projects?: Array<{ __typename?: 'UserNotificationSettingProjectConfigurationOutput', id?: string | null } | null> | null };

export type AssetRelationAttributeDefinitionFragmentFragment = { __typename?: 'AssetRelationAttributeDefinition', id: string, createTime: string, updateTime: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType, sequence: number, relationType: AssetRelationAttributeDefinitionRelationType };

export type AssetRelationFragmentFragment = { __typename?: 'AssetRelation', id: string, createTime: string, updateTime: string, name: string, description?: string | null, type: AssetRelationType, sourceAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, targetAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, assetRelationAttributes?: Array<{ __typename?: 'AssetRelationAttribute', id: string, value?: string | null, assetID?: string | null, assetRelationAttributeDefinition: { __typename?: 'AssetRelationAttributeDefinition', id: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType } } | null> | null };

export type AttributeDefinitionFragmentFragment = { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number };

export type AssetAttributeFragmentFragment = { __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } };

export type AssetItemAttributeDefinitionFragmentFragment = { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number };

export type AssetItemAttributeFragmentFragment = { __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } };

export type AssetBaseFragmentFragment = { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null };

export type AssetSummaryFragmentFragment = { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, systemRating: AssetSystemRating, assetType: { __typename?: 'AssetType', id: string, name: string }, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating } };

export type AssetItemFragmentFragment = { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string } };

export type AssetFragmentFragment = { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null };

export type FullAssetItemFragmentFragment = { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } };

export type ProjectAssetItemFragmentFragment = { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null };

export type CommentFragment = { __typename?: 'ProjectZoneStandardProfileRequirementComment', id: string, createTime: string, comment: string, requirementCommentStatus: ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type CreateComponentRequestViewFragmentFragment = { __typename?: 'ComponentCreateRequestView', id: string, componentID?: string | null, componentName: string, componentVersion: string, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, requesterID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, statusCode: ComponentCreateRequestStatusCode, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null, comments: Array<{ __typename?: 'ComponentCreateRequestViewComment', comment: string, userID: string, createTime: string }> };

export type CreateComponentRequestStatusTransitionFragment = { __typename?: 'ComponentCreateRequestViewAllowedStatusTransition', id: string, code: ComponentCreateRequestStatusCode, blocked: boolean, reason?: string | null };

export type CreateComponentRequestCommentFragment = { __typename?: 'ComponentCreateRequestViewComment', comment: string, userID: string, createTime: string };

export type CreateComponentRequestFragmentFragment = { __typename?: 'ComponentCreateRequest', id: string, componentID?: string | null, componentName?: string | null, componentVersion?: string | null, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null };

export type CreateComponentRequestViewFragment = { __typename?: 'ComponentCreateRequestView', id: string, componentID?: string | null, componentName: string, componentVersion: string, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, requesterID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, statusCode: ComponentCreateRequestStatusCode, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null, statusTransitions: Array<{ __typename?: 'ComponentCreateRequestViewAllowedStatusTransition', id: string, code: ComponentCreateRequestStatusCode, blocked: boolean, reason?: string | null }>, comments: Array<{ __typename?: 'ComponentCreateRequestViewComment', comment: string, userID: string, createTime: string }> };

export type FileAssetFieldsFragment = { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null };

export type CraModuleCommentFieldsFragment = { __typename?: 'CRAModuleComment', id: string, action: CraModuleCommentAction, content: string, createTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type EncodedFileFieldsFragment = { __typename?: 'EncodedFile', fileName: string, content: string, type: string };

export type CraUploadFieldsFragment = { __typename?: 'CRAUpload', id: string, createTime: string, updateTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type CraFieldsFragment = { __typename?: 'CRA', id: string, type: CraType, isCompleted: boolean, isApplicable?: boolean | null, justification?: string | null, updateTime: string };

export type CraCybersecRiskAssessmentUploadFieldsFragment = { __typename?: 'CRACybersecRiskAssessmentUpload', id: string, createTime: string, updateTime: string, completeness: CraCybersecRiskAssessmentUploadCompleteness, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type CraDocumentationUploadFieldsFragment = { __typename?: 'CRADocumentationUpload', id: string, createTime: string, kind: CraDocumentationUploadKind, category: CraDocumentationUploadCategory, link?: string | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, fileAsset?: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null };

export type CraVulnerabilityHandlingUploadFieldsFragment = { __typename?: 'CRAVulnerabilityHandlingUpload', id: string, createTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type CraGeneralFieldsFragment = { __typename?: 'CRAGeneral', id: string, isCompleted: boolean, productName?: string | null, ProductVersion?: string | null, ProductCategory?: CraGeneralProductCategory | null, supportPeriod?: number | null, supportPeriodStartDate?: string | null, supportPeriodEndDate?: string | null, productLifetime?: number | null, productLifetimeStartDate?: string | null, productLifetimeEndDate?: string | null, supportPeriodInformation?: string | null, createTime: string, updateTime: string, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, projectManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null };

export type NotificationFragmentFragment = { __typename?: 'Notification', id: string, title: string, publishDate: string, lastUpdateDate?: string | null, priority: NotificationPriority, impact?: string | null, source: NotificationSource, description?: string | null, cvssVector?: string | null, cvssOverrideVector?: string | null, solutionStatus: string, action: NotificationAction, solutionDetails?: string | null, references?: Array<string | null> | null, legalNotice?: string | null, cves?: Array<{ __typename?: 'Cve', id: string, code: string, description?: string | null, weakness?: string | null, publishDate: string, lastUpdateDate: string, cvssVector?: string | null, cvssBaseScore?: number | null, cvssExploitabilityScore?: number | null, cvssImpactScore?: number | null, source: CveSource } | null> | null, cvss?: { __typename?: 'CVSS20', score: number, vector: string } | { __typename?: 'CVSS30', score: number, vector: string } | { __typename?: 'CVSS40', score: number, vector: string } | null, customizedCVSS?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null, vendorAdvisories?: Array<{ __typename?: 'NotificationVendorAdvisoryOutput', vendor?: string | null, name?: string | null, url?: string | null }> | null };

export type MitigationFragmentFragment = { __typename?: 'Mitigation', id: string, createTime: string, updateTime: string, status: MitigationStatus, assignee: MitigationAssignee, statusReason?: string | null, workcycle?: { __typename?: 'Task', id: string, title: string, startAt?: string | null, dueAt?: string | null } | null, componentNotification?: { __typename?: 'ComponentNotification', notification: { __typename?: 'Notification', id: string, title: string } } | null, assetItem: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating, project: { __typename?: 'Project', id: string } }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null }, measure?: { __typename?: 'Measure', id: string, name: string, type: MeasureType, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null } | null, mitigationTests?: Array<{ __typename?: 'MitigationTest', id: string, createTime: string, updateTime: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, tester: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null };

export type ProjectHierarchyTodoFragmentFragment = { __typename?: 'ProjectHierarchyTodo', id: string, title: string, description: string, status: ProjectHierarchyTodoStatus, seqNo: number, createTime: string, updateTime: string, projectHierarchy: { __typename?: 'ProjectHierarchy', id: string } };

export type RequirementsForProfileFieldsFragment = { __typename?: 'RequirementOnProjectZone', id: string, name: string, requirementCommentStatus?: RequirementOnProjectZoneRequirementCommentStatus | null, alias: string, description: string, guidance: string, implementationGuidance?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, speName?: string | null, subSpeName?: string | null, requirementCommentCreateTime?: string | null };

export type RequirementBasicFragmentFragment = { __typename?: 'Requirement', id: string, name: string };

export type RequirementMinimalFragmentFragment = { __typename?: 'Requirement', id: string, name: string, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string } | null> | null };

export type RichStandardFragmentFragment = { __typename?: 'Standard', id: string, name: string, description: string, validFrom: string, validTo?: string | null, releasedAt: string, implementationGuidance?: string | null, requirementsCount: number, country?: { __typename?: 'Country', name: string } | null, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null };

export type StandardFragmentFragment = { __typename?: 'Standard', id: string, name: string, validFrom: string, validTo?: string | null, releasedAt: string };

export type StandardWithProfileFragment = { __typename?: 'Standard', description: string, releasedAt: string, validFrom: string, validTo?: string | null, id: string, name: string, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null };

export type SurveyClassificationClassPartialFragment = { __typename?: 'SurveyClassificationClass', id: string, name: string, description: string, activities: Array<{ __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity } | null> };

export type SecurityActivitiesPartialFragment = { __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity };

export type SurveyQuestionPartialFragment = { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null };

export type SurveyFormContentPartialFragment = { __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } };

export type SurveyFormPartialFragment = { __typename?: 'SurveyForm', id: string, version: number, contents: Array<{ __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } | null> };

export type BaseSurveyPartialFragment = { __typename?: 'Survey', id: string, optimisticLockVersion: number, classificationScore: number, status: SurveyStatus, isApproved: boolean, conductedAt?: string | null, actionTransitionLog: string, approved1At?: string | null, approved2At?: string | null, externalDocumentID?: string | null, comment: string, classificationClass: { __typename?: 'SurveyClassificationClass', id: string, name: string, description: string, activities: Array<{ __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity } | null> }, project: { __typename?: 'Project', id: string }, author: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, profile: { __typename?: 'SurveyProfile', id: string, name: string, perequisties: string, securityActivities: string } };

export type TaskPartialFragment = { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } };

export type TasksConnectionPartialFragment = { __typename?: 'TaskConnection', totalCount: number, edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } } }> };

export type TasksCommentPartialFragment = { __typename?: 'TaskComment', id: string, content: string, createTime: string, updateTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } };

export type TraBasePartialFragment = { __typename?: 'TRA', id: string, createTime: string, updateTime?: string | null, title: string, description: string, status: TraStatus, lockedAt?: string | null, approved1At?: string | null, approved2At?: string | null, project: { __typename?: 'Project', id: string, name: string }, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, participants?: Array<{ __typename?: 'TRAParticipant', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> | null, reports?: Array<{ __typename?: 'TRAReport', id: string, title: string, description: string, extension: string, classification: TraReportClassification, createTime: string }> | null };

export type TraPartialFragment = { __typename?: 'TRA', body: string, id: string, createTime: string, updateTime?: string | null, title: string, description: string, status: TraStatus, lockedAt?: string | null, approved1At?: string | null, approved2At?: string | null, project: { __typename?: 'Project', id: string, name: string }, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, participants?: Array<{ __typename?: 'TRAParticipant', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> | null, reports?: Array<{ __typename?: 'TRAReport', id: string, title: string, description: string, extension: string, classification: TraReportClassification, createTime: string }> | null };

export type CreatePersonalAccessTokenMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  expiresIn: Scalars['Int']['input'];
}>;


export type CreatePersonalAccessTokenMutation = { __typename?: 'Mutation', createAPIToken: { __typename?: 'CreateAPITokenResponse', token: string } };

export type CreateAssetRelationMutationVariables = Exact<{
  input: CreateAssetRelationRawInput;
}>;


export type CreateAssetRelationMutation = { __typename?: 'Mutation', createAssetRelation?: { __typename?: 'AssetRelation', id: string, createTime: string, updateTime: string, name: string, description?: string | null, type: AssetRelationType, sourceAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, targetAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, assetRelationAttributes?: Array<{ __typename?: 'AssetRelationAttribute', id: string, value?: string | null, assetID?: string | null, assetRelationAttributeDefinition: { __typename?: 'AssetRelationAttributeDefinition', id: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType } } | null> | null } | null };

export type UpdateAssetRelationForProjectMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: UpdateAssetRelationRawInput;
}>;


export type UpdateAssetRelationForProjectMutation = { __typename?: 'Mutation', updateAssetRelationForProject?: { __typename?: 'AssetRelation', id: string, createTime: string, updateTime: string, name: string, description?: string | null, type: AssetRelationType, sourceAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, targetAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, assetRelationAttributes?: Array<{ __typename?: 'AssetRelationAttribute', id: string, value?: string | null, assetID?: string | null, assetRelationAttributeDefinition: { __typename?: 'AssetRelationAttributeDefinition', id: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType } } | null> | null } | null };

export type DeleteAssetRelationsForProjectMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAssetRelationsForProjectMutation = { __typename?: 'Mutation', deleteAssetRelationsForProject: Array<{ __typename?: 'AssetRelation', id: string }> };

export type ImportAssetRelationsListMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  pid: Scalars['ID']['input'];
}>;


export type ImportAssetRelationsListMutation = { __typename?: 'Mutation', importAssetRelationsList: { __typename?: 'ProjectAssetRelationsImportSummary', total: number, successful: number, unsuccessful: number, assetRelationsUpdated: number, assetRelationsCreated: number, assetRelationAttributesUpdated: number, assetRelationAttributesCreated: number, failedRows?: Array<number | null> | null, errors?: Array<string | null> | null } };

export type DeleteAssetRelationAttributeDefinitionsMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAssetRelationAttributeDefinitionsMutation = { __typename?: 'Mutation', deleteAssetRelationAttributeDefinitionsForProject: Array<{ __typename?: 'AssetRelationAttributeDefinition', id: string }> };

export type CreateAssetRelationAttributeDefinitionsMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<CreateAssetRelationAttributeDefinitionRawInput> | CreateAssetRelationAttributeDefinitionRawInput;
}>;


export type CreateAssetRelationAttributeDefinitionsMutation = { __typename?: 'Mutation', createAssetRelationAttributeDefinitionsForProject: Array<{ __typename?: 'AssetRelationAttributeDefinition', id: string, createTime: string, updateTime: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType, sequence: number, relationType: AssetRelationAttributeDefinitionRelationType }> };

export type DeleteAssetsMutationVariables = Exact<{
  assetIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAssetsMutation = { __typename?: 'Mutation', deleteAsset: Array<{ __typename?: 'Asset', id: string }> };

export type MoveAssetsToSecurityZoneMutationVariables = Exact<{
  pzid: Scalars['ID']['input'];
  assetIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MoveAssetsToSecurityZoneMutation = { __typename?: 'Mutation', updateAssetsProjectZone: Array<{ __typename?: 'Asset', id: string }> };

export type UpdateAssetItemLinkedComponentMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  componentID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateAssetItemLinkedComponentMutation = { __typename?: 'Mutation', updateAssetItem: Array<{ __typename?: 'AssetItem', id: string }> };

export type UploadAssetListMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  pid: Scalars['ID']['input'];
}>;


export type UploadAssetListMutation = { __typename?: 'Mutation', importAssetsList: { __typename?: 'ProjectImportAssetsSummary', total: number, successful: number, unsuccessful: number, assetsUpdated: number, assetsCreated: number, assetItemsUpdated: number, assetItemsCreated: number, projectZonesUpdated: number, failedRows?: Array<number | null> | null, errors?: Array<string | null> | null } };

export type CreateAssetMutationVariables = Exact<{
  input: Array<CreateAssetRawInput> | CreateAssetRawInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset: Array<{ __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }> };

export type UpdateAssetsMutationVariables = Exact<{
  input: UpdateAssetBulkInput;
}>;


export type UpdateAssetsMutation = { __typename?: 'Mutation', updateAssets: Array<{ __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }> };

export type CreateAssetItemMutationVariables = Exact<{
  input: Array<CreateAssetItemRawInput> | CreateAssetItemRawInput;
}>;


export type CreateAssetItemMutation = { __typename?: 'Mutation', createAssetItem: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> };

export type UpdateAssetItemMutationVariables = Exact<{
  input: UpdateAssetItemBulkInput;
}>;


export type UpdateAssetItemMutation = { __typename?: 'Mutation', updateAssetItem: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null }> };

export type DeleteAssetItemMutationVariables = Exact<{
  input: BulkIdInput;
}>;


export type DeleteAssetItemMutation = { __typename?: 'Mutation', deleteAssetItem: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string } }> };

export type CreateAssetAttributeDefinitionMutationVariables = Exact<{
  input: Array<CreateAssetAttributeDefinitionRawInput> | CreateAssetAttributeDefinitionRawInput;
}>;


export type CreateAssetAttributeDefinitionMutation = { __typename?: 'Mutation', createAssetAttributeDefinition: Array<{ __typename?: 'AssetAttributeDefinition', id: string }> };

export type UpdateAssetAttributeDefinitionSequenceMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<UpdateAssetAttributeDefinitionSequenceRawInput> | UpdateAssetAttributeDefinitionSequenceRawInput;
}>;


export type UpdateAssetAttributeDefinitionSequenceMutation = { __typename?: 'Mutation', updateAssetAttributeDefinitionSequence: Array<{ __typename?: 'AssetAttributeDefinition', id: string, sequence: number }> };

export type UpdateAssetItemAttributeDefinitionSequenceMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<UpdateAssetItemAttributeDefinitionSequenceRawInput> | UpdateAssetItemAttributeDefinitionSequenceRawInput;
}>;


export type UpdateAssetItemAttributeDefinitionSequenceMutation = { __typename?: 'Mutation', updateAssetItemAttributeDefinitionSequence: Array<{ __typename?: 'AssetItemAttributeDefinition', id: string, sequence: number }> };

export type DeleteAssetAttributeDefinitionMutationVariables = Exact<{
  input: BulkIdInput;
}>;


export type DeleteAssetAttributeDefinitionMutation = { __typename?: 'Mutation', deleteAssetAttributeDefinition: Array<{ __typename?: 'AssetAttributeDefinition', id: string }> };

export type CreateItemAttributeDefinitionMutationVariables = Exact<{
  input: Array<CreateAssetItemAttributeDefinitionRawInput> | CreateAssetItemAttributeDefinitionRawInput;
}>;


export type CreateItemAttributeDefinitionMutation = { __typename?: 'Mutation', createAssetItemAttributeDefinition: Array<{ __typename?: 'AssetItemAttributeDefinition', id: string }> };

export type DeleteItemAttributeDefinitionMutationVariables = Exact<{
  input: BulkIdInput;
}>;


export type DeleteItemAttributeDefinitionMutation = { __typename?: 'Mutation', deleteAssetItemAttributeDefinition: Array<{ __typename?: 'AssetItemAttributeDefinition', id: string }> };

export type CreateCommentMutationVariables = Exact<{
  spid: Scalars['ID']['input'];
  rqid: Scalars['ID']['input'];
  pzid: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  status: ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createProjectZoneStandardProfileRequirementComment: { __typename?: 'ProjectZoneStandardProfileRequirementComment', id: string, createTime: string, comment: string, requirementCommentStatus: ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } };

export type CreateComponentCreateRequestMutationVariables = Exact<{
  input: CreateComponentCreateRequestRawInput;
}>;


export type CreateComponentCreateRequestMutation = { __typename?: 'Mutation', createComponentCreateRequest?: { __typename?: 'CreateComponentCreateRequestWithStatusTransitionsOutput', request: { __typename?: 'ComponentCreateRequest', id: string, componentID?: string | null, componentName?: string | null, componentVersion?: string | null, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null }, statusTransitions: Array<{ __typename?: 'ComponentCreateRequestViewAllowedStatusTransition', id: string, code: ComponentCreateRequestStatusCode, blocked: boolean, reason?: string | null }> } | null };

export type ChangeComponentCreateRequestStatusMutationVariables = Exact<{
  input: ReviewComponentCreateRequestRawInput;
}>;


export type ChangeComponentCreateRequestStatusMutation = { __typename?: 'Mutation', reviewComponentCreateRequest?: { __typename?: 'ComponentCreateRequest', id: string, componentID?: string | null, componentName?: string | null, componentVersion?: string | null, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null } | null };

export type UpdateComponentCreateRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateComponentCreateRequestRawInput;
}>;


export type UpdateComponentCreateRequestMutation = { __typename?: 'Mutation', updateComponentCreateRequest?: { __typename?: 'ComponentCreateRequest', id: string, componentID?: string | null, componentName?: string | null, componentVersion?: string | null, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null } | null };

export type SaveCraMutationVariables = Exact<{
  input: SaveCraInput;
}>;


export type SaveCraMutation = { __typename?: 'Mutation', saveCRA: { __typename?: 'CRA', id: string, type: CraType, isCompleted: boolean, isApplicable?: boolean | null, justification?: string | null, updateTime: string } };

export type SetCraCompletionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
}>;


export type SetCraCompletionMutation = { __typename?: 'Mutation', setCRACompletion: { __typename?: 'CRA', id: string, isCompleted: boolean, isApplicable?: boolean | null, justification?: string | null, updateTime: string } };

export type CreateCraUploadMutationVariables = Exact<{
  craID: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
}>;


export type CreateCraUploadMutation = { __typename?: 'Mutation', createCRAUpload: { __typename?: 'CRAUpload', id: string, createTime: string, updateTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } } };

export type DeleteCraUploadMutationVariables = Exact<{
  craUploadID: Scalars['ID']['input'];
}>;


export type DeleteCraUploadMutation = { __typename?: 'Mutation', deleteCRAUpload: string };

export type SetCraCybersecRiskAssessmentCompletionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
}>;


export type SetCraCybersecRiskAssessmentCompletionMutation = { __typename?: 'Mutation', setCRACybersecRiskAssessmentCompletion: { __typename?: 'CRACybersecRiskAssessment', id: string, isCompleted: boolean, updateTime: string } };

export type CreateCraCybersecRiskAssessmentUploadMutationVariables = Exact<{
  craCybersecurityRiskAssessmentID: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
}>;


export type CreateCraCybersecRiskAssessmentUploadMutation = { __typename?: 'Mutation', createCRACybersecRiskAssessmentUpload: { __typename?: 'CRACybersecRiskAssessmentUpload', id: string, createTime: string, updateTime: string, completeness: CraCybersecRiskAssessmentUploadCompleteness, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } } };

export type SetCompletenessCraCybersecRiskAssessmentUploadMutationVariables = Exact<{
  craCybersecurityRiskAssessmentUploadID: Scalars['ID']['input'];
  completeness: CraCybersecRiskAssessmentUploadCompleteness;
}>;


export type SetCompletenessCraCybersecRiskAssessmentUploadMutation = { __typename?: 'Mutation', setCompletenessCRACybersecRiskAssessmentUpload: { __typename?: 'CRACybersecRiskAssessmentUpload', id: string, completeness: CraCybersecRiskAssessmentUploadCompleteness, updateTime: string } };

export type DeleteCraCybersecRiskAssessmentUploadMutationVariables = Exact<{
  craCybersecurityRiskAssessmentUploadID: Scalars['ID']['input'];
}>;


export type DeleteCraCybersecRiskAssessmentUploadMutation = { __typename?: 'Mutation', deleteCRACybersecRiskAssessmentUpload: string };

export type CreateCraDocumentationUploadMutationVariables = Exact<{
  input: CreateCraDocumentationUploadRawInput;
  upload?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type CreateCraDocumentationUploadMutation = { __typename?: 'Mutation', createCRADocumentationUpload: { __typename?: 'CRADocumentationUpload', id: string, createTime: string, kind: CraDocumentationUploadKind, category: CraDocumentationUploadCategory, link?: string | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, fileAsset?: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } };

export type DeleteCraDocumentationUploadMutationVariables = Exact<{
  craDocumentationUploadID: Scalars['ID']['input'];
}>;


export type DeleteCraDocumentationUploadMutation = { __typename?: 'Mutation', deleteCRADocumentationUpload: string };

export type SaveCraDocumentationMutationVariables = Exact<{
  input: SaveCraDocumentationInput;
}>;


export type SaveCraDocumentationMutation = { __typename?: 'Mutation', saveCRADocumentation: { __typename?: 'CRADocumentation', id: string, isCompleted: boolean, hasProductVisual: boolean, hasRefDocuments: boolean, hasIntendedPurpose: boolean, hasSecDesignArchitecture: boolean, hasProcessReference: boolean, uploads: Array<{ __typename?: 'CRADocumentationUpload', id: string, createTime: string, kind: CraDocumentationUploadKind, category: CraDocumentationUploadCategory, link?: string | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, fileAsset?: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null }> } };

export type SetCraDocumentationCompletionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
}>;


export type SetCraDocumentationCompletionMutation = { __typename?: 'Mutation', setCRADocumentationCompletion: { __typename?: 'CRADocumentation', id: string, isCompleted: boolean } };

export type SaveCraVulnerabilityHandlingMutationVariables = Exact<{
  input: SaveCraVulnerabilityHandlingInput;
}>;


export type SaveCraVulnerabilityHandlingMutation = { __typename?: 'Mutation', saveCRAVulnerabilityHandling: { __typename?: 'CRAVulnerabilityHandling', id: string, IsCompleted: boolean, seContact?: string | null, seContactValidationDate?: string | null, customerContact?: string | null, customerContactValidationDate?: string | null } };

export type SetCraVulnerabilityHandlingCompletionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
}>;


export type SetCraVulnerabilityHandlingCompletionMutation = { __typename?: 'Mutation', setCRAVulnerabilityHandlingCompletion: { __typename?: 'CRAVulnerabilityHandling', id: string, IsCompleted: boolean } };

export type CreateCraVulnerabilityHandlingUploadMutationVariables = Exact<{
  craVulnerabilityHandlingID: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
}>;


export type CreateCraVulnerabilityHandlingUploadMutation = { __typename?: 'Mutation', createCRAVulnerabilityHandlingUpload: { __typename?: 'CRAVulnerabilityHandlingUpload', id: string, createTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } } };

export type DeleteCraVulnerabilityHandlingUploadMutationVariables = Exact<{
  craVulnerabilityHandlingUploadID: Scalars['ID']['input'];
}>;


export type DeleteCraVulnerabilityHandlingUploadMutation = { __typename?: 'Mutation', deleteCRAVulnerabilityHandlingUpload: string };

export type SaveCraGeneralMutationVariables = Exact<{
  input: SaveCraGeneralInput;
}>;


export type SaveCraGeneralMutation = { __typename?: 'Mutation', saveCRAGeneral: { __typename?: 'CRAGeneral', id: string, isCompleted: boolean, productName?: string | null, ProductVersion?: string | null, ProductCategory?: CraGeneralProductCategory | null, supportPeriod?: number | null, supportPeriodStartDate?: string | null, supportPeriodEndDate?: string | null, productLifetime?: number | null, productLifetimeStartDate?: string | null, productLifetimeEndDate?: string | null, supportPeriodInformation?: string | null, createTime: string, updateTime: string, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, projectManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null } };

export type SetCraGeneralCompletionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
}>;


export type SetCraGeneralCompletionMutation = { __typename?: 'Mutation', setCRAGeneralCompletion: { __typename?: 'CRAGeneral', id: string, isCompleted: boolean } };

export type OverrideCvssMutationVariables = Exact<{
  data: OverrideCvssInput;
}>;


export type OverrideCvssMutation = { __typename?: 'Mutation', overrideCVSS: boolean };

export type CreateProjectHierarchyMutationVariables = Exact<{
  attributes?: InputMaybe<Array<SaveProjectHierarchyAttributeRawInput> | SaveProjectHierarchyAttributeRawInput>;
  commodityManager?: InputMaybe<Scalars['String']['input']>;
  criticality: ProjectHierarchyCriticality;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
  projectID: Scalars['ID']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  typeID: Scalars['ID']['input'];
}>;


export type CreateProjectHierarchyMutation = { __typename?: 'Mutation', saveProjectHierarchy: { __typename?: 'ProjectHierarchy', id: string, name: string, description: string, supplierName?: string | null, createTime: string, updateTime: string, criticality: ProjectHierarchyCriticality, commodityManager?: string | null, children: Array<{ __typename?: 'ProjectHierarchy', id: string }>, project: { __typename?: 'Project', id: string }, type: { __typename?: 'ProjectHierarchyType', id: string, name: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null, parentHierarchy?: { __typename?: 'ProjectHierarchy', id: string, name: string } | null, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }>, projectHierarchyAttributes?: Array<{ __typename?: 'ProjectHierarchyAttribute', id: string, value?: string | null, projectHierarchyAttributeDefinition: { __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType } }> | null } };

export type DeleteProjectHierarchyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectHierarchyMutation = { __typename?: 'Mutation', deleteProjectHierarchy: { __typename?: 'ProjectHierarchy', id: string } };

export type CreateProjectHierarchyAssetMutationVariables = Exact<{
  assetIDs: BulkIdInput;
  projectHierarchyID: Scalars['ID']['input'];
}>;


export type CreateProjectHierarchyAssetMutation = { __typename?: 'Mutation', createProjectHierarchyAsset: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }> };

export type GetProjectHierarchyForAssetQueryVariables = Exact<{
  assetID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyForAssetQuery = { __typename?: 'Query', projectHierarchies: { __typename?: 'ProjectHierarchyConnection', edges: Array<{ __typename?: 'ProjectHierarchyEdge', node: { __typename?: 'ProjectHierarchy', id: string, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }> } }> } };

export type CreateProjectHierarchyFileMutationVariables = Exact<{
  projectHierarchyID: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectHierarchyFileMutation = { __typename?: 'Mutation', createProjectHierarchyFile: { __typename?: 'ProjectHierarchyFile', id: string, projectHierarchyID: string, createTime: string, updateTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, size: number, contentType: string, createTime: string } } };

export type DeleteProjectHierarchyFilesMutationVariables = Exact<{
  input: BulkIdInput;
}>;


export type DeleteProjectHierarchyFilesMutation = { __typename?: 'Mutation', deleteProjectHierarchyFiles: Array<{ __typename?: 'ProjectHierarchyFile', id: string }> };

export type CreateProjectHierarchyAttributeDefinitionMutationVariables = Exact<{
  input: Array<CreateProjectHierarchyAttributeDefinitionInput> | CreateProjectHierarchyAttributeDefinitionInput;
}>;


export type CreateProjectHierarchyAttributeDefinitionMutation = { __typename?: 'Mutation', createProjectHierarchyAttributeDefinition: Array<{ __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType, project: { __typename?: 'Project', id: string }, projectHierarchyType: { __typename?: 'ProjectHierarchyType', id: string } }> };

export type DeleteProjectHierarchyAttributeDefinitionMutationVariables = Exact<{
  input: BulkIdInput;
}>;


export type DeleteProjectHierarchyAttributeDefinitionMutation = { __typename?: 'Mutation', deleteProjectHierarchyAttributeDefinition: Array<{ __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType, isMandatory: boolean }> };

export type UpdateProjectHierarchyAttributeDefinitionSequenceMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<UpdateProjectHierarchyAttributeDefinitionSequenceRawInput> | UpdateProjectHierarchyAttributeDefinitionSequenceRawInput;
}>;


export type UpdateProjectHierarchyAttributeDefinitionSequenceMutation = { __typename?: 'Mutation', updateProjectHierarchyAttributeDefinitionSequence: Array<{ __typename?: 'ProjectHierarchyAttributeDefinition', id: string, sequence: number }> };

export type CreateMeasureMutationVariables = Exact<{
  input: CreateMeasureInput;
}>;


export type CreateMeasureMutation = { __typename?: 'Mutation', createMeasure: { __typename?: 'Measure', id: string, createTime: string, updateTime: string, name: string, type: MeasureType, howto?: string | null, resources?: string | null, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null, mitigations?: Array<{ __typename?: 'Mitigation', id: string }> | null } };

export type UpdateMeasureMutationVariables = Exact<{
  input: UpdateMeasureRawInput;
}>;


export type UpdateMeasureMutation = { __typename?: 'Mutation', updateMeasure: { __typename?: 'Measure', id: string, createTime: string, updateTime: string, name: string, type: MeasureType, howto?: string | null, resources?: string | null, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null, mitigations?: Array<{ __typename?: 'Mitigation', id: string }> | null } };

export type SaveMitigationsBulkMutationVariables = Exact<{
  input: SaveMitigationBulkInput;
}>;


export type SaveMitigationsBulkMutation = { __typename?: 'Mutation', saveMitigationsBulk: Array<{ __typename?: 'Mitigation', id: string, createTime: string, updateTime: string, status: MitigationStatus, assignee: MitigationAssignee, statusReason?: string | null, workcycle?: { __typename?: 'Task', id: string, title: string, startAt?: string | null, dueAt?: string | null } | null, componentNotification?: { __typename?: 'ComponentNotification', notification: { __typename?: 'Notification', id: string, title: string } } | null, assetItem: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating, project: { __typename?: 'Project', id: string } }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null }, measure?: { __typename?: 'Measure', id: string, name: string, type: MeasureType, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null } | null, mitigationTests?: Array<{ __typename?: 'MitigationTest', id: string, createTime: string, updateTime: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, tester: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null }> };

export type SetMitigationsStatusMutationVariables = Exact<{
  input: SetMitigationssStatusInput;
}>;


export type SetMitigationsStatusMutation = { __typename?: 'Mutation', setMitigationsStatus: Array<{ __typename?: 'Mitigation', id: string, createTime: string, updateTime: string, status: MitigationStatus, assignee: MitigationAssignee, statusReason?: string | null, workcycle?: { __typename?: 'Task', id: string, title: string, startAt?: string | null, dueAt?: string | null } | null, componentNotification?: { __typename?: 'ComponentNotification', notification: { __typename?: 'Notification', id: string, title: string } } | null, assetItem: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating, project: { __typename?: 'Project', id: string } }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null }, measure?: { __typename?: 'Measure', id: string, name: string, type: MeasureType, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null } | null, mitigationTests?: Array<{ __typename?: 'MitigationTest', id: string, createTime: string, updateTime: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, tester: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null }> };

export type CreateMitigationTestsMutationVariables = Exact<{
  input: Array<CreateMitigationTestRawInput> | CreateMitigationTestRawInput;
}>;


export type CreateMitigationTestsMutation = { __typename?: 'Mutation', createMitigationTests: Array<{ __typename?: 'MitigationTest', id: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, measure: { __typename?: 'Measure', id: string }, mitigation: { __typename?: 'Mitigation', id: string }, tester: { __typename?: 'User', id: string } }> };

export type UpdateMitigationTestsMutationVariables = Exact<{
  input: UpdateMitigationTestBulkInput;
}>;


export type UpdateMitigationTestsMutation = { __typename?: 'Mutation', updateMitigationTests: Array<{ __typename?: 'MitigationTest', id: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, measure: { __typename?: 'Measure', id: string }, mitigation: { __typename?: 'Mitigation', id: string }, tester: { __typename?: 'User', id: string } }> };

export type CreateProjectHierarchyTodoMutationVariables = Exact<{
  description: Scalars['String']['input'];
  hierarchyID: Scalars['ID']['input'];
  status: ProjectHierarchyTodoStatus;
  title: Scalars['String']['input'];
}>;


export type CreateProjectHierarchyTodoMutation = { __typename?: 'Mutation', createProjectHierarchyTodos: Array<{ __typename?: 'ProjectHierarchyTodo', id: string, title: string, description: string, status: ProjectHierarchyTodoStatus, seqNo: number, createTime: string, updateTime: string, projectHierarchy: { __typename?: 'ProjectHierarchy', id: string } }> };

export type UpdateProjectHierarchyTodoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectHierarchyTodoStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateProjectHierarchyTodoMutation = { __typename?: 'Mutation', updateProjectHierarchyTodo?: { __typename?: 'ProjectHierarchyTodo', id: string, title: string, description: string, status: ProjectHierarchyTodoStatus, seqNo: number, createTime: string, updateTime: string, projectHierarchy: { __typename?: 'ProjectHierarchy', id: string } } | null };

export type DeleteProjectHierarchyTodoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectHierarchyTodoMutation = { __typename?: 'Mutation', deleteProjectHierarchyTodos: Array<{ __typename?: 'ProjectHierarchyTodo', id: string }> };

export type CreateBulkProjectHierarchyTodosMutationVariables = Exact<{
  hierarchyID: Scalars['ID']['input'];
  input: Array<CreateProjectHierarchyTodoRawInput> | CreateProjectHierarchyTodoRawInput;
}>;


export type CreateBulkProjectHierarchyTodosMutation = { __typename?: 'Mutation', createProjectHierarchyTodos: Array<{ __typename?: 'ProjectHierarchyTodo', id: string, title: string, description: string, status: ProjectHierarchyTodoStatus, seqNo: number, createTime: string, updateTime: string, projectHierarchy: { __typename?: 'ProjectHierarchy', id: string } }> };

export type DeleteBulkProjectHierarchyTodosMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteBulkProjectHierarchyTodosMutation = { __typename?: 'Mutation', deleteProjectHierarchyTodos: Array<{ __typename?: 'ProjectHierarchyTodo', id: string }> };

export type SetUsersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  users?: InputMaybe<Array<ProjectUserInput> | ProjectUserInput>;
}>;


export type SetUsersMutation = { __typename?: 'Mutation', setProjectUsers?: Array<{ __typename?: 'ProjectUser', user: { __typename?: 'User', id: string, firstName: string, lastName: string }, role?: { __typename?: 'ProjectUserRole', id: string, name: string } | null } | null> | null };

export type CreateProjectGuidanceConfigMutationVariables = Exact<{
  name: Scalars['String']['input'];
  projectTypeID: Scalars['ID']['input'];
  standardProfileID: Scalars['ID']['input'];
  requirementsConfig?: InputMaybe<Array<SaveProjectGuidanceRequirementConfigInput> | SaveProjectGuidanceRequirementConfigInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateProjectGuidanceConfigMutation = { __typename?: 'Mutation', saveProjectGuidance: { __typename?: 'ProjectGuidance', id: string, name: string } };

export type DeleteProjectGuidanceConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectGuidanceConfigMutation = { __typename?: 'Mutation', deleteProjectGuidance: { __typename?: 'ProjectGuidance', id: string } };

export type PublishProjectGuidanceConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishProjectGuidanceConfigMutation = { __typename?: 'Mutation', publishProjectGuidance: { __typename?: 'ProjectGuidance', id: string, name: string, isPublished: boolean } };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  statusID: Scalars['ID']['input'];
  milestoneID: Scalars['ID']['input'];
  typeID: Scalars['ID']['input'];
  organizationID: Scalars['ID']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  locationStreet?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  plantName?: InputMaybe<Scalars['String']['input']>;
  plantExternalID?: InputMaybe<Scalars['String']['input']>;
  pointInput?: InputMaybe<PointInput>;
  standardProfileIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'Project', id: string, name: string, description: string, updateTime?: string | null, createTime?: string | null, locationCountry?: string | null, locationCity?: string | null, locationPostalCode?: string | null, locationStreet?: string | null, plantName?: string | null, plantExternalID?: string | null, creator?: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, email: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, milestone?: { __typename?: 'ProjectMilestone', id: string, name: string } | null, status?: { __typename?: 'ProjectStatus', id: string, name: string } | null, type?: { __typename?: 'ProjectType', id: string, name: string } | null, tags?: Array<{ __typename?: 'ProjectTag', id: string, name: string }> | null, point?: { __typename?: 'Point', latitude: number, longitude: number } | null, projectStandardProfiles?: Array<{ __typename?: 'ProjectStandardProfile', id: string, standardProfile?: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null }> | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  statusID?: InputMaybe<Scalars['ID']['input']>;
  milestoneID?: InputMaybe<Scalars['ID']['input']>;
  typeID?: InputMaybe<Scalars['ID']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  locationStreet?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  plantName?: InputMaybe<Scalars['String']['input']>;
  plantExternalID?: InputMaybe<Scalars['String']['input']>;
  pointInput?: InputMaybe<PointInput>;
  securityResponsibleID?: InputMaybe<Scalars['ID']['input']>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'Project', id: string, name: string, description: string, updateTime?: string | null, createTime?: string | null, customerName?: string | null, customerEmail?: string | null, customerPhone?: string | null, customerAddress?: string | null, locationCountry?: string | null, locationCity?: string | null, locationPostalCode?: string | null, locationStreet?: string | null, plantName?: string | null, plantExternalID?: string | null, creator?: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, email: string } | null, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, milestone?: { __typename?: 'ProjectMilestone', id: string, name: string } | null, status?: { __typename?: 'ProjectStatus', id: string, name: string } | null, type?: { __typename?: 'ProjectType', id: string, name: string } | null, tags?: Array<{ __typename?: 'ProjectTag', id: string, name: string }> | null, point?: { __typename?: 'Point', latitude: number, longitude: number } | null } | null };

export type CopyProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  milestoneID: Scalars['ID']['input'];
  statusID: Scalars['ID']['input'];
  copyProjectAttributes: Scalars['Boolean']['input'];
  copyProjectUsers: Scalars['Boolean']['input'];
  copyCountries: Scalars['Boolean']['input'];
  copyStandardProfiles: Scalars['Boolean']['input'];
  copyCustomerAndLocation: Scalars['Boolean']['input'];
  copyTasks: Scalars['Boolean']['input'];
  copyTasksDeliverables: Scalars['Boolean']['input'];
  copyTasksEvidences: Scalars['Boolean']['input'];
  copyPssClassification: Scalars['Boolean']['input'];
  copyCRAEU: Scalars['Boolean']['input'];
  copyCRAEULinkedFiles: Scalars['Boolean']['input'];
  copyProjectHierarchyAttributes: Scalars['Boolean']['input'];
  copyProjectHierarchies: Scalars['Boolean']['input'];
  copyProjectHierarchiesFiles: Scalars['Boolean']['input'];
  copyProjectHierarchiesTodos: Scalars['Boolean']['input'];
  copyProjectZones: Scalars['Boolean']['input'];
  copyProjectZoneStandardProfiles: Scalars['Boolean']['input'];
  copyAssetAttributes: Scalars['Boolean']['input'];
  copyAssets: Scalars['Boolean']['input'];
  copyAssetItems: Scalars['Boolean']['input'];
  copyAssetRelations: Scalars['Boolean']['input'];
  copyAssetItemsAttributes: Scalars['Boolean']['input'];
  copyAssetRelationsAttributes: Scalars['Boolean']['input'];
  copyMeasures: Scalars['Boolean']['input'];
  copyTRA: Scalars['Boolean']['input'];
}>;


export type CopyProjectMutation = { __typename?: 'Mutation', copyProject?: { __typename?: 'CopyProjectResult', projectID: string } | null };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject?: { __typename?: 'Project', id: string } | null };

export type CreateProjectZoneMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  parentZoneId: Scalars['ID']['input'];
  exposureRating: ProjectZoneExposureRating;
  standardProfileIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateProjectZoneMutation = { __typename?: 'Mutation', saveProjectZone: { __typename?: 'ProjectZone', id: string, name: string } };

export type UpdateProjectZoneMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  parentZoneId?: InputMaybe<Scalars['ID']['input']>;
  exposureRating: ProjectZoneExposureRating;
  standardProfileIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateProjectZoneMutation = { __typename?: 'Mutation', saveProjectZone: { __typename?: 'ProjectZone', id: string } };

export type DeleteProjectZoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectZoneMutation = { __typename?: 'Mutation', deleteProjectZone: { __typename?: 'ProjectZone', id: string } };

export type CreateProjectAttributeMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<CreateProjectAttributeRawInput> | CreateProjectAttributeRawInput;
}>;


export type CreateProjectAttributeMutation = { __typename?: 'Mutation', createProjectAttribute: Array<{ __typename?: 'ProjectAttribute', id: string, label: string, type: ProjectAttributeType, sequence: number }> };

export type DeleteProjectAttributeMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: BulkIdInput;
}>;


export type DeleteProjectAttributeMutation = { __typename?: 'Mutation', deleteProjectAttribute: Array<{ __typename?: 'ProjectAttribute', id: string }> };

export type UpdateProjectAttributeSequenceMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<UpdateProjectAttributeSequenceRawInput> | UpdateProjectAttributeSequenceRawInput;
}>;


export type UpdateProjectAttributeSequenceMutation = { __typename?: 'Mutation', updateProjectAttributeSequence: Array<{ __typename?: 'ProjectAttribute', id: string, sequence: number }> };

export type UpdateProjectAttributeMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  input: Array<UpdateProjectAttributeValueInput> | UpdateProjectAttributeValueInput;
}>;


export type UpdateProjectAttributeMutation = { __typename?: 'Mutation', updateProjectAttributeValue: Array<{ __typename?: 'ProjectAttribute', id: string, label: string, type: ProjectAttributeType, sequence: number, value?: string | null }> };

export type UploadStandardsMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadStandardsMutation = { __typename?: 'Mutation', importStandards: { __typename?: 'StandardImportSummary', errors?: Array<string | null> | null, standards?: { __typename?: 'StandardImportSummaryStats', total: number, successful: number, unsuccessful: number, failedRows?: Array<number | null> | null } | null, requirements?: { __typename?: 'StandardImportSummaryStats', total: number, successful: number, unsuccessful: number, failedRows?: Array<number | null> | null, missing?: Array<string | null> | null } | null, mappings?: { __typename?: 'StandardImportSummaryStats', total: number, successful: number, unsuccessful: number } | null } };

export type ComponentVendorAssessmentImportSummaryMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ComponentVendorAssessmentImportSummaryMutation = { __typename?: 'Mutation', importComponentVendorAssessments: { __typename?: 'ComponentVendorAssessmentImportSummary', errors?: Array<string | null> | null } };

export type ExportComponentVendorAssessmentsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportComponentVendorAssessmentsQueryQuery = { __typename?: 'Query', exportComponentVendorAssessments: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type SaveSurveyMutationVariables = Exact<{
  surveyInput: SaveSurveyInput;
}>;


export type SaveSurveyMutation = { __typename?: 'Mutation', saveSurvey: { __typename: 'Survey', answers: string, id: string, optimisticLockVersion: number, classificationScore: number, status: SurveyStatus, isApproved: boolean, conductedAt?: string | null, actionTransitionLog: string, approved1At?: string | null, approved2At?: string | null, externalDocumentID?: string | null, comment: string, form: { __typename?: 'SurveyForm', version: number, id: string, contents: Array<{ __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } | null> }, classificationClass: { __typename?: 'SurveyClassificationClass', id: string, name: string, description: string, activities: Array<{ __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity } | null> }, project: { __typename?: 'Project', id: string }, author: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, profile: { __typename?: 'SurveyProfile', id: string, name: string, perequisties: string, securityActivities: string } } };

export type DeleteSurveyMutationVariables = Exact<{
  surveyID: Scalars['ID']['input'];
}>;


export type DeleteSurveyMutation = { __typename?: 'Mutation', deleteSurvey: { __typename?: 'Survey', id: string } };

export type SetSurveyStateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  surveyStateSatus: SurveySetStateStatus;
  optimisticLockVersion: Scalars['Int']['input'];
}>;


export type SetSurveyStateMutation = { __typename?: 'Mutation', setSurveyState: { __typename?: 'Survey', answers: string, id: string, optimisticLockVersion: number, classificationScore: number, status: SurveyStatus, isApproved: boolean, conductedAt?: string | null, actionTransitionLog: string, approved1At?: string | null, approved2At?: string | null, externalDocumentID?: string | null, comment: string, form: { __typename?: 'SurveyForm', version: number, id: string, contents: Array<{ __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } | null> }, classificationClass: { __typename?: 'SurveyClassificationClass', id: string, name: string, description: string, activities: Array<{ __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity } | null> }, project: { __typename?: 'Project', id: string }, author: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, profile: { __typename?: 'SurveyProfile', id: string, name: string, perequisties: string, securityActivities: string } } };

export type SurveyFormImportMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type SurveyFormImportMutation = { __typename?: 'Mutation', surveyFormImport: { __typename?: 'SurveyFormImportSummary', errors?: Array<string> | null } };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskRawInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } } };

export type UpdateTasksMutationVariables = Exact<{
  updateTaskBulkInput: UpdateTaskBulkInput;
}>;


export type UpdateTasksMutation = { __typename?: 'Mutation', updateTasks: Array<{ __typename?: 'Task', id: string, status: TaskStatus }> };

export type DeleteProjectTasksMutationVariables = Exact<{
  pid: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteProjectTasksMutation = { __typename?: 'Mutation', deleteProjectTasks: Array<{ __typename?: 'Task', id: string }> };

export type SaveTaskDeliverablesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<SaveTaskDeliverableInput> | SaveTaskDeliverableInput;
}>;


export type SaveTaskDeliverablesMutation = { __typename?: 'Mutation', saveTaskDeliverables: Array<{ __typename?: 'TaskDeliverable', id: string }> };

export type CreateTaskCommentMutationVariables = Exact<{
  input: CreateTaskCommentRawInput;
}>;


export type CreateTaskCommentMutation = { __typename?: 'Mutation', createTaskComment: { __typename?: 'TaskComment', id: string } };

export type CreateTaskEvidenceLinkMutationVariables = Exact<{
  input: CreateTaskEvidenceRawInput;
  upload?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type CreateTaskEvidenceLinkMutation = { __typename?: 'Mutation', createTaskEvidence: { __typename?: 'TaskEvidence', id: string } };

export type DeleteTaskEvidenceMutationVariables = Exact<{
  taskID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskEvidenceMutation = { __typename?: 'Mutation', deleteTaskEvidence: { __typename?: 'TaskEvidence', id: string } };

export type CreateTraMutationVariables = Exact<{
  input: CreateTraRawInput;
}>;


export type CreateTraMutation = { __typename?: 'Mutation', createTRA: { __typename?: 'TRA', id: string, title: string, description: string, status: TraStatus, lockedAt?: string | null, project: { __typename?: 'Project', id: string, name: string }, lockedBy?: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, orgCode: string, email: string, location: string, are: string, admin: boolean, active: boolean } | null, createdBy: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, orgCode: string, email: string, location: string, are: string, admin: boolean, active: boolean }, approver1?: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, orgCode: string, email: string, location: string, are: string, admin: boolean, active: boolean } | null, approver2?: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, orgCode: string, email: string, location: string, are: string, admin: boolean, active: boolean } | null } };

export type CreateTraReportMutationVariables = Exact<{
  input: CreateTraReportRawInput;
}>;


export type CreateTraReportMutation = { __typename?: 'Mutation', createTRAReport: { __typename?: 'TRAReport', id: string } };

export type ActivateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'User', id: string, active: boolean } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'User', id: string, active: boolean } };

export type UploadUserMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadUserMutation = { __typename?: 'Mutation', importUsers: { __typename?: 'UserImportSummary', total: number, successful: number, unsuccessful: number, failedRows?: Array<number | null> | null, errors?: Array<string | null> | null } };

export type SaveUserNotificationSettingsMutationVariables = Exact<{
  input: SaveUserNotificationSettingInput;
}>;


export type SaveUserNotificationSettingsMutation = { __typename?: 'Mutation', saveUserNotificationSetting: { __typename?: 'UserNotificationSetting', id: string, userID: string, enable: boolean } };

export type SetUserOrganizationsMutationVariables = Exact<{
  input: SetUserOrganizationsInput;
}>;


export type SetUserOrganizationsMutation = { __typename?: 'Mutation', setUserOrganizations?: Array<{ __typename?: 'OrganizationUser', id: string, role: OrganizationUserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null }> | null };

export type GetAssetRelationsForProjectQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetRelationOrder>;
  where?: InputMaybe<AssetRelationWhereInput>;
}>;


export type GetAssetRelationsForProjectQuery = { __typename?: 'Query', assetRelationsForProject: { __typename?: 'AssetRelationConnection', totalCount: number, edges: Array<{ __typename?: 'AssetRelationEdge', node: { __typename?: 'AssetRelation', id: string, createTime: string, updateTime: string, name: string, description?: string | null, type: AssetRelationType, sourceAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, targetAsset: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } }, assetRelationAttributes?: Array<{ __typename?: 'AssetRelationAttribute', id: string, value?: string | null, assetID?: string | null, assetRelationAttributeDefinition: { __typename?: 'AssetRelationAttributeDefinition', id: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType } } | null> | null } }> } };

export type GetAssetRelationAttributeDefinitionsForProjectQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetRelationAttributeDefinitionOrder>;
  where?: InputMaybe<AssetRelationAttributeDefinitionWhereInput>;
}>;


export type GetAssetRelationAttributeDefinitionsForProjectQuery = { __typename?: 'Query', assetRelationAttributeDefinitionsForProject: { __typename?: 'AssetRelationAttributeDefinitionConnection', totalCount: number, edges: Array<{ __typename?: 'AssetRelationAttributeDefinitionEdge', node: { __typename?: 'AssetRelationAttributeDefinition', id: string, createTime: string, updateTime: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType, sequence: number, relationType: AssetRelationAttributeDefinitionRelationType } }> } };

export type GetProjectAssetsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectAssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', totalCount: number, edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> } };

export type GetProjectAssetsCountQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectAssetsCountQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', totalCount: number } };

export type GetAssetsInProjectZoneQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
}>;


export type GetAssetsInProjectZoneQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> } };

export type GetAssetItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssetItemQuery = { __typename?: 'Query', assetItems: { __typename?: 'AssetItemConnection', edges: Array<{ __typename?: 'AssetItemEdge', node: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } }> } };

export type GetAssetItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetItemWhereInput>;
  orderBy?: InputMaybe<AssetItemOrder>;
}>;


export type GetAssetItemsQuery = { __typename?: 'Query', assetItems: { __typename?: 'AssetItemConnection', totalCount: number, edges: Array<{ __typename?: 'AssetItemEdge', node: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, systemRating: AssetSystemRating, assetType: { __typename?: 'AssetType', id: string, name: string }, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating } }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null } }> } };

export type GetProjectAssetItemsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectAssetItemsQuery = { __typename?: 'Query', assetItems: { __typename?: 'AssetItemConnection', edges: Array<{ __typename?: 'AssetItemEdge', node: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null } }> } };

export type GetAssetNameQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetNameQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } } }> } };

export type GetProjectAssetsSearchQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProjectAssetsSearchQuery = { __typename?: 'Query', assetsInProject: { __typename?: 'AssetConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, projectZone: { __typename?: 'ProjectZone', id: string, name: string } } }> } };

export type AssetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssetTypesQuery = { __typename?: 'Query', assetTypes: { __typename?: 'AssetTypeConnection', edges: Array<{ __typename?: 'AssetTypeEdge', node: { __typename?: 'AssetType', id: string, name: string } }> } };

export type ItemAttributeDefinitionsForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type ItemAttributeDefinitionsForProjectQuery = { __typename?: 'Query', assetItemAttributeDefinitionsForProject?: { __typename?: 'AssetItemAttributeDefinitionConnection', edges: Array<{ __typename?: 'AssetItemAttributeDefinitionEdge', node: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> } | null };

export type AssetAttributeDefinitionsForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type AssetAttributeDefinitionsForProjectQuery = { __typename?: 'Query', assetAttributeDefinitionsForProject?: { __typename?: 'AssetAttributeDefinitionConnection', edges: Array<{ __typename?: 'AssetAttributeDefinitionEdge', node: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number, assetType: { __typename?: 'AssetType', id: string, name: string } } }> } | null };

export type GetSbomAssetsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  format: SbomExportFormat;
  includeComponentInfo: Scalars['Boolean']['input'];
  includeVulnerabilities: Scalars['Boolean']['input'];
}>;


export type GetSbomAssetsQuery = { __typename?: 'Query', exportProjectSBOM?: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } | null };

export type GetComponentsSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetComponentsSourcesQuery = { __typename?: 'Query', componentSources: { __typename?: 'ComponentSourceConnection', edges: Array<{ __typename?: 'ComponentSourceEdge', node: { __typename?: 'ComponentSource', id: string, name: string } }> } };

export type GetComponentCreateRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetComponentCreateRequestsQuery = { __typename?: 'Query', componentCreateRequestsView: { __typename?: 'ComponentCreateRequestViewConnection', edges: Array<{ __typename?: 'ComponentCreateRequestViewEdge', node: { __typename?: 'ComponentCreateRequestView', id: string, componentID?: string | null, componentName: string, componentVersion: string, componentVendorName?: string | null, componentVendorID?: string | null, requestPriority?: ComponentCreateRequestRequestPriority | null, userID: string, requesterID: string, referenceWeb?: string | null, referenceSecurity?: string | null, statusID: string, statusCode: ComponentCreateRequestStatusCode, sourceID: string, externalRequestRef?: string | null, externalComponentID?: string | null, externalRequestStatus?: string | null, statusTransitions: Array<{ __typename?: 'ComponentCreateRequestViewAllowedStatusTransition', id: string, code: ComponentCreateRequestStatusCode, blocked: boolean, reason?: string | null }>, comments: Array<{ __typename?: 'ComponentCreateRequestViewComment', comment: string, userID: string, createTime: string }> } }> } };

export type GetComponentByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetComponentByIdQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', createTime?: string | null, updateTime?: string | null, id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', name: string, id: string, ifa?: string | null, description?: string | null, assessments?: Array<{ __typename?: 'ComponentVendorAssessment', type: ComponentVendorAssessmentType, result: ComponentVendorAssessmentResult, status: ComponentVendorAssessmentStatus }> | null } } }> } };

export type GetComponentsByVendorQueryVariables = Exact<{
  partialName: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetComponentsByVendorQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', id: string, name: string, version: string } }> } };

export type GetComponentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  orderBy?: InputMaybe<ComponentOrderField>;
  orderDirection: OrderDirection;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetComponentsQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null, endCursor?: any | null }, edges: Array<{ __typename?: 'ComponentEdge', cursor: any, node: { __typename?: 'Component', createTime?: string | null, updateTime?: string | null, id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', name: string, id: string, ifa?: string | null, description?: string | null, assessments?: Array<{ __typename?: 'ComponentVendorAssessment', type: ComponentVendorAssessmentType, result: ComponentVendorAssessmentResult, status: ComponentVendorAssessmentStatus }> | null } } }> } };

export type GetComponentsServerQueryVariables = Exact<{
  orderBy?: InputMaybe<ComponentOrder>;
  where?: InputMaybe<ComponentWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetComponentsServerQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', totalCount: number, edges: Array<{ __typename?: 'ComponentEdge', cursor: any, node: { __typename?: 'Component', createTime?: string | null, updateTime?: string | null, id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', name: string, id: string, ifa?: string | null, description?: string | null, assessments?: Array<{ __typename?: 'ComponentVendorAssessment', type: ComponentVendorAssessmentType, result: ComponentVendorAssessmentResult, status: ComponentVendorAssessmentStatus }> | null } } }> } };

export type GetComponentsSearchServerQueryVariables = Exact<{
  orderBy?: InputMaybe<ComponentOrder>;
  where?: InputMaybe<ComponentWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetComponentsSearchServerQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } }> } };

export type GetComponentsAffectedByNotificationQueryVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type GetComponentsAffectedByNotificationQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, source: NotificationSource, body: string, components?: Array<{ __typename?: 'Component', id: string, name: string, version: string, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null> | null } }> } };

export type GetUserRelevantComponentsAffectedByNotificationQueryVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type GetUserRelevantComponentsAffectedByNotificationQuery = { __typename?: 'Query', componentsAffectedByNotification: { __typename?: 'ComponentAffectedByNotificationConnection', edges: Array<{ __typename?: 'ComponentAffectedByNotificationEdge', node: { __typename?: 'ComponentAffectedByNotification', id: string, name: string, affectedProjectsCount: number, componentVendorID?: string | null, componentVendorName?: string | null, version: string, isValid: boolean, affectedAssetsCount: number } }> } };

export type GetComponentsAffectedByNotificationInProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  notificationId: Scalars['ID']['input'];
}>;


export type GetComponentsAffectedByNotificationInProjectQuery = { __typename?: 'Query', componentsAffectedByNotificationInProject: { __typename?: 'ComponentAffectedByNotificationProjectConnection', edges: Array<{ __typename?: 'ComponentAffectedByNotificationProjectEdge', node: { __typename?: 'ComponentAffectedByNotificationProject', id: string, name: string, componentVendorID?: string | null, componentVendorName?: string | null, version: string, isValid: boolean, affectedAssetsCount: number } }> } };

export type FindComponentsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type FindComponentsQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } }> } };

export type SearchComponentNamesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  orderBy?: InputMaybe<ComponentOrderField>;
  orderDirection: OrderDirection;
}>;


export type SearchComponentNamesQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', totalCount: number, edges: Array<{ __typename?: 'ComponentEdge', cursor: any, node: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', name: string } } }> } };

export type GetComponentQueryVariables = Exact<{
  componentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetComponentQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } }> } };

export type GetComponentNameOnlyQueryVariables = Exact<{
  componentId: Scalars['ID']['input'];
}>;


export type GetComponentNameOnlyQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', name: string } }> } };

export type GetComponentSourcesByIdQueryVariables = Exact<{
  componentId: Scalars['ID']['input'];
}>;


export type GetComponentSourcesByIdQuery = { __typename?: 'Query', componentsWithSources: { __typename?: 'ComponentWithSourcesConnection', edges: Array<{ __typename?: 'ComponentWithSourcesEdge', node: { __typename?: 'ComponentWithSources', id: string, sourcesData: Array<{ __typename?: 'ComponentSourceRaw', id: string, componentName: string, sourceName: string, sourceID: string, vendorName: string, version?: string | null, createTime: string, eolDate?: string | null, cpe?: string | null }> } }> } };

export type GetComponentsSourcesByIdsQueryVariables = Exact<{
  componentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetComponentsSourcesByIdsQuery = { __typename?: 'Query', componentsWithSources: { __typename?: 'ComponentWithSourcesConnection', edges: Array<{ __typename?: 'ComponentWithSourcesEdge', node: { __typename?: 'ComponentWithSources', id: string, sourcesData: Array<{ __typename?: 'ComponentSourceRaw', id: string, componentName: string, sourceName: string, sourceID: string, vendorName: string, version?: string | null, createTime: string, eolDate?: string | null, cpe?: string | null }> } }> } };

export type GetCountriesTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesTreeQuery = { __typename?: 'Query', countries: { __typename?: 'CountryConnection', edges: Array<{ __typename?: 'CountryEdge', node: { __typename?: 'Country', id: string, name: string, parent?: { __typename?: 'Country', id: string } | null, countryStandards?: Array<{ __typename?: 'CountryStandard', description: string }> | null } }> } };

export type GetCrasForProjectQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type GetCrasForProjectQuery = { __typename?: 'Query', crasForProject: Array<{ __typename?: 'CRA', id: string, type: CraType, isCompleted: boolean, isApplicable?: boolean | null, justification?: string | null, updateTime: string }> };

export type GetCraEvidenceQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type GetCraEvidenceQuery = { __typename?: 'Query', crasForProject: Array<{ __typename?: 'CRA', id: string, type: CraType, uploads: Array<{ __typename?: 'CRAUpload', id: string, createTime: string, updateTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } }> }> };

export type GetCraCommentsQueryVariables = Exact<{
  craID: Scalars['ID']['input'];
}>;


export type GetCraCommentsQuery = { __typename?: 'Query', craComments: Array<{ __typename?: 'CRAModuleComment', id: string, action: CraModuleCommentAction, content: string, createTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> };

export type DownloadCraUploadFileQueryVariables = Exact<{
  craUploadID: Scalars['ID']['input'];
}>;


export type DownloadCraUploadFileQuery = { __typename?: 'Query', downloadCRAUploadFile: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type GetCraTopicStatusesQueryVariables = Exact<{
  craID: Scalars['ID']['input'];
}>;


export type GetCraTopicStatusesQuery = { __typename?: 'Query', general: { __typename?: 'CRAGeneral', id: string, isCompleted: boolean }, documentation: { __typename?: 'CRADocumentation', id: string, isCompleted: boolean }, vulnerability: { __typename?: 'CRAVulnerabilityHandling', id: string, isCompleted: boolean }, risk: { __typename?: 'CRACybersecRiskAssessment', id: string, isCompleted: boolean } };

export type GetCraCybersecRiskAssessmentForCraQueryVariables = Exact<{
  craID: Scalars['ID']['input'];
}>;


export type GetCraCybersecRiskAssessmentForCraQuery = { __typename?: 'Query', getCRACybersecRiskAssessmentForCRA: { __typename?: 'CRACybersecRiskAssessment', id: string, isCompleted: boolean, uploads: Array<{ __typename?: 'CRACybersecRiskAssessmentUpload', id: string, createTime: string, updateTime: string, completeness: CraCybersecRiskAssessmentUploadCompleteness, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } }> } };

export type GetCraCybersecRiskAssessmentCommentsQueryVariables = Exact<{
  craCybersecRiskAssessmentID: Scalars['ID']['input'];
}>;


export type GetCraCybersecRiskAssessmentCommentsQuery = { __typename?: 'Query', craCybersecRiskAssessmentComments: Array<{ __typename?: 'CRAModuleComment', id: string, action: CraModuleCommentAction, content: string, createTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> };

export type DownloadCraCybersecRiskAssessmentUploadFileQueryVariables = Exact<{
  craCybersecurityRiskAssessmentUploadID: Scalars['ID']['input'];
}>;


export type DownloadCraCybersecRiskAssessmentUploadFileQuery = { __typename?: 'Query', downloadCRACybersecurityRiskAssessmentUploadFile: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type GetCraDocumentationForCraQueryVariables = Exact<{
  craID: Scalars['ID']['input'];
}>;


export type GetCraDocumentationForCraQuery = { __typename?: 'Query', getCRADocumentationForCRA: { __typename?: 'CRADocumentation', id: string, isCompleted: boolean, hasProductVisual: boolean, hasRefDocuments: boolean, hasIntendedPurpose: boolean, hasSecDesignArchitecture: boolean, hasProcessReference: boolean, uploads: Array<{ __typename?: 'CRADocumentationUpload', id: string, createTime: string, kind: CraDocumentationUploadKind, category: CraDocumentationUploadCategory, link?: string | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, fileAsset?: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null }> } };

export type GetCraDocumentationCommentsQueryVariables = Exact<{
  craDocumentationID: Scalars['ID']['input'];
}>;


export type GetCraDocumentationCommentsQuery = { __typename?: 'Query', craDocumentationComments: Array<{ __typename?: 'CRAModuleComment', id: string, action: CraModuleCommentAction, content: string, createTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> };

export type DownloadCraDocumentationUploadFileQueryVariables = Exact<{
  craDocumentationUploadID: Scalars['ID']['input'];
}>;


export type DownloadCraDocumentationUploadFileQuery = { __typename?: 'Query', downloadCRADocumentationUploadFile: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type GetCraGeneralForCraQueryVariables = Exact<{
  craID: Scalars['ID']['input'];
}>;


export type GetCraGeneralForCraQuery = { __typename?: 'Query', getCRAGeneralForCRA: { __typename?: 'CRAGeneral', id: string, isCompleted: boolean, productName?: string | null, ProductVersion?: string | null, ProductCategory?: CraGeneralProductCategory | null, supportPeriod?: number | null, supportPeriodStartDate?: string | null, supportPeriodEndDate?: string | null, productLifetime?: number | null, productLifetimeStartDate?: string | null, productLifetimeEndDate?: string | null, supportPeriodInformation?: string | null, createTime: string, updateTime: string, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, projectManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null } };

export type GetCraGeneralCommentsQueryVariables = Exact<{
  craGeneral: Scalars['ID']['input'];
}>;


export type GetCraGeneralCommentsQuery = { __typename?: 'Query', craGeneralComments: Array<{ __typename?: 'CRAModuleComment', id: string, action: CraModuleCommentAction, content: string, createTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> };

export type DownloadCraVulnerabilityHandlingUploadFileQueryVariables = Exact<{
  craVulnerabilityHandlingUploadID: Scalars['ID']['input'];
}>;


export type DownloadCraVulnerabilityHandlingUploadFileQuery = { __typename?: 'Query', downloadCRAVulnerabilityHandlingUploadFile: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type GetCraVulnerabilityHandlingForCraQueryVariables = Exact<{
  craID: Scalars['ID']['input'];
}>;


export type GetCraVulnerabilityHandlingForCraQuery = { __typename?: 'Query', getCRAVulnerabilityHandlingForCRA: { __typename?: 'CRAVulnerabilityHandling', id: string, IsCompleted: boolean, seContact?: string | null, seContactValidationDate?: string | null, customerContact?: string | null, customerContactValidationDate?: string | null, uploads: Array<{ __typename?: 'CRAVulnerabilityHandlingUpload', id: string, createTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } }> } };

export type GetCraVulnerabilityHandlingCommentsQueryVariables = Exact<{
  craVulnerabilityHandlingID: Scalars['ID']['input'];
}>;


export type GetCraVulnerabilityHandlingCommentsQuery = { __typename?: 'Query', craVulnerabilityHandlingComments: Array<{ __typename?: 'CRAModuleComment', id: string, action: CraModuleCommentAction, content: string, createTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> };

export type GetProjectDashboardSummaryCardsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectDashboardSummaryCardsQuery = { __typename?: 'Query', getProjectDashboardSummaryCards?: { __typename?: 'ProjectDashboardSummaryCards', assetsCount: number, componentsCount: number, projectZonesCount: number, tasksCount: number, tasksCompletedCount: number, trasCount: number, trasInProgressCount: number, trasReadyForApprovalCount: number, mitigationsCount: number, survey?: { __typename?: 'ProjectDashboardSummaryCardsSurvey', id: string, classificationScore: number, status: SurveyStatus, classificationClassID: string, classificationClassName: string } | null } | null };

export type GetDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardQuery = { __typename?: 'Query', portalDashboard: { __typename?: 'PortalDashboard', projects: { __typename?: 'PortalDashboardProjects', totalCount: number, nodes: Array<{ __typename?: 'ProjectReadModel', id: string, name: string, organizationID: string, organizationName: string, projectTypeID: string, projectTypeName: string, projectStatusID: string, projectStatusName: string }> }, inProgressTasks: { __typename?: 'PortalDashboardTasks', totalCount: number, nodes: Array<{ __typename?: 'TaskReadModel', id: string, title: string, priority: TaskPriority, status: TaskStatus }> }, notStartedTasks: { __typename?: 'PortalDashboardTasks', totalCount: number, nodes: Array<{ __typename?: 'TaskReadModel', id: string, title: string, priority: TaskPriority, status: TaskStatus }> }, notifications: { __typename?: 'PortalDashboardNotifications', totalCount: number, nodes: Array<{ __typename?: 'NotificationReadModel', id: string, title: string, source: string, priority: string, cvssVector: string, publishDate: string, cvss?: { __typename: 'CVSS20', score: number } | { __typename: 'CVSS30', score: number } | { __typename: 'CVSS40', score: number } | null }> }, assetItems: { __typename?: 'PortalDashboardAssetItems', totalCount: number }, projectZones: { __typename?: 'PortalDashboardProjectZones', totalCount: number } } };

export type ExportProjectAssetsListQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  options?: InputMaybe<ProjectExportAssetsOptions>;
}>;


export type ExportProjectAssetsListQuery = { __typename?: 'Query', exportAssetsList: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type ExportProjectSbomQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  format: SbomExportFormat;
}>;


export type ExportProjectSbomQuery = { __typename?: 'Query', exportProjectSBOM?: { __typename?: 'EncodedFile', fileName: string, type: string, content: string } | null };

export type ExportProjectMitigationStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: NotificationStatusExportFilter;
}>;


export type ExportProjectMitigationStatusQuery = { __typename?: 'Query', exportProjectMitigationStatus?: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } | null };

export type ExportUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportUsersQuery = { __typename?: 'Query', exportUsers: { __typename?: 'EncodedFile', fileName: string, type: string, content: string } };

export type SurveyFormExportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SurveyFormExportQuery = { __typename?: 'Query', surveyFormExport?: { __typename?: 'EncodedFile', fileName: string, type: string, content: string } | null };

export type ProjectNotificationsReportQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
  includeMitigations: Scalars['Boolean']['input'];
  includeAffected: Scalars['Boolean']['input'];
}>;


export type ProjectNotificationsReportQuery = { __typename?: 'Query', projectNotificationsReport?: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } | null };

export type ExportAssetRelationsQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type ExportAssetRelationsQuery = { __typename?: 'Query', exportAssetRelations?: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } | null };

export type GetHierarchyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHierarchyTypesQuery = { __typename?: 'Query', ProjectHierarchyTypes: { __typename?: 'ProjectHierarchyTypeConnection', edges: Array<{ __typename?: 'ProjectHierarchyTypeEdge', node: { __typename?: 'ProjectHierarchyType', id: string, name: string } }> } };

export type GetProjectHierarchyQueryVariables = Exact<{
  hierarchyID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyQuery = { __typename?: 'Query', projectHierarchies: { __typename?: 'ProjectHierarchyConnection', edges: Array<{ __typename?: 'ProjectHierarchyEdge', node: { __typename?: 'ProjectHierarchy', id: string, name: string, description: string, supplierName?: string | null, createTime: string, updateTime: string, criticality: ProjectHierarchyCriticality, commodityManager?: string | null, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', projectHierarchyID: string, assetID: string, id: string }>, projectHierarchyTodos: Array<{ __typename?: 'ProjectHierarchyTodo', id: string, title: string, description: string }>, children: Array<{ __typename?: 'ProjectHierarchy', id: string }>, project: { __typename?: 'Project', id: string }, type: { __typename?: 'ProjectHierarchyType', id: string, name: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null, parentHierarchy?: { __typename?: 'ProjectHierarchy', id: string, name: string } | null, projectHierarchyAttributes?: Array<{ __typename?: 'ProjectHierarchyAttribute', id: string, value?: string | null, projectHierarchyAttributeDefinition: { __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType } }> | null } }> } };

export type GetProjectHierarchyAssetsQueryVariables = Exact<{
  hierarchyID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyAssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> } };

export type GetProjectHierarchyAssetsNotAssignedQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyAssetsNotAssignedQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> } };

export type GetAssetsForSystemsQueryVariables = Exact<{
  systemIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetAssetsForSystemsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null, asset: { __typename?: 'Asset', id: string } } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> } };

export type GetProjectHierarchyAssetsBySystemsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyAssetsBySystemsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, projectHierarchies?: Array<{ __typename?: 'ProjectHierarchy', id: string, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }> }> | null } }> } | null };

export type GetProjectHierarchyTodosQueryVariables = Exact<{
  hierarchyID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyTodosQuery = { __typename?: 'Query', projectHierarchyTodos?: { __typename?: 'ProjectHierarchyTodoConnection', edges: Array<{ __typename?: 'ProjectHierarchyTodoEdge', node: { __typename?: 'ProjectHierarchyTodo', id: string, title: string, description: string, status: ProjectHierarchyTodoStatus, seqNo: number, createTime: string, updateTime: string, projectHierarchy: { __typename?: 'ProjectHierarchy', id: string } } }> } | null };

export type GetProjectHierarchyFilesQueryVariables = Exact<{
  hierarchyID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyFilesQuery = { __typename?: 'Query', projectHierarchies: { __typename?: 'ProjectHierarchyConnection', edges: Array<{ __typename?: 'ProjectHierarchyEdge', node: { __typename?: 'ProjectHierarchy', id: string, projectHierarchyFiles: Array<{ __typename?: 'ProjectHierarchyFile', id: string, description?: string | null, projectHierarchyID: string, createTime: string, updateTime: string, fileAsset: { __typename?: 'FileAsset', id: string, name: string, size: number, contentType: string, createTime: string, projectID: string, refID: string, updateTime: string } }> } }> } };

export type DownloadProjectHierarchyFileQueryVariables = Exact<{
  projectHierarchyFileID: Scalars['ID']['input'];
}>;


export type DownloadProjectHierarchyFileQuery = { __typename?: 'Query', downloadProjectHierarchyFile: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type GetProjectHierarchyAttributeDefinitionsQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type GetProjectHierarchyAttributeDefinitionsQuery = { __typename?: 'Query', projectHierarchyAttributeDefinitionsForProject?: { __typename?: 'ProjectHierarchyAttributeDefinitionConnection', edges: Array<{ __typename?: 'ProjectHierarchyAttributeDefinitionEdge', node: { __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType, isMandatory: boolean, sequence: number, project: { __typename?: 'Project', id: string, name: string }, projectHierarchyType: { __typename?: 'ProjectHierarchyType', id: string, name: string }, projectHierarchyAttributes?: Array<{ __typename?: 'ProjectHierarchyAttribute', id: string, value?: string | null }> | null } }> } | null };

export type GetMaintenanceInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceInfoQuery = { __typename?: 'Query', maintenanceData: { __typename?: 'MaintenanceData', message?: string | null } };

export type GetMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMappingsQuery = { __typename?: 'Query', requirementMappings: { __typename?: 'RequirementMappingConnection', edges: Array<{ __typename?: 'RequirementMappingEdge', node: { __typename?: 'RequirementMapping', id: string, comment: string, parentRequirement: { __typename?: 'Requirement', name: string }, childRequirement: { __typename?: 'Requirement', name: string } } }> } };

export type GetSecurityNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSecurityNotificationQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, title: string, publishDate: string, lastUpdateDate?: string | null, priority: NotificationPriority, impact?: string | null, source: NotificationSource, description?: string | null, cvssVector?: string | null, cvssOverrideVector?: string | null, solutionStatus: string, action: NotificationAction, solutionDetails?: string | null, references?: Array<string | null> | null, legalNotice?: string | null, cves?: Array<{ __typename?: 'Cve', id: string, code: string, description?: string | null, weakness?: string | null, publishDate: string, lastUpdateDate: string, cvssVector?: string | null, cvssBaseScore?: number | null, cvssExploitabilityScore?: number | null, cvssImpactScore?: number | null, source: CveSource } | null> | null, cvss?: { __typename?: 'CVSS20', score: number, vector: string } | { __typename?: 'CVSS30', score: number, vector: string } | { __typename?: 'CVSS40', score: number, vector: string } | null, customizedCVSS?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null, vendorAdvisories?: Array<{ __typename?: 'NotificationVendorAdvisoryOutput', vendor?: string | null, name?: string | null, url?: string | null }> | null } }> } };

export type GetSecurityNotificationForComponentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSecurityNotificationForComponentQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, title: string, publishDate: string, lastUpdateDate?: string | null, priority: NotificationPriority, impact?: string | null, source: NotificationSource, description?: string | null, cvssVector?: string | null, cvssOverrideVector?: string | null, solutionStatus: string, action: NotificationAction, solutionDetails?: string | null, references?: Array<string | null> | null, legalNotice?: string | null, cves?: Array<{ __typename?: 'Cve', id: string, code: string, description?: string | null, weakness?: string | null, publishDate: string, lastUpdateDate: string, cvssVector?: string | null, cvssBaseScore?: number | null, cvssExploitabilityScore?: number | null, cvssImpactScore?: number | null, source: CveSource } | null> | null, cvss?: { __typename?: 'CVSS20', score: number, vector: string } | { __typename?: 'CVSS30', score: number, vector: string } | { __typename?: 'CVSS40', score: number, vector: string } | null, customizedCVSS?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null, vendorAdvisories?: Array<{ __typename?: 'NotificationVendorAdvisoryOutput', vendor?: string | null, name?: string | null, url?: string | null }> | null } }> } };

export type GetSecurityNotificationForProjectServerQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  orderBy?: InputMaybe<NotificationOrder>;
  where?: InputMaybe<NotificationWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetSecurityNotificationForProjectServerQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename: 'Project', id: string, name: string, notifications: { __typename?: 'NotificationConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, title: string, publishDate: string, lastUpdateDate?: string | null, impact?: string | null, source: NotificationSource, cvssVector?: string | null, affectedAssetItemsCount?: number | null, cves?: Array<{ __typename?: 'Cve', id: string, code: string } | null> | null, cvss?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null, customizedCVSS?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null } }> } } }> } | null };

export type GetSecurityNotificationsServerQueryVariables = Exact<{
  orderBy?: InputMaybe<NotificationOrder>;
  where?: InputMaybe<NotificationWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showCvss?: Scalars['Boolean']['input'];
  showCustomizedCvss?: Scalars['Boolean']['input'];
  showCvssVector?: Scalars['Boolean']['input'];
  showSource?: Scalars['Boolean']['input'];
  showCves?: Scalars['Boolean']['input'];
  showPublishDate?: Scalars['Boolean']['input'];
  showLastUpdateDate?: Scalars['Boolean']['input'];
  showImpact?: Scalars['Boolean']['input'];
}>;


export type GetSecurityNotificationsServerQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'NotificationEdge', cursor: any, node: { __typename?: 'Notification', id: string, title: string, publishDate?: string, lastUpdateDate?: string | null, impact?: string | null, source?: NotificationSource, cvssVector?: string | null, cvssOverrideVector?: string | null, cves?: Array<{ __typename?: 'Cve', code: string } | null> | null, cvss?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null, customizedCVSS?: { __typename?: 'CVSS20', score: number } | { __typename?: 'CVSS30', score: number } | { __typename?: 'CVSS40', score: number } | null } }> } };

export type GetSecurityNotificationsServerDetailsQueryVariables = Exact<{
  notificationID: Scalars['ID']['input'];
}>;


export type GetSecurityNotificationsServerDetailsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, title: string, publishDate: string, lastUpdateDate?: string | null, impact?: string | null, source: NotificationSource, cvssVector?: string | null, cvssOverrideVector?: string | null, solutionStatus: string, action: NotificationAction, solutionDetails?: string | null, references?: Array<string | null> | null, legalNotice?: string | null, cves?: Array<{ __typename?: 'Cve', id: string, code: string, description?: string | null, weakness?: string | null, publishDate: string, lastUpdateDate: string, cvssVector?: string | null, cvssBaseScore?: number | null, source: CveSource } | null> | null, vendorAdvisories?: Array<{ __typename?: 'NotificationVendorAdvisoryOutput', name?: string | null }> | null, components?: Array<{ __typename?: 'Component', id: string, name: string, cpeName?: string | null, version: string, eolReached: boolean, eolDate?: string | null, monitoredSince?: string | null, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null> | null } }> } };

export type GetProjectComponentsNotificationsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  where?: InputMaybe<ProjectComponentNotificationWhereInput>;
  orderBy?: InputMaybe<ProjectComponentNotificationOrder>;
}>;


export type GetProjectComponentsNotificationsQuery = { __typename?: 'Query', projectComponentsNotifications: { __typename?: 'ProjectComponentNotificationConnection', edges: Array<{ __typename?: 'ProjectComponentNotificationEdge', node: { __typename?: 'ProjectComponentNotification', id: string, notificationID: string, notificationTitle: string, notificationPriority: string, notificationPublishDate: string, notificationLastUpdateDate?: string | null, notificationCvssBaseScore?: number | null, notificationCvssTemporalScore?: number | null, notificationCvssOveralScore?: number | null, notificationCvssVector?: string | null, notificationImpact?: string | null, notificationSource: string, componentID: string, componentName: string, componentVersion: string, componentIsValid: boolean, componentEolReached: boolean, componentCpeName?: string | null, componentVendorID: string, componentVendorName: string, assetItemID: string, assetItemName: string, assetID: string, assetName: string, assetAlias: string, assetStatus: string, assetRating: string, assetTypeID: string, assetTypeName: string, projectZoneID: string, projectZoneName: string, projectZoneExposureRating: string, projectID: string, mitigationID?: string | null, mitigationStatus?: string | null, mitigationAssignee?: string | null, measureID?: string | null, measureName?: string | null, measureType?: string | null, mitigationTestID?: string | null, mitigationTestResult?: string | null, customizedCVSS?: { __typename?: 'CVSS20', score: number, vector: string } | { __typename?: 'CVSS30', score: number, vector: string } | { __typename?: 'CVSS40', score: number, vector: string } | null } }> } };

export type GetProjectComponentsNotificationsServerQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectComponentNotificationWhereInput>;
  orderBy?: InputMaybe<ProjectComponentNotificationOrder>;
}>;


export type GetProjectComponentsNotificationsServerQuery = { __typename?: 'Query', projectComponentsNotifications: { __typename?: 'ProjectComponentNotificationConnection', totalCount: number, edges: Array<{ __typename?: 'ProjectComponentNotificationEdge', node: { __typename?: 'ProjectComponentNotification', id: string, notificationID: string, notificationTitle: string, notificationPriority: string, notificationPublishDate: string, notificationLastUpdateDate?: string | null, notificationCvssBaseScore?: number | null, notificationCvssTemporalScore?: number | null, notificationCvssOveralScore?: number | null, notificationCvssVector?: string | null, notificationImpact?: string | null, notificationSource: string, componentID: string, componentName: string, componentVersion: string, componentIsValid: boolean, componentEolReached: boolean, componentCpeName?: string | null, componentVendorID: string, componentVendorName: string, assetItemID: string, assetItemName: string, assetID: string, assetName: string, assetAlias: string, assetStatus: string, assetRating: string, assetTypeID: string, assetTypeName: string, projectZoneID: string, projectZoneName: string, projectZoneExposureRating: string, projectID: string, mitigationID?: string | null, mitigationStatus?: string | null, mitigationAssignee?: string | null, measureID?: string | null, measureName?: string | null, measureType?: string | null, mitigationTestID?: string | null, mitigationTestResult?: string | null, customizedCVSS?: { __typename?: 'CVSS20', score: number, vector: string } | { __typename?: 'CVSS30', score: number, vector: string } | { __typename?: 'CVSS40', score: number, vector: string } | null } }> } };

export type GetUnresolvedNotificationsByZoneQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  zoneID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUnresolvedNotificationsByZoneQuery = { __typename?: 'Query', projectComponentsNotifications: { __typename?: 'ProjectComponentNotificationConnection', totalCount: number, edges: Array<{ __typename?: 'ProjectComponentNotificationEdge', node: { __typename?: 'ProjectComponentNotification', assetItemID: string, componentID: string, projectZoneID: string, notificationID: string, mitigationStatus?: string | null } }> } };

export type GetMeasuresForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetMeasuresForProjectQuery = { __typename?: 'Query', measures?: { __typename?: 'MeasureConnection', totalCount: number, edges: Array<{ __typename?: 'MeasureEdge', node: { __typename?: 'Measure', id: string, createTime: string, updateTime: string, name: string, type: MeasureType, howto?: string | null, resources?: string | null, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null, mitigations?: Array<{ __typename?: 'Mitigation', id: string }> | null } }> } | null };

export type GetMitigationsQueryVariables = Exact<{
  input: MitigationWhereInput;
}>;


export type GetMitigationsQuery = { __typename?: 'Query', mitigations?: { __typename?: 'MitigationConnection', totalCount: number, edges: Array<{ __typename?: 'MitigationEdge', node: { __typename?: 'Mitigation', id: string, createTime: string, updateTime: string, status: MitigationStatus, assignee: MitigationAssignee, statusReason?: string | null, workcycle?: { __typename?: 'Task', id: string, title: string, startAt?: string | null, dueAt?: string | null } | null, componentNotification?: { __typename?: 'ComponentNotification', notification: { __typename?: 'Notification', id: string, title: string } } | null, assetItem: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating, project: { __typename?: 'Project', id: string } }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null }, measure?: { __typename?: 'Measure', id: string, name: string, type: MeasureType, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null } | null, mitigationTests?: Array<{ __typename?: 'MitigationTest', id: string, createTime: string, updateTime: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, tester: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null } }> } | null };

export type GetMitigationsServerQueryVariables = Exact<{
  where: MitigationWhereInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MitigationOrder>;
}>;


export type GetMitigationsServerQuery = { __typename?: 'Query', mitigations?: { __typename?: 'MitigationConnection', totalCount: number, edges: Array<{ __typename?: 'MitigationEdge', node: { __typename?: 'Mitigation', id: string, createTime: string, updateTime: string, status: MitigationStatus, assignee: MitigationAssignee, statusReason?: string | null, workcycle?: { __typename?: 'Task', id: string, title: string, startAt?: string | null, dueAt?: string | null } | null, componentNotification?: { __typename?: 'ComponentNotification', notification: { __typename?: 'Notification', id: string, title: string } } | null, assetItem: { __typename?: 'AssetItem', id: string, name: string, description?: string | null, externalIdentifier?: string | null, isValid: boolean, type: AssetItemType, createTime?: string | null, updateTime?: string | null, asset: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating, project: { __typename?: 'Project', id: string } }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null }, component?: { __typename?: 'Component', id: string, name: string, version: string, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, createTime?: string | null, cpeName?: string | null, url?: string | null, securityUrl?: string | null, isValid: boolean, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, ifa?: string | null, description?: string | null } } | null, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null }, measure?: { __typename?: 'Measure', id: string, name: string, type: MeasureType, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null } | null, mitigationTests?: Array<{ __typename?: 'MitigationTest', id: string, createTime: string, updateTime: string, result: MitigationTestResult, comment?: string | null, envName?: string | null, tester: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null } }> } | null };

export type GetMeasuresServerQueryVariables = Exact<{
  where: MeasureWhereInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MeasureOrder>;
}>;


export type GetMeasuresServerQuery = { __typename?: 'Query', measures?: { __typename?: 'MeasureConnection', totalCount: number, edges: Array<{ __typename?: 'MeasureEdge', node: { __typename?: 'Measure', id: string, createTime: string, updateTime: string, name: string, type: MeasureType, howto?: string | null, resources?: string | null, justification?: string | null, updateToComponent?: { __typename?: 'Component', id: string, name: string, version: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string } } | null, mitigations?: Array<{ __typename?: 'Mitigation', id: string }> | null } }> } | null };

export type GetOrganizationsQueryVariables = Exact<{
  orderBy?: InputMaybe<OrganizationOrder>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationConnection', edges: Array<{ __typename?: 'OrganizationEdge', node: { __typename?: 'Organization', id: string, name: string, parentOrganization?: { __typename?: 'Organization', id: string } | null } }> } };

export type ProjectZoneFragmentFragment = { __typename?: 'ProjectZone', id: string, name: string, description: string, exposureRating: ProjectZoneExposureRating, assetsCount: number, createTime: string, updateTime: string, parentZone?: { __typename?: 'ProjectZone', id: string, name: string } | null };

export type StandardProfileFragmentFragment = { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null };

export type GetZoneStandardProfilesQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
}>;


export type GetZoneStandardProfilesQuery = { __typename?: 'Query', projectZoneStandardProfiles: { __typename?: 'ProjectZoneStandardProfileConnection', edges: Array<{ __typename?: 'ProjectZoneStandardProfileEdge', node: { __typename?: 'ProjectZoneStandardProfile', standardProfile: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } } }> } };

export type GetZoneDetailsQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
  pid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetZoneDetailsQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', id: string, name: string, description: string, exposureRating: ProjectZoneExposureRating, assetsCount: number, createTime: string, updateTime: string, parentZone?: { __typename?: 'ProjectZone', id: string, name: string } | null } }> }, projectZoneStandardProfiles: { __typename?: 'ProjectZoneStandardProfileConnection', edges: Array<{ __typename?: 'ProjectZoneStandardProfileEdge', node: { __typename?: 'ProjectZoneStandardProfile', standardProfile: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } } }> } };

export type GetZoneNameQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
  pid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetZoneNameQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', name: string } }> } };

export type GetRootZoneQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetRootZoneQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', id: string, name: string } }> } };

export type GetCommentsQueryVariables = Exact<{
  rqid: Scalars['ID']['input'];
  spid: Scalars['ID']['input'];
  pzid: Scalars['ID']['input'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', projectZoneStandardProfileRequirementCommentsGet: Array<{ __typename?: 'ProjectZoneStandardProfileRequirementComment', id: string, createTime: string, comment: string, requirementCommentStatus: ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> };

export type GetProjectsQueryVariables = Exact<{
  where?: InputMaybe<ProjectWhereInput>;
  field?: InputMaybe<ProjectOrderField>;
  direction: OrderDirection;
}>;


export type GetProjectsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', totalCount: number, edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, name: string, description: string, updateTime?: string | null, createTime?: string | null, customerName?: string | null, customerEmail?: string | null, customerPhone?: string | null, customerAddress?: string | null, locationCountry?: string | null, locationCity?: string | null, locationPostalCode?: string | null, locationStreet?: string | null, plantName?: string | null, plantExternalID?: string | null, creator?: { __typename?: 'User', id: string, gid: string, firstName: string, lastName: string, email: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, milestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, status?: { __typename?: 'ProjectStatus', id: string, name: string } | null, type?: { __typename?: 'ProjectType', id: string, name: string } | null, projectCountries?: Array<{ __typename?: 'ProjectCountry', country: { __typename?: 'Country', id: string } }> | null, tags?: Array<{ __typename?: 'ProjectTag', id: string, name: string }> | null, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, participants?: Array<{ __typename?: 'OrganizationUser', id: string, user: { __typename?: 'User', id: string } } | { __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string } } | null> | null, projectAttributes?: Array<{ __typename?: 'ProjectAttribute', id: string, sequence: number, label: string, type: ProjectAttributeType, value?: string | null }> | null, point?: { __typename?: 'Point', latitude: number, longitude: number } | null, projectStandardProfiles?: Array<{ __typename?: 'ProjectStandardProfile', id: string, standardProfile?: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null }> | null } }> } | null };

export type GetProjectZonesInProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectZonesInProjectQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', id: string, name: string } }> } };

export type GetUnorderedProjectZonesInProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetUnorderedProjectZonesInProjectQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', id: string, name: string } }> } };

export type ListProjectZonesQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type ListProjectZonesQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', id: string, name: string, description: string, exposureRating: ProjectZoneExposureRating, assetsCount: number, createTime: string, updateTime: string, parentZone?: { __typename?: 'ProjectZone', id: string, name: string } | null } }> } };

export type GetProjectComponentsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  orderBy?: InputMaybe<ComponentInProjectOrder>;
  where?: InputMaybe<ComponentInProjectWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetProjectComponentsQuery = { __typename?: 'Query', componentsInProject: { __typename?: 'ComponentInProjectConnection', totalCount: number, edges: Array<{ __typename?: 'ComponentInProjectEdge', node: { __typename?: 'ComponentInProject', id: string, name: string, componentVendorName?: string | null, version: string, isValid: boolean, cpeName?: string | null, eolDate?: string | null, eolReached: boolean, monitoredSince?: string | null, usedInProjectCount: number, url?: string | null, securityURL?: string | null, createTime: string, lastSync: string, projectID: string, updateTime: string, hasAssessments: boolean } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null } } };

export type GetProjectsAffectedByNotificationQueryVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type GetProjectsAffectedByNotificationQuery = { __typename?: 'Query', projectsAffectedByNotification: { __typename?: 'ProjectAffectedByNotificationConnection', edges: Array<{ __typename?: 'ProjectAffectedByNotificationEdge', node: { __typename?: 'ProjectAffectedByNotification', id: string, name: string, description: string, affectedComponentsCount: number, affectedAssetsCount: number } }> } };

export type GetComponentsAffectedByAnyNotificationsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ComponentAffectedByNotificationProjectOrder>;
}>;


export type GetComponentsAffectedByAnyNotificationsQuery = { __typename?: 'Query', componentsAffectedByNotificationInProject: { __typename?: 'ComponentAffectedByNotificationProjectConnection', edges: Array<{ __typename?: 'ComponentAffectedByNotificationProjectEdge', node: { __typename?: 'ComponentAffectedByNotificationProject', id: string, name: string, affectedAssetsCount: number } }> } };

export type GetMitigationsSummaryInProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetMitigationsSummaryInProjectQuery = { __typename?: 'Query', mitigations?: { __typename?: 'MitigationConnection', totalCount: number } | null };

export type GetProjectNameQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectNameQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', name: string } }> } | null };

export type GetProjectTasksSummaryQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectTasksSummaryQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, status: TaskStatus } }> } | null };

export type GetProjectsTasksSummaryQueryVariables = Exact<{
  projectIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetProjectsTasksSummaryQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, status: TaskStatus, project: { __typename?: 'Project', id: string } } }> } | null };

export type GetZonesCountForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetZonesCountForProjectQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', totalCount: number } };

export type TrasForProjectSummaryQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type TrasForProjectSummaryQuery = { __typename?: 'Query', tras?: { __typename?: 'TRAConnection', totalCount: number, edges: Array<{ __typename?: 'TRAEdge', node: { __typename?: 'TRA', status: TraStatus } }> } | null };

export type GetAssetsCountForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetAssetsCountForProjectQuery = { __typename?: 'Query', assetsInProject: { __typename?: 'AssetConnection', totalCount: number, edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', assetItems?: Array<{ __typename?: 'AssetItem', id: string } | null> | null } }> } };

export type GetComponentsCountForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetComponentsCountForProjectQuery = { __typename?: 'Query', componentsInProject: { __typename?: 'ComponentInProjectConnection', totalCount: number } };

export type GetSbomStatsForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetSbomStatsForProjectQuery = { __typename?: 'Query', componentsInProject: { __typename?: 'ComponentInProjectConnection', totalCount: number }, assetItems: { __typename?: 'AssetItemConnection', totalCount: number }, projectComponentsNotifications: { __typename?: 'ProjectComponentNotificationConnection', totalCount: number } };

export type GetProjectUsersRolesQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectUsersRolesQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', users?: Array<{ __typename?: 'ProjectUser', user: { __typename?: 'User', id: string }, role?: { __typename?: 'ProjectUserRole', id: string, name: string } | null } | null> | null } }> } | null };

export type GetProjectDetailsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectDetailsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, name: string, description: string, plantName?: string | null, locationStreet?: string | null, locationCity?: string | null, locationPostalCode?: string | null, locationCountry?: string | null, plantExternalID?: string | null, customerName?: string | null, customerEmail?: string | null, customerPhone?: string | null, customerAddress?: string | null, projectStandardProfiles?: Array<{ __typename?: 'ProjectStandardProfile', id: string, standardProfile?: { __typename?: 'StandardProfile', id: string } | null }> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, milestone?: { __typename?: 'ProjectMilestone', id: string, name: string } | null, status?: { __typename?: 'ProjectStatus', id: string } | null, type?: { __typename?: 'ProjectType', id: string, name: string } | null, participants?: Array<{ __typename?: 'OrganizationUser', id: string, user: { __typename?: 'User', id: string } } | { __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string } } | null> | null, point?: { __typename?: 'Point', latitude: number, longitude: number } | null, creator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, securityResponsible?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, projectAttributes?: Array<{ __typename?: 'ProjectAttribute', id: string, sequence: number, label: string, type: ProjectAttributeType, value?: string | null }> | null, projectCountries?: Array<{ __typename?: 'ProjectCountry', country: { __typename?: 'Country', id: string } }> | null, tags?: Array<{ __typename?: 'ProjectTag', id: string, name: string }> | null } }> } | null };

export type GetProjectMarketCountriesQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectMarketCountriesQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, projectCountries?: Array<{ __typename?: 'ProjectCountry', country: { __typename?: 'Country', id: string, name: string } }> | null } }> } | null };

export type ProjectUserParticipantFragment = { __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, role?: { __typename?: 'ProjectUserRole', id: string, name: string } | null };

export type OrganizationUserParticipantFragment = { __typename?: 'OrganizationUser', id: string, organizationRole: OrganizationUserRole, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null };

export type GetParticipantsForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetParticipantsForProjectQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, name: string, creator?: { __typename?: 'User', id: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, participants?: Array<{ __typename?: 'OrganizationUser', id: string, organizationRole: OrganizationUserRole, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null } | { __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, role?: { __typename?: 'ProjectUserRole', id: string, name: string } | null } | null> | null } }> } | null };

export type GetUsersForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetUsersForProjectQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', users?: Array<{ __typename?: 'ProjectUser', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, role?: { __typename?: 'ProjectUserRole', id: string, name: string } | null } | null> | null } }> } | null };

export type GetProjectGuidanceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectGuidanceConfigsQuery = { __typename?: 'Query', projectGuidances: { __typename?: 'ProjectGuidanceConnection', edges: Array<{ __typename?: 'ProjectGuidanceEdge', node: { __typename?: 'ProjectGuidance', id: string, name: string, createTime: string, updateTime: string, isPublished: boolean, version: number, projectType: { __typename?: 'ProjectType', id: string, name: string }, standardProfile: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } } }> } };

export type GetProjectGuidancesByProjectTypeQueryVariables = Exact<{
  projectTypeId: Scalars['ID']['input'];
}>;


export type GetProjectGuidancesByProjectTypeQuery = { __typename?: 'Query', projectGuidances: { __typename?: 'ProjectGuidanceConnection', edges: Array<{ __typename?: 'ProjectGuidanceEdge', node: { __typename?: 'ProjectGuidance', id: string, standardProfile: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } } }> } };

export type GetProjectTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectTypesQuery = { __typename?: 'Query', projectTypes: { __typename?: 'ProjectTypeConnection', edges: Array<{ __typename?: 'ProjectTypeEdge', node: { __typename?: 'ProjectType', id: string, name: string } }> } };

export type GetProjectSearchFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectSearchFiltersQuery = { __typename?: 'Query', projectStatuses: { __typename?: 'ProjectStatusConnection', edges: Array<{ __typename?: 'ProjectStatusEdge', node: { __typename?: 'ProjectStatus', id: string, name: string } }> }, projectTypes: { __typename?: 'ProjectTypeConnection', edges: Array<{ __typename?: 'ProjectTypeEdge', node: { __typename?: 'ProjectType', id: string, name: string } }> } };

export type GetProjectTagsMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectTagsMeQuery = { __typename?: 'Query', projectTagsMe: Array<string> };

export type ProjectFormFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectFormFieldsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationConnection', edges: Array<{ __typename?: 'OrganizationEdge', node: { __typename?: 'Organization', id: string, name: string, parentOrganization?: { __typename?: 'Organization', id: string } | null } }> }, projectStatuses: { __typename?: 'ProjectStatusConnection', edges: Array<{ __typename?: 'ProjectStatusEdge', node: { __typename?: 'ProjectStatus', id: string, name: string } }> }, projectTypes: { __typename?: 'ProjectTypeConnection', edges: Array<{ __typename?: 'ProjectTypeEdge', node: { __typename?: 'ProjectType', id: string, name: string } }> }, projectMilestones: { __typename?: 'ProjectMilestoneConnection', edges: Array<{ __typename?: 'ProjectMilestoneEdge', node: { __typename?: 'ProjectMilestone', id: string, name: string, seqNo: number } }> }, users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } };

export type GetProjectMilestonesByProjectTypeIdQueryVariables = Exact<{
  projectTypeId: Scalars['ID']['input'];
}>;


export type GetProjectMilestonesByProjectTypeIdQuery = { __typename?: 'Query', projectMilestones: { __typename?: 'ProjectMilestoneConnection', edges: Array<{ __typename?: 'ProjectMilestoneEdge', node: { __typename?: 'ProjectMilestone', id: string, name: string, seqNo: number } }> } };

export type GetProjectStatusesAndMilestonesQueryVariables = Exact<{
  projectTypeId: Scalars['ID']['input'];
}>;


export type GetProjectStatusesAndMilestonesQuery = { __typename?: 'Query', projectStatuses: { __typename?: 'ProjectStatusConnection', edges: Array<{ __typename?: 'ProjectStatusEdge', node: { __typename?: 'ProjectStatus', id: string, name: string } }> }, projectMilestones: { __typename?: 'ProjectMilestoneConnection', edges: Array<{ __typename?: 'ProjectMilestoneEdge', node: { __typename?: 'ProjectMilestone', id: string, name: string, seqNo: number } }> } };

export type GetProjectForGuidanceQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectForGuidanceQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, milestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string } } | null, type?: { __typename?: 'ProjectType', id: string, name: string } | null } }> } | null };

export type GetProjectGuidanceQueryVariables = Exact<{
  projectTypeId: Scalars['ID']['input'];
}>;


export type GetProjectGuidanceQuery = { __typename?: 'Query', projectPhases: { __typename?: 'ProjectPhaseConnection', edges: Array<{ __typename?: 'ProjectPhaseEdge', node: { __typename?: 'ProjectPhase', id: string, name: string, seqNo: number, projectTypeID: string } }> }, projectMilestones: { __typename?: 'ProjectMilestoneConnection', edges: Array<{ __typename?: 'ProjectMilestoneEdge', node: { __typename?: 'ProjectMilestone', id: string, name: string, seqNo: number, description: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string, seqNo: number, projectTypeID: string } } }> } };

export type GetProjectPhasesAndMilestonesQueryVariables = Exact<{
  projectTypeId: Scalars['ID']['input'];
}>;


export type GetProjectPhasesAndMilestonesQuery = { __typename?: 'Query', projectPhases: { __typename?: 'ProjectPhaseConnection', edges: Array<{ __typename?: 'ProjectPhaseEdge', node: { __typename?: 'ProjectPhase', id: string, name: string, projectTypeID: string, seqNo: number, projectMilestones?: Array<{ __typename?: 'ProjectMilestone', id: string, name: string, description: string, seqNo: number } | null> | null } }> } };

export type ProjectsStatsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type ProjectsStatsQuery = { __typename?: 'Query', pendingTasks?: { __typename?: 'TaskConnection', totalCount: number } | null, assets: { __typename?: 'AssetConnection', totalCount: number }, components: { __typename?: 'ComponentInProjectConnection', totalCount: number } };

export type GetProjectResourcesQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectResourcesQuery = { __typename?: 'Query', projectZones: { __typename?: 'ProjectZoneConnection', edges: Array<{ __typename?: 'ProjectZoneEdge', node: { __typename?: 'ProjectZone', id: string, name: string, description: string, exposureRating: ProjectZoneExposureRating, assetsCount: number, createTime: string, updateTime: string, parentZone?: { __typename?: 'ProjectZone', id: string, name: string } | null } }> }, assets: { __typename?: 'AssetConnection', totalCount: number, edges: Array<{ __typename?: 'AssetEdge', node: { __typename?: 'Asset', id: string, name: string, description?: string | null, alias?: string | null, status: AssetStatus, systemRating: AssetSystemRating, createTime?: string | null, updateTime?: string | null, assetItems?: Array<{ __typename?: 'AssetItem', id: string, assetItemAttributes?: Array<{ __typename?: 'AssetItemAttribute', id: string, value?: string | null, assetItemAttributeDefinition: { __typename?: 'AssetItemAttributeDefinition', id: string, label: string, type: AssetItemAttributeDefinitionType, isMandatory: boolean, assetItemType: AssetItemAttributeDefinitionAssetItemType, sequence: number } }> | null } | null> | null, projectZone: { __typename?: 'ProjectZone', id: string, name: string, exposureRating: ProjectZoneExposureRating }, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> }, assetAttributeDefinitionsForProject?: { __typename?: 'AssetAttributeDefinitionConnection', edges: Array<{ __typename?: 'AssetAttributeDefinitionEdge', node: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number, assetType: { __typename?: 'AssetType', id: string, name: string }, assetAttributes?: Array<{ __typename?: 'AssetAttribute', id: string, value?: string | null, assetAttributeDefinition: { __typename?: 'AssetAttributeDefinition', id: string, label: string, isMandatory: boolean, type: AssetAttributeDefinitionType, sequence: number } }> | null } }> } | null, assetRelationsForProject: { __typename?: 'AssetRelationConnection', edges: Array<{ __typename?: 'AssetRelationEdge', node: { __typename?: 'AssetRelation', id: string, name: string, description?: string | null, type: AssetRelationType, sourceAsset: { __typename?: 'Asset', id: string }, targetAsset: { __typename?: 'Asset', id: string }, assetRelationAttributes?: Array<{ __typename?: 'AssetRelationAttribute', value?: string | null, assetRelationAttributeDefinition: { __typename?: 'AssetRelationAttributeDefinition', id: string, label: string, type: AssetRelationAttributeDefinitionType, objectType: AssetRelationAttributeDefinitionObjectType } } | null> | null } }> } };

export type GetProjectAttributesQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectAttributesQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, projectAttributes?: Array<{ __typename?: 'ProjectAttribute', id: string, label: string, sequence: number, type: ProjectAttributeType, value?: string | null }> | null } }> } | null };

export type GetProjectHierarchiesQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectHierarchiesQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges: Array<{ __typename?: 'ProjectEdge', node: { __typename?: 'Project', id: string, projectHierarchies?: Array<{ __typename?: 'ProjectHierarchy', id: string, name: string, description: string, supplierName?: string | null, createTime: string, updateTime: string, criticality: ProjectHierarchyCriticality, commodityManager?: string | null, children: Array<{ __typename?: 'ProjectHierarchy', id: string }>, project: { __typename?: 'Project', id: string }, type: { __typename?: 'ProjectHierarchyType', id: string, name: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null, parentHierarchy?: { __typename?: 'ProjectHierarchy', id: string, name: string } | null, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }>, projectHierarchyAttributes?: Array<{ __typename?: 'ProjectHierarchyAttribute', id: string, value?: string | null, projectHierarchyAttributeDefinition: { __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType } }> | null }> | null } }> } | null };

export type GetProjectSystemsMenuQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectSystemsMenuQuery = { __typename?: 'Query', projectHierarchies: { __typename?: 'ProjectHierarchyConnection', edges: Array<{ __typename?: 'ProjectHierarchyEdge', node: { __typename?: 'ProjectHierarchy', id: string, name: string, parentHierarchy?: { __typename?: 'ProjectHierarchy', id: string } | null } }> } };

export type GetProjectSystemsQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectSystemsQuery = { __typename?: 'Query', projectHierarchies: { __typename?: 'ProjectHierarchyConnection', edges: Array<{ __typename?: 'ProjectHierarchyEdge', node: { __typename?: 'ProjectHierarchy', id: string, name: string, description: string, supplierName?: string | null, createTime: string, updateTime: string, criticality: ProjectHierarchyCriticality, commodityManager?: string | null, children: Array<{ __typename?: 'ProjectHierarchy', id: string }>, project: { __typename?: 'Project', id: string }, type: { __typename?: 'ProjectHierarchyType', id: string, name: string }, organization?: { __typename?: 'Organization', id: string, name: string } | null, parentHierarchy?: { __typename?: 'ProjectHierarchy', id: string, name: string } | null, projectHierarchyAssets: Array<{ __typename?: 'ProjectHierarchyAsset', id: string, assetID: string, projectHierarchyID: string }>, projectHierarchyAttributes?: Array<{ __typename?: 'ProjectHierarchyAttribute', id: string, value?: string | null, projectHierarchyAttributeDefinition: { __typename?: 'ProjectHierarchyAttributeDefinition', id: string, label: string, type: ProjectHierarchyAttributeDefinitionType } }> | null } }> } };

export type GetProjectCraCountQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectCraCountQuery = { __typename?: 'Query', crasForProject: Array<{ __typename?: 'CRA', id: string }> };

export type ProjectSecurityNotificationReportVulnerabilityManagementReportQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
  includeAssets: Scalars['Boolean']['input'];
  includeMitigations: Scalars['Boolean']['input'];
}>;


export type ProjectSecurityNotificationReportVulnerabilityManagementReportQuery = { __typename?: 'Query', projectSecurityNotificationReportVulnerabilityManagementReport: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type ProjectAssetsReportQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProjectAssetsReportQuery = { __typename?: 'Query', projectAssetsReport: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type ProjectAssetsConfigurationReportQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
  projectZoneID?: InputMaybe<Scalars['ID']['input']>;
  assetID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProjectAssetsConfigurationReportQuery = { __typename?: 'Query', projectAssetsConfigurationReport: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type ProjectSecurityNotificationReportByAssetVulnerabilityManagementReportQueryVariables = Exact<{
  projectID: Scalars['ID']['input'];
  projectZoneID: Scalars['ID']['input'];
  assetID?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
  includeMitigations: Scalars['Boolean']['input'];
}>;


export type ProjectSecurityNotificationReportByAssetVulnerabilityManagementReportQuery = { __typename?: 'Query', projectSecurityNotificationReportByAssetVulnerabilityManagementReport: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type RequirementWithSpeFieldsFragment = { __typename?: 'RequirementWithSPE', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, standardName?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, subSpeName?: string | null, speName?: string | null };

export type RequirementOnProjectZoneFieldsFragment = { __typename?: 'RequirementOnProjectZone', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, speName?: string | null, subSpeName?: string | null, requirementCommentStatus?: RequirementOnProjectZoneRequirementCommentStatus | null, requirementCommentCreateTime?: string | null };

export type GetRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequirementsQuery = { __typename?: 'Query', requirementsWithSPEs: { __typename?: 'RequirementWithSPEConnection', edges: Array<{ __typename?: 'RequirementWithSPEEdge', node: { __typename?: 'RequirementWithSPE', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, standardName?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, subSpeName?: string | null, speName?: string | null } }> } };

export type GetRequirementMappingsQueryVariables = Exact<{
  requirementId: Scalars['ID']['input'];
}>;


export type GetRequirementMappingsQuery = { __typename?: 'Query', requirements: { __typename?: 'RequirementConnection', edges: Array<{ __typename?: 'RequirementEdge', node: { __typename?: 'Requirement', name: string } }> }, requirementMappings: { __typename?: 'RequirementMappingConnection', totalCount: number, edges: Array<{ __typename?: 'RequirementMappingEdge', node: { __typename?: 'RequirementMapping', id: string, comment: string, childRequirement: { __typename?: 'Requirement', id: string, name: string }, mappingCoverage?: { __typename?: 'MappingCoverage', name: string } | null } }> } };

export type GetRequirementsCountForStandardProfileQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
  spid: Scalars['ID']['input'];
}>;


export type GetRequirementsCountForStandardProfileQuery = { __typename?: 'Query', requirementsOnProjectZone: { __typename?: 'RequirementOnProjectZoneConnection', totalCount: number } };

export type GetRequirementsForZoneQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
}>;


export type GetRequirementsForZoneQuery = { __typename?: 'Query', requirementsOnProjectZone: { __typename?: 'RequirementOnProjectZoneConnection', totalCount: number, edges: Array<{ __typename?: 'RequirementOnProjectZoneEdge', node: { __typename?: 'RequirementOnProjectZone', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, speName?: string | null, subSpeName?: string | null, requirementCommentStatus?: RequirementOnProjectZoneRequirementCommentStatus | null, requirementCommentCreateTime?: string | null } }> } };

export type GetRequirementsForStandardProfileQueryVariables = Exact<{
  pzid: Scalars['ID']['input'];
  spid: Scalars['ID']['input'];
}>;


export type GetRequirementsForStandardProfileQuery = { __typename?: 'Query', requirementsOnProjectZone: { __typename?: 'RequirementOnProjectZoneConnection', totalCount: number, edges: Array<{ __typename?: 'RequirementOnProjectZoneEdge', node: { __typename?: 'RequirementOnProjectZone', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, speName?: string | null, subSpeName?: string | null, requirementCommentStatus?: RequirementOnProjectZoneRequirementCommentStatus | null, requirementCommentCreateTime?: string | null } }> } };

export type GetRequirementNameQueryVariables = Exact<{
  rid: Scalars['ID']['input'];
}>;


export type GetRequirementNameQuery = { __typename?: 'Query', requirements: { __typename?: 'RequirementConnection', edges: Array<{ __typename?: 'RequirementEdge', node: { __typename?: 'Requirement', name: string } }> } };

export type GetRequirementQueryVariables = Exact<{
  rid: Scalars['ID']['input'];
}>;


export type GetRequirementQuery = { __typename?: 'Query', requirements: { __typename?: 'RequirementWithSPEConnection', edges: Array<{ __typename?: 'RequirementWithSPEEdge', node: { __typename?: 'RequirementWithSPE', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, standardName?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, subSpeName?: string | null, speName?: string | null } }> } };

export type GetProjectGuidanceRequirementsQueryVariables = Exact<{
  projectGuidanceId: Scalars['ID']['input'];
}>;


export type GetProjectGuidanceRequirementsQuery = { __typename?: 'Query', projectGuidanceRequirements: { __typename?: 'ProjectGuidanceRequirementConnection', edges: Array<{ __typename?: 'ProjectGuidanceRequirementEdge', node: { __typename?: 'ProjectGuidanceRequirement', id: string, projectMilestone: { __typename?: 'ProjectMilestone', id: string }, taskTemplate: { __typename?: 'TaskTemplate', id: string }, requirement: { __typename?: 'Requirement', id: string } } }> } };

export type GetRequirementsWithStandardProfileQueryVariables = Exact<{
  sid?: InputMaybe<Scalars['ID']['input']>;
  spids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetRequirementsWithStandardProfileQuery = { __typename?: 'Query', requirementsWithStandardProfiles: { __typename?: 'RequirementWithStandardProfileConnection', totalCount: number, edges: Array<{ __typename?: 'RequirementWithStandardProfileEdge', node: { __typename?: 'RequirementWithStandardProfile', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, standardName?: string | null, standardProfileName?: string | null, standardProfileAlias?: string | null, maturityLevelName?: string | null, securityLevelName?: string | null, subSpeName?: string | null, speName?: string | null } }> } };

export type GetReqForProfileDDvaluesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReqForProfileDDvaluesQuery = { __typename?: 'Query', securityLevelName: { __typename?: 'SecurityLevelConnection', edges: Array<{ __typename?: 'SecurityLevelEdge', node: { __typename?: 'SecurityLevel', id: string, name: string } }> }, maturityLevelName: { __typename?: 'MaturityLevelConnection', edges: Array<{ __typename?: 'MaturityLevelEdge', node: { __typename?: 'MaturityLevel', id: string, name: string } }> }, speName: { __typename?: 'SPEConnection', edges: Array<{ __typename?: 'SPEEdge', node: { __typename?: 'SPE', id: string, name: string } }> }, subSpeName: { __typename?: 'SubSPEConnection', edges: Array<{ __typename?: 'SubSPEEdge', node: { __typename?: 'SubSPE', id: string, name: string } }> } };

export type GetProfileNameQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileNameQuery = { __typename?: 'Query', standardProfiles: { __typename?: 'StandardProfileConnection', edges: Array<{ __typename?: 'StandardProfileEdge', node: { __typename?: 'StandardProfile', name: string, standard?: { __typename?: 'Standard', id: string } | null } }> } };

export type GetStandardQueryVariables = Exact<{
  sid: Scalars['ID']['input'];
}>;


export type GetStandardQuery = { __typename?: 'Query', standards: { __typename?: 'StandardConnection', edges: Array<{ __typename?: 'StandardEdge', node: { __typename?: 'Standard', id: string, name: string, validFrom: string, validTo?: string | null, releasedAt: string, requirementsCount: number, description: string, implementationGuidance?: string | null, country?: { __typename?: 'Country', name: string } | null, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null } }> } };

export type GetStandardProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardProfilesQuery = { __typename?: 'Query', standardProfiles: { __typename?: 'StandardProfileConnection', edges: Array<{ __typename?: 'StandardProfileEdge', node: { __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } }> } };

export type GetStandardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardsQuery = { __typename?: 'Query', standards: { __typename?: 'StandardConnection', totalCount: number, edges: Array<{ __typename?: 'StandardEdge', node: { __typename?: 'Standard', description: string, releasedAt: string, validFrom: string, validTo?: string | null, id: string, name: string, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null } }> } };

export type GetStandardsWithRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardsWithRequirementsQuery = { __typename?: 'Query', standards: { __typename?: 'StandardConnection', edges: Array<{ __typename?: 'StandardEdge', node: { __typename?: 'Standard', description: string, releasedAt: string, validFrom: string, validTo?: string | null, id: string, name: string, requirements?: Array<{ __typename?: 'Requirement', id: string, name: string } | null> | null, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null } }> } };

export type GetAllStandardsRichQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStandardsRichQuery = { __typename?: 'Query', standards: { __typename?: 'StandardConnection', edges: Array<{ __typename?: 'StandardEdge', node: { __typename?: 'Standard', id: string, name: string, description: string, validFrom: string, validTo?: string | null, releasedAt: string, implementationGuidance?: string | null, requirementsCount: number, country?: { __typename?: 'Country', name: string } | null, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null } }> } };

export type GetStandardNameQueryVariables = Exact<{
  sid: Scalars['ID']['input'];
}>;


export type GetStandardNameQuery = { __typename?: 'Query', standards: { __typename?: 'StandardConnection', edges: Array<{ __typename?: 'StandardEdge', node: { __typename?: 'Standard', name: string } }> } };

export type GetStandardNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardNamesQuery = { __typename?: 'Query', standards: { __typename?: 'StandardConnection', edges: Array<{ __typename?: 'StandardEdge', node: { __typename?: 'Standard', id: string, name: string, validFrom: string, validTo?: string | null, releasedAt: string } }> } };

export type GetMinimalSurveyForProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMinimalSurveyForProjectQuery = { __typename?: 'Query', projectSurvey?: { __typename?: 'Survey', id: string, optimisticLockVersion: number, classificationScore: number, status: SurveyStatus, isApproved: boolean, conductedAt?: string | null, actionTransitionLog: string, approved1At?: string | null, approved2At?: string | null, externalDocumentID?: string | null, comment: string, form: { __typename?: 'SurveyForm', version: number }, classificationClass: { __typename?: 'SurveyClassificationClass', id: string, name: string, description: string, activities: Array<{ __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity } | null> }, project: { __typename?: 'Project', id: string }, author: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, profile: { __typename?: 'SurveyProfile', id: string, name: string, perequisties: string, securityActivities: string } } | null };

export type GetSurveyForProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSurveyForProjectQuery = { __typename?: 'Query', projectSurvey?: { __typename?: 'Survey', answers: string, id: string, optimisticLockVersion: number, classificationScore: number, status: SurveyStatus, isApproved: boolean, conductedAt?: string | null, actionTransitionLog: string, approved1At?: string | null, approved2At?: string | null, externalDocumentID?: string | null, comment: string, form: { __typename?: 'SurveyForm', version: number, id: string, contents: Array<{ __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } | null> }, classificationClass: { __typename?: 'SurveyClassificationClass', id: string, name: string, description: string, activities: Array<{ __typename?: 'SurveyClassificationClassActivity', id: string, title: string, description: string, additionalDescription?: string | null, sequence: number, necessity: SurveyClassificationClassActivityNecessity } | null> }, project: { __typename?: 'Project', id: string }, author: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2User?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, profile: { __typename?: 'SurveyProfile', id: string, name: string, perequisties: string, securityActivities: string } } | null };

export type GetCraPsspDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCraPsspDataQuery = { __typename?: 'Query', projectSurvey?: { __typename?: 'Survey', id: string, status: SurveyStatus, classificationClass: { __typename?: 'SurveyClassificationClass', id: string, name: string } } | null };

export type ActiveLatestSurveryFormWithProfilesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ActiveLatestSurveryFormWithProfilesQuery = { __typename?: 'Query', surveyForms: { __typename?: 'SurveyFormConnection', totalCount: number, edges: Array<{ __typename?: 'SurveyFormEdge', node: { __typename?: 'SurveyForm', id: string, version: number, isPublished: boolean, profiles: Array<{ __typename?: 'SurveyProfile', id: string, name: string, securityActivities: string } | null>, contents: Array<{ __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } | null> } }> } };

export type GetSurveyFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSurveyFormQuery = { __typename?: 'Query', surveyForms: { __typename?: 'SurveyFormConnection', edges: Array<{ __typename?: 'SurveyFormEdge', node: { __typename?: 'SurveyForm', id: string, version: number, contents: Array<{ __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number }, profile: { __typename?: 'SurveyProfile', id: string, name: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } | null> } }> } };

export type GetSurveyProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveyProfilesQuery = { __typename?: 'Query', surveyProfiles: { __typename?: 'SurveyProfileConnection', edges: Array<{ __typename?: 'SurveyProfileEdge', node: { __typename?: 'SurveyProfile', id: string, name: string, perequisties: string, securityActivities: string } }> } };

export type SurveryFormsWithProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveryFormsWithProfilesQuery = { __typename?: 'Query', surveyForms: { __typename?: 'SurveyFormConnection', totalCount: number, edges: Array<{ __typename?: 'SurveyFormEdge', node: { __typename?: 'SurveyForm', id: string, version: number, kind: SurveyFormKind, profiles: Array<{ __typename?: 'SurveyProfile', id: string, name: string, securityActivities: string } | null> } }> } };

export type GetLatestPsspSurveyFormWithProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestPsspSurveyFormWithProfilesQuery = { __typename?: 'Query', surveyForms: { __typename?: 'SurveyFormConnection', totalCount: number, edges: Array<{ __typename?: 'SurveyFormEdge', node: { __typename?: 'SurveyForm', id: string, version: number, profiles: Array<{ __typename?: 'SurveyProfile', id: string, name: string, securityActivities: string, perequisties: string } | null> } }> } };

export type SurveyFormContentListQueryVariables = Exact<{
  profileID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SurveyFormContentListQuery = { __typename?: 'Query', surveyFormContents?: { __typename?: 'SurveyFormContentConnection', totalCount: number, edges: Array<{ __typename?: 'SurveyFormContentEdge', node: { __typename?: 'SurveyFormContent', id: string, sequence: number, form: { __typename?: 'SurveyForm', id: string, version: number, isPublished: boolean, profiles: Array<{ __typename?: 'SurveyProfile', id: string, name: string, securityActivities: string } | null> }, profile: { __typename?: 'SurveyProfile', id: string, name: string, securityActivities: string }, question?: { __typename?: 'SurveyQuestion', id: string, topic: string, question: string, questionGuidance: string, answerHeader: string, surveyQuestionOptions?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, value: number, sequence: number } | null> | null } | null, topicClusterType: { __typename?: 'SurveyTopicClusterType', id: string, name: string } } }> } | null };

export type GetProjectSurveyReportQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectSurveyReportQuery = { __typename?: 'Query', projectSurveyReport?: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } | null };

export type GetTaskTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskTemplatesQuery = { __typename?: 'Query', taskTemplates: { __typename?: 'TaskTemplateConnection', edges: Array<{ __typename?: 'TaskTemplateEdge', node: { __typename?: 'TaskTemplate', id: string, title: string } }> } };

export type GetProjectTasksQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type GetProjectTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', totalCount: number, edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } } }> } | null };

export type GetSpecificProjectTasksQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
  taskIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  taskSource?: InputMaybe<TaskSource>;
}>;


export type GetSpecificProjectTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', totalCount: number, edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } } }> } | null };

export type GetTasksQueryVariables = Exact<{
  where?: InputMaybe<TaskWhereInput>;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', totalCount: number, edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } } }> } | null };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, title: string } }> } | null };

export type GetGlobalTasksQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GetGlobalTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', totalCount: number, edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, title: string, description: string, isMandatory: boolean, isApplicable: boolean, priority?: TaskPriority | null, status: TaskStatus, referenceDocuments: string, source: TaskSource, topic?: TaskTopic | null, createTime: string, updateTime: string, dueAt?: string | null, kind: TaskKind, deliverables: Array<{ __typename?: 'TaskDeliverable', id: string, title: string, isChecked: boolean }>, projectMilestone?: { __typename?: 'ProjectMilestone', id: string, name: string, projectPhase: { __typename?: 'ProjectPhase', id: string, name: string } } | null, assignee?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, project: { __typename?: 'Project', id: string, name: string, type?: { __typename?: 'ProjectType', id: string } | null } } }> } | null };

export type GetTasksCommentsQueryVariables = Exact<{
  tid: Scalars['ID']['input'];
}>;


export type GetTasksCommentsQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', id: string, taskComments: Array<{ __typename?: 'TaskComment', id: string, content: string, createTime: string, updateTime: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> } }> } | null };

export type ExportProjectTasksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  taskIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ExportProjectTasksQuery = { __typename?: 'Query', exportProjectTasks?: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } | null };

export type RequirementsForTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RequirementsForTaskQuery = { __typename?: 'Query', requirementsForTask: Array<{ __typename?: 'Requirement', id: string, name: string, alias: string, description: string, guidance: string, implementationGuidance?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, description: string } | null, standardProfiles?: Array<{ __typename?: 'StandardProfile', id: string, name: string, alias: string, description?: string | null, standard?: { __typename?: 'Standard', id: string, name: string, releasedAt: string } | null } | null> | null }> };

export type GetTaskEvidencesQueryVariables = Exact<{
  tid: Scalars['ID']['input'];
}>;


export type GetTaskEvidencesQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskConnection', edges: Array<{ __typename?: 'TaskEdge', node: { __typename?: 'Task', taskEvidences: Array<{ __typename?: 'TaskEvidence', id: string, kind: TaskEvidenceKind, link?: string | null, createTime: string, updateTime: string, fileAsset?: { __typename?: 'FileAsset', id: string, name: string, size: number, refID: string, contentType: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } }> } | null };

export type DownloadTaskEvidenceQueryVariables = Exact<{
  taskEvidenceID: Scalars['ID']['input'];
}>;


export type DownloadTaskEvidenceQuery = { __typename?: 'Query', downloadTaskEvidenceFile: { __typename?: 'EncodedFile', fileName: string, content: string, type: string } };

export type TrasForProjectQueryVariables = Exact<{
  pid: Scalars['ID']['input'];
}>;


export type TrasForProjectQuery = { __typename?: 'Query', tras?: { __typename?: 'TRAConnection', edges: Array<{ __typename?: 'TRAEdge', node: { __typename?: 'TRA', metadata?: string | null, id: string, createTime: string, updateTime?: string | null, title: string, description: string, status: TraStatus, lockedAt?: string | null, approved1At?: string | null, approved2At?: string | null, project: { __typename?: 'Project', id: string, name: string }, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, participants?: Array<{ __typename?: 'TRAParticipant', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> | null, reports?: Array<{ __typename?: 'TRAReport', id: string, title: string, description: string, extension: string, classification: TraReportClassification, createTime: string }> | null } }> } | null };

export type TraQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TraQuery = { __typename?: 'Query', tras?: { __typename?: 'TRAConnection', edges: Array<{ __typename?: 'TRAEdge', node: { __typename?: 'TRA', body: string, id: string, createTime: string, updateTime?: string | null, title: string, description: string, status: TraStatus, lockedAt?: string | null, approved1At?: string | null, approved2At?: string | null, project: { __typename?: 'Project', id: string, name: string }, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, participants?: Array<{ __typename?: 'TRAParticipant', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> | null, reports?: Array<{ __typename?: 'TRAReport', id: string, title: string, description: string, extension: string, classification: TraReportClassification, createTime: string }> | null } }> } | null };

export type TraHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TraHistoryQuery = { __typename?: 'Query', tras?: { __typename?: 'TRAConnection', edges: Array<{ __typename?: 'TRAEdge', node: { __typename?: 'TRA', id: string, history?: Array<{ __typename?: 'TRAHistory', id: string, createTime: string, status: TraHistoryStatus, comment?: string | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null } }> } | null };

export type SetTraParticipantsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  participants?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SetTraParticipantsMutation = { __typename?: 'Mutation', setTRAParticipants?: Array<{ __typename?: 'TRAParticipant', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null };

export type UpdateTraMutationVariables = Exact<{
  input: UpdateTraRawInput;
}>;


export type UpdateTraMutation = { __typename?: 'Mutation', updateTRA: { __typename?: 'TRA', id: string, createTime: string, updateTime?: string | null, title: string, description: string, status: TraStatus, lockedAt?: string | null, approved1At?: string | null, approved2At?: string | null, project: { __typename?: 'Project', id: string, name: string }, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string }, approver1?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, approver2?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null, participants?: Array<{ __typename?: 'TRAParticipant', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> | null, reports?: Array<{ __typename?: 'TRAReport', id: string, title: string, description: string, extension: string, classification: TraReportClassification, createTime: string }> | null } };

export type SetTraStateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  state: TraSetStateStatus;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetTraStateMutation = { __typename?: 'Mutation', setTRAState: { __typename?: 'TRA', id: string, status: TraStatus } };

export type TraTemplateVariantsQueryVariables = Exact<{ [key: string]: never; }>;


export type TraTemplateVariantsQuery = { __typename?: 'Query', traTemplateVariants?: Array<string> | null };

export type TraTemplateByVariantQueryVariables = Exact<{
  variant: Scalars['String']['input'];
}>;


export type TraTemplateByVariantQuery = { __typename?: 'Query', traTemplateLatestForVariant?: { __typename?: 'TRATemplate', id: string, createTime: string, title: string, description: string, variant: string, body: string } | null };

export type LatestAttckQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestAttckQuery = { __typename?: 'Query', attckLatest: { __typename?: 'Attck', id: string, createTime: string, version: string, url: string, domain: AttckDomain, assets: Array<{ __typename?: 'AttckAsset', id: string, name: string, description: string, label: string, srcId: string, url: string }>, techniques: Array<{ __typename?: 'AttckTechnique', id: string, name: string, srcId: string, description: string, label: string, url: string, techniqueAssets: Array<{ __typename?: 'AttckTechniqueAsset', id: string, asset: { __typename?: 'AttckAsset', id: string } }>, techniqueMitigations: Array<{ __typename?: 'AttckTechniqueMitigation', id: string, description: string, srcId: string, mitigation: { __typename?: 'AttckMitigation', id: string, name: string, label: string, description: string, srcId: string, url: string } }> }>, tactics: Array<{ __typename?: 'AttckTactic', id: string, name: string, label: string, description: string, srcId: string, url: string, techniques: Array<{ __typename?: 'AttckTechnique', id: string }> }> } };

export type ListAttcksQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAttcksQuery = { __typename?: 'Query', attcks: { __typename?: 'AttckConnection', edges: Array<{ __typename?: 'AttckEdge', node: { __typename?: 'Attck', id: string, version: string, createTime: string, domain: AttckDomain, assets: Array<{ __typename?: 'AttckAsset', id: string, name: string, label: string, description: string }>, tactics: Array<{ __typename?: 'AttckTactic', id: string, name: string, label: string, description: string, techniques: Array<{ __typename?: 'AttckTechnique', label: string, description: string, techniqueMitigations: Array<{ __typename?: 'AttckTechniqueMitigation', id: string, mitigation: { __typename?: 'AttckMitigation', name: string, description: string, label: string } }> }> }>, techniques: Array<{ __typename?: 'AttckTechnique', id: string, name: string, description: string, url: string, techniqueMitigations: Array<{ __typename?: 'AttckTechniqueMitigation', id: string, description: string, mitigation: { __typename?: 'AttckMitigation', name: string, description: string, label: string } }> }> } }> } };

export type LockTraMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LockTraMutation = { __typename?: 'Mutation', lockTRA: { __typename?: 'TRA', id: string, status: TraStatus, lockedAt?: string | null, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type UnlockTraMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockTraMutation = { __typename?: 'Mutation', unlockTRA: { __typename?: 'TRA', id: string, status: TraStatus, lockedAt?: string | null, lockedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type DownloadTraReportContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadTraReportContentQuery = { __typename?: 'Query', downloadTRAReportContent: { __typename?: 'EncodedFile', content: string, type: string, fileName: string } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> } };

export type GetUserDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', gid: string, orgCode: string, location: string, are: string, admin: boolean, active: boolean, id: string, firstName: string, lastName: string, email: string, organizations?: Array<{ __typename?: 'OrganizationUser', id: string, role: OrganizationUserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null }> | null } }> } };

export type GetUsersForSelectQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersForSelectQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> } };

export type GetUsersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', gid: string, orgCode: string, location: string, are: string, admin: boolean, active: boolean, id: string, firstName: string, lastName: string, email: string, organizations?: Array<{ __typename?: 'OrganizationUser', id: string, role: OrganizationUserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null }> | null } }> } };

export type GetUsersForAdminQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
}>;


export type GetUsersForAdminQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', gid: string, orgCode: string, location: string, are: string, admin: boolean, active: boolean, id: string, firstName: string, lastName: string, email: string } }> } };

export type GetIcsoUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIcsoUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> } };

export type UsersOfProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type UsersOfProjectQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, organizations?: Array<{ __typename?: 'OrganizationUser', role: OrganizationUserRole }> | null } }> } };

export type FindUsersQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type FindUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } }> } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'User', gid: string, orgCode: string, location: string, are: string, admin: boolean, active: boolean, id: string, firstName: string, lastName: string, email: string } };

export type GetUserNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationSettingsQuery = { __typename?: 'Query', userNotificationSetting?: { __typename?: 'UserNotificationSetting', id: string, userID: string, enable: boolean, frequency?: UserNotificationSettingFrequency | null, projects?: Array<{ __typename?: 'UserNotificationSettingProjectConfigurationOutput', id?: string | null, priorityEnabled?: boolean | null, cvssEnabled?: boolean | null, cvssMinScore?: number | null, assetsAndZonesEnabled?: boolean | null, assignedOnly?: boolean | null, priority?: UserNotificationSettingTaskNotificationPriority | null, tasksEnabled?: boolean | null, vulnerabilitiesEnabled?: boolean | null } | null> | null } | null };

export type GetAllComponentVendorsQueryVariables = Exact<{
  partialName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllComponentVendorsQuery = { __typename?: 'Query', componentVendors: { __typename?: 'ComponentVendorConnection', edges: Array<{ __typename?: 'ComponentVendorEdge', node: { __typename?: 'ComponentVendor', id: string, name: string } }> } };

export type GetComponentVendorByIdQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetComponentVendorByIdQuery = { __typename?: 'Query', componentVendors: { __typename?: 'ComponentVendorConnection', edges: Array<{ __typename?: 'ComponentVendorEdge', node: { __typename?: 'ComponentVendor', id: string, name: string } }> } };

export type GetComponentVendorAndIdentifiersQueryVariables = Exact<{
  componentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetComponentVendorAndIdentifiersQuery = { __typename?: 'Query', components: { __typename?: 'ComponentConnection', edges: Array<{ __typename?: 'ComponentEdge', node: { __typename?: 'Component', id: string, name: string, componentVendor: { __typename?: 'ComponentVendor', id: string, name: string, assessments?: Array<{ __typename?: 'ComponentVendorAssessment', id: string, status: ComponentVendorAssessmentStatus, result: ComponentVendorAssessmentResult, type: ComponentVendorAssessmentType, completionTime?: string | null }> | null }, componentExternalIdentifiers?: Array<{ __typename?: 'ComponentExternalIdentifier', id: string, source: ComponentExternalIdentifierSource, externalIdentifier: string }> | null } }> } };

export type UserEventsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserEventsSubscription = { __typename?: 'Subscription', userEvents: { __typename?: 'UserEvent', type: UserEventType, status: OperationStatus, resourceID: string, message?: string | null } };

export const ComponentSourceRawFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentSourceRawFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentSourceRaw"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"cpe"}}]}}]} as unknown as DocumentNode<ComponentSourceRawFragmentFragment, unknown>;
export const ComponentPartialFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}}]} as unknown as DocumentNode<ComponentPartialFragmentFragment, unknown>;
export const ComponentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}}]} as unknown as DocumentNode<ComponentFragmentFragment, unknown>;
export const ComponentSearchFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentSearchFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ComponentSearchFragmentFragment, unknown>;
export const ProjectCustomerPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCustomerPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}}]}}]} as unknown as DocumentNode<ProjectCustomerPartialFragment, unknown>;
export const ProjectSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"plantName"}},{"kind":"Field","name":{"kind":"Name","value":"locationStreet"}},{"kind":"Field","name":{"kind":"Name","value":"locationCity"}},{"kind":"Field","name":{"kind":"Name","value":"locationPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationCountry"}},{"kind":"Field","name":{"kind":"Name","value":"plantExternalID"}},{"kind":"Field","name":{"kind":"Name","value":"projectStandardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCustomerPartial"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCustomerPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}}]}}]} as unknown as DocumentNode<ProjectSummaryFragment, unknown>;
export const ProjectLocationPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectLocationPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCountry"}},{"kind":"Field","name":{"kind":"Name","value":"locationCity"}},{"kind":"Field","name":{"kind":"Name","value":"locationPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationStreet"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<ProjectLocationPartialFragment, unknown>;
export const ProjectPlantPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPlantPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantName"}},{"kind":"Field","name":{"kind":"Name","value":"plantExternalID"}}]}}]} as unknown as DocumentNode<ProjectPlantPartialFragment, unknown>;
export const StandardProfileFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<StandardProfileFragmentFragment, unknown>;
export const ProjectProfilePartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectProfilePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectStandardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<ProjectProfilePartialFragment, unknown>;
export const ProjectHierarchyPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"criticality"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityManager"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectHierarchyPartialFragment, unknown>;
export const MinimalUserPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<MinimalUserPartialFragment, unknown>;
export const ProjectUserPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<ProjectUserPartialFragment, unknown>;
export const NotificationSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNotificationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<NotificationSettingsFragment, unknown>;
export const AssetRelationAttributeDefinitionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}}]}}]} as unknown as DocumentNode<AssetRelationAttributeDefinitionFragmentFragment, unknown>;
export const AssetRelationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]} as unknown as DocumentNode<AssetRelationFragmentFragment, unknown>;
export const AssetSummaryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}}]}}]} as unknown as DocumentNode<AssetSummaryFragmentFragment, unknown>;
export const AttributeDefinitionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]} as unknown as DocumentNode<AttributeDefinitionFragmentFragment, unknown>;
export const AssetAttributeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]} as unknown as DocumentNode<AssetAttributeFragmentFragment, unknown>;
export const AssetBaseFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}}]} as unknown as DocumentNode<AssetBaseFragmentFragment, unknown>;
export const AssetItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AssetItemFragmentFragment, unknown>;
export const AssetItemAttributeDefinitionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]} as unknown as DocumentNode<AssetItemAttributeDefinitionFragmentFragment, unknown>;
export const AssetItemAttributeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]} as unknown as DocumentNode<AssetItemAttributeFragmentFragment, unknown>;
export const AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}}]} as unknown as DocumentNode<AssetFragmentFragment, unknown>;
export const FullAssetItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}}]} as unknown as DocumentNode<FullAssetItemFragmentFragment, unknown>;
export const CommentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZoneStandardProfileRequirementComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CommentFragment, unknown>;
export const CreateComponentRequestFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}}]}}]} as unknown as DocumentNode<CreateComponentRequestFragmentFragment, unknown>;
export const CreateComponentRequestCommentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestViewComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]} as unknown as DocumentNode<CreateComponentRequestCommentFragment, unknown>;
export const CreateComponentRequestViewFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestViewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"requesterID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestComment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestViewComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]} as unknown as DocumentNode<CreateComponentRequestViewFragmentFragment, unknown>;
export const CreateComponentRequestStatusTransitionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestStatusTransition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestViewAllowedStatusTransition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]} as unknown as DocumentNode<CreateComponentRequestStatusTransitionFragment, unknown>;
export const CreateComponentRequestViewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestViewFragment"}},{"kind":"Field","name":{"kind":"Name","value":"statusTransitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestStatusTransition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestComment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestViewComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestViewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"requesterID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestComment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestStatusTransition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestViewAllowedStatusTransition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]} as unknown as DocumentNode<CreateComponentRequestViewFragment, unknown>;
export const CraModuleCommentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraModuleCommentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAModuleComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CraModuleCommentFieldsFragment, unknown>;
export const EncodedFileFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<EncodedFileFieldsFragment, unknown>;
export const FileAssetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<FileAssetFieldsFragment, unknown>;
export const CraUploadFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CraUploadFieldsFragment, unknown>;
export const CraFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<CraFieldsFragment, unknown>;
export const CraCybersecRiskAssessmentUploadFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraCybersecRiskAssessmentUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRACybersecRiskAssessmentUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"completeness"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CraCybersecRiskAssessmentUploadFieldsFragment, unknown>;
export const CraDocumentationUploadFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraDocumentationUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRADocumentationUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CraDocumentationUploadFieldsFragment, unknown>;
export const CraVulnerabilityHandlingUploadFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraVulnerabilityHandlingUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAVulnerabilityHandlingUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CraVulnerabilityHandlingUploadFieldsFragment, unknown>;
export const CraGeneralFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraGeneralFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAGeneral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"ProductVersion"}},{"kind":"Field","name":{"kind":"Name","value":"ProductCategory"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetime"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetimeStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetimeEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodInformation"}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<CraGeneralFieldsFragment, unknown>;
export const NotificationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"cves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"weakness"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssBaseScore"}},{"kind":"Field","name":{"kind":"Name","value":"cvssExploitabilityScore"}},{"kind":"Field","name":{"kind":"Name","value":"cvssImpactScore"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssOverrideVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"vector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"solutionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"legalNotice"}},{"kind":"Field","name":{"kind":"Name","value":"vendorAdvisories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<NotificationFragmentFragment, unknown>;
export const ProjectAssetItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}}]} as unknown as DocumentNode<ProjectAssetItemFragmentFragment, unknown>;
export const MitigationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MitigationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mitigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"}},{"kind":"Field","name":{"kind":"Name","value":"statusReason"}},{"kind":"Field","name":{"kind":"Name","value":"workcycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]} as unknown as DocumentNode<MitigationFragmentFragment, unknown>;
export const ProjectHierarchyTodoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProjectHierarchyTodoFragmentFragment, unknown>;
export const RequirementsForProfileFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"requirementsForProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementOnProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentCreateTime"}}]}}]} as unknown as DocumentNode<RequirementsForProfileFieldsFragment, unknown>;
export const RequirementBasicFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementBasicFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Requirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<RequirementBasicFragmentFragment, unknown>;
export const RequirementMinimalFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementMinimalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Requirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RequirementMinimalFragmentFragment, unknown>;
export const RichStandardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichStandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsCount"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<RichStandardFragmentFragment, unknown>;
export const StandardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]} as unknown as DocumentNode<StandardFragmentFragment, unknown>;
export const StandardWithProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardWithProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<StandardWithProfileFragment, unknown>;
export const SecurityActivitiesPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}}]} as unknown as DocumentNode<SecurityActivitiesPartialFragment, unknown>;
export const SurveyClassificationClassPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyClassificationClassPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClass"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityActivitiesPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}}]} as unknown as DocumentNode<SurveyClassificationClassPartialFragment, unknown>;
export const SurveyQuestionPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<SurveyQuestionPartialFragment, unknown>;
export const SurveyFormContentPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<SurveyFormContentPartialFragment, unknown>;
export const SurveyFormPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SurveyFormPartialFragment, unknown>;
export const BaseSurveyPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSurveyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optimisticLockVersion"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityActivitiesPartial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classificationScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isApproved"}},{"kind":"Field","name":{"kind":"Name","value":"conductedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionTransitionLog"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approver2User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentID"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<BaseSurveyPartialFragment, unknown>;
export const TaskPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<TaskPartialFragment, unknown>;
export const TasksConnectionPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksConnectionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskPartial"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]} as unknown as DocumentNode<TasksConnectionPartialFragment, unknown>;
export const TasksCommentPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksCommentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<TasksCommentPartialFragment, unknown>;
export const TraBasePartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraBasePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}}]} as unknown as DocumentNode<TraBasePartialFragment, unknown>;
export const TraPartialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TraBasePartial"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraBasePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}}]} as unknown as DocumentNode<TraPartialFragment, unknown>;
export const ProjectZoneFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectZoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<ProjectZoneFragmentFragment, unknown>;
export const ProjectUserParticipantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectUserParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProjectUserParticipantFragment, unknown>;
export const OrganizationUserParticipantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationUserParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"organizationRole"},"name":{"kind":"Name","value":"role"}}]}}]} as unknown as DocumentNode<OrganizationUserParticipantFragment, unknown>;
export const RequirementWithSpeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementWithSPEFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementWithSPE"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"standardName"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}}]}}]} as unknown as DocumentNode<RequirementWithSpeFieldsFragment, unknown>;
export const RequirementOnProjectZoneFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementOnProjectZoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementOnProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentCreateTime"}}]}}]} as unknown as DocumentNode<RequirementOnProjectZoneFieldsFragment, unknown>;
export const CreatePersonalAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePersonalAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresIn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAPIToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueForID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiresIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresIn"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<CreatePersonalAccessTokenMutation, CreatePersonalAccessTokenMutationVariables>;
export const CreateAssetRelationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssetRelation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetRelationRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssetRelation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetRelationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAssetRelationMutation, CreateAssetRelationMutationVariables>;
export const UpdateAssetRelationForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetRelationForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetRelationRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetRelationForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetRelationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssetRelationForProjectMutation, UpdateAssetRelationForProjectMutationVariables>;
export const DeleteAssetRelationsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetRelationsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetRelationsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetRelationsForProjectMutation, DeleteAssetRelationsForProjectMutationVariables>;
export const ImportAssetRelationsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportAssetRelationsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importAssetRelationsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"unsuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationsUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationsCreated"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributesUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributesCreated"}},{"kind":"Field","name":{"kind":"Name","value":"failedRows"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ImportAssetRelationsListMutation, ImportAssetRelationsListMutationVariables>;
export const DeleteAssetRelationAttributeDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetRelationAttributeDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetRelationAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetRelationAttributeDefinitionsMutation, DeleteAssetRelationAttributeDefinitionsMutationVariables>;
export const CreateAssetRelationAttributeDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssetRelationAttributeDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetRelationAttributeDefinitionRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssetRelationAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}}]}}]} as unknown as DocumentNode<CreateAssetRelationAttributeDefinitionsMutation, CreateAssetRelationAttributeDefinitionsMutationVariables>;
export const DeleteAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIDs"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetsMutation, DeleteAssetsMutationVariables>;
export const MoveAssetsToSecurityZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveAssetsToSecurityZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetsProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIDs"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MoveAssetsToSecurityZoneMutation, MoveAssetsToSecurityZoneMutationVariables>;
export const UpdateAssetItemLinkedComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetItemLinkedComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"componentID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetItemLinkedComponentMutation, UpdateAssetItemLinkedComponentMutationVariables>;
export const UploadAssetListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadAssetList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importAssetsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"unsuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"assetsUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"assetsCreated"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemsUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemsCreated"}},{"kind":"Field","name":{"kind":"Name","value":"projectZonesUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"failedRows"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UploadAssetListMutation, UploadAssetListMutationVariables>;
export const CreateAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAssetMutation, CreateAssetMutationVariables>;
export const UpdateAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetBulkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssetsMutation, UpdateAssetsMutationVariables>;
export const CreateAssetItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssetItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetItemRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssetItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAssetItemMutation, CreateAssetItemMutationVariables>;
export const UpdateAssetItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetItemBulkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssetItemMutation, UpdateAssetItemMutationVariables>;
export const DeleteAssetItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetItemMutation, DeleteAssetItemMutationVariables>;
export const CreateAssetAttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssetAttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetAttributeDefinitionRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssetAttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAssetAttributeDefinitionMutation, CreateAssetAttributeDefinitionMutationVariables>;
export const UpdateAssetAttributeDefinitionSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetAttributeDefinitionSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetAttributeDefinitionSequenceRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetAttributeDefinitionSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetAttributeDefinitionSequenceMutation, UpdateAssetAttributeDefinitionSequenceMutationVariables>;
export const UpdateAssetItemAttributeDefinitionSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetItemAttributeDefinitionSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetItemAttributeDefinitionSequenceRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetItemAttributeDefinitionSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetItemAttributeDefinitionSequenceMutation, UpdateAssetItemAttributeDefinitionSequenceMutationVariables>;
export const DeleteAssetAttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetAttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetAttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetAttributeDefinitionMutation, DeleteAssetAttributeDefinitionMutationVariables>;
export const CreateItemAttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateItemAttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetItemAttributeDefinitionRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssetItemAttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateItemAttributeDefinitionMutation, CreateItemAttributeDefinitionMutationVariables>;
export const DeleteItemAttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteItemAttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetItemAttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteItemAttributeDefinitionMutation, DeleteItemAttributeDefinitionMutationVariables>;
export const CreateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rqid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZoneStandardProfileRequirementCommentRequirementCommentStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectZoneStandardProfileRequirementComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requirementID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rqid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requirementCommentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Comment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZoneStandardProfileRequirementComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateComponentCreateRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateComponentCreateRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateComponentCreateRequestRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComponentCreateRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusTransitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestStatusTransition"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestStatusTransition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequestViewAllowedStatusTransition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]} as unknown as DocumentNode<CreateComponentCreateRequestMutation, CreateComponentCreateRequestMutationVariables>;
export const ChangeComponentCreateRequestStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeComponentCreateRequestStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewComponentCreateRequestRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewComponentCreateRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}}]}}]} as unknown as DocumentNode<ChangeComponentCreateRequestStatusMutation, ChangeComponentCreateRequestStatusMutationVariables>;
export const UpdateComponentCreateRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComponentCreateRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateComponentCreateRequestRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComponentCreateRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateComponentRequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateComponentRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}}]}}]} as unknown as DocumentNode<UpdateComponentCreateRequestMutation, UpdateComponentCreateRequestMutationVariables>;
export const SaveCraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCRAInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<SaveCraMutation, SaveCraMutationVariables>;
export const SetCraCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCraCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCRACompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isCompleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]}}]} as unknown as DocumentNode<SetCraCompletionMutation, SetCraCompletionMutationVariables>;
export const CreateCraUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCraUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCRAUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}},{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraUploadFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<CreateCraUploadMutation, CreateCraUploadMutationVariables>;
export const DeleteCraUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCraUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCRAUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craUploadID"}}}]}]}}]} as unknown as DocumentNode<DeleteCraUploadMutation, DeleteCraUploadMutationVariables>;
export const SetCraCybersecRiskAssessmentCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCraCybersecRiskAssessmentCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCRACybersecRiskAssessmentCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isCompleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]}}]} as unknown as DocumentNode<SetCraCybersecRiskAssessmentCompletionMutation, SetCraCybersecRiskAssessmentCompletionMutationVariables>;
export const CreateCraCybersecRiskAssessmentUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCraCybersecRiskAssessmentUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCRACybersecRiskAssessmentUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentID"}}},{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraCybersecRiskAssessmentUploadFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraCybersecRiskAssessmentUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRACybersecRiskAssessmentUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"completeness"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<CreateCraCybersecRiskAssessmentUploadMutation, CreateCraCybersecRiskAssessmentUploadMutationVariables>;
export const SetCompletenessCraCybersecRiskAssessmentUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCompletenessCraCybersecRiskAssessmentUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completeness"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CRACybersecRiskAssessmentUploadCompleteness"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCompletenessCRACybersecRiskAssessmentUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"}}},{"kind":"Argument","name":{"kind":"Name","value":"completeness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completeness"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completeness"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]}}]} as unknown as DocumentNode<SetCompletenessCraCybersecRiskAssessmentUploadMutation, SetCompletenessCraCybersecRiskAssessmentUploadMutationVariables>;
export const DeleteCraCybersecRiskAssessmentUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCraCybersecRiskAssessmentUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCRACybersecRiskAssessmentUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"}}}]}]}}]} as unknown as DocumentNode<DeleteCraCybersecRiskAssessmentUploadMutation, DeleteCraCybersecRiskAssessmentUploadMutationVariables>;
export const CreateCraDocumentationUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCraDocumentationUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCRADocumentationUploadRawInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCRADocumentationUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraDocumentationUploadFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraDocumentationUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRADocumentationUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<CreateCraDocumentationUploadMutation, CreateCraDocumentationUploadMutationVariables>;
export const DeleteCraDocumentationUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCraDocumentationUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craDocumentationUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCRADocumentationUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craDocumentationUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craDocumentationUploadID"}}}]}]}}]} as unknown as DocumentNode<DeleteCraDocumentationUploadMutation, DeleteCraDocumentationUploadMutationVariables>;
export const SaveCraDocumentationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCraDocumentation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCRADocumentationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCRADocumentation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"hasProductVisual"}},{"kind":"Field","name":{"kind":"Name","value":"hasRefDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"hasIntendedPurpose"}},{"kind":"Field","name":{"kind":"Name","value":"hasSecDesignArchitecture"}},{"kind":"Field","name":{"kind":"Name","value":"hasProcessReference"}},{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraDocumentationUploadFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraDocumentationUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRADocumentationUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<SaveCraDocumentationMutation, SaveCraDocumentationMutationVariables>;
export const SetCraDocumentationCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCraDocumentationCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCRADocumentationCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isCompleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]} as unknown as DocumentNode<SetCraDocumentationCompletionMutation, SetCraDocumentationCompletionMutationVariables>;
export const SaveCraVulnerabilityHandlingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCraVulnerabilityHandling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCRAVulnerabilityHandlingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCRAVulnerabilityHandling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"IsCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"seContact"}},{"kind":"Field","name":{"kind":"Name","value":"seContactValidationDate"}},{"kind":"Field","name":{"kind":"Name","value":"customerContact"}},{"kind":"Field","name":{"kind":"Name","value":"customerContactValidationDate"}}]}}]}}]} as unknown as DocumentNode<SaveCraVulnerabilityHandlingMutation, SaveCraVulnerabilityHandlingMutationVariables>;
export const SetCraVulnerabilityHandlingCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCraVulnerabilityHandlingCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCRAVulnerabilityHandlingCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isCompleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"IsCompleted"}}]}}]}}]} as unknown as DocumentNode<SetCraVulnerabilityHandlingCompletionMutation, SetCraVulnerabilityHandlingCompletionMutationVariables>;
export const CreateCraVulnerabilityHandlingUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCraVulnerabilityHandlingUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCRAVulnerabilityHandlingUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craVulnerabilityHandlingID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingID"}}},{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraVulnerabilityHandlingUploadFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraVulnerabilityHandlingUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAVulnerabilityHandlingUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<CreateCraVulnerabilityHandlingUploadMutation, CreateCraVulnerabilityHandlingUploadMutationVariables>;
export const DeleteCraVulnerabilityHandlingUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCraVulnerabilityHandlingUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCRAVulnerabilityHandlingUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craVulnerabilityHandlingUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingUploadID"}}}]}]}}]} as unknown as DocumentNode<DeleteCraVulnerabilityHandlingUploadMutation, DeleteCraVulnerabilityHandlingUploadMutationVariables>;
export const SaveCraGeneralDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCraGeneral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCRAGeneralInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCRAGeneral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraGeneralFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraGeneralFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAGeneral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"ProductVersion"}},{"kind":"Field","name":{"kind":"Name","value":"ProductCategory"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetime"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetimeStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetimeEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodInformation"}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<SaveCraGeneralMutation, SaveCraGeneralMutationVariables>;
export const SetCraGeneralCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCraGeneralCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCRAGeneralCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isCompleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCompleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]} as unknown as DocumentNode<SetCraGeneralCompletionMutation, SetCraGeneralCompletionMutationVariables>;
export const OverrideCvssDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OverrideCvss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OverrideCVSSInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overrideCVSS"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<OverrideCvssMutation, OverrideCvssMutationVariables>;
export const CreateProjectHierarchyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectHierarchy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveProjectHierarchyAttributeRawInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commodityManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"criticality"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyCriticality"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProjectHierarchy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"commodityManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commodityManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"criticality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"criticality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supplierName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"criticality"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityManager"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectHierarchyMutation, CreateProjectHierarchyMutationVariables>;
export const DeleteProjectHierarchyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectHierarchy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectHierarchy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectHierarchyMutation, DeleteProjectHierarchyMutationVariables>;
export const CreateProjectHierarchyAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectHierarchyAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIDs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectHierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectHierarchyAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIDs"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectHierarchyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectHierarchyID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}}]}}]} as unknown as DocumentNode<CreateProjectHierarchyAssetMutation, CreateProjectHierarchyAssetMutationVariables>;
export const GetProjectHierarchyForAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectHierarchyForAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectHierarchyAssetsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyForAssetQuery, GetProjectHierarchyForAssetQueryVariables>;
export const CreateProjectHierarchyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectHierarchyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectHierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectHierarchyFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectHierarchyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectHierarchyID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]}}]} as unknown as DocumentNode<CreateProjectHierarchyFileMutation, CreateProjectHierarchyFileMutationVariables>;
export const DeleteProjectHierarchyFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectHierarchyFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectHierarchyFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectHierarchyFilesMutation, DeleteProjectHierarchyFilesMutationVariables>;
export const CreateProjectHierarchyAttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectHierarchyAttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectHierarchyAttributeDefinitionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectHierarchyAttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectHierarchyAttributeDefinitionMutation, CreateProjectHierarchyAttributeDefinitionMutationVariables>;
export const DeleteProjectHierarchyAttributeDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectHierarchyAttributeDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectHierarchyAttributeDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectHierarchyAttributeDefinitionMutation, DeleteProjectHierarchyAttributeDefinitionMutationVariables>;
export const UpdateProjectHierarchyAttributeDefinitionSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectHierarchyAttributeDefinitionSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectHierarchyAttributeDefinitionSequenceRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectHierarchyAttributeDefinitionSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectHierarchyAttributeDefinitionSequenceMutation, UpdateProjectHierarchyAttributeDefinitionSequenceMutationVariables>;
export const CreateMeasureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMeasure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMeasureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMeasure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"howto"}},{"kind":"Field","name":{"kind":"Name","value":"resources"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMeasureMutation, CreateMeasureMutationVariables>;
export const UpdateMeasureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMeasure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMeasureRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMeasure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"howto"}},{"kind":"Field","name":{"kind":"Name","value":"resources"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMeasureMutation, UpdateMeasureMutationVariables>;
export const SaveMitigationsBulkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMitigationsBulk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveMitigationBulkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveMitigationsBulk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MitigationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MitigationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mitigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"}},{"kind":"Field","name":{"kind":"Name","value":"statusReason"}},{"kind":"Field","name":{"kind":"Name","value":"workcycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<SaveMitigationsBulkMutation, SaveMitigationsBulkMutationVariables>;
export const SetMitigationsStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMitigationsStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetMitigationssStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMitigationsStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MitigationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MitigationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mitigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"}},{"kind":"Field","name":{"kind":"Name","value":"statusReason"}},{"kind":"Field","name":{"kind":"Name","value":"workcycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<SetMitigationsStatusMutation, SetMitigationsStatusMutationVariables>;
export const CreateMitigationTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMitigationTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMitigationTestRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMitigationTests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMitigationTestsMutation, CreateMitigationTestsMutationVariables>;
export const UpdateMitigationTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMitigationTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMitigationTestBulkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMitigationTests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMitigationTestsMutation, UpdateMitigationTestsMutationVariables>;
export const CreateProjectHierarchyTodoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectHierarchyTodo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodoStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectHierarchyTodos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectHierarchyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateProjectHierarchyTodoMutation, CreateProjectHierarchyTodoMutationVariables>;
export const UpdateProjectHierarchyTodoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectHierarchyTodo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodoStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seqNo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectHierarchyTodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seqNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seqNo"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectHierarchyTodoMutation, UpdateProjectHierarchyTodoMutationVariables>;
export const DeleteProjectHierarchyTodoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectHierarchyTodo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectHierarchyTodos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IDs"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectHierarchyTodoMutation, DeleteProjectHierarchyTodoMutationVariables>;
export const CreateBulkProjectHierarchyTodosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBulkProjectHierarchyTodos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectHierarchyTodoRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectHierarchyTodos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectHierarchyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateBulkProjectHierarchyTodosMutation, CreateBulkProjectHierarchyTodosMutationVariables>;
export const DeleteBulkProjectHierarchyTodosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBulkProjectHierarchyTodos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectHierarchyTodos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteBulkProjectHierarchyTodosMutation, DeleteBulkProjectHierarchyTodosMutationVariables>;
export const SetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setProjectUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SetUsersMutation, SetUsersMutationVariables>;
export const CreateProjectGuidanceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectGuidanceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requirementsConfig"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveProjectGuidanceRequirementConfigInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProjectGuidance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requirementsConfig"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requirementsConfig"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateProjectGuidanceConfigMutation, CreateProjectGuidanceConfigMutationVariables>;
export const DeleteProjectGuidanceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectGuidanceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectGuidance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectGuidanceConfigMutation, DeleteProjectGuidanceConfigMutationVariables>;
export const PublishProjectGuidanceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishProjectGuidanceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishProjectGuidance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]} as unknown as DocumentNode<PublishProjectGuidanceConfigMutation, PublishProjectGuidanceConfigMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"milestoneID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationStreet"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationPostalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plantName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plantExternalID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pointInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PointInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIDs"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"countryIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryIDs"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"statusID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"milestoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"milestoneID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationStreet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationStreet"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationPostalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationPostalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationCity"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationCountry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationCountry"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plantName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plantExternalID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plantExternalID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pointInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pointInput"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileIDs"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectLocationPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPlantPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectProfilePartial"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectLocationPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCountry"}},{"kind":"Field","name":{"kind":"Name","value":"locationCity"}},{"kind":"Field","name":{"kind":"Name","value":"locationPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationStreet"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPlantPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantName"}},{"kind":"Field","name":{"kind":"Name","value":"plantExternalID"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectProfilePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectStandardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"milestoneID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationStreet"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationPostalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plantName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plantExternalID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pointInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PointInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"securityResponsibleID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"countryIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryIDs"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"statusID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"milestoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"milestoneID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationStreet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationStreet"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationPostalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationPostalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationCity"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationCountry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationCountry"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plantName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plantExternalID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plantExternalID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pointInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pointInput"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"securityResponsibleID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"securityResponsibleID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCustomerPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectLocationPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPlantPartial"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCustomerPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectLocationPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCountry"}},{"kind":"Field","name":{"kind":"Name","value":"locationCity"}},{"kind":"Field","name":{"kind":"Name","value":"locationPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationStreet"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPlantPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantName"}},{"kind":"Field","name":{"kind":"Name","value":"plantExternalID"}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CopyProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"milestoneID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyCountries"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyStandardProfiles"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyCustomerAndLocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyTasks"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyTasksDeliverables"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyTasksEvidences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyPssClassification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyCRAEU"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyCRAEULinkedFiles"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchyAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchies"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchiesFiles"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchiesTodos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectZones"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectZoneStandardProfiles"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyAssets"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetItems"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetRelations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetItemsAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetRelationsAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyMeasures"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyTRA"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"milestoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"milestoneID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"statusID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectAttributes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyCountries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyCountries"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyStandardProfiles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyStandardProfiles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyCustomerAndLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyCustomerAndLocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyTasks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyTasks"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyTasksDeliverables"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyTasksDeliverables"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyTasksEvidences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyTasksEvidences"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyPssClassification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyPssClassification"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyCRAEU"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyCRAEU"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyCRAEULinkedFiles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyCRAEULinkedFiles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectHierarchyAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchyAttributes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectHierarchies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchies"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectHierarchiesFiles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchiesFiles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectHierarchiesTodos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectHierarchiesTodos"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectZones"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectZones"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyProjectZoneStandardProfiles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyProjectZoneStandardProfiles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyAssetAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetAttributes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyAssets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyAssets"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyAssetItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetItems"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyAssetRelations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetRelations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyAssetItemsAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetItemsAttributes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyAssetRelationsAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyAssetRelationsAttributes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyMeasures"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyMeasures"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyTRA"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyTRA"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectID"}}]}}]}}]} as unknown as DocumentNode<CopyProjectMutation, CopyProjectMutationVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const CreateProjectZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProjectZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentZoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exposureRating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZoneExposureRating"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentZoneId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exposureRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exposureRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateProjectZoneMutation, CreateProjectZoneMutationVariables>;
export const UpdateProjectZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentZoneId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exposureRating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZoneExposureRating"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentZoneId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exposureRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exposureRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standardProfileIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectZoneMutation, UpdateProjectZoneMutationVariables>;
export const DeleteProjectZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectZoneMutation, DeleteProjectZoneMutationVariables>;
export const CreateProjectAttributeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectAttribute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectAttributeRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<CreateProjectAttributeMutation, CreateProjectAttributeMutationVariables>;
export const DeleteProjectAttributeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectAttribute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkIDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectAttributeMutation, DeleteProjectAttributeMutationVariables>;
export const UpdateProjectAttributeSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectAttributeSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectAttributeSequenceRawInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectAttributeSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectAttributeSequenceMutation, UpdateProjectAttributeSequenceMutationVariables>;
export const UpdateProjectAttributeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectAttribute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectAttributeValueInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectAttributeValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectAttributeMutation, UpdateProjectAttributeMutationVariables>;
export const UploadStandardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadStandards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importStandards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"unsuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"failedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"unsuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"failedRows"}},{"kind":"Field","name":{"kind":"Name","value":"missing"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"unsuccessful"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UploadStandardsMutation, UploadStandardsMutationVariables>;
export const ComponentVendorAssessmentImportSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComponentVendorAssessmentImportSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importComponentVendorAssessments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ComponentVendorAssessmentImportSummaryMutation, ComponentVendorAssessmentImportSummaryMutationVariables>;
export const ExportComponentVendorAssessmentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportComponentVendorAssessmentsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportComponentVendorAssessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ExportComponentVendorAssessmentsQueryQuery, ExportComponentVendorAssessmentsQueryQueryVariables>;
export const SaveSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveSurveyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSurveyPartial"}},{"kind":"Field","name":{"kind":"Name","value":"answers"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormPartial"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSurveyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optimisticLockVersion"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityActivitiesPartial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classificationScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isApproved"}},{"kind":"Field","name":{"kind":"Name","value":"conductedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionTransitionLog"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approver2User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentID"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}}]}}]}}]} as unknown as DocumentNode<SaveSurveyMutation, SaveSurveyMutationVariables>;
export const DeleteSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSurveyMutation, DeleteSurveyMutationVariables>;
export const SetSurveyStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSurveyState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyStateSatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveySetStateStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"optimisticLockVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSurveyState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyStateSatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"optimisticLockVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"optimisticLockVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSurveyPartial"}},{"kind":"Field","name":{"kind":"Name","value":"answers"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormPartial"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSurveyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optimisticLockVersion"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityActivitiesPartial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classificationScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isApproved"}},{"kind":"Field","name":{"kind":"Name","value":"conductedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionTransitionLog"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approver2User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentID"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}}]}}]}}]} as unknown as DocumentNode<SetSurveyStateMutation, SetSurveyStateMutationVariables>;
export const SurveyFormImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SurveyFormImport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyFormImport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SurveyFormImportMutation, SurveyFormImportMutationVariables>;
export const CreateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>;
export const UpdateTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTaskBulkInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskBulkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTaskBulkInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateTasksMutation, UpdateTasksMutationVariables>;
export const DeleteProjectTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectTasksMutation, DeleteProjectTasksMutationVariables>;
export const SaveTaskDeliverablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveTaskDeliverables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveTaskDeliverableInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveTaskDeliverables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveTaskDeliverablesMutation, SaveTaskDeliverablesMutationVariables>;
export const CreateTaskCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTaskComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskCommentRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTaskComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>;
export const CreateTaskEvidenceLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTaskEvidenceLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskEvidenceRawInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTaskEvidence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTaskEvidenceLinkMutation, CreateTaskEvidenceLinkMutationVariables>;
export const DeleteTaskEvidenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTaskEvidence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskEvidence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskID"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskEvidenceID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskEvidenceMutation, DeleteTaskEvidenceMutationVariables>;
export const CreateTraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTRA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTRARawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTraMutation, CreateTraMutationVariables>;
export const CreateTraReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTRAReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTRAReportRawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTRAReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTraReportMutation, CreateTraReportMutationVariables>;
export const ActivateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<ActivateUserMutation, ActivateUserMutationVariables>;
export const DeactivateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const UploadUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"unsuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"failedRows"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UploadUserMutation, UploadUserMutationVariables>;
export const SaveUserNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveUserNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveUserNotificationSettingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveUserNotificationSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}}]}}]}}]} as unknown as DocumentNode<SaveUserNotificationSettingsMutation, SaveUserNotificationSettingsMutationVariables>;
export const SetUserOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetUserOrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserOrganizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SetUserOrganizationsMutation, SetUserOrganizationsMutationVariables>;
export const GetAssetRelationsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetRelationsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetRelationsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetRelationFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetRelationsForProjectQuery, GetAssetRelationsForProjectQueryVariables>;
export const GetAssetRelationAttributeDefinitionsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetRelationAttributeDefinitionsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetRelationAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetRelationAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}}]}}]} as unknown as DocumentNode<GetAssetRelationAttributeDefinitionsForProjectQuery, GetAssetRelationAttributeDefinitionsForProjectQueryVariables>;
export const GetProjectAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}}]} as unknown as DocumentNode<GetProjectAssetsQuery, GetProjectAssetsQueryVariables>;
export const GetProjectAssetsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAssetsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetProjectAssetsCountQuery, GetProjectAssetsCountQueryVariables>;
export const GetAssetsInProjectZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetsInProjectZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}}]} as unknown as DocumentNode<GetAssetsInProjectZoneQuery, GetAssetsInProjectZoneQueryVariables>;
export const GetAssetItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAssetItemFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssetItemQuery, GetAssetItemQueryVariables>;
export const GetAssetItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetSummaryFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}}]}}]} as unknown as DocumentNode<GetAssetItemsQuery, GetAssetItemsQueryVariables>;
export const GetProjectAssetItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAssetItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasAssetWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectAssetItemFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]} as unknown as DocumentNode<GetProjectAssetItemsQuery, GetProjectAssetItemsQueryVariables>;
export const GetAssetNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssetName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetNameQuery, GetAssetNameQueryVariables>;
export const GetProjectAssetsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAssetsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetsInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectAssetsSearchQuery, GetProjectAssetsSearchQueryVariables>;
export const AssetTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetTypesQuery, AssetTypesQueryVariables>;
export const ItemAttributeDefinitionsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ItemAttributeDefinitionsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]} as unknown as DocumentNode<ItemAttributeDefinitionsForProjectQuery, ItemAttributeDefinitionsForProjectQueryVariables>;
export const AssetAttributeDefinitionsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetAttributeDefinitionsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]} as unknown as DocumentNode<AssetAttributeDefinitionsForProjectQuery, AssetAttributeDefinitionsForProjectQueryVariables>;
export const GetSbomAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSBOMAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SBOMExportFormat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeComponentInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeVulnerabilities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportProjectSBOM"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeComponentInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeComponentInfo"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeVulnerabilities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeVulnerabilities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetSbomAssetsQuery, GetSbomAssetsQueryVariables>;
export const GetComponentsSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentsSourcesQuery, GetComponentsSourcesQueryVariables>;
export const GetComponentCreateRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentCreateRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentCreateRequestsView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"requestPriority"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"requesterID"}},{"kind":"Field","name":{"kind":"Name","value":"referenceWeb"}},{"kind":"Field","name":{"kind":"Name","value":"referenceSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"statusID"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestRef"}},{"kind":"Field","name":{"kind":"Name","value":"externalComponentID"}},{"kind":"Field","name":{"kind":"Name","value":"externalRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"statusTransitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentCreateRequestsQuery, GetComponentCreateRequestsQueryVariables>;
export const GetComponentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<GetComponentByIdQuery, GetComponentByIdQueryVariables>;
export const GetComponentsByVendorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsByVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partialName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partialName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"componentVendorID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentsByVendorQuery, GetComponentsByVendorQueryVariables>;
export const GetComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentOrderField"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasComponentVendorWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<GetComponentsQuery, GetComponentsQueryVariables>;
export const GetComponentsServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<GetComponentsServerQuery, GetComponentsServerQueryVariables>;
export const GetComponentsSearchServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsSearchServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentSearchFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentSearchFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetComponentsSearchServerQuery, GetComponentsSearchServerQueryVariables>;
export const GetComponentsAffectedByNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsAffectedByNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"components"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentsAffectedByNotificationQuery, GetComponentsAffectedByNotificationQueryVariables>;
export const GetUserRelevantComponentsAffectedByNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserRelevantComponentsAffectedByNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsAffectedByNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"affectedProjectsCount"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"affectedAssetsCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserRelevantComponentsAffectedByNotificationQuery, GetUserRelevantComponentsAffectedByNotificationQueryVariables>;
export const GetComponentsAffectedByNotificationInProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsAffectedByNotificationInProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsAffectedByNotificationInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"affectedAssetsCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentsAffectedByNotificationInProjectQuery, GetComponentsAffectedByNotificationInProjectQueryVariables>;
export const FindComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasComponentVendorWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentSearchFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentSearchFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindComponentsQuery, FindComponentsQueryVariables>;
export const SearchComponentNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchComponentNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentOrderField"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasComponentVendorWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SearchComponentNamesQuery, SearchComponentNamesQueryVariables>;
export const GetComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}}]} as unknown as DocumentNode<GetComponentQuery, GetComponentQueryVariables>;
export const GetComponentNameOnlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComponentNameOnly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentNameOnlyQuery, GetComponentNameOnlyQueryVariables>;
export const GetComponentSourcesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentSourcesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsWithSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourcesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentSourceRawFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentSourceRawFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentSourceRaw"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"cpe"}}]}}]} as unknown as DocumentNode<GetComponentSourcesByIdQuery, GetComponentSourcesByIdQueryVariables>;
export const GetComponentsSourcesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsSourcesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsWithSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourcesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentSourceRawFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentSourceRawFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentSourceRaw"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceID"}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"cpe"}}]}}]} as unknown as DocumentNode<GetComponentsSourcesByIdsQuery, GetComponentsSourcesByIdsQueryVariables>;
export const GetCountriesTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountriesTree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryStandards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCountriesTreeQuery, GetCountriesTreeQueryVariables>;
export const GetCrasForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCrasForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crasForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<GetCrasForProjectQuery, GetCrasForProjectQueryVariables>;
export const GetCraEvidenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraEvidence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crasForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraUploadFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<GetCraEvidenceQuery, GetCraEvidenceQueryVariables>;
export const GetCraCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraModuleCommentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraModuleCommentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAModuleComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCraCommentsQuery, GetCraCommentsQueryVariables>;
export const DownloadCraUploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadCraUploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCRAUploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craUploadID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<DownloadCraUploadFileQuery, DownloadCraUploadFileQueryVariables>;
export const GetCraTopicStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraTopicStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"general"},"name":{"kind":"Name","value":"getCRAGeneralForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"documentation"},"name":{"kind":"Name","value":"getCRADocumentationForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vulnerability"},"name":{"kind":"Name","value":"getCRAVulnerabilityHandlingForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"isCompleted"},"name":{"kind":"Name","value":"IsCompleted"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"risk"},"name":{"kind":"Name","value":"getCRACybersecRiskAssessmentForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]} as unknown as DocumentNode<GetCraTopicStatusesQuery, GetCraTopicStatusesQueryVariables>;
export const GetCraCybersecRiskAssessmentForCraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraCybersecRiskAssessmentForCra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCRACybersecRiskAssessmentForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraCybersecRiskAssessmentUploadFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraCybersecRiskAssessmentUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRACybersecRiskAssessmentUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"completeness"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<GetCraCybersecRiskAssessmentForCraQuery, GetCraCybersecRiskAssessmentForCraQueryVariables>;
export const GetCraCybersecRiskAssessmentCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraCybersecRiskAssessmentComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecRiskAssessmentID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craCybersecRiskAssessmentComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craCybersecRiskAssessmentID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecRiskAssessmentID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraModuleCommentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraModuleCommentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAModuleComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCraCybersecRiskAssessmentCommentsQuery, GetCraCybersecRiskAssessmentCommentsQueryVariables>;
export const DownloadCraCybersecRiskAssessmentUploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadCraCybersecRiskAssessmentUploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCRACybersecurityRiskAssessmentUploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craCybersecurityRiskAssessmentUploadID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<DownloadCraCybersecRiskAssessmentUploadFileQuery, DownloadCraCybersecRiskAssessmentUploadFileQueryVariables>;
export const GetCraDocumentationForCraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraDocumentationForCra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCRADocumentationForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"hasProductVisual"}},{"kind":"Field","name":{"kind":"Name","value":"hasRefDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"hasIntendedPurpose"}},{"kind":"Field","name":{"kind":"Name","value":"hasSecDesignArchitecture"}},{"kind":"Field","name":{"kind":"Name","value":"hasProcessReference"}},{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraDocumentationUploadFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraDocumentationUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRADocumentationUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<GetCraDocumentationForCraQuery, GetCraDocumentationForCraQueryVariables>;
export const GetCraDocumentationCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraDocumentationComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craDocumentationID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craDocumentationComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craDocumentationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craDocumentationID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraModuleCommentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraModuleCommentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAModuleComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCraDocumentationCommentsQuery, GetCraDocumentationCommentsQueryVariables>;
export const DownloadCraDocumentationUploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadCraDocumentationUploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craDocumentationUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCRADocumentationUploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craDocumentationUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craDocumentationUploadID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<DownloadCraDocumentationUploadFileQuery, DownloadCraDocumentationUploadFileQueryVariables>;
export const GetCraGeneralForCraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraGeneralForCra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCRAGeneralForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraGeneralFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraGeneralFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAGeneral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"ProductVersion"}},{"kind":"Field","name":{"kind":"Name","value":"ProductCategory"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetime"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetimeStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"productLifetimeEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"supportPeriodInformation"}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<GetCraGeneralForCraQuery, GetCraGeneralForCraQueryVariables>;
export const GetCraGeneralCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraGeneralComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craGeneral"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craGeneralComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craGeneral"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craGeneral"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraModuleCommentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraModuleCommentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAModuleComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCraGeneralCommentsQuery, GetCraGeneralCommentsQueryVariables>;
export const DownloadCraVulnerabilityHandlingUploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadCraVulnerabilityHandlingUploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingUploadID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCRAVulnerabilityHandlingUploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craVulnerabilityHandlingUploadID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingUploadID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<DownloadCraVulnerabilityHandlingUploadFileQuery, DownloadCraVulnerabilityHandlingUploadFileQueryVariables>;
export const GetCraVulnerabilityHandlingForCraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraVulnerabilityHandlingForCra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCRAVulnerabilityHandlingForCRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"IsCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"seContact"}},{"kind":"Field","name":{"kind":"Name","value":"seContactValidationDate"}},{"kind":"Field","name":{"kind":"Name","value":"customerContact"}},{"kind":"Field","name":{"kind":"Name","value":"customerContactValidationDate"}},{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraVulnerabilityHandlingUploadFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAssetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraVulnerabilityHandlingUploadFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAVulnerabilityHandlingUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAssetFields"}}]}}]}}]} as unknown as DocumentNode<GetCraVulnerabilityHandlingForCraQuery, GetCraVulnerabilityHandlingForCraQueryVariables>;
export const GetCraVulnerabilityHandlingCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraVulnerabilityHandlingComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craVulnerabilityHandlingComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craVulnerabilityHandlingID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craVulnerabilityHandlingID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraModuleCommentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CraModuleCommentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CRAModuleComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCraVulnerabilityHandlingCommentsQuery, GetCraVulnerabilityHandlingCommentsQueryVariables>;
export const GetProjectDashboardSummaryCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectDashboardSummaryCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProjectDashboardSummaryCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetsCount"}},{"kind":"Field","name":{"kind":"Name","value":"componentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"projectZonesCount"}},{"kind":"Field","name":{"kind":"Name","value":"tasksCount"}},{"kind":"Field","name":{"kind":"Name","value":"tasksCompletedCount"}},{"kind":"Field","name":{"kind":"Name","value":"trasCount"}},{"kind":"Field","name":{"kind":"Name","value":"trasInProgressCount"}},{"kind":"Field","name":{"kind":"Name","value":"trasReadyForApprovalCount"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classificationScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClassID"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClassName"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectDashboardSummaryCardsQuery, GetProjectDashboardSummaryCardsQueryVariables>;
export const GetDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationID"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"projectTypeID"}},{"kind":"Field","name":{"kind":"Name","value":"projectTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"projectStatusID"}},{"kind":"Field","name":{"kind":"Name","value":"projectStatusName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inProgressTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notStartedTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"cvss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardQuery, GetDashboardQueryVariables>;
export const ExportProjectAssetsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportProjectAssetsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectExportAssetsOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportAssetsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ExportProjectAssetsListQuery, ExportProjectAssetsListQueryVariables>;
export const ExportProjectSbomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportProjectSBOM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SBOMExportFormat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportProjectSBOM"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<ExportProjectSbomQuery, ExportProjectSbomQueryVariables>;
export const ExportProjectMitigationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportProjectMitigationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationStatusExportFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportProjectMitigationStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterNotificationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ExportProjectMitigationStatusQuery, ExportProjectMitigationStatusQueryVariables>;
export const ExportUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<ExportUsersQuery, ExportUsersQueryVariables>;
export const SurveyFormExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyFormExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyFormExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<SurveyFormExportQuery, SurveyFormExportQueryVariables>;
export const ProjectNotificationsReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectNotificationsReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeMitigations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAffected"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectNotificationsReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeMitigations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeMitigations"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeAffected"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAffected"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ProjectNotificationsReportQuery, ProjectNotificationsReportQueryVariables>;
export const ExportAssetRelationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportAssetRelations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportAssetRelations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ExportAssetRelationsQuery, ExportAssetRelationsQueryVariables>;
export const GetHierarchyTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHierarchyTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProjectHierarchyTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetHierarchyTypesQuery, GetHierarchyTypesQueryVariables>;
export const GetProjectHierarchyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectHierarchy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyPartial"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyTodos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"criticality"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityManager"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyQuery, GetProjectHierarchyQueryVariables>;
export const GetProjectHierarchyAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectHierarchyAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectHierarchyAssetsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectHierarchyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyAssetsQuery, GetProjectHierarchyAssetsQueryVariables>;
export const GetProjectHierarchyAssetsNotAssignedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectHierarchyAssetsNotAssigned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectHierarchyAssets"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyAssetsNotAssignedQuery, GetProjectHierarchyAssetsNotAssignedQueryVariables>;
export const GetAssetsForSystemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssetsForSystems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectHierarchyAssetsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectHierarchyIDIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemIDs"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetsForSystemsQuery, GetAssetsForSystemsQueryVariables>;
export const GetProjectHierarchyAssetsBySystemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectHierarchyAssetsBySystems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyAssetsBySystemsQuery, GetProjectHierarchyAssetsBySystemsQueryVariables>;
export const GetProjectHierarchyTodosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectHierarchyTodos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyTodos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectHierarchyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"SEQNO"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyTodoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchyTodo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyTodosQuery, GetProjectHierarchyTodosQueryVariables>;
export const GetProjectHierarchyFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectHierarchyFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchyID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"projectID"}},{"kind":"Field","name":{"kind":"Name","value":"refID"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyFilesQuery, GetProjectHierarchyFilesQueryVariables>;
export const DownloadProjectHierarchyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadProjectHierarchyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectHierarchyFileID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadProjectHierarchyFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectHierarchyFileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectHierarchyFileID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<DownloadProjectHierarchyFileQuery, DownloadProjectHierarchyFileQueryVariables>;
export const GetProjectHierarchyAttributeDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectHierarchyAttributeDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchyAttributeDefinitionsQuery, GetProjectHierarchyAttributeDefinitionsQueryVariables>;
export const GetMaintenanceInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMaintenanceInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenanceData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMaintenanceInfoQuery, GetMaintenanceInfoQueryVariables>;
export const GetMappingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementMappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"parentRequirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childRequirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMappingsQuery, GetMappingsQueryVariables>;
export const GetSecurityNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecurityNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"cves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"weakness"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssBaseScore"}},{"kind":"Field","name":{"kind":"Name","value":"cvssExploitabilityScore"}},{"kind":"Field","name":{"kind":"Name","value":"cvssImpactScore"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssOverrideVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"vector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"solutionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"legalNotice"}},{"kind":"Field","name":{"kind":"Name","value":"vendorAdvisories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetSecurityNotificationQuery, GetSecurityNotificationQueryVariables>;
export const GetSecurityNotificationForComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecurityNotificationForComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasComponentsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"cves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"weakness"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssBaseScore"}},{"kind":"Field","name":{"kind":"Name","value":"cvssExploitabilityScore"}},{"kind":"Field","name":{"kind":"Name","value":"cvssImpactScore"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssOverrideVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"vector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"solutionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"legalNotice"}},{"kind":"Field","name":{"kind":"Name","value":"vendorAdvisories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetSecurityNotificationForComponentQuery, GetSecurityNotificationForComponentQueryVariables>;
export const GetSecurityNotificationForProjectServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecurityNotificationForProjectServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"resolved"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"cves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affectedAssetItemsCount"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSecurityNotificationForProjectServerQuery, GetSecurityNotificationForProjectServerQueryVariables>;
export const GetSecurityNotificationsServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecurityNotificationsServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showCvss"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showCustomizedCvss"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showCvssVector"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showCves"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showPublishDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showLastUpdateDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showImpact"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showPublishDate"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showLastUpdateDate"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"impact"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showImpact"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"source"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showSource"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"cves"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showCves"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showCvssVector"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showCvss"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"cvss"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showCvss"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvssOverrideVector"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showCustomizedCvss"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showCustomizedCvss"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSecurityNotificationsServerQuery, GetSecurityNotificationsServerQueryVariables>;
export const GetSecurityNotificationsServerDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecurityNotificationsServerDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"cves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"weakness"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssBaseScore"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"cvssOverrideVector"}},{"kind":"Field","name":{"kind":"Name","value":"solutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"solutionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"legalNotice"}},{"kind":"Field","name":{"kind":"Name","value":"vendorAdvisories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"components"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSecurityNotificationsServerDetailsQuery, GetSecurityNotificationsServerDetailsQueryVariables>;
export const GetProjectComponentsNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectComponentsNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectComponentNotificationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectComponentNotificationOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectComponentsNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationID"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTitle"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPriority"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPublishDate"}},{"kind":"Field","name":{"kind":"Name","value":"notificationLastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssBaseScore"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssTemporalScore"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssOveralScore"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"notificationImpact"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSource"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentIsValid"}},{"kind":"Field","name":{"kind":"Name","value":"componentEolReached"}},{"kind":"Field","name":{"kind":"Name","value":"componentCpeName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemID"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemName"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"assetName"}},{"kind":"Field","name":{"kind":"Name","value":"assetAlias"}},{"kind":"Field","name":{"kind":"Name","value":"assetStatus"}},{"kind":"Field","name":{"kind":"Name","value":"assetRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypeID"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneID"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneName"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneExposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationAssignee"}},{"kind":"Field","name":{"kind":"Name","value":"measureID"}},{"kind":"Field","name":{"kind":"Name","value":"measureName"}},{"kind":"Field","name":{"kind":"Name","value":"measureType"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTestID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTestResult"}},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"vector"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectComponentsNotificationsQuery, GetProjectComponentsNotificationsQueryVariables>;
export const GetProjectComponentsNotificationsServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectComponentsNotificationsServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectComponentNotificationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectComponentNotificationOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectComponentsNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationID"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTitle"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPriority"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPublishDate"}},{"kind":"Field","name":{"kind":"Name","value":"notificationLastUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssBaseScore"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssTemporalScore"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssOveralScore"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCvssVector"}},{"kind":"Field","name":{"kind":"Name","value":"notificationImpact"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSource"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"componentName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"componentIsValid"}},{"kind":"Field","name":{"kind":"Name","value":"componentEolReached"}},{"kind":"Field","name":{"kind":"Name","value":"componentCpeName"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorID"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemID"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemName"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"assetName"}},{"kind":"Field","name":{"kind":"Name","value":"assetAlias"}},{"kind":"Field","name":{"kind":"Name","value":"assetStatus"}},{"kind":"Field","name":{"kind":"Name","value":"assetRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypeID"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneID"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneName"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneExposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationAssignee"}},{"kind":"Field","name":{"kind":"Name","value":"measureID"}},{"kind":"Field","name":{"kind":"Name","value":"measureName"}},{"kind":"Field","name":{"kind":"Name","value":"measureType"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTestID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTestResult"}},{"kind":"Field","name":{"kind":"Name","value":"customizedCVSS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"vector"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetProjectComponentsNotificationsServerQuery, GetProjectComponentsNotificationsServerQueryVariables>;
export const GetUnresolvedNotificationsByZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnresolvedNotificationsByZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectComponentsNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mitigationIDIsNil"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mitigationIDIsNil"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"mitigationStatusNotIn"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"COMPLETED","block":false},{"kind":"StringValue","value":"OBSOLETE","block":false}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetStatusNotIn"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"INVALID","block":false}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetItemID"}},{"kind":"Field","name":{"kind":"Name","value":"componentID"}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneID"}},{"kind":"Field","name":{"kind":"Name","value":"notificationID"}},{"kind":"Field","name":{"kind":"Name","value":"mitigationStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetUnresolvedNotificationsByZoneQuery, GetUnresolvedNotificationsByZoneQueryVariables>;
export const GetMeasuresForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMeasuresForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"howto"}},{"kind":"Field","name":{"kind":"Name","value":"resources"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetMeasuresForProjectQuery, GetMeasuresForProjectQueryVariables>;
export const GetMitigationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMitigations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MitigationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MitigationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MitigationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mitigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"}},{"kind":"Field","name":{"kind":"Name","value":"statusReason"}},{"kind":"Field","name":{"kind":"Name","value":"workcycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GetMitigationsQuery, GetMitigationsQueryVariables>;
export const GetMitigationsServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMitigationsServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MitigationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MitigationOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MitigationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComponentPartialFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Component"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ifa"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectAssetItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComponentPartialFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MitigationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mitigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"}},{"kind":"Field","name":{"kind":"Name","value":"statusReason"}},{"kind":"Field","name":{"kind":"Name","value":"workcycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectAssetItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigationTests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"envName"}},{"kind":"Field","name":{"kind":"Name","value":"tester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GetMitigationsServerQuery, GetMitigationsServerQueryVariables>;
export const GetMeasuresServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMeasuresServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MeasureWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MeasureOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"howto"}},{"kind":"Field","name":{"kind":"Name","value":"resources"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updateToComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetMeasuresServerQuery, GetMeasuresServerQueryVariables>;
export const GetOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetZoneStandardProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZoneStandardProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZoneStandardProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<GetZoneStandardProfilesQuery, GetZoneStandardProfilesQueryVariables>;
export const GetZoneDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZoneDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectZoneFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectZoneStandardProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectZoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<GetZoneDetailsQuery, GetZoneDetailsQueryVariables>;
export const GetZoneNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZoneName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneNameQuery, GetZoneNameQueryVariables>;
export const GetRootZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRootZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentZoneIDIsNil"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRootZoneQuery, GetRootZoneQueryVariables>;
export const GetCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rqid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZoneStandardProfileRequirementCommentsGet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requirementID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rqid"}}},{"kind":"Argument","name":{"kind":"Name","value":"standardProfileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spid"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Comment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZoneStandardProfileRequirementComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCommentsQuery, GetCommentsQueryVariables>;
export const GetProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"field"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectOrderField"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"field"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCustomerPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectLocationPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPlantPartial"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectProfilePartial"}},{"kind":"Field","name":{"kind":"Name","value":"projectCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCustomerPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectLocationPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCountry"}},{"kind":"Field","name":{"kind":"Name","value":"locationCity"}},{"kind":"Field","name":{"kind":"Name","value":"locationPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationStreet"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPlantPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantName"}},{"kind":"Field","name":{"kind":"Name","value":"plantExternalID"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectProfilePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectStandardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetProjectZonesInProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectZonesInProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectZonesInProjectQuery, GetProjectZonesInProjectQueryVariables>;
export const GetUnorderedProjectZonesInProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnorderedProjectZonesInProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnorderedProjectZonesInProjectQuery, GetUnorderedProjectZonesInProjectQueryVariables>;
export const ListProjectZonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProjectZones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectZoneFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectZoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<ListProjectZonesQuery, ListProjectZonesQueryVariables>;
export const GetProjectComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentInProjectOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentInProjectWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendorName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"cpeName"}},{"kind":"Field","name":{"kind":"Name","value":"eolDate"}},{"kind":"Field","name":{"kind":"Name","value":"eolReached"}},{"kind":"Field","name":{"kind":"Name","value":"monitoredSince"}},{"kind":"Field","name":{"kind":"Name","value":"usedInProjectCount"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"securityURL"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"lastSync"}},{"kind":"Field","name":{"kind":"Name","value":"projectID"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"hasAssessments"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectComponentsQuery, GetProjectComponentsQueryVariables>;
export const GetProjectsAffectedByNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectsAffectedByNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsAffectedByNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"affectedComponentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"affectedAssetsCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectsAffectedByNotificationQuery, GetProjectsAffectedByNotificationQueryVariables>;
export const GetComponentsAffectedByAnyNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsAffectedByAnyNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentAffectedByNotificationProjectOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsAffectedByNotificationInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"affectedAssetsCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentsAffectedByAnyNotificationsQuery, GetComponentsAffectedByAnyNotificationsQueryVariables>;
export const GetMitigationsSummaryInProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMitigationsSummaryInProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mitigations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasAssetItemWith"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasAssetWith"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetMitigationsSummaryInProjectQuery, GetMitigationsSummaryInProjectQueryVariables>;
export const GetProjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectNameQuery, GetProjectNameQueryVariables>;
export const GetProjectTasksSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectTasksSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectTasksSummaryQuery, GetProjectTasksSummaryQueryVariables>;
export const GetProjectsTasksSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectsTasksSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectIDIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectIDs"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectsTasksSummaryQuery, GetProjectsTasksSummaryQueryVariables>;
export const GetZonesCountForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZonesCountForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetZonesCountForProjectQuery, GetZonesCountForProjectQueryVariables>;
export const TrasForProjectSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"trasForProjectSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrasForProjectSummaryQuery, TrasForProjectSummaryQueryVariables>;
export const GetAssetsCountForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetsCountForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetsInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetsCountForProjectQuery, GetAssetsCountForProjectQueryVariables>;
export const GetComponentsCountForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentsCountForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetComponentsCountForProjectQuery, GetComponentsCountForProjectQueryVariables>;
export const GetSbomStatsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSbomStatsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentsInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasAssetWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectComponentsNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetSbomStatsForProjectQuery, GetSbomStatsForProjectQueryVariables>;
export const GetProjectUsersRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectUsersRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectUsersRolesQuery, GetProjectUsersRolesQueryVariables>;
export const GetProjectDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCustomerPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"plantName"}},{"kind":"Field","name":{"kind":"Name","value":"locationStreet"}},{"kind":"Field","name":{"kind":"Name","value":"locationCity"}},{"kind":"Field","name":{"kind":"Name","value":"locationPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationCountry"}},{"kind":"Field","name":{"kind":"Name","value":"plantExternalID"}},{"kind":"Field","name":{"kind":"Name","value":"projectStandardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCustomerPartial"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"securityResponsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>;
export const GetProjectMarketCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectMarketCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectMarketCountriesQuery, GetProjectMarketCountriesQueryVariables>;
export const GetParticipantsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParticipantsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectUserParticipant"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationUserParticipant"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectUserParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationUserParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"organizationRole"},"name":{"kind":"Name","value":"role"}}]}}]} as unknown as DocumentNode<GetParticipantsForProjectQuery, GetParticipantsForProjectQueryVariables>;
export const GetUsersForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectUserPartial"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUsersForProjectQuery, GetUsersForProjectQueryVariables>;
export const GetProjectGuidanceConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectGuidanceConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectGuidances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"projectType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<GetProjectGuidanceConfigsQuery, GetProjectGuidanceConfigsQueryVariables>;
export const GetProjectGuidancesByProjectTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectGuidancesByProjectType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectGuidances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"VERSION"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<GetProjectGuidancesByProjectTypeQuery, GetProjectGuidancesByProjectTypeQueryVariables>;
export const GetProjectTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectTypesQuery, GetProjectTypesQueryVariables>;
export const GetProjectSearchFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSearchFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectSearchFiltersQuery, GetProjectSearchFiltersQueryVariables>;
export const GetProjectTagsMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectTagsMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTagsMe"}}]}}]} as unknown as DocumentNode<GetProjectTagsMeQuery, GetProjectTagsMeQueryVariables>;
export const ProjectFormFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectFormFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectFormFieldsQuery, ProjectFormFieldsQueryVariables>;
export const GetProjectMilestonesByProjectTypeIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectMilestonesByProjectTypeId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectMilestones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectPhaseWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectMilestonesByProjectTypeIdQuery, GetProjectMilestonesByProjectTypeIdQueryVariables>;
export const GetProjectStatusesAndMilestonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectStatusesAndMilestones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectPhaseWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectStatusesAndMilestonesQuery, GetProjectStatusesAndMilestonesQueryVariables>;
export const GetProjectForGuidanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectForGuidance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectForGuidanceQuery, GetProjectForGuidanceQueryVariables>;
export const GetProjectGuidanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectGuidance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectPhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"projectTypeID"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectPhaseWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"projectTypeID"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectGuidanceQuery, GetProjectGuidanceQueryVariables>;
export const GetProjectPhasesAndMilestonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectPhasesAndMilestones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectPhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTypeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTypeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectTypeID"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seqNo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectPhasesAndMilestonesQuery, GetProjectPhasesAndMilestonesQueryVariables>;
export const ProjectsStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pendingTasks"},"name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"COMPLETED"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"components"},"name":{"kind":"Name","value":"componentsInProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProjectsStatsQuery, ProjectsStatsQueryVariables>;
export const GetProjectResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectZoneFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectZoneWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetBaseFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeFragment"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinitionsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationsForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetRelationAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttributeDefinitionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttributeDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemType"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectZoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}},{"kind":"Field","name":{"kind":"Name","value":"assetsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetBaseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"systemRating"}},{"kind":"Field","name":{"kind":"Name","value":"projectZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exposureRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAttributeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetItemAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetItemAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assetItemAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetItemAttributeDefinitionFragment"}}]}}]}}]} as unknown as DocumentNode<GetProjectResourcesQuery, GetProjectResourcesQueryVariables>;
export const GetProjectAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectAttributesQuery, GetProjectAttributesQueryVariables>;
export const GetProjectHierarchiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectHierarchies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyPartial"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"criticality"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityManager"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectHierarchiesQuery, GetProjectHierarchiesQueryVariables>;
export const GetProjectSystemsMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSystemsMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectSystemsMenuQuery, GetProjectSystemsMenuQueryVariables>;
export const GetProjectSystemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSystems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectHierarchies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectHierarchyPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectHierarchyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectHierarchy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"criticality"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityManager"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetID"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"projectHierarchyAttributeDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectSystemsQuery, GetProjectSystemsQueryVariables>;
export const GetProjectCraCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectCraCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crasForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetProjectCraCountQuery, GetProjectCraCountQueryVariables>;
export const ProjectSecurityNotificationReportVulnerabilityManagementReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectSecurityNotificationReportVulnerabilityManagementReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAssets"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeMitigations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSecurityNotificationReportVulnerabilityManagementReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeAssets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAssets"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeMitigations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeMitigations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ProjectSecurityNotificationReportVulnerabilityManagementReportQuery, ProjectSecurityNotificationReportVulnerabilityManagementReportQueryVariables>;
export const ProjectAssetsReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectAssetsReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectZoneID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectAssetsReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectZoneID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ProjectAssetsReportQuery, ProjectAssetsReportQueryVariables>;
export const ProjectAssetsConfigurationReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectAssetsConfigurationReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectZoneID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectAssetsConfigurationReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectZoneID"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ProjectAssetsConfigurationReportQuery, ProjectAssetsConfigurationReportQueryVariables>;
export const ProjectSecurityNotificationReportByAssetVulnerabilityManagementReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectSecurityNotificationReportByAssetVulnerabilityManagementReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectZoneID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeMitigations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSecurityNotificationReportByAssetVulnerabilityManagementReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectID"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectZoneID"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetID"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeMitigations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeMitigations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EncodedFileFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EncodedFileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EncodedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ProjectSecurityNotificationReportByAssetVulnerabilityManagementReportQuery, ProjectSecurityNotificationReportByAssetVulnerabilityManagementReportQueryVariables>;
export const GetRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsWithSPEs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequirementWithSPEFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementWithSPEFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementWithSPE"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"standardName"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}}]}}]} as unknown as DocumentNode<GetRequirementsQuery, GetRequirementsQueryVariables>;
export const GetRequirementMappingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirementMappings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requirementId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirementMappings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasParentRequirementWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requirementId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"childRequirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mappingCoverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRequirementMappingsQuery, GetRequirementMappingsQueryVariables>;
export const GetRequirementsCountForStandardProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirementsCountForStandardProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsOnProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetRequirementsCountForStandardProfileQuery, GetRequirementsCountForStandardProfileQueryVariables>;
export const GetRequirementsForZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirementsForZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsOnProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequirementOnProjectZoneFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementOnProjectZoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementOnProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentCreateTime"}}]}}]} as unknown as DocumentNode<GetRequirementsForZoneQuery, GetRequirementsForZoneQueryVariables>;
export const GetRequirementsForStandardProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirementsForStandardProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsOnProjectZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectZoneID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pzid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequirementOnProjectZoneFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementOnProjectZoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementOnProjectZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requirementCommentCreateTime"}}]}}]} as unknown as DocumentNode<GetRequirementsForStandardProfileQuery, GetRequirementsForStandardProfileQueryVariables>;
export const GetRequirementNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirementName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRequirementNameQuery, GetRequirementNameQueryVariables>;
export const GetRequirementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"requirements"},"name":{"kind":"Name","value":"requirementsWithSPEs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequirementWithSPEFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementWithSPEFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementWithSPE"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"standardName"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}}]}}]} as unknown as DocumentNode<GetRequirementQuery, GetRequirementQueryVariables>;
export const GetProjectGuidanceRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectGuidanceRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectGuidanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectGuidanceRequirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectGuidanceID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectGuidanceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectGuidanceRequirementsQuery, GetProjectGuidanceRequirementsQueryVariables>;
export const GetRequirementsWithStandardProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequirementsWithStandardProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsWithStandardProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"standardID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"standardProfileIDIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"standardName"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfileName"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfileAlias"}},{"kind":"Field","name":{"kind":"Name","value":"maturityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"securityLevelName"}},{"kind":"Field","name":{"kind":"Name","value":"subSpeName"}},{"kind":"Field","name":{"kind":"Name","value":"speName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRequirementsWithStandardProfileQuery, GetRequirementsWithStandardProfileQueryVariables>;
export const GetReqForProfileDDvaluesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReqForProfileDDvalues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"securityLevelName"},"name":{"kind":"Name","value":"securityLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"maturityLevelName"},"name":{"kind":"Name","value":"maturityLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"speName"},"name":{"kind":"Name","value":"SPEs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"subSpeName"},"name":{"kind":"Name","value":"subSPEs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReqForProfileDDvaluesQuery, GetReqForProfileDDvaluesQueryVariables>;
export const GetProfileNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileNameQuery, GetProfileNameQueryVariables>;
export const GetStandardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsCount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<GetStandardQuery, GetStandardQueryVariables>;
export const GetStandardProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<GetStandardProfilesQuery, GetStandardProfilesQueryVariables>;
export const GetStandardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardWithProfile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardWithProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]} as unknown as DocumentNode<GetStandardsQuery, GetStandardsQueryVariables>;
export const GetStandardsWithRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandardsWithRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardWithProfile"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequirementBasicFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardWithProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequirementBasicFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Requirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetStandardsWithRequirementsQuery, GetStandardsWithRequirementsQueryVariables>;
export const GetAllStandardsRichDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllStandardsRich"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RichStandardFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichStandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsCount"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]} as unknown as DocumentNode<GetAllStandardsRichQuery, GetAllStandardsRichQueryVariables>;
export const GetStandardNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandardName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStandardNameQuery, GetStandardNameQueryVariables>;
export const GetStandardNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandardNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Standard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]} as unknown as DocumentNode<GetStandardNamesQuery, GetStandardNamesQueryVariables>;
export const GetMinimalSurveyForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMinimalSurveyForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSurveyPartial"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSurveyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optimisticLockVersion"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityActivitiesPartial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classificationScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isApproved"}},{"kind":"Field","name":{"kind":"Name","value":"conductedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionTransitionLog"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approver2User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentID"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}}]} as unknown as DocumentNode<GetMinimalSurveyForProjectQuery, GetMinimalSurveyForProjectQueryVariables>;
export const GetSurveyForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSurveyForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSurveyPartial"}},{"kind":"Field","name":{"kind":"Name","value":"answers"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormPartial"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityActivitiesPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyClassificationClassActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"necessity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSurveyPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optimisticLockVersion"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityActivitiesPartial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classificationScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isApproved"}},{"kind":"Field","name":{"kind":"Name","value":"conductedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionTransitionLog"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approver2User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentID"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}}]}}]}}]} as unknown as DocumentNode<GetSurveyForProjectQuery, GetSurveyForProjectQueryVariables>;
export const GetCraPsspDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCraPsspData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"classificationClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCraPsspDataQuery, GetCraPsspDataQueryVariables>;
export const ActiveLatestSurveryFormWithProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activeLatestSurveryFormWithProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyForms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"EnumValue","value":"PSSCLASSIFICATION"}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasContentsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"VERSION"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormPartial"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}}]}}]}}]} as unknown as DocumentNode<ActiveLatestSurveryFormWithProfilesQuery, ActiveLatestSurveryFormWithProfilesQueryVariables>;
export const GetSurveyFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveyForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyForms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasContentsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}}]}}]}}]} as unknown as DocumentNode<GetSurveyFormQuery, GetSurveyFormQueryVariables>;
export const GetSurveyProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveyProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSurveyProfilesQuery, GetSurveyProfilesQueryVariables>;
export const SurveryFormsWithProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"surveryFormsWithProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyForms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"EnumValue","value":"PSSCLASSIFICATION"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"VERSION"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SurveryFormsWithProfilesQuery, SurveryFormsWithProfilesQueryVariables>;
export const GetLatestPsspSurveyFormWithProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestPsspSurveyFormWithProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyForms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"EnumValue","value":"PSSCLASSIFICATION"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"VERSION"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}},{"kind":"Field","name":{"kind":"Name","value":"perequisties"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestPsspSurveyFormWithProfilesQuery, GetLatestPsspSurveyFormWithProfilesQueryVariables>;
export const SurveyFormContentListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"surveyFormContentList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyFormContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profileID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyFormContentPartial"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"securityActivities"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyQuestionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"answerHeader"}},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SurveyFormContentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyFormContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SurveyQuestionPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicClusterType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SurveyFormContentListQuery, SurveyFormContentListQueryVariables>;
export const GetProjectSurveyReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSurveyReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSurveyReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyKind"},"value":{"kind":"EnumValue","value":"PSSCLASSIFICATION"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetProjectSurveyReportQuery, GetProjectSurveyReportQueryVariables>;
export const GetTaskTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTaskTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskTemplatesQuery, GetTaskTemplatesQueryVariables>;
export const GetProjectTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksConnectionPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksConnectionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskPartial"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectTasksQuery, GetProjectTasksQueryVariables>;
export const GetSpecificProjectTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpecificProjectTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"idIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskIDs"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskSource"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksConnectionPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksConnectionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskPartial"}}]}}]}}]}}]} as unknown as DocumentNode<GetSpecificProjectTasksQuery, GetSpecificProjectTasksQueryVariables>;
export const GetTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksConnectionPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksConnectionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskPartial"}}]}}]}}]}}]} as unknown as DocumentNode<GetTasksQuery, GetTasksQueryVariables>;
export const GetTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskQuery, GetTaskQueryVariables>;
export const GetGlobalTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGlobalTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assigneeID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksConnectionPartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMandatory"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicable"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"projectMilestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectPhase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksConnectionPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskPartial"}}]}}]}}]}}]} as unknown as DocumentNode<GetGlobalTasksQuery, GetGlobalTasksQueryVariables>;
export const GetTasksCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTasksComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taskComments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksCommentPartial"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksCommentPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}}]}}]} as unknown as DocumentNode<GetTasksCommentsQuery, GetTasksCommentsQueryVariables>;
export const ExportProjectTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportProjectTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportProjectTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskIDs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ExportProjectTasksQuery, ExportProjectTasksQueryVariables>;
export const RequirementsForTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RequirementsForTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsForTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"Field","name":{"kind":"Name","value":"implementationGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"standardProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StandardProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StandardProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandardProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}}]}}]} as unknown as DocumentNode<RequirementsForTaskQuery, RequirementsForTaskQueryVariables>;
export const GetTaskEvidencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTaskEvidences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskEvidences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"fileAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"refID"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskEvidencesQuery, GetTaskEvidencesQueryVariables>;
export const DownloadTaskEvidenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadTaskEvidence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskEvidenceID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadTaskEvidenceFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskEvidenceID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskEvidenceID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<DownloadTaskEvidenceQuery, DownloadTaskEvidenceQueryVariables>;
export const TrasForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"trasForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TraBasePartial"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraBasePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}}]} as unknown as DocumentNode<TrasForProjectQuery, TrasForProjectQueryVariables>;
export const TraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TraPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraBasePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TraBasePartial"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]} as unknown as DocumentNode<TraQuery, TraQueryVariables>;
export const TraHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"traHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TraHistoryQuery, TraHistoryQueryVariables>;
export const SetTraParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setTRAParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participants"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setTRAParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participants"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<SetTraParticipantsMutation, SetTraParticipantsMutationVariables>;
export const UpdateTraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTRA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTRARawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TraBasePartial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TraBasePartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TRA"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"updateTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approved1At"}},{"kind":"Field","name":{"kind":"Name","value":"approved2At"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approver2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}}]}}]} as unknown as DocumentNode<UpdateTraMutation, UpdateTraMutationVariables>;
export const SetTraStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setTRAState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TRASetStateStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setTRAState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"traID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SetTraStateMutation, SetTraStateMutationVariables>;
export const TraTemplateVariantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"traTemplateVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traTemplateVariants"}}]}}]} as unknown as DocumentNode<TraTemplateVariantsQuery, TraTemplateVariantsQueryVariables>;
export const TraTemplateByVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"traTemplateByVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traTemplateLatestForVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<TraTemplateByVariantQuery, TraTemplateByVariantQueryVariables>;
export const LatestAttckDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"latestAttck"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attckLatest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"srcId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"techniques"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"srcId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"techniqueAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"techniqueMitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"srcId"}},{"kind":"Field","name":{"kind":"Name","value":"mitigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"srcId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tactics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"srcId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"techniques"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LatestAttckQuery, LatestAttckQueryVariables>;
export const ListAttcksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAttcks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attcks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tactics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"techniques"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"techniqueMitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mitigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"techniques"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"techniqueMitigations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mitigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListAttcksQuery, ListAttcksQueryVariables>;
export const LockTraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"lockTRA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockTRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"traID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<LockTraMutation, LockTraMutationVariables>;
export const UnlockTraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unlockTRA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlockTRA"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"traID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lockedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<UnlockTraMutation, UnlockTraMutationVariables>;
export const DownloadTraReportContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadTRAReportContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadTRAReportContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"traReportID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<DownloadTraReportContentQuery, DownloadTraReportContentQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const GetUsersForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersForSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetUsersForSelectQuery, GetUsersForSelectQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetUsersForAdminQuery, GetUsersForAdminQueryVariables>;
export const GetIcsoUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIcsoUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasOrganizationUsersWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"EnumValue","value":"ICSO"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetIcsoUsersQuery, GetIcsoUsersQueryVariables>;
export const UsersOfProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersOfProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasProjectsWith"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<UsersOfProjectQuery, UsersOfProjectQueryVariables>;
export const FindUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstNameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastNameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<FindUsersQuery, FindUsersQueryVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MinimalUserPartial"}},{"kind":"Field","name":{"kind":"Name","value":"gid"}},{"kind":"Field","name":{"kind":"Name","value":"orgCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"are"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MinimalUserPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;
export const GetUserNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNotificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotificationSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priorityEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"cvssEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"cvssMinScore"}},{"kind":"Field","name":{"kind":"Name","value":"assetsAndZonesEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"assignedOnly"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"tasksEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vulnerabilitiesEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>;
export const GetAllComponentVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllComponentVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partialName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameContainsFold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partialName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllComponentVendorsQuery, GetAllComponentVendorsQueryVariables>;
export const GetComponentVendorByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentVendorById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"componentVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentVendorByIdQuery, GetComponentVendorByIdQueryVariables>;
export const GetComponentVendorAndIdentifiersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponentVendorAndIdentifiers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"componentVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"completionTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentExternalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentVendorAndIdentifiersQuery, GetComponentVendorAndIdentifiersQueryVariables>;
export const UserEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resourceID"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UserEventsSubscription, UserEventsSubscriptionVariables>;